(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('@material-ui/core'), require('prop-types'), require('@material-ui/core/styles'), require('@material-ui/icons/ChevronRight'), require('@material-ui/icons/FiberManualRecord'), require('@material-ui/icons/NavigateNext'), require('@material-ui/icons/KeyboardArrowDown'), require('@material-ui/icons/Search'), require('@material-ui/icons/Menu'), require('@material-ui/core/Link'), require('@material-ui/icons/ArrowBackIos'), require('@material-ui/core/Modal'), require('@material-ui/core/Backdrop'), require('@material-ui/core/Fade'), require('@material-ui/core/Button'), require('@material-ui/core/Typography'), require('@material-ui/core/Divider'), require('@material-ui/core/TextField'), require('@material-ui/core/Switch'), require('@material-ui/core/Table'), require('@material-ui/core/TableBody'), require('@material-ui/core/TableCell'), require('@material-ui/core/TableContainer'), require('@material-ui/core/TableRow'), require('@material-ui/core/Paper'), require('@material-ui/core/Checkbox'), require('@material-ui/icons/CloseRounded'), require('@material-ui/core/Grid'), require('@material-ui/core/Container'), require('@material-ui/icons/ChevronLeft'), require('react-image-gallery'), require('@material-ui/core/Tooltip'), require('@material-ui/core/IconButton'), require('@material-ui/core/InputAdornment'), require('@material-ui/icons/Visibility'), require('@material-ui/icons/VisibilityOff'), require('@material-ui/core/FormControl'), require('@material-ui/core/Select'), require('@material-ui/icons/HelpRounded'), require('@material-ui/lab/Autocomplete'), require('@material-ui/core/FormControlLabel'), require('@material-ui/icons/Info'), require('@material-ui/icons/AddRounded'), require('react-flags-select'), require('react-number-format'), require('@material-ui/icons/LockOutlined'), require('html-react-parser'), require('@material-ui/core/Card'), require('@material-ui/core/CardActionArea'), require('@material-ui/core/CardContent'), require('@material-ui/icons/CheckCircle'), require('@material-ui/icons/PaymentOutlined'), require('@material-ui/core/Accordion'), require('@material-ui/core/AccordionSummary'), require('@material-ui/core/AccordionDetails'), require('@material-ui/icons/CheckCircleRounded'), require('@material-ui/icons/KeyboardArrowDownRounded'), require('@material-ui/icons/CancelRounded'), require('@material-ui/core/CircularProgress'), require('@material-ui/icons/MonetizationOn'), require('@material-ui/icons/LocalShipping'), require('@material-ui/icons/Storefront'), require('react-phone-input-2'), require('@material-ui/icons/StorefrontRounded'), require('@material-ui/icons/LocalAtmRounded'), require('@material-ui/icons/CreditCardRounded'), require('@material-ui/icons/ScheduleRounded'), require('@material-ui/core/MenuItem'), require('@material-ui/core/MobileStepper'), require('@material-ui/icons/KeyboardArrowLeft'), require('@material-ui/icons/KeyboardArrowRight'), require('react-swipeable-views'), require('react-swipeable-views-utils'), require('react-elastic-carousel'), require('styled-components'), require('@material-ui/icons/ArrowForwardIosRounded'), require('react-image-lightbox'), require('react-image-lightbox/style.css'), require('@material-ui/core/TableHead'), require('@material-ui/icons/InfoRounded'), require('@material-ui/icons/InfoOutlined'), require('@material-ui/icons/CheckCircleOutlineRounded'), require('@material-ui/icons/ArrowBackIosRounded'), require('@material-ui/icons/PlayArrow'), require('@material-ui/core/Avatar'), require('@material-ui/lab/AvatarGroup'), require('@material-ui/icons/CallMadeRounded'), require('react-modal-video'), require('@material-ui/icons/PersonRounded'), require('@material-ui/icons/DateRangeRounded'), require('@material-ui/icons/DateRange'), require('@material-ui/icons/RemoveRedEyeOutlined'), require('@material-ui/icons/LocationOnRounded'), require('@material-ui/core/AppBar'), require('@material-ui/core/Tabs'), require('@material-ui/core/Tab'), require('@material-ui/core/Box'), require('@material-ui/icons/ExpandMore'), require('@material-ui/icons/Person'), require('@material-ui/core/Breadcrumbs'), require('react-router-dom'), require('@material-ui/icons/Favorite'), require('react-responsive-carousel/lib/styles/carousel.min.css'), require('react-responsive-carousel'), require('@material-ui/icons/ArrowForwardRounded'), require('@material-ui/icons/Today'), require('@material-ui/icons/Schedule'), require('@material-ui/icons/ArrowForward'), require('@material-ui/icons/LocationOn'), require('@material-ui/icons/AttachMoneyRounded'), require('@material-ui/icons/FastfoodRounded'), require('@material-ui/icons/GroupRounded'), require('@material-ui/icons/EmailOutlined'), require('@material-ui/icons/Call'), require('@material-ui/core/Menu'), require('@material-ui/icons/Close'), require('@material-ui/icons/DirectionsOutlined'), require('@material-ui/icons/InsertLinkRounded'), require('@material-ui/icons/AddCircleOutlineRounded'), require('@material-ui/icons/RemoveCircleOutlineRounded'), require('@material-ui/icons/DoneOutline')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', '@material-ui/core', 'prop-types', '@material-ui/core/styles', '@material-ui/icons/ChevronRight', '@material-ui/icons/FiberManualRecord', '@material-ui/icons/NavigateNext', '@material-ui/icons/KeyboardArrowDown', '@material-ui/icons/Search', '@material-ui/icons/Menu', '@material-ui/core/Link', '@material-ui/icons/ArrowBackIos', '@material-ui/core/Modal', '@material-ui/core/Backdrop', '@material-ui/core/Fade', '@material-ui/core/Button', '@material-ui/core/Typography', '@material-ui/core/Divider', '@material-ui/core/TextField', '@material-ui/core/Switch', '@material-ui/core/Table', '@material-ui/core/TableBody', '@material-ui/core/TableCell', '@material-ui/core/TableContainer', '@material-ui/core/TableRow', '@material-ui/core/Paper', '@material-ui/core/Checkbox', '@material-ui/icons/CloseRounded', '@material-ui/core/Grid', '@material-ui/core/Container', '@material-ui/icons/ChevronLeft', 'react-image-gallery', '@material-ui/core/Tooltip', '@material-ui/core/IconButton', '@material-ui/core/InputAdornment', '@material-ui/icons/Visibility', '@material-ui/icons/VisibilityOff', '@material-ui/core/FormControl', '@material-ui/core/Select', '@material-ui/icons/HelpRounded', '@material-ui/lab/Autocomplete', '@material-ui/core/FormControlLabel', '@material-ui/icons/Info', '@material-ui/icons/AddRounded', 'react-flags-select', 'react-number-format', '@material-ui/icons/LockOutlined', 'html-react-parser', '@material-ui/core/Card', '@material-ui/core/CardActionArea', '@material-ui/core/CardContent', '@material-ui/icons/CheckCircle', '@material-ui/icons/PaymentOutlined', '@material-ui/core/Accordion', '@material-ui/core/AccordionSummary', '@material-ui/core/AccordionDetails', '@material-ui/icons/CheckCircleRounded', '@material-ui/icons/KeyboardArrowDownRounded', '@material-ui/icons/CancelRounded', '@material-ui/core/CircularProgress', '@material-ui/icons/MonetizationOn', '@material-ui/icons/LocalShipping', '@material-ui/icons/Storefront', 'react-phone-input-2', '@material-ui/icons/StorefrontRounded', '@material-ui/icons/LocalAtmRounded', '@material-ui/icons/CreditCardRounded', '@material-ui/icons/ScheduleRounded', '@material-ui/core/MenuItem', '@material-ui/core/MobileStepper', '@material-ui/icons/KeyboardArrowLeft', '@material-ui/icons/KeyboardArrowRight', 'react-swipeable-views', 'react-swipeable-views-utils', 'react-elastic-carousel', 'styled-components', '@material-ui/icons/ArrowForwardIosRounded', 'react-image-lightbox', 'react-image-lightbox/style.css', '@material-ui/core/TableHead', '@material-ui/icons/InfoRounded', '@material-ui/icons/InfoOutlined', '@material-ui/icons/CheckCircleOutlineRounded', '@material-ui/icons/ArrowBackIosRounded', '@material-ui/icons/PlayArrow', '@material-ui/core/Avatar', '@material-ui/lab/AvatarGroup', '@material-ui/icons/CallMadeRounded', 'react-modal-video', '@material-ui/icons/PersonRounded', '@material-ui/icons/DateRangeRounded', '@material-ui/icons/DateRange', '@material-ui/icons/RemoveRedEyeOutlined', '@material-ui/icons/LocationOnRounded', '@material-ui/core/AppBar', '@material-ui/core/Tabs', '@material-ui/core/Tab', '@material-ui/core/Box', '@material-ui/icons/ExpandMore', '@material-ui/icons/Person', '@material-ui/core/Breadcrumbs', 'react-router-dom', '@material-ui/icons/Favorite', 'react-responsive-carousel/lib/styles/carousel.min.css', 'react-responsive-carousel', '@material-ui/icons/ArrowForwardRounded', '@material-ui/icons/Today', '@material-ui/icons/Schedule', '@material-ui/icons/ArrowForward', '@material-ui/icons/LocationOn', '@material-ui/icons/AttachMoneyRounded', '@material-ui/icons/FastfoodRounded', '@material-ui/icons/GroupRounded', '@material-ui/icons/EmailOutlined', '@material-ui/icons/Call', '@material-ui/core/Menu', '@material-ui/icons/Close', '@material-ui/icons/DirectionsOutlined', '@material-ui/icons/InsertLinkRounded', '@material-ui/icons/AddCircleOutlineRounded', '@material-ui/icons/RemoveCircleOutlineRounded', '@material-ui/icons/DoneOutline'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.reactSampleComponentsLibrary = {}, global.React, global.core, global.PropTypes, global.styles$1, global.ChevronRightIcon, global.FiberManualRecordIcon, global.NavigateNextIcon, global.KeyboardArrowDownIcon, global.SearchIcon, global.MenuIcon, global.Link, global.ArrowBackIosIcon, global.Modal, global.Backdrop, global.Fade, global.Button, global.Typography, global.Divider, global.TextField, global.Switch, global.Table, global.TableBody, global.TableCell, global.TableContainer, global.TableRow, global.Paper, global.Checkbox, global.CloseRoundedIcon, global.Grid, global.Container, global.ChevronLeftIcon, global.ImageGallery, global.Tooltip, global.IconButton, global.InputAdornment, global.Visibility, global.VisibilityOff, global.FormControl, global.Select, global.HelpRoundedIcon, global.Autocomplete, global.FormControlLabel, global.InfoIcon, global.AddRoundedIcon, global.ReactFlagsSelect, null, global.LockOutlinedIcon, global.parse, global.Card, global.CardActionArea, global.CardContent, global.CheckCircleIcon, global.PaymentOutlinedIcon, global.Accordion, global.AccordionSummary, global.AccordionDetails, global.CheckCircleRoundedIcon, global.KeyboardArrowDownRoundedIcon, global.CancelRoundedIcon, global.CircularProgress, global.MonetizationOnIcon, global.LocalShippingIcon, global.StorefrontIcon, global.PhoneInput, global.StorefrontRoundedIcon, global.LocalAtmRoundedIcon, global.CreditCardRoundedIcon, global.ScheduleRoundedIcon, global.MenuItem, global.MobileStepper, global.KeyboardArrowLeft, global.KeyboardArrowRight, global.SwipeableViews, global.reactSwipeableViewsUtils, global.Carousel, global.styled, global.ArrowForwardIosRoundedIcon, global.Lightbox, null, global.TableHead, global.InfoRoundedIcon, global.InfoOutlinedIcon, global.CheckCircleOutlineRoundedIcon, global.ArrowBackIosRoundedIcon, global.PlayArrowIcon, global.Avatar, global.AvatarGroup, global.CallMadeRoundedIcon, global.ModalVideo, global.PersonRoundedIcon, global.DateRangeRoundedIcon, global.DateRangeIcon, global.RemoveRedEyeOutlinedIcon, global.LocationOnRoundedIcon, global.AppBar, global.Tabs, global.Tab, global.Box, global.ExpandMoreIcon, global.PersonIcon, global.Breadcrumbs, null, global.FavoriteIcon, null, global.reactResponsiveCarousel, global.ArrowForwardRoundedIcon, global.CalendarIcon, global.ClockIcon, global.ArrowForwardIcon, global.LocationOnIcon, global.AttachMoneyRoundedIcon, global.FastfoodRoundedIcon, global.GroupRoundedIcon, global.EmailOutlinedIcon, global.CallIcon, global.Menu, global.CloseIcon, global.DirectionsOutlinedIcon, global.InsertLinkRoundedIcon, global.AddCircleOutlineRoundedIcon, global.RemoveCircleOutlineRoundedIcon, global.DoneOutlineIcon));
})(this, (function (exports, React, core, PropTypes, styles$1, ChevronRightIcon, FiberManualRecordIcon, NavigateNextIcon, KeyboardArrowDownIcon, SearchIcon, MenuIcon, Link, ArrowBackIosIcon, Modal, Backdrop, Fade, Button, Typography, Divider, TextField, Switch, Table, TableBody, TableCell, TableContainer, TableRow, Paper, Checkbox, CloseRoundedIcon, Grid, Container, ChevronLeftIcon, ImageGallery, Tooltip, IconButton, InputAdornment, Visibility, VisibilityOff, FormControl, Select, HelpRoundedIcon, Autocomplete, FormControlLabel, InfoIcon, AddRoundedIcon, ReactFlagsSelect, NumberFormat, LockOutlinedIcon, parse, Card, CardActionArea, CardContent, CheckCircleIcon, PaymentOutlinedIcon, Accordion, AccordionSummary, AccordionDetails, CheckCircleRoundedIcon, KeyboardArrowDownRoundedIcon, CancelRoundedIcon, CircularProgress, MonetizationOnIcon, LocalShippingIcon, StorefrontIcon, PhoneInput, StorefrontRoundedIcon, LocalAtmRoundedIcon, CreditCardRoundedIcon, ScheduleRoundedIcon, MenuItem, MobileStepper, KeyboardArrowLeft, KeyboardArrowRight, SwipeableViews, reactSwipeableViewsUtils, Carousel, styled, ArrowForwardIosRoundedIcon, Lightbox, style_css, TableHead, InfoRoundedIcon, InfoOutlinedIcon, CheckCircleOutlineRoundedIcon, ArrowBackIosRoundedIcon, PlayArrowIcon, Avatar, AvatarGroup, CallMadeRoundedIcon, ModalVideo, PersonRoundedIcon, DateRangeRoundedIcon, DateRangeIcon, RemoveRedEyeOutlinedIcon, LocationOnRoundedIcon, AppBar, Tabs, Tab, Box, ExpandMoreIcon, PersonIcon, Breadcrumbs, reactRouterDom, FavoriteIcon, carousel_min_css, reactResponsiveCarousel, ArrowForwardRoundedIcon, CalendarIcon, ClockIcon, ArrowForwardIcon, LocationOnIcon, AttachMoneyRoundedIcon, FastfoodRoundedIcon, GroupRoundedIcon, EmailOutlinedIcon, CallIcon, Menu, CloseIcon, DirectionsOutlinedIcon, InsertLinkRoundedIcon, AddCircleOutlineRoundedIcon, RemoveCircleOutlineRoundedIcon, DoneOutlineIcon) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
  var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
  var ChevronRightIcon__default = /*#__PURE__*/_interopDefaultLegacy(ChevronRightIcon);
  var FiberManualRecordIcon__default = /*#__PURE__*/_interopDefaultLegacy(FiberManualRecordIcon);
  var NavigateNextIcon__default = /*#__PURE__*/_interopDefaultLegacy(NavigateNextIcon);
  var KeyboardArrowDownIcon__default = /*#__PURE__*/_interopDefaultLegacy(KeyboardArrowDownIcon);
  var SearchIcon__default = /*#__PURE__*/_interopDefaultLegacy(SearchIcon);
  var MenuIcon__default = /*#__PURE__*/_interopDefaultLegacy(MenuIcon);
  var Link__default = /*#__PURE__*/_interopDefaultLegacy(Link);
  var ArrowBackIosIcon__default = /*#__PURE__*/_interopDefaultLegacy(ArrowBackIosIcon);
  var Modal__default = /*#__PURE__*/_interopDefaultLegacy(Modal);
  var Backdrop__default = /*#__PURE__*/_interopDefaultLegacy(Backdrop);
  var Fade__default = /*#__PURE__*/_interopDefaultLegacy(Fade);
  var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
  var Typography__default = /*#__PURE__*/_interopDefaultLegacy(Typography);
  var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);
  var TextField__default = /*#__PURE__*/_interopDefaultLegacy(TextField);
  var Switch__default = /*#__PURE__*/_interopDefaultLegacy(Switch);
  var Table__default = /*#__PURE__*/_interopDefaultLegacy(Table);
  var TableBody__default = /*#__PURE__*/_interopDefaultLegacy(TableBody);
  var TableCell__default = /*#__PURE__*/_interopDefaultLegacy(TableCell);
  var TableContainer__default = /*#__PURE__*/_interopDefaultLegacy(TableContainer);
  var TableRow__default = /*#__PURE__*/_interopDefaultLegacy(TableRow);
  var Paper__default = /*#__PURE__*/_interopDefaultLegacy(Paper);
  var Checkbox__default = /*#__PURE__*/_interopDefaultLegacy(Checkbox);
  var CloseRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(CloseRoundedIcon);
  var Grid__default = /*#__PURE__*/_interopDefaultLegacy(Grid);
  var Container__default = /*#__PURE__*/_interopDefaultLegacy(Container);
  var ChevronLeftIcon__default = /*#__PURE__*/_interopDefaultLegacy(ChevronLeftIcon);
  var ImageGallery__default = /*#__PURE__*/_interopDefaultLegacy(ImageGallery);
  var Tooltip__default = /*#__PURE__*/_interopDefaultLegacy(Tooltip);
  var IconButton__default = /*#__PURE__*/_interopDefaultLegacy(IconButton);
  var InputAdornment__default = /*#__PURE__*/_interopDefaultLegacy(InputAdornment);
  var Visibility__default = /*#__PURE__*/_interopDefaultLegacy(Visibility);
  var VisibilityOff__default = /*#__PURE__*/_interopDefaultLegacy(VisibilityOff);
  var FormControl__default = /*#__PURE__*/_interopDefaultLegacy(FormControl);
  var Select__default = /*#__PURE__*/_interopDefaultLegacy(Select);
  var HelpRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(HelpRoundedIcon);
  var Autocomplete__default = /*#__PURE__*/_interopDefaultLegacy(Autocomplete);
  var FormControlLabel__default = /*#__PURE__*/_interopDefaultLegacy(FormControlLabel);
  var InfoIcon__default = /*#__PURE__*/_interopDefaultLegacy(InfoIcon);
  var AddRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(AddRoundedIcon);
  var ReactFlagsSelect__default = /*#__PURE__*/_interopDefaultLegacy(ReactFlagsSelect);
  var LockOutlinedIcon__default = /*#__PURE__*/_interopDefaultLegacy(LockOutlinedIcon);
  var parse__default = /*#__PURE__*/_interopDefaultLegacy(parse);
  var Card__default = /*#__PURE__*/_interopDefaultLegacy(Card);
  var CardActionArea__default = /*#__PURE__*/_interopDefaultLegacy(CardActionArea);
  var CardContent__default = /*#__PURE__*/_interopDefaultLegacy(CardContent);
  var CheckCircleIcon__default = /*#__PURE__*/_interopDefaultLegacy(CheckCircleIcon);
  var PaymentOutlinedIcon__default = /*#__PURE__*/_interopDefaultLegacy(PaymentOutlinedIcon);
  var Accordion__default = /*#__PURE__*/_interopDefaultLegacy(Accordion);
  var AccordionSummary__default = /*#__PURE__*/_interopDefaultLegacy(AccordionSummary);
  var AccordionDetails__default = /*#__PURE__*/_interopDefaultLegacy(AccordionDetails);
  var CheckCircleRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(CheckCircleRoundedIcon);
  var KeyboardArrowDownRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(KeyboardArrowDownRoundedIcon);
  var CancelRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(CancelRoundedIcon);
  var CircularProgress__default = /*#__PURE__*/_interopDefaultLegacy(CircularProgress);
  var MonetizationOnIcon__default = /*#__PURE__*/_interopDefaultLegacy(MonetizationOnIcon);
  var LocalShippingIcon__default = /*#__PURE__*/_interopDefaultLegacy(LocalShippingIcon);
  var StorefrontIcon__default = /*#__PURE__*/_interopDefaultLegacy(StorefrontIcon);
  var PhoneInput__default = /*#__PURE__*/_interopDefaultLegacy(PhoneInput);
  var StorefrontRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(StorefrontRoundedIcon);
  var LocalAtmRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(LocalAtmRoundedIcon);
  var CreditCardRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(CreditCardRoundedIcon);
  var ScheduleRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(ScheduleRoundedIcon);
  var MenuItem__default = /*#__PURE__*/_interopDefaultLegacy(MenuItem);
  var MobileStepper__default = /*#__PURE__*/_interopDefaultLegacy(MobileStepper);
  var KeyboardArrowLeft__default = /*#__PURE__*/_interopDefaultLegacy(KeyboardArrowLeft);
  var KeyboardArrowRight__default = /*#__PURE__*/_interopDefaultLegacy(KeyboardArrowRight);
  var SwipeableViews__default = /*#__PURE__*/_interopDefaultLegacy(SwipeableViews);
  var Carousel__default = /*#__PURE__*/_interopDefaultLegacy(Carousel);
  var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
  var ArrowForwardIosRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(ArrowForwardIosRoundedIcon);
  var Lightbox__default = /*#__PURE__*/_interopDefaultLegacy(Lightbox);
  var TableHead__default = /*#__PURE__*/_interopDefaultLegacy(TableHead);
  var InfoRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(InfoRoundedIcon);
  var InfoOutlinedIcon__default = /*#__PURE__*/_interopDefaultLegacy(InfoOutlinedIcon);
  var CheckCircleOutlineRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(CheckCircleOutlineRoundedIcon);
  var ArrowBackIosRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(ArrowBackIosRoundedIcon);
  var PlayArrowIcon__default = /*#__PURE__*/_interopDefaultLegacy(PlayArrowIcon);
  var Avatar__default = /*#__PURE__*/_interopDefaultLegacy(Avatar);
  var AvatarGroup__default = /*#__PURE__*/_interopDefaultLegacy(AvatarGroup);
  var CallMadeRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(CallMadeRoundedIcon);
  var ModalVideo__default = /*#__PURE__*/_interopDefaultLegacy(ModalVideo);
  var PersonRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(PersonRoundedIcon);
  var DateRangeRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(DateRangeRoundedIcon);
  var DateRangeIcon__default = /*#__PURE__*/_interopDefaultLegacy(DateRangeIcon);
  var RemoveRedEyeOutlinedIcon__default = /*#__PURE__*/_interopDefaultLegacy(RemoveRedEyeOutlinedIcon);
  var LocationOnRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(LocationOnRoundedIcon);
  var AppBar__default = /*#__PURE__*/_interopDefaultLegacy(AppBar);
  var Tabs__default = /*#__PURE__*/_interopDefaultLegacy(Tabs);
  var Tab__default = /*#__PURE__*/_interopDefaultLegacy(Tab);
  var Box__default = /*#__PURE__*/_interopDefaultLegacy(Box);
  var ExpandMoreIcon__default = /*#__PURE__*/_interopDefaultLegacy(ExpandMoreIcon);
  var PersonIcon__default = /*#__PURE__*/_interopDefaultLegacy(PersonIcon);
  var Breadcrumbs__default = /*#__PURE__*/_interopDefaultLegacy(Breadcrumbs);
  var FavoriteIcon__default = /*#__PURE__*/_interopDefaultLegacy(FavoriteIcon);
  var ArrowForwardRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(ArrowForwardRoundedIcon);
  var CalendarIcon__default = /*#__PURE__*/_interopDefaultLegacy(CalendarIcon);
  var ClockIcon__default = /*#__PURE__*/_interopDefaultLegacy(ClockIcon);
  var ArrowForwardIcon__default = /*#__PURE__*/_interopDefaultLegacy(ArrowForwardIcon);
  var LocationOnIcon__default = /*#__PURE__*/_interopDefaultLegacy(LocationOnIcon);
  var AttachMoneyRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(AttachMoneyRoundedIcon);
  var FastfoodRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(FastfoodRoundedIcon);
  var GroupRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(GroupRoundedIcon);
  var EmailOutlinedIcon__default = /*#__PURE__*/_interopDefaultLegacy(EmailOutlinedIcon);
  var CallIcon__default = /*#__PURE__*/_interopDefaultLegacy(CallIcon);
  var Menu__default = /*#__PURE__*/_interopDefaultLegacy(Menu);
  var CloseIcon__default = /*#__PURE__*/_interopDefaultLegacy(CloseIcon);
  var DirectionsOutlinedIcon__default = /*#__PURE__*/_interopDefaultLegacy(DirectionsOutlinedIcon);
  var InsertLinkRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(InsertLinkRoundedIcon);
  var AddCircleOutlineRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(AddCircleOutlineRoundedIcon);
  var RemoveCircleOutlineRoundedIcon__default = /*#__PURE__*/_interopDefaultLegacy(RemoveCircleOutlineRoundedIcon);
  var DoneOutlineIcon__default = /*#__PURE__*/_interopDefaultLegacy(DoneOutlineIcon);

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
      raw = strings.slice(0);
    }

    return Object.freeze(Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw)
      }
    }));
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;

    var _s, _e;

    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function styleInject(css, ref) {
    if ( ref === void 0 ) ref = {};
    var insertAt = ref.insertAt;

    if (!css || typeof document === 'undefined') { return; }

    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';

    if (insertAt === 'top') {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }

  var css_248z$1t = "@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");body{font-family:Poppins,sans-serif}input:-webkit-autofill,input:-webkit-autofill:active,input:-webkit-autofill:focus,input:-webkit-autofill:hover{-webkit-box-shadow:0 0 0 30px #fff inset!important}";
  styleInject(css_248z$1t);

  var css_248z$1s = "@media (min-width:1280px){.PublishStepsContainer .MuiContainer-maxWidthLg{max-width:1140px}}.PublishStepsContainer{padding-top:45px}.PublishStepsContainer .MuiTabs-root.MuiTabs-vertical{width:263px;float:left;margin-right:30px}.PublishStepsContainer button{font-family:Poppins,sans-serif;font-size:14px;border-right:1px solid rgba(0,0,0,.0902);min-height:48px;text-transform:none;font-weight:500;color:#4c5e67;opacity:1!important}.PublishStepsContainer button .MuiTab-wrapper{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.PublishStepsContainer button.Mui-selected{color:#2a8853;-webkit-box-shadow:0 1px 4px rgba(0,0,0,.0902);box-shadow:0 1px 4px rgba(0,0,0,.0902);border:1px solid #f5f5f5}.PrivateTabIndicator-vertical-16{background-color:#2a8853!important}.PublishStepsContainer button.Mui-selected{border-bottom:1px solid rgba(0,0,0,.0902)}.PublishStepsContainer .left263{width:263px}.PublishStepsContainer .publishHeader{text-align:center}.PublishStepsContainer .publishHeader .publishTitle{color:#1b2121;font-size:20px;font-family:Poppins,sans-serif;font-weight:600;line-height:1;margin-bottom:10px}.PublishStepsContainer .publishHeader .publishPlainText{color:#4c5e67;font-size:14px;font-family:Poppins,sans-serif}.tabpanel{width:calc(100% - 263px);display:table-cell}.panelItem{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;border-top:1px solid rgba(0,0,0,.05882);padding:20px 0;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.panelItem,.panelItem .panel-sub-header{display:-webkit-box;display:-ms-flexbox;display:flex}.panelItem .panelItem-icon p{color:#eeb000;background-color:#fbf7ee;width:40px;height:40px;line-height:40px;text-align:center;border-radius:41px;font-size:20px;font-family:Poppins,sans-serif;font-weight:500}.panelItem-details{padding:0 15px}.panelItem-details .panelItem-heading{color:#1b2121;font-size:16px;font-family:Poppins,sans-serif}.panelItem-details .panelItem-detail-text{font-size:12px;color:#b0b9c1;font-family:Poppins,sans-serif}.publishTopContainer{margin-bottom:25px}.reviewBtn{background-color:#e4e8ec;color:#fff!important;font-size:14px;font-family:Poppins,sans-serif;margin-top:20px!important}.panelItem:last-child{border-bottom:1px solid rgba(0,0,0,.05882)}.PublishStepsContainer button svg{color:#f2eafd;margin-right:10px;margin-bottom:0!important}.PublishStepsContainer button{opacity:.4}.tabpanel .MuiBox-root{padding-left:0!important;padding-right:0!important}@media (max-width:820px){.PublishStepsContainer .MuiTabs-root.MuiTabs-vertical{width:100%;float:none;margin-right:0}.PublishStepsContainer button{width:100%;display:block;max-width:none}.panelItem .panelItem-icon p{margin-right:20px}}@media (max-width:600px){.PublishStepsContainer .MuiTabs-root.MuiTabs-vertical{width:100%}.PublishStepsContainer button{max-width:100%}.tabpanel div.MuiBox-root{padding:0}.tabpanel{padding-top:20px}.tabpanel .panelItem{padding:20px 0!important}.panelItem-details{padding-left:10px!important}}@media (min-width:992px){.PublishStepsContainer .publishHeader .publishPlainText{max-width:650px;margin:0 auto}}";
  styleInject(css_248z$1s);

  var _excluded$3 = ["children", "value", "index"];

  function TabPanel$3(props) {
    var children = props.children,
        value = props.value,
        index = props.index,
        other = _objectWithoutProperties(props, _excluded$3);

    return /*#__PURE__*/React__default["default"].createElement("div", _extends({
      role: "tabpanel",
      hidden: value !== index,
      id: "vertical-tabpanel-".concat(index),
      "aria-labelledby": "vertical-tab-".concat(index)
    }, other), value === index && /*#__PURE__*/React__default["default"].createElement(core.Box, {
      p: 3
    }, /*#__PURE__*/React__default["default"].createElement(core.Typography, null, children)));
  }

  TabPanel$3.propTypes = {
    children: PropTypes__default["default"].node,
    index: PropTypes__default["default"].any.isRequired,
    value: PropTypes__default["default"].any.isRequired
  };

  function a11yProps$3(index) {
    return {
      id: "vertical-tab-".concat(index),
      'aria-controls': "vertical-tabpanel-".concat(index)
    };
  }

  var useStyles$4 = styles$1.makeStyles(function (theme) {
    return {
      root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        height: 224
      },
      tabs: {
        borderRight: "1px solid ".concat(theme.palette.divider)
      }
    };
  });

  function VerticalTabs(props) {
    useStyles$4();

    var _React$useState = React__default["default"].useState(0),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        value = _React$useState2[0],
        setValue = _React$useState2[1];

    var handleChange = function handleChange(event, newValue) {
      setValue(newValue);
    };

    return /*#__PURE__*/React__default["default"].createElement(core.Box, {
      className: "PublishStepsContainer"
    }, /*#__PURE__*/React__default["default"].createElement(core.Container, {
      maxWidth: "lg"
    }, /*#__PURE__*/React__default["default"].createElement(core.Tabs, {
      orientation: "vertical",
      variant: "scrollable",
      value: value,
      onChange: handleChange,
      "aria-label": "Vertical tabs example"
    }, props.tabItems && props.tabItems.length ? props.tabItems.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(core.Tab, _extends({
        key: i,
        label: item.title,
        icon: /*#__PURE__*/React__default["default"].createElement(FiberManualRecordIcon__default["default"], null)
      }, a11yProps$3(i)));
    }) : null), props.tabItems && props.tabItems.length ? props.tabItems.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(TabPanel$3, {
        key: i,
        value: value,
        index: i,
        className: "tabpanel"
      }, item.component);
    }) : null));
  }

  VerticalTabs.propTypes = {
    tabItems: PropTypes__default["default"].array
  };

  var css_248z$1r = ".ProgressBarContainer{background:#f7f9fa;position:relative;overflow:auto;padding:30px 0 36px}.ProgressBarContainer .MuiListItem-root{padding:0}.status-content{overflow:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;padding:5px 0}.statusContainer{width:100%;display:inline-block;position:relative;top:10px}.statusBtn{bottom:10px;position:relative;text-align:right;margin-left:56px}.statusBtn,.statusBtn .viewBtn{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.statusBtn .viewBtn{margin-right:8px;color:#1b2121;width:124px;height:40px;padding:0}.statusBtn .viewBtn span{font-family:Poppins,sans-serif;font-size:14px;font-weight:500}.statusBtn .editBtn{color:#2a8853;width:172px;height:40px;padding:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.statusBtn button{background:#fff;font-family:Poppins,sans-serif;font-size:14px;border:none;-webkit-box-shadow:0 0 10px rgba(0,0,0,.0902);box-shadow:0 0 10px rgba(0,0,0,.0902)}.statusBtn button:hover{background:#fff}.progressRow .MuiLinearProgress-bar{background-color:#2a8853!important}.ProgressBarContainer .progressRow{background-color:rgba(42,136,83,.16078)}.ProgressBarContainer .sponsor-text2{color:#1b2121;font-family:Poppins,sans-serif;font-size:24px;display:inline-block;margin-bottom:10px;letter-spacing:0;font-weight:500;margin-top:-12px;line-height:26px}.ProgressBarContainer .raised-text{color:#4c5e67;font-size:14px;font-family:Poppins,sans-serif;font-weight:400;margin-top:3px}.ProgressBarContainer .raised-text span{font-family:Poppins,sans-serif;font-weight:600}.ProgressBarContainer .MuiListItem-gutters{padding-left:0;padding-right:0;font-family:Poppins,sans-serif;font-weight:400;font-size:14px}.ProgressBarContainer .active-breadcrumb{color:#2a8853;font-family:Poppins,sans-serif;font-weight:400;font-size:14px}.MuiTabs-indicator{background-color:#2a8853}.ProgressBarContainer .t_container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ProgressBarContainer .title_section{width:65%}@media (max-width:991px){.status-content{display:block}.status-content .statusContainer{width:100%}.status-content .statusBtn{float:left;margin-top:15px}.ProgressBarContainer .sponsor-text2{margin-top:0;margin-bottom:0}.ProgressBarContainer .title_section{width:100%}.statusBtn{bottom:0;position:relative;width:100%;text-align:left;margin-top:20px;margin-left:0}.ProgressBarContainer .t_container{display:block;-webkit-box-align:center;-ms-flex-align:center;align-items:center}}@media (min-width:992px){.sponsor-text2{position:relative;top:15px}}@media (min-width:1280px){.ProgressBarContainer .MuiContainer-maxWidthLg{max-width:1140px}}@media (max-width:768px){.statusBtn{float:none;position:relative;display:block}.statusBtn .viewBtn{margin-right:0;color:#1b2121;width:100%;margin-bottom:18px;margin-top:8px}.statusBtn .editBtn{color:#2a8853;width:100%}}";
  styleInject(css_248z$1r);

  function SubHeader(props) {
    var buttonsItems = props.buttonsItems,
        onButtonClick = props.onButtonClick,
        showProgressBar = props.showProgressBar,
        secondHeading = props.secondHeading,
        amountHeading = props.amountHeading,
        progressPercentage = props.progressPercentage,
        breadcrumbsItems = props.breadcrumbsItems,
        onBreadcrumbClick = props.onBreadcrumbClick;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(core.Box, {
      className: "ProgressBarContainer"
    }, /*#__PURE__*/React__default["default"].createElement(core.Container, {
      maxWidth: "lg"
    }, breadcrumbsItems && breadcrumbsItems.length ? /*#__PURE__*/React__default["default"].createElement(core.Breadcrumbs, {
      separator: /*#__PURE__*/React__default["default"].createElement(NavigateNextIcon__default["default"], {
        fontSize: "small"
      }),
      "aria-label": "breadcrumb"
    }, breadcrumbsItems.map(function (item, i) {
      return item.current ? /*#__PURE__*/React__default["default"].createElement(core.Typography, {
        key: i,
        color: "textPrimary",
        className: "active-breadcrumb"
      }, item.title) : /*#__PURE__*/React__default["default"].createElement(core.ListItem, {
        key: i,
        color: "inherit",
        onClick: function onClick() {
          return onBreadcrumbClick(item.path);
        }
      }, " ", item.title, " ");
    })) : null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "t_container"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "title_section"
    }, /*#__PURE__*/React__default["default"].createElement(core.Typography, {
      variant: "body1",
      gutterBottom: true,
      className: "sponsor-text2"
    }, props.sponsorTitle), /*#__PURE__*/React__default["default"].createElement(core.Box, {
      className: "statusContainer"
    }, showProgressBar && /*#__PURE__*/React__default["default"].createElement(core.LinearProgress, {
      className: "progressRow",
      variant: "determinate",
      value: progressPercentage
    }), /*#__PURE__*/React__default["default"].createElement(core.Typography, {
      variant: "body1",
      gutterBottom: true,
      className: "raised-text"
    }, /*#__PURE__*/React__default["default"].createElement("span", null, amountHeading), " ", secondHeading))), /*#__PURE__*/React__default["default"].createElement(core.Box, {
      className: "statusBtn"
    }, buttonsItems && buttonsItems.length ? buttonsItems.map(function (btn, i) {
      return /*#__PURE__*/React__default["default"].createElement(core.Button, {
        key: i,
        variant: "outlined",
        className: btn["class"],
        startIcon: btn.icon,
        onClick: function onClick() {
          return onButtonClick(btn.path);
        }
      }, btn.title);
    }) : null)))));
  }

  SubHeader.propTypes = {
    onButtonClick: PropTypes__default["default"].func,
    buttonsItems: PropTypes__default["default"].array,
    showProgressBar: PropTypes__default["default"].bool,
    progressPercentage: PropTypes__default["default"].number,
    sponsorTitle: PropTypes__default["default"].string,
    amountHeading: PropTypes__default["default"].string,
    secondHeading: PropTypes__default["default"].string,
    onBreadcrumbClick: PropTypes__default["default"].func,
    breadcrumbsItems: PropTypes__default["default"].array
  };

  var css_248z$1q = ".headerContainer{height:80px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-shadow:0 4px 2px -2px rgba(0,0,0,.05882);box-shadow:0 4px 2px -2px rgba(0,0,0,.05882);position:relative;background-color:#fff}.headerContainer .logo{display:inline-block}.headerContainer .header-menu-links{display:inline-block;margin-left:22px;position:relative;bottom:12px}.headerContainer .header-menu-links .menu-li-container{display:-webkit-box;display:-ms-flexbox;display:flex}.headerContainer .header-menu-links p li{color:#1b2121;font-size:14px;font-family:Poppins,sans-serif;font-weight:500;text-decoration:none;padding:0 10px;width:unset;cursor:pointer;letter-spacing:.56px}.headerContainer .header-menu-links p li svg{color:#4c5e67;width:20px}.headerContainer .profile-dropdown{float:right;font-family:Roboto,sans-serif;font-size:15px;font-weight:600;position:relative}.headerContainer .profile-dropdown,.headerContainer .profile-dropdown span{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.headerContainer .profile-dropdown span{background:#1b2121;color:#fff;width:40px;height:40px;text-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:100px}.headerContainer .profile-dropdown svg{color:#4c5e67}.headerContainer .profile-dropdown-submenus{width:256px;display:inline-block;position:absolute;border:1px solid #e8e9e9;-webkit-box-shadow:0 0 10px #fff;box-shadow:0 0 10px #fff;border-radius:3px;background:#fff;padding:10px 0;right:-10px;top:55px}.headerContainer .profile-dropdown-submenus p li{display:block;color:#1b2121;font-family:Poppins;text-decoration:none;font-size:14px;padding:7px 10px}.headerContainer .profile-dropdown-submenus p li:hover{background:#f7f9fa;cursor:pointer}.profile-dropdown .profile-dropdown-submenus .top-arrow{width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-bottom:5px solid #d2d2d2;position:absolute;top:-5px;left:78%}.headerContainer .header-searchbar{position:absolute;max-width:1140px;width:100%;background:#fff;top:15px;max-width:1092px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.headerContainer .header-searchbar div{width:100%;font-family:Poppins,sans-serif;font-size:16px}.headerContainer .header-searchbar img{position:absolute;top:20px}.headerContainer .header-searchbar .MuiInput-underline,.headerContainer .header-searchbar label{padding-left:30px}.headerContainer .header-searchbar div label{color:#b0b9c1}.header-searchbar .MuiInput-underline:before{border-bottom:none}.header-searchbar .MuiInput-underline:after{border-bottom:2px solid #2a8853}.header-searchbar .searchBtn{height:36px;width:116px;font-size:14px;font-family:Poppins,sans-serif;font-weight:500;border-radius:2px}.header-searchbar .searchBtn,.header-searchbar .searchBtn:hover{background-color:#2a8853;color:#fff}.mob-header-bar{background-color:#fff!important;padding:0 0 10px}.mob-header-bar .MuiToolbar-regular,.mob-header-bar .top-mob-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.mob-header-bar .top-mob-container{width:100%}.mob-header-bar .top-mob-container .logo{padding-top:10px}.mob-header-bar .header-menu-links li{width:100%;color:#000;text-decoration:none;font-size:14px;font-family:Poppins,sans-serif;padding:10px 0 8px;border-bottom:1px solid #fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.mob-header-bar .header-menu-links p{padding-left:20px;padding-right:20px}.mob-header-bar .header-menu-links p a{font-size:14px;color:#1b2121;padding:15px 18px;position:relative;cursor:pointer;text-transform:uppercase;display:block;text-align:left}.mob-header-bar .header-menu-links p a svg{position:absolute;right:0}.mob-header-bar .mob-search{position:relative}.mob-header-bar .mob-search svg{position:absolute;top:20px}.mob-header-bar .mob-search div{width:100%}.mob-header-bar .mob-search input,.mob-header-bar .mob-search label{color:#fff;padding-left:25px;font-family:Poppins,sans-serif}.mob-header-bar .mob-search .MuiInput-underline:before{border-bottom:1px solid #fff!important}.mob-header-bar .mob-search .MuiInput-underline:after{border-bottom:2px solid #fff}.mob-header-bar .mob-search input{color:#fff}.header_button_col .signup_btn{color:#1b2121;font-size:14px;font-family:Poppins,sans-serif;font-weight:500;text-decoration:none;padding:0 16px;width:unset;cursor:pointer;letter-spacing:.56px}.header_button_col{float:right}.header_button_col .login_button{width:104px;height:36px;background:#2a8853 0 0 no-repeat padding-box;border-radius:2px;color:#fff;font-size:14px;font-family:Poppins,sans-serif;font-weight:500}@media (max-width:850px){.headerContainer{display:none}.mob-header-bar .top-mob-container .logo img{width:100%}.mob-header-bar .top-mob-container .logo{max-width:160px}}@media (min-width:851px){.mob-header-bar{display:none!important}}@media (min-width:1280px){.headerContainer .MuiContainer-maxWidthLg{max-width:1140px}}";
  styleInject(css_248z$1q);

  function Header(props) {
    var _useState = React.useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        showDropdownItems = _useState2[0],
        setshowDropdownItems = _useState2[1];

    var _useState3 = React.useState(false),
        _useState4 = _slicedToArray(_useState3, 2),
        showSearchInput = _useState4[0],
        setshowSearchInput = _useState4[1];

    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(core.AppBar, {
      position: "static",
      className: "mob-header-bar"
    }, /*#__PURE__*/React__default["default"].createElement(core.Toolbar, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "top-mob-container"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "logo"
    }, /*#__PURE__*/React__default["default"].createElement("a", {
      to: "/"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.logo,
      alt: "logo"
    }))), /*#__PURE__*/React__default["default"].createElement(core.IconButton, {
      edge: "start",
      color: "inherit",
      "aria-label": "menu"
    }, /*#__PURE__*/React__default["default"].createElement(MenuIcon__default["default"], null)))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "header-menu-links"
    }, /*#__PURE__*/React__default["default"].createElement(core.Typography, {
      className: "menu-li-container"
    }, props.headerItems && props.headerItems.length ? props.headerItems.map(function (item, i) {
      if (item.title !== "Search") {
        return /*#__PURE__*/React__default["default"].createElement(core.ListItem, {
          key: i,
          onClick: function onClick() {
            return props.navigate(item.path);
          }
        }, item.icon, " ", item.title, " ", item.children && item.children.length ? /*#__PURE__*/React__default["default"].createElement(KeyboardArrowDownIcon__default["default"], null) : null, " ");
      }
    }) : null, props.showSearchInput && /*#__PURE__*/React__default["default"].createElement("form", {
      noValidate: true,
      autoComplete: "off",
      className: "mob-search"
    }, /*#__PURE__*/React__default["default"].createElement(SearchIcon__default["default"], null), " ", /*#__PURE__*/React__default["default"].createElement(core.TextField, {
      id: "standard-basic",
      label: "Standard"
    }))))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "headerContainer"
    }, /*#__PURE__*/React__default["default"].createElement(core.Container, {
      maxWidth: "lg"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "logo"
    }, /*#__PURE__*/React__default["default"].createElement("a", {
      href: "/"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.logo,
      alt: "logo"
    }))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "header-menu-links"
    }, /*#__PURE__*/React__default["default"].createElement(core.Typography, {
      className: "menu-li-container"
    }, props.headerItems && props.headerItems.length ? props.headerItems.map(function (item) {
      return /*#__PURE__*/React__default["default"].createElement(core.ListItem, {
        onClick: function onClick() {
          return item.title === "Search" ? setshowSearchInput(true) : props.navigate(item.path);
        }
      }, item.icon, " ", item.title, " ", item.children && item.children.length ? /*#__PURE__*/React__default["default"].createElement(KeyboardArrowDownIcon__default["default"], null) : null, " ");
    }) : null)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "profile-dropdown"
    }, /*#__PURE__*/React__default["default"].createElement("span", null, "AN"), " ", /*#__PURE__*/React__default["default"].createElement(KeyboardArrowDownIcon__default["default"], {
      onClick: function onClick() {
        return setshowDropdownItems(!showDropdownItems);
      }
    }), showDropdownItems && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "profile-dropdown-submenus"
    }, /*#__PURE__*/React__default["default"].createElement(core.Box, {
      className: "top-arrow"
    }, " "), /*#__PURE__*/React__default["default"].createElement(core.Typography, null, props.dropdownItems && props.dropdownItems.length ? props.dropdownItems.map(function (item) {
      return /*#__PURE__*/React__default["default"].createElement(core.ListItem, {
        onClick: function onClick() {
          return props.navigate(item.path);
        }
      }, item.title);
    }) : null))), showSearchInput && /*#__PURE__*/React__default["default"].createElement("form", {
      noValidate: true,
      autoComplete: "off",
      className: "header-searchbar"
    }, /*#__PURE__*/React__default["default"].createElement(SearchIcon__default["default"], null), /*#__PURE__*/React__default["default"].createElement(core.TextField, {
      id: "standard-basic",
      label: "Find fundraiser by name or location",
      onFocus: function onFocus() {
        return setshowSearchInput(true);
      },
      onBlur: function onBlur() {
        return setshowSearchInput(false);
      }
    }), /*#__PURE__*/React__default["default"].createElement(core.Button, {
      variant: "contained",
      className: "searchBtn"
    }, "SEARCH")), props.headerSignupButton && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "header_button_col"
    }, /*#__PURE__*/React__default["default"].createElement(core.Button, {
      className: "signup_btn"
    }, "Sign up"), /*#__PURE__*/React__default["default"].createElement(core.Button, {
      className: "login_button"
    }, "login")))));
  }

  Header.propTypes = {
    headerItems: PropTypes__default["default"].array,
    showSearchInput: PropTypes__default["default"].bool,
    dropdownItems: PropTypes__default["default"].array,
    navigate: PropTypes__default["default"].func
  };

  var css_248z$1p = ".SuccessAlertContainer{color:#fff;height:80px;line-height:92px}.SuccessAlertContainer .SuccessAlertText{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.SuccessAlertContainer .SuccessAlertcheckText{display:inline-block;position:relative;bottom:6px;left:10px;font-family:Poppins,sans-serif;font-size:14px}.SuccessAlertContainer .SuccessAlertcrossImg{cursor:pointer}";
  styleInject(css_248z$1p);

  function Alert(props) {
    var closeIcon = props.closeIcon,
        doneIcon = props.doneIcon;
        props.onCloseClick;

    var _React$useState = React__default["default"].useState(true),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        showElement = _React$useState2[0],
        setShowElement = _React$useState2[1];

    React.useEffect(function () {
      setTimeout(function () {
        setShowElement(false);
      }, props.AlertDuration);
    }, []);

    var _useState = React.useState(true),
        _useState2 = _slicedToArray(_useState, 2),
        show = _useState2[0],
        setShow = _useState2[1];

    return /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, showElement ? /*#__PURE__*/React__default["default"].createElement("div", null, show ? /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SuccessAlertContainer",
      style: {
        backgroundColor: props.backgroundColor
      }
    }, /*#__PURE__*/React__default["default"].createElement(core.Container, {
      maxWidth: "lg"
    }, /*#__PURE__*/React__default["default"].createElement(core.Box, {
      className: "SuccessAlertText"
    }, /*#__PURE__*/React__default["default"].createElement(core.Box, null, /*#__PURE__*/React__default["default"].createElement("img", {
      src: doneIcon,
      alt: "check"
    }), /*#__PURE__*/React__default["default"].createElement(core.Typography, {
      variant: "body1",
      className: "SuccessAlertcheckText"
    }, props.message)), /*#__PURE__*/React__default["default"].createElement(core.Box, {
      className: "SuccessAlertcrossImg"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: closeIcon,
      alt: "cancel",
      onClick: function onClick() {
        return setShow(false);
      }
    }))))) : null) : /*#__PURE__*/React__default["default"].createElement("div", null), " ");
  }

  Alert.propTypes = {
    message: PropTypes__default["default"].string,
    onCloseClick: PropTypes__default["default"].func,
    show: PropTypes__default["default"].bool
  };

  var css_248z$1o = ".integration-detail-breadcrumb{background-color:#f7f8fa}.integration-detail-breadcrumb li a{color:#4d4d4d;font-size:14px;font-weight:500}.integration-detail-breadcrumb li a.active-breadcrumb{color:#7266fb}.integration-detail-section{padding:30px 0}.integration-detail-section .back-link{color:#4d4d4d;font-size:14px;font-family:Poppins,sans-serif;font-weight:600;display:block;margin-top:10px;margin-bottom:20px}.integration-detail-section .back-link svg{font-weight:600;font-size:18px;position:relative;top:4px;margin-right:3px}.integration-detail-section .detail-dp{background-color:#05ce78;border-radius:4px;height:262px;margin:10px 0 0;width:100%}.integration-detail-section .detail-dp,.integration-detail-section .detail-dp .dp-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.integration-detail-section .detail-dp .dp-container{margin:0 auto;text-align:center;background-color:#fff;padding:0;border-radius:8px;width:112px;height:112px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.integration-detail-section .detail-dp .dp-container img{width:68px;height:68px}.integration-detail-section .pricing-btn{background-color:#7266fb;color:#fff;border-radius:25px;font-size:14px;font-family:Poppins,sans-serif;width:100%;height:43px;margin-top:30px}.integration-detail-section .pricing-btn:hover{background-color:#7266fb}.integration-detail-section .view-web-btn{border:1px solid #e8e9e9;width:100%;height:43px;margin-top:20px;font-size:14px;font-family:Poppins,sans-serif;background:none;-webkit-box-shadow:none;box-shadow:none;border-radius:25px;color:#7266fb}.integration-detail-section .view-web-btn:hover{background-color:#7266fb!important;color:#fff;border:1px solid #7266fb}.integration-detail-section .view-web-btn .fa{color:#d3d8da}.integration-detail-section .compatible-section,.integration-detail-section .distance-top{margin-top:30px}.integration-detail-section .compatible-section .compatible-t{color:#4d4d4d;font-size:18px;font-family:Poppins,sans-serif;font-weight:700}.integration-detail-section .compatible-section .tags{font-size:14px;color:#4d4d4d;font-family:Poppins,sans-serif;background-color:#f7f8fa;padding:10px 16px;border-radius:5px;display:inline-block;margin:5px;font-weight:500}.integration-detail-section .integration-detail-content{margin-top:8px}.integration-detail-section .integration-detail-content .integ-t{color:#4d4d4d;font-family:Poppins,sans-serif;font-weight:700;font-size:26px}.integration-detail-section .integration-detail-content .integ-text{color:#818e94;line-height:34px;font-family:Poppins,sans-serif;font-size:18px;margin-top:10px}.integration-detail-section .integration-feature{margin-top:25px}.integration-detail-section .integration-feature .feature-t{color:#4d4d4d;font-size:18px;font-family:Poppins,sans-serif;font-weight:700}.integration-detail-section .feature-content{display:-webkit-box;display:-ms-flexbox;display:flex;margin:20px 0}.integration-detail-section .feature-content img{width:24px;height:24px;margin-right:8px}.integration-detail-section .feature-content .feature-h{color:#4d4d4d;font-size:16px;font-weight:500;font-family:Poppins,sans-serif}.integration-detail-section .feature-content .feature-b{color:#818e94;font-size:14px;line-height:1.6}.tag_row{margin-left:-5px;margin-top:15px}.pricing-modal-parent{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.pricing-modal{background-color:#fff;text-align:center;width:100%;position:relative;max-width:1140px;overflow-y:auto}.pricing-modal .modal-pricing-table tbody{display:block!important;overflow-y:overlay;overflow-x:hidden}.pricing-modal .kiosk-pricing-modal.modal-pricing-table tbody{display:block!important;max-height:190px!important;overflow-y:overlay;overflow-x:hidden}@media (max-width:670px){.modal-pricing-table.kiosk-pricing-modal{overflow-x:auto!important;width:650px!important}}@media (max-width:1366px){.pricing-modal{height:580px!important}}@media (max-width:960px){.modal-select-btn,.pricing-modal .select-btn{width:90%!important}}.scrollbar-width-none{scrollbar-width:none}.modal-pricing-table thead,.pricing-modal .modal-pricing-table tbody tr,.pricing-modal .modal-pricing-table tfoot{display:table!important;width:100%;table-layout:fixed!important}@media (min-width:1400px){.pricing-modal{max-height:880px!important}.pricing-modal.deenfund-pricing-modal{height:834px}.pricing-modal.deenfund-pricing-modal .modal-pricing-table{overflow-x:hidden}.pricing-modal .kiosk-pricing-modal.modal-pricing-table tbody{max-height:304px!important}}.pricing-modal .modal-pricing-table tbody::-webkit-scrollbar,.pricing-modal::-webkit-scrollbar{width:6px;height:6px}.pricing-modal .modal-pricing-table tbody::-webkit-scrollbar-track,.pricing-modal::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 5px grey;box-shadow:inset 0 0 5px grey;border-radius:10px}.pricing-modal .modal-pricing-table tbody::-webkit-scrollbar-thumb,.pricing-modal::-webkit-scrollbar-thumb{background:#737272;border-radius:10px}.pricing-modal .modal-pricing-table tbody::-webkit-scrollbar-thumb:hover,.pricing-modal::-webkit-scrollbar-thumb:hover{background:#737272}.pricing-modal .close_icon{position:absolute;right:30px;top:23px;color:#818e94;cursor:pointer;font-size:24px;z-index:1000!important}.pricing-modal .td-price,.pricing-modal td{font-family:Poppins,sans-serif}.pricing-modal .td-price{font-weight:500}.pricing-modal .MuiCheckbox-root{padding:6px}.pricing-modal .coming_soon{color:#818e94}.pricing-modal:focus{outline:none}.top_img_popup{margin-top:18px;width:127px}.pricing-modal .top-label{text-align:center;color:#818e94;font-family:Poppins,sans-serif;font-size:12px;margin-bottom:18px}.modal-label{font-size:18px!important;font-weight:700!important}.modal-label,.modal-label-price{color:#4d4d4d!important;font-family:Poppins,sans-serif!important;margin:5px auto!important}.modal-label-price{font-size:26px!important;font-weight:500!important}.modal-label-plan{color:#818e94!important;font-size:14px!important;margin:5px auto 20px!important}.modal-select-btn{background-color:#7266fb!important;color:#fff!important;border-radius:25px!important;height:36px;width:148px;margin-bottom:8px!important}.modal-pricing-table::-webkit-scrollbar{width:6px;height:6px}.modal-pricing-table::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 5px grey;box-shadow:inset 0 0 5px grey;border-radius:10px}.modal-pricing-table::-webkit-scrollbar-thumb{background:#737272;border-radius:10px}.modal-pricing-table::-webkit-scrollbar-thumb:hover{background:#737272}.modal-pricing-table{height:auto;-webkit-box-shadow:none;box-shadow:none}.modal-pricing-table table{border-collapse:collapse}.modal-pricing-table td,.modal-pricing-table th{position:relative;border:1px solid #e4e8ec}.most-left p{display:contents;font-weight:500;font-size:14px}.most-left img{position:absolute;right:10px}.MuiCheckbox-root{color:#4d4d4d!important}.Mui-checked{color:#05ce78!important}.monthly-l{color:#7266fb;font-size:14px;font-weight:500}.billed-a,.monthly-l{font-family:Poppins,sans-serif}.billed-a{color:#4d4d4d;display:inline-block;font-weight:600}.save-t{float:right;margin-right:31px;color:#05ce78;font-weight:400;padding-top:3px}.monthly-left{color:#4d4d4d;font-size:14px}td.MuiTableCell-root.MuiTableCell-body.most-left{min-width:280px}.package_card{cursor:pointer;height:100px}.modal_info_icon{position:relative;top:7px}.pricing-modal .MuiTableCell-root{padding:14px 22px!important}@media (max-width:600px){.integration-detail-section .detail-dp{margin:20px auto 10px}.integration-detail-breadcrumb li a{font-size:12px}.integration-detail-section .integration-detail-content .integ-text{font-size:14px}}@media (max-width:650px){.integration-detail-section .view-web-btn{font-size:12px}}";
  styleInject(css_248z$1o);

  var css_248z$1n = "@import \"~react-image-gallery/styles/css/image-gallery.css\";.pricing-modal-parent{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.hardware-details-modal{background-color:#fff;text-align:left;width:100%;position:relative;max-width:1140px;height:630px;overflow-y:auto;margin-left:20px;outline:none;border-radius:4px}.hd-title{color:#4d4d4d;font-family:Poppins,sans-serif;font-weight:600;font-size:18px;display:block;text-align:center}.model_backBtn{position:absolute}.hardware-details-modal::-webkit-scrollbar{width:6px;height:6px}.hardware-details-modal::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 5px grey;box-shadow:inset 0 0 5px grey;border-radius:10px}.hardware-details-modal::-webkit-scrollbar-thumb{background:#737272;border-radius:10px}.hardware-details-modal::-webkit-scrollbar-thumb:hover{background:#737272}.hardware-details-modal .close_icon{color:#818e94;cursor:pointer;font-size:24px;position:absolute;top:30px;right:30px}.hardware-details-modal .top-label{color:#818e94;font-family:Poppins,sans-serif;font-size:12px;padding-bottom:18px;margin-top:5px;text-align:center}.hardware-top-section{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding-top:24px;padding-right:10px}.hardware-top-section,.hardware-top-section button{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.hardware-top-section button{border-radius:25px;position:absolute;left:50px;width:86px;height:36px;display:-webkit-box;display:-ms-flexbox;display:flex}.hardware-body-section .carousel .thumbs{-webkit-transform:translateZ(0)!important;transform:translateZ(0)!important;padding-left:0}.hardware-body-section .carousel .thumbs li img{width:64px;height:64px;border-radius:4px}.hardware-body-section .carousel .thumb{border-radius:15px}.hardware-body-section .carousel .control-dots{display:none!important}.hardware-body-section .carousel .control-arrow{opacity:1}.carousel.carousel-slider .control-arrow:hover,.hardware-body-section .carousel.carousel-slider .control-arrow{background:#000!important;opacity:.4!important}@media (max-width:960px){.hardware-body-section .hardware-right-content .select-opt button{margin-top:20px}}.hardware-body-section .hardware-right-content .right-title{color:#4d4d4d;font-size:30px;font-weight:700;text-align:left;font-family:Poppins,sans-serif}.hardware-body-section .hardware-right-content .price-plan{color:#4d4d4d;font-weight:500;font-size:26px;font-family:Poppins,sans-serif;text-align:left;padding-top:5px}.hardware-body-section .hardware-right-content .light-price-color{color:#818e94;font-size:20px}.hardware-body-section .hardware-right-content .hardware-desc{color:#818e94;font-family:Poppins,sans-serif;font-size:16px;text-align:left;padding-top:20px;line-height:1.8}.hardware-body-section .hardware-right-content .plus-one{color:#4d4d4d;font-family:Poppins,sans-serif;font-size:14px;font-weight:500;padding-top:20px;text-align:left}.hardware-body-section .hardware-right-content .select-btn-container{padding-top:25px}.hardware-body-section .hardware-right-content .hard-select-box{width:100%;text-align:left}.hard-select-box-cont .MuiOutlinedInput-input{height:46px!important;width:100%!important;padding:0 10px!important}.MuiOutlinedInput-input{padding:16.5px 14px}.hardware-body-section .hardware-right-content .select-opt button{background:#7266fb;width:206px;height:46px;float:left}.hardware-body-section .hardware-right-content .select-opt button span{font-size:14px;color:#fff}.hardware-body-section .hardware-right-content .hard-right-divider{margin:25px 0}.hardware-body-section .hardware-right-content .feature-t{color:#4d4d4d;text-align:left;font-family:Poppins,sans-serif;font-weight:700;font-size:18px}.hardware-body-section .hardware-right-content .feature-list ul{padding-left:18px}.hardware-body-section .hardware-right-content .feature-list ul li{color:#818e94;text-align:left;font-family:Poppins,sans-serif;font-size:16px;line-height:1.8}.hardware-body-section .include-t{color:#4d4d4d;font-family:Poppins,sans-serif;font-weight:700;font-size:18px;text-align:left}.hardware-body-section .package-line{display:-webkit-box;display:-ms-flexbox;display:flex;padding:10px}.hardware-body-section .available-packages{border:1px solid #eee;margin-top:20px;border-radius:5px}.hardware-body-section .package-text .package-title{color:#4d4d4d;font-family:Poppins,sans-serif;font-size:16px;text-align:left;margin-left:7px;font-weight:500}.hardware-body-section .package-text{padding-left:0;padding-top:20px}.hardware-body-section .package-text .learn-m{color:#818e94;font-family:Poppins,sans-serif;font-size:14px;padding:1px 8px}.hardware-body-section{position:relative;top:50px}.hardware-details-number-of-devices-input-label .MuiInputLabel-outlined{font-size:14px}.image-gallery{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent;position:relative}.image-gallery-content{position:relative;line-height:0;top:0}.image-gallery-slide-wrapper{position:relative}.image-gallery-right-nav{right:0}.image-gallery-left-nav,.image-gallery-right-nav{padding:50px 10px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.image-gallery-icon{color:#fff;-webkit-transition:all .2s ease-out;transition:all .2s ease-out;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;border:0;cursor:pointer;outline:none;position:absolute;z-index:4;filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"2\" /><feOffset dx=\"1\" dy=\"3\" result=\"offsetblur\" /><feFlood flood-color=\"rgba(26,26,26,1)\" /><feComposite in2=\"offsetblur\" operator=\"in\" /><feMerge><feMergeNode /><feMergeNode in=\"SourceGraphic\" /></feMerge></filter></svg>#filter');-webkit-filter:drop-shadow(0 2px 2px #1a1a1a);filter:drop-shadow(0 2px 2px #1a1a1a)}.image-gallery-slides{line-height:0;overflow:hidden;position:relative;white-space:nowrap;text-align:center}.image-gallery-slide.center{position:relative}.image-gallery-slide .image-gallery-image{width:100%;-o-object-fit:contain;object-fit:contain}.image-gallery-slide{left:0;position:absolute;top:0;width:100%}.image-gallery-thumbnails-wrapper{position:relative}.image-gallery-thumbnails{overflow:hidden;padding:5px 0}.image-gallery-thumbnails .image-gallery-thumbnails-container{cursor:pointer;text-align:center;-webkit-transition:-webkit-transform .45s ease-out;transition:-webkit-transform .45s ease-out;transition:transform .45s ease-out;transition:transform .45s ease-out,-webkit-transform .45s ease-out;white-space:nowrap}.image-gallery-thumbnail .image-gallery-thumbnail-inner{position:relative}.image-gallery-thumbnail .image-gallery-thumbnail-image{vertical-align:middle;width:100%;line-height:0}@media (min-width:1400px){.hardware-details-modal{height:780px}}@media (max-width:576px){.hardware-body-section{position:relative;top:20px}.hardware-details-modal{width:95%;height:560px}.hardware-body-section .hardware-right-content .select-opt button{widows:90%;margin-top:35px}.hardware-top-section button{left:5px;font-size:11px}.hardware-top-section button svg{width:15px}}.image-gallery-left-nav,.image-gallery-right-nav{display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#000!important;opacity:.4!important;padding-left:5px!important;padding-right:5px!important}.image-gallery-left-nav svg,.image-gallery-right-nav svg{display:none}.image-gallery-left-nav:before{margin:0 5px;display:inline-block;border-top:8px solid transparent;border-bottom:8px solid transparent;content:\"\";border-right:8px solid #fff}.image-gallery-left-nav[disabled],.image-gallery-right-nav[disabled]{display:none}.image-gallery-slide:focus{outline:none}.image-gallery-right-nav:before{margin:0 5px;display:inline-block;border-top:8px solid transparent;border-bottom:8px solid transparent;content:\"\";border-left:8px solid #fff}.image-gallery-content .image-gallery-slide .image-gallery-image{max-height:unset}.image-gallery-thumbnail{padding:5px 0}.image-gallery-thumbnails .image-gallery-thumbnails-container{margin:20px 25px;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.image-gallery-thumbnail{-webkit-transition:border .15s ease-in;transition:border .15s ease-in;display:inline-block;margin-right:11px;white-space:nowrap;overflow:hidden;width:auto!important;padding:0!important;border-radius:15px;border:1px solid #e8e9e9}.image-gallery-thumbnail.active,.image-gallery-thumbnail:focus,.image-gallery-thumbnail:hover{border:1px solid #7266fb!important}";
  styleInject(css_248z$1n);

  var useStyles$3 = styles$1.makeStyles(function (theme) {
    return {
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3)
      }
    };
  });
  function ModalHardwareDetails(props) {
    var numOfDevices = props.numOfDevices,
        setnumOfDevices = props.setnumOfDevices,
        deviceTitle = props.deviceTitle,
        devicePrice = props.devicePrice,
        hardwareSlideImages = props.hardwareSlideImages,
        includeInPackage = props.includeInPackage,
        hardwareFeatures = props.hardwareFeatures,
        onSelectClick = props.onSelectClick,
        modalButtonText = props.modalButtonText,
        modalButtonStyles = props.modalButtonStyles;
    var classes = useStyles$3();

    var _React$useState = React__default["default"].useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        open = _React$useState2[0],
        setOpen = _React$useState2[1];

    var handleOpen = function handleOpen() {
      setOpen(true);
    };

    var handleClose = function handleClose() {
      setOpen(false);
    }; // const handleDragStart = (e) => e.preventDefault();
    // const items = hardwareSlideImages && hardwareSlideImages.length ? hardwareSlideImages.map((el, i) => {
    // 	return <div key={i}><img src={el} onDragStart={handleDragStart} alt="deen-label" /></div>
    // }) : [];
    // const renderDotsItem = () => {
    // 	console.log("here")
    // 	// return <img src={hardwareSlideImages[0]} alt="deen-label" />
    // 	return "a"
    // }
    // const images = 
    // [
    // 	{
    // 	  original: 'https://picsum.photos/id/1018/1000/600/',
    // 	  thumbnail: 'https://picsum.photos/id/1018/250/150/',
    // 	},
    // 	{
    // 	  original: 'https://picsum.photos/id/1015/1000/600/',
    // 	  thumbnail: 'https://picsum.photos/id/1015/250/150/',
    // 	},
    // 	{
    // 	  original: 'https://picsum.photos/id/1019/1000/600/',
    // 	  thumbnail: 'https://picsum.photos/id/1019/250/150/',
    // 	},
    //   ];


    var images = hardwareSlideImages && hardwareSlideImages.length ? hardwareSlideImages.map(function (el, i) {
      return {
        original: el,
        thumbnail: el
      };
    }) : [];
    return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      style: _objectSpread2({}, modalButtonStyles),
      className: "see-feature-btn",
      onClick: handleOpen
    }, modalButtonText, /*#__PURE__*/React__default["default"].createElement(ChevronRightIcon__default["default"], null)), /*#__PURE__*/React__default["default"].createElement(Modal__default["default"], {
      "aria-labelledby": "transition-modal-title",
      "aria-describedby": "transition-modal-description",
      className: classes.modal,
      open: open,
      onClose: handleClose,
      closeAfterTransition: true,
      BackdropComponent: Backdrop__default["default"],
      BackdropProps: {
        timeout: 500
      }
    }, /*#__PURE__*/React__default["default"].createElement(Fade__default["default"], {
      "in": open
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "hardware-details-modal"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "hardware-top-section"
    }, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      variant: "outlined",
      onClick: handleClose
    }, " ", /*#__PURE__*/React__default["default"].createElement(ChevronLeftIcon__default["default"], null), " BACK"), /*#__PURE__*/React__default["default"].createElement("span", {
      className: "hd-title"
    }, "Hardware details"), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      variant: "body1",
      className: "top-label"
    }, "Donation and fundraising platform"), /*#__PURE__*/React__default["default"].createElement(CloseRoundedIcon__default["default"], {
      className: "close_icon",
      onClick: handleClose
    })), /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "hardware-body-section"
    }, /*#__PURE__*/React__default["default"].createElement(Container__default["default"], {
      maxWidth: "lg"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 4
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      sm: 6,
      md: 5,
      lg: 5
    }, /*#__PURE__*/React__default["default"].createElement(ImageGallery__default["default"], {
      items: images,
      showFullscreenButton: false,
      showPlayButton: false,
      infinite: false
    }), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      variant: "body1",
      className: "include-t"
    }, "Included in the package"), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "available-packages"
    }, includeInPackage && includeInPackage.length ? includeInPackage.map(function (el, i) {
      return /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, " ", /*#__PURE__*/React__default["default"].createElement("div", {
        className: "package-line"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        src: el.image,
        alt: "player"
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "package-text"
      }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
        variant: "body1",
        className: "package-title"
      }, el.title), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
        className: "learn-m"
      }, "LEARN MORE"))), /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], {
        className: "hard-right-divider"
      }));
    }) : null)), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      sm: 6,
      md: 7,
      lg: 7,
      className: "hardware-right-content"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      variant: "body1",
      className: "right-title"
    }, deviceTitle), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      variant: "body1",
      className: "price-plan"
    }, "$", devicePrice, " ", /*#__PURE__*/React__default["default"].createElement("span", {
      className: "light-price-color"
    }, "/month per device")), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      variant: "body1",
      className: "hardware-desc"
    }, "Engage your visitors with organizations updates, announcements and much more Engage your visitors with organizations updates, announcements and much more"), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      variant: "body1",
      className: "plus-one"
    }, "+ One time setup cost $200/device"), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 4,
      className: "select-btn-container"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      sm: 12,
      md: 6,
      lg: 5,
      className: "hard-select-box-cont"
    }, /*#__PURE__*/React__default["default"].createElement(TextField__default["default"], {
      id: "outlined-basic",
      variant: "outlined",
      type: "number",
      onChange: function onChange(e) {
        return e.target.value >= 0 ? setnumOfDevices(e.target.value) : null;
      },
      value: numOfDevices
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      sm: 12,
      md: 5,
      lg: 6,
      className: "select-opt"
    }, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      variant: "contained",
      color: "primary",
      onClick: function onClick() {
        onSelectClick(numOfDevices, props.planName);
        setOpen(false);
      },
      disabled: numOfDevices ? false : true
    }, "SELECT"))), /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], {
      className: "hard-right-divider"
    }), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      variant: "body1",
      className: "feature-t"
    }, "Features"), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "feature-list"
    }, /*#__PURE__*/React__default["default"].createElement("ul", null, hardwareFeatures && hardwareFeatures.length ? hardwareFeatures.map(function (el, i) {
      return /*#__PURE__*/React__default["default"].createElement("li", {
        key: i
      }, el);
    }) : null))))))))));
  }

  styles$1.withStyles(function (theme) {
    return {
      tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11
      }
    };
  })(Tooltip__default["default"]);
  var useStylesBootstrap = styles$1.makeStyles(function (theme) {
    return {
      arrow: {
        color: theme.palette.common.black
      },
      tooltip: {
        backgroundColor: theme.palette.common.black
      }
    };
  });

  function BootstrapTooltip(props) {
    var classes = useStylesBootstrap();
    return /*#__PURE__*/React__default["default"].createElement(Tooltip__default["default"], _extends({
      arrow: true,
      classes: classes
    }, props));
  }

  styles$1.withStyles(function (theme) {
    return {
      tooltip: {
        backgroundColor: '#4D4D4D',
        color: '#FFFFFF',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9'
      }
    };
  })(Tooltip__default["default"]);
  function CustomToolTip(props) {
    return /*#__PURE__*/React__default["default"].createElement(BootstrapTooltip, {
      title: "Customize your own donation form to match organization brand and embed in your website.",
      className: "tooltip-btn-container",
      placement: "top"
    }, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], null, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.infoIcon,
      alt: "info"
    })));
  }

  var css_248z$1m = ".privacy-plan-tabs .MuiPaper-elevation1{border:1px solid #e4e8ec}.privacy-plan-tabs .pricing-container{margin-top:55px;margin-bottom:100px}.privacy-plan-tabs .free.pricing-package .MuiSwitch-colorPrimary.Mui-checked,.privacy-plan-tabs .free.pricing-package .MuiSwitch-colorPrimary.Mui-checked+.MuiSwitch-track{color:#7266fb}.see-df-text-top-bar{color:#818e94;font-size:12px;font-family:Poppins,sans-serif;font-weight:400}.see-feature-top-bar.img{margin-bottom:0!important}.see-feature-top-bar.img img{width:127px}.see-df-text-top-bar{font-size:12px!important;height:30px}.privacy-plan-tabs .pricing-container .blue-text{color:#7266fb;font-size:14px;font-family:Poppins,sans-serif;font-weight:500}.privacy-plan-tabs .pricing-container .gray-text{color:#4d4d4d;font-size:14px;font-family:Poppins,sans-serif;font-weight:500}.privacy-plan-tabs .pricing-container .green-text{color:#05ce78;font-size:14px;font-family:Poppins,sans-serif;font-style:italic}.privacy-plan-tabs .pricing-container .pricing-head{text-align:center;background-color:#f7f8fa;border-bottom:1px solid #e4e8ec;padding:20px 15px}.privacy-plan-tabs .pricing-head .title-t{color:#4d4d4d;font-family:Poppins,sans-serif;font-weight:600;font-size:18px}.privacy-plan-tabs .price-t{color:#4d4d4d;font-family:Poppins,sans-serif;font-size:26px;font-weight:500}.privacy-plan-tabs .pricing-m{color:#4d4d4d;font-family:Poppins,sans-serif;font-size:18px}.privacy-plan-tabs .billed-m{color:#818e94;font-size:14px;font-family:Poppins,sans-serif}.privacy-plan-tabs .gsf-btn,.privacy-plan-tabs .gsf-btn:hover{background-color:#7266fb;color:#fff;font-size:14px;font-family:Poppins,sans-serif;border-radius:35px;padding:5px 20px;border:none;margin-top:15px;font-weight:600}.privacy-plan-tabs .pricing-body-t{color:#2d2d2d;font-family:Poppins,sans-serif;font-size:14px;font-weight:600}.plan-card .MuiCardContent-root{padding:0}.plan-card .pricing-body{padding:20px 15px;min-height:400px}.plan-card .pricing-features{display:-webkit-box;display:-ms-flexbox;display:flex;margin:20px 0;color:#4d4d4d;font-family:Poppins,sans-serif;font-size:14px}.plan-card .pricing-features img{width:20px;height:20px}.plan-card .pricing-features p{padding-left:8px;font-size:14px}.plan-card .feature-btn{text-align:center;padding:20px 15px 0}.plan-card .feature-btn button{background:#f7f8fa;width:100%;color:#7266fb;border-radius:25px}.privacy-plan-tabs .most-popular{background-color:#7266fb;color:#fff;font-family:Poppins,sans-serif;font-size:14px;font-weight:500;padding:8px;border-radius:4px 4px 0 0;text-align:center}.most-popular.blank{background-color:transparent}.monthly-cost-container-content .monthly-cost-container{border-radius:5px;border:1px solid #e8e9e9}.monthly-cost-container .monthly-header{border-radius:5px 5px 0 0}.create-your-own,.plan-comparison{padding-top:80px;padding-bottom:80px}.create-your-own{margin-bottom:300px;background-color:#f7f8fa}.plan-comparison{padding-top:80px;padding-bottom:180px;background-image:-webkit-gradient(linear,left top,left bottom,from(#f7f8fa),to(rgba(247,248,250,0)));background-image:linear-gradient(#f7f8fa,rgba(247,248,250,0))}.plan-comparison .pricing-plan .plan-t{text-align:left;color:#7266fb;font-family:Poppins,sans-serif;font-weight:700;font-size:18px}.plan-comparison .pricing-plan .plan-label-x{color:#4d4d4d;font-family:Poppins,sans-serif;font-weight:700;font-size:30px;text-align:left;line-height:40px;margin-top:10px}.privacy-plan-tabs .modal-pricing-table{height:auto}.privacy-plan-tabs .modal-pricing-table .monthly-l{color:#4d4d4d;font-family:Roboto,sans-serif;font-size:14px;font-weight:500;text-transform:uppercase}.privacy-plan-tabs .modal-pricing-table .billed-a{color:#7266fb;font-family:Roboto,sans-serif;font-size:14px;font-weight:500;text-transform:uppercase}.deenfund-tooltip-p{position:relative!important}.deenfund-tooltip-p .tooltip-btn-container{position:unset!important}.modal-pricing-table.table_container .most-left img{position:unset}.privacy-plan-tabs .modal-pricing-table td{vertical-align:middle;padding-left:18px!important}.privacy-plan-tabs .modal-pricing-table td .modal-select-btn{padding:6px 15px;margin:10px 0}.create-your-own-main-td:hover{background-color:#fff!important}.cut-price{color:#d3d8da;font-size:26px;font-family:Poppins,sans-serif;font-weight:500;margin-right:5px}.privacy-plan-tabs .modal-label img{position:relative;top:5px}.privacy-plan-tabs .modal-pricing-table .main-head-row{background-color:#f7f8fa;border:1px solid #e4e8ec;text-transform:uppercase}.main-head-row .text-t{color:#4d4d4d;font-family:Poppins,sans-serif;font-weight:700;font-size:14px}.main-head-row .light-text-t{color:#818e94;font-family:Poppins,sans-serif;font-size:12px;text-transform:none}.main-head-row img{position:relative;top:5px}.dark-coming{color:#818e94!important;font-family:Poppins,sans-serif!important;font-size:14px!important}.billed-a.font-medium,.dark-coming,.monthly-l.font-medium{font-weight:500!important}.privacy-plan-tabs .modal-pricing-table .more-integ{color:#818e94!important;font-family:Roboto,sans-serif!important;font-size:14px!important;text-align:center!important;font-weight:500}.choose_title_section{padding-bottom:30px!important}.create-your-own .custom-plan .custom-t{color:#4d4d4d;font-family:Poppins,sans-serif;font-weight:700;font-size:30px;text-align:center}.create-your-own .custom-plan .custom-label{color:#818e94;font-family:Poppins,sans-serif;font-size:18px;text-align:center;margin-top:16px}.create-your-own .deenfund-section{background:#fff;padding:20px;border-radius:4px;margin-bottom:20px}.create-your-own .deenfund-section .accept-t{color:#818e94;font-family:Poppins,sans-serif;font-size:16px;margin-top:10px;margin-bottom:15px}.create-your-own .deenfund-section .custom-q{text-align:center;border-radius:5px}.check-plan-container{border:1px solid rgba(0,0,0,.12)!important}.check-plan-container:hover{cursor:pointer;-webkit-box-shadow:0 1px 1px -1px rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 10px 0 rgba(0,0,0,.12)!important;box-shadow:0 1px 1px -1px rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 10px 0 rgba(0,0,0,.12)!important}.create-your-own .deenfund-section .custom-info{text-align:center;color:#4d4d4d;font-family:Poppins,sans-serif;font-size:16px;font-weight:500}.create-your-own .deenfund-section .custom-p-price{text-align:center;color:#4d4d4d;font-family:Poppins,sans-serif;font-size:20px;font-weight:500}.create-your-own .see-feature-btn{color:#7266fb;font-family:Poppins,sans-serif;font-weight:700;margin-top:20px}.deenfund-section .dark-blue-circle{background-color:#7266fb}.deenfund-section .dark-blue-circle,.light-blue-circle{width:40px;height:40px;border-radius:40px;display:inline-block}.light-blue-circle{background-color:#2490f9}.deenfund-section .deenkiosk-t{color:#4d4d4d;font-family:Poppins,sans-serif;font-size:29px;padding-left:10px;line-height:1;position:relative;top:15px}.deenfund-section .logo_img{width:187px}.create-your-own .feature-details{margin-top:20px}.create-your-own .feature-title{display:inline-block;padding-left:15px;position:relative;bottom:8px}.create-your-own .feature-title p{color:#4d4d4d;font-family:Poppins,sans-serif;font-size:14px;font-weight:500}.create-your-own .feature-title .see-feature-btn{margin-top:5px}.no-of-devices .MuiSelect-outlined.MuiSelect-outlined{padding-right:32px;font-weight:500;color:#4d4d4d}.create-your-own .no-of-devices{display:inline;float:right;width:200px;font-family:Poppins,sans-serif}.create-your-own .no-of-devices .MuiFormControl-root{width:100%}.create-your-own .no-of-devices .MuiOutlinedInput-root{top:10px;height:46px}.create-your-own .custom-q.check-plan{background-color:#f7f6ff;border:1px solid #7266fb}.create-your-own .check-plan-container{border:none;position:relative}.create-your-own .check-plan-container .custom-q.check-plan .check-mark-circle{position:absolute;top:8px;right:8px}.integration-section-custom .title-a{color:#4d4d4d;font-family:Poppins,sans-serif;font-size:30px;font-weight:700}.integration-section-custom .accept-t{color:#818e94;font-family:Poppins,sans-serif;font-size:16px;margin:10px 0 20px}.integration-header{background-color:#f1f3f6;color:#4d4d4d;padding:14px}.integration-header .header-xt{font-weight:700;color:#4d4d4d;font-size:14px}.integration-header .first_td{padding-left:39px}.event-dfx{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.view-label{color:#818e94;font-size:14px!important;margin-top:12px!important}.view-label .see-feature-btn{margin-top:0}.monthly-cost-container .monthly-header{text-align:center;background-color:#fff;padding-top:30px;padding-bottom:10px}.monthly-cost-container .monthly-header .monthly-t{color:#4d4d4d;font-family:Poppins,sans-serif;font-weight:700;font-size:18px}.monthly-cost-container .monthly-header .monthly-p{color:#4d4d4d;font-family:Poppins,sans-serif;font-weight:500;font-size:26px}.monthly-cost-container .monthly-header .monthly-l-price{color:#818e94;font-size:14px}.monthly-cost-container .monthly-header .purchase-btn{background-color:#7266fb;color:#fff;font-size:14px;font-family:Poppins,sans-serif;border-radius:35px;padding:8px 20px;border:none;margin-top:15px;font-weight:600;width:85%;margin-bottom:20px}.monthly-cost-container .monthly-header hr{margin:10px 0 0}.monthly-cost-container .monthly-body{padding:30px;background-color:#fff;border-radius:0 0 5px 5px}.monthly-cost-container .monthly-body .month-options{background-color:#f7f8fa;padding:16px 20px;margin-bottom:8px;position:relative}.monthly-cost-container .monthly-body .month-options .m-option-t{color:#4d4d4d;font-family:Poppins,sans-serif;font-size:16px;font-weight:700}.monthly-cost-container .monthly-body .month-options .m-option-l{color:#818e94;font-family:Poppins,sans-serif;font-size:14px}.close_icon{position:absolute;right:10px;top:10px;color:#818e94;cursor:pointer;font-size:24px;z-index:1000!important}.close_icon:hover{color:#7266fb}.close_icon.disable{color:#e8e9e9}.event-dfx img{width:24px;height:24px}.table_container{margin-top:30px;border:none!important}.collapse-text{font-size:12px!important;line-height:24px!important;font-family:Poppins,sans-serif!important}.package_card:hover{-webkit-box-shadow:0 1px 1px -1px rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 10px 0 rgba(0,0,0,.12)!important;box-shadow:0 1px 1px -1px rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 10px 0 rgba(0,0,0,.12)!important}.integrations_table .privacy-plan-tabs .modal-pricing-table td{padding:15px 30px 6px!important;vertical-align:middle}.integrations_table tr td{text-align:left}.integrations_table tr td p{font-size:14px}.table_txt{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.integrations_table tr td .event-dfx,.integrations_table tr td .header-xt{font-family:Poppins,sans-serif!important}.integrations_table tr td .event-dfx{width:100%;padding-left:15px;font-weight:500;position:relative;top:1px;font-size:14px;color:#4d4d4d}.modal-pricing-table tr:hover{background:#f7f8fa;cursor:pointer}.MuiTableCell-root{padding:14px 30px!important}.integrations_table tr td .PrivateSwitchBase-root-1{padding:0}.label_device{font-size:14px!important;font-family:Poppins,sans-serif!important;color:#818e94!important}.devider{margin-top:15px!important;margin-bottom:20px!important}.MuiSwitch-colorSecondary.Mui-checked{color:#7266fb!important}.MuiSwitch-colorSecondary.Mui-checked+.MuiSwitch-track{background-color:#7266fb!important;opacity:.4}.packges_container{padding:14px 20px!important}.prod_img{width:90px;height:90px}.bg-success,.cuIYFB,.jDNNKh.bg-success{background-color:#7266fb!important}.hd_amount{display:block}.see-detail-btn{margin:10px 0}.see-detail-btn span{color:#7266fb!important}.see-detail-btn span,.select-btn{font-family:Poppins,sans-serif!important;font-size:14px!important}.select-btn{background-color:#7266fb!important;color:#fff!important;font-weight:500!important;width:206px;border-radius:25px!important;height:46px;margin:16px 0 10px!important}.total-cost{font-family:Poppins,sans-serif;color:#818e94!important}.monthly-left,.total-cost{font-size:14px!important}.dark-blue-circle{background-color:#7266fb;width:26px;height:26px;border-radius:40px;display:inline-block}.deenkiosk-t{color:#4d4d4d;font-family:Poppins,sans-serif;font-size:18px;padding-left:10px;line-height:1;position:relative;top:4px;font-weight:500}.see-feature-top-bar{margin:0!important;padding-top:18px}.MuiTooltip-popper .MuiTooltip-tooltip{background-color:#4d4d4d;text-align:center;font-size:12px;color:#fff}.MuiTooltip-popper .MuiTooltip-arrow{color:#4d4d4d}.tooltip-btn-container{min-width:24px!important;position:absolute!important;right:0;bottom:10px}.custom-td-plan .tooltip-btn-container{bottom:0!important;position:relative!important}.tooltip-btn-container img{position:unset!important}.info-img-tooltip-css{position:absolute;right:0}.hardware-details-number-of-devices-input-label .MuiInputLabel-outlined{font-size:12px}.all-integration-features-modal .tooltip-btn-container,.integration-type-feature .tooltip-btn-container{min-width:24px!important;position:absolute!important;right:-25px;bottom:-5px}.integrations-modal-t .modal-pricing-table.integrations_table{position:relative}.modal-pricing-table.integrations_table{border:none}.modal-pricing-table.integrations_table .close_icon{position:absolute;right:30px;top:30px;color:#818e94;cursor:pointer;font-size:24px;z-index:1000!important}.modal-pricing-table.integrations_table tr td:first-child,.modal-pricing-table.integrations_table tr td:nth-child(2){min-width:200px}.integrations-modal-t .modal-pricing-table.integrations_table tr td:first-child{min-width:20px}.custom-price-modal{width:100%;text-transform:capitalize!important;padding:0!important}.custom-price-modal .package_card{width:100%}.custom-price-modal:hover span{-webkit-box-shadow:0 1px 1px -1px rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 10px 0 rgba(0,0,0,.12)!important;box-shadow:0 1px 1px -1px rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 10px 0 rgba(0,0,0,.12)!important}.custom-price-modal .custom-p-price{text-transform:lowercase!important}.logo_tagline{color:#818e94;font-size:12px!important;margin-top:6px!important;padding-bottom:18px}.MuiTable-root .MuiTableBody-root .billed_monthly{vertical-align:top!important;padding-top:20px!important}.hardware-details-number-of-devices-input-label .MuiOutlinedInput-input{height:46px!important;width:100%!important;padding:0 10px!important}@media (max-width:767px){.create-your-own .no-of-devices{float:none}.pricing-modal .modal-pricing-table tbody{width:1000px}.privacy-plan-tabs .modal-pricing-table td .modal-select-btn{min-width:160px}.plan-card .pricing-body{padding:20px 15px;min-height:0}.model_backBtn{position:relative}.hardware-top-section button{left:20px;font-size:11px;margin-bottom:13px}}@media (max-width:576px){.pricing-modal{height:540px;width:95%}.deenkiosk-t{font-size:22px;top:5px}.dark-blue-circle{width:30px;height:30px}.pricing-modal .close_icon{top:13px!important}.create-your-own .custom-plan .custom-t,.integration-section-custom .title-a{font-size:24px}}.kiosk-pricing-modal .disabled-select-btn{background-color:#e4e8ec!important;cursor:default!important;color:#818e94!important}.kiosk-pricing-modal .current-plan{color:#fff;background-color:#3cc480;width:100%;position:absolute;top:0;left:0;padding:0;text-transform:capitalize}.kiosk-pricing-modal .modal-label-select-btn{margin-top:24px!important}.pricing-modal .MuiTableContainer-root{overflow-x:hidden}";
  styleInject(css_248z$1m);

  var discountedPriceMonthly = function discountedPriceMonthly(price, rate) {
    if (!rate || rate === undefined) return price;
    return parseInt(price) - parseInt(price) * rate;
  };
  var discountedPrice2 = function discountedPrice2(price, rate) {
    if (!rate || rate === undefined) return {
      price: price,
      disPrice: price
    };
    rate = parseInt(rate) / 100;
    return {
      price: price,
      disPrice: parseInt(price) - parseInt(price) * rate
    };
  };
  var useStyles$2 = styles$1.makeStyles(function (theme) {
    return {
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3)
      }
    };
  });
  function PricingModal(props) {
    var _applicationInfo$imag, _applicationInfo$imag2, _applicationInfo$plan3, _applicationInfo$feat, _applicationInfo$hard2, _applicationInfo$plan5, _applicationInfo$plan6;

    var _useState = React.useState({}),
        _useState2 = _slicedToArray(_useState, 2),
        deviceCount = _useState2[0],
        setdeviceCount = _useState2[1]; // const [handleOpen, sethandleOpen] = useState(false)


    console.log("devicePrice is: ", props === null || props === void 0 ? void 0 : props.devicePrice);
    var selectedPlan = props.selectedPlan,
        handleSelectedPlan = props.handleSelectedPlan,
        handleSelectedPlanData = props.handleSelectedPlanData,
        setModal = props.setModal,
        applicationInfo = props.applicationInfo,
        devicePrice = props.devicePrice;
    var classes = useStyles$2();

    var _useState3 = React.useState([]),
        _useState4 = _slicedToArray(_useState3, 2),
        customOptions = _useState4[0],
        setcustomOptions = _useState4[1];

    var addToSelectedArray = function addToSelectedArray(e, data) {
      if (e.target.checked) {
        var prevSelected = _toConsumableArray(customOptions);

        prevSelected.push(_objectSpread2({}, data));
        setcustomOptions(_toConsumableArray(prevSelected));
      } else {
        var _prevSelected = _toConsumableArray(customOptions);

        _prevSelected = _prevSelected.filter(function (el) {
          return el.name !== data.name;
        });
        setcustomOptions(_toConsumableArray(_prevSelected));
      }
    };

    React.useEffect(function () {
      setcustomOptions([]);
    }, [selectedPlan]);

    var planSelected = function planSelected(planName, disPrice, planPrice, app, noOfDevicesSelected) {
      var _applicationInfo$hard;

      // console.log(planName, planPrice, app, noOfDevicesSelected)
      if (applicationInfo !== null && applicationInfo !== void 0 && (_applicationInfo$hard = applicationInfo.hardware) !== null && _applicationInfo$hard !== void 0 && _applicationInfo$hard.length) {
        var deviceAndPlanTotal = parseInt(noOfDevicesSelected) > 0 ? disPrice + parseInt(noOfDevicesSelected) * (devicePrice ? parseInt(devicePrice) : 200) : disPrice;
        var selectedPlanData;

        if (planName.toLowerCase() === "custom") {
          var _plan, _plan$monthlyBilling, _plan2, _plan2$annuallyBillin;

          selectedPlanData = {
            plan: deviceAndPlanTotal,
            planPrice: parseInt(noOfDevicesSelected) > 0 ? planPrice + parseInt(noOfDevicesSelected) * 200 : planPrice,
            total: customOptions.reduce(function (acc, curr) {
              return curr.selected === true ? acc + curr.price : acc;
            }, 0),
            stripePlanId: selectedPlan === "monthly" ? (_plan = plan) === null || _plan === void 0 ? void 0 : (_plan$monthlyBilling = _plan.monthlyBilling) === null || _plan$monthlyBilling === void 0 ? void 0 : _plan$monthlyBilling.stripePlanId : (_plan2 = plan) === null || _plan2 === void 0 ? void 0 : (_plan2$annuallyBillin = _plan2.annuallyBilling) === null || _plan2$annuallyBillin === void 0 ? void 0 : _plan2$annuallyBillin.stripePlanId,
            planData: customOptions.filter(function (el) {
              return el.selected === true;
            }),
            devices: noOfDevicesSelected > 0 ? noOfDevicesSelected : 0
          };
        } else {
          var _applicationInfo$plan, _plan3$monthlyBilling, _plan3$annuallyBillin, _plan3$features;

          var _plan3 = applicationInfo !== null && applicationInfo !== void 0 && (_applicationInfo$plan = applicationInfo.plans) !== null && _applicationInfo$plan !== void 0 && _applicationInfo$plan.length ? applicationInfo === null || applicationInfo === void 0 ? void 0 : applicationInfo.plans.find(function (plan) {
            return plan.name.toLowerCase() === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
          }) : null;

          selectedPlanData = {
            plan: planName,
            total: deviceAndPlanTotal,
            // planPrice: parseInt(noOfDevicesSelected) > 0 ? planPrice + parseInt(noOfDevicesSelected) * 200 : planPrice,
            planPrice: planPrice,
            stripePlanId: selectedPlan === "monthly" ? _plan3 === null || _plan3 === void 0 ? void 0 : (_plan3$monthlyBilling = _plan3.monthlyBilling) === null || _plan3$monthlyBilling === void 0 ? void 0 : _plan3$monthlyBilling.stripePlanId : _plan3 === null || _plan3 === void 0 ? void 0 : (_plan3$annuallyBillin = _plan3.annuallyBilling) === null || _plan3$annuallyBillin === void 0 ? void 0 : _plan3$annuallyBillin.stripePlanId,
            devices: noOfDevicesSelected > 0 ? noOfDevicesSelected : 0,
            planData: _plan3 !== null && _plan3 !== void 0 && (_plan3$features = _plan3.features) !== null && _plan3$features !== void 0 && _plan3$features.length ? _plan3.features.map(function (el) {
              return {
                name: el.title,
                price: monthPriceForPlan(el)
              };
            }) : []
          };
        }

        handleSelectedPlanData(_defineProperty({}, app, _objectSpread2({}, selectedPlanData)));
        setModal(false);
      } else {
        var _selectedPlanData;

        if (planName.toLowerCase() === "custom") {
          var _plan4, _plan4$monthlyBilling, _plan5, _plan5$annuallyBillin;

          _selectedPlanData = {
            plan: planName,
            total: customOptions.reduce(function (acc, curr) {
              return curr.selected === true ? acc + curr.price : acc;
            }, 0),
            planData: customOptions.filter(function (el) {
              return el.selected === true;
            }),
            planPrice: parseInt(noOfDevicesSelected) > 0 ? planPrice + parseInt(noOfDevicesSelected) * 200 : planPrice,
            stripePlanId: selectedPlan === "monthly" ? (_plan4 = plan) === null || _plan4 === void 0 ? void 0 : (_plan4$monthlyBilling = _plan4.monthlyBilling) === null || _plan4$monthlyBilling === void 0 ? void 0 : _plan4$monthlyBilling.stripePlanId : (_plan5 = plan) === null || _plan5 === void 0 ? void 0 : (_plan5$annuallyBillin = _plan5.annuallyBilling) === null || _plan5$annuallyBillin === void 0 ? void 0 : _plan5$annuallyBillin.stripePlanId
          };
        } else {
          var _applicationInfo$plan2, _plan6$monthlyBilling, _plan6$annuallyBillin, _plan6$features;

          var _plan6 = applicationInfo !== null && applicationInfo !== void 0 && (_applicationInfo$plan2 = applicationInfo.plans) !== null && _applicationInfo$plan2 !== void 0 && _applicationInfo$plan2.length ? applicationInfo === null || applicationInfo === void 0 ? void 0 : applicationInfo.plans.find(function (plan) {
            return plan.name.toLowerCase() === (planName === null || planName === void 0 ? void 0 : planName.toLowerCase());
          }) : null;

          _selectedPlanData = {
            plan: planName,
            total: disPrice,
            planPrice: parseInt(noOfDevicesSelected) > 0 ? planPrice + parseInt(noOfDevicesSelected) * 200 : planPrice,
            stripePlanId: selectedPlan === "monthly" ? _plan6 === null || _plan6 === void 0 ? void 0 : (_plan6$monthlyBilling = _plan6.monthlyBilling) === null || _plan6$monthlyBilling === void 0 ? void 0 : _plan6$monthlyBilling.stripePlanId : _plan6 === null || _plan6 === void 0 ? void 0 : (_plan6$annuallyBillin = _plan6.annuallyBilling) === null || _plan6$annuallyBillin === void 0 ? void 0 : _plan6$annuallyBillin.stripePlanId,
            planData: _plan6 !== null && _plan6 !== void 0 && (_plan6$features = _plan6.features) !== null && _plan6$features !== void 0 && _plan6$features.length ? _plan6.features.map(function (el) {
              return {
                name: el.title,
                price: monthPriceForPlan(el)
              };
            }) : []
          };
        } // console.log("select plan", selectedPlanData)


        handleSelectedPlanData(_defineProperty({}, app, _objectSpread2({}, _selectedPlanData)));
        setModal(false);
      }
    };

    var customPlanPrice = customOptions && customOptions.length ? customOptions.reduce(function (acc, curr) {
      return curr.selected === true ? acc + curr.price : acc;
    }, 0) : 0;

    var monthPriceForPlan2 = function monthPriceForPlan2(plan) {
      var _plan$monthlyBilling2, _plan$monthlyBilling3, _plan$annuallyBilling, _plan$annuallyBilling2;

      return selectedPlan === "monthly" ? discountedPrice2(plan === null || plan === void 0 ? void 0 : (_plan$monthlyBilling2 = plan.monthlyBilling) === null || _plan$monthlyBilling2 === void 0 ? void 0 : _plan$monthlyBilling2.price, plan === null || plan === void 0 ? void 0 : (_plan$monthlyBilling3 = plan.monthlyBilling) === null || _plan$monthlyBilling3 === void 0 ? void 0 : _plan$monthlyBilling3.discountPercentage) : discountedPrice2(plan === null || plan === void 0 ? void 0 : (_plan$annuallyBilling = plan.annuallyBilling) === null || _plan$annuallyBilling === void 0 ? void 0 : _plan$annuallyBilling.price, plan === null || plan === void 0 ? void 0 : (_plan$annuallyBilling2 = plan.annuallyBilling) === null || _plan$annuallyBilling2 === void 0 ? void 0 : _plan$annuallyBilling2.discountPercentage);
    };

    var monthPriceForAnnualPlan = function monthPriceForAnnualPlan(price) {
      return price ? (price / 12).toFixed(2) : price;
    };

    var monthPriceForPlan = function monthPriceForPlan(data) {
      var _data$monthlyBilling$, _data$monthlyBilling, _data$annuallyBilling;

      return selectedPlan === "monthly" ? (_data$monthlyBilling$ = data === null || data === void 0 ? void 0 : (_data$monthlyBilling = data.monthlyBilling) === null || _data$monthlyBilling === void 0 ? void 0 : _data$monthlyBilling.price) !== null && _data$monthlyBilling$ !== void 0 ? _data$monthlyBilling$ : 0 : data === null || data === void 0 ? void 0 : (_data$annuallyBilling = data.annuallyBilling) === null || _data$annuallyBilling === void 0 ? void 0 : _data$annuallyBilling.price;
    };

    var _React$useState = React__default["default"].useState(0),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        numOfDevices = _React$useState2[0],
        setnumOfDevices = _React$useState2[1];

    var onSelectClick = function onSelectClick(numOfDevices, planName) {
      console.log("numOfDevices", numOfDevices, planName);
      setdeviceCount(_objectSpread2(_objectSpread2({}, deviceCount), {}, _defineProperty({}, planName, numOfDevices)));
    }; // console.log("deviceCount", deviceCount)


    return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      style: _objectSpread2({}, props.buttonStyle),
      className: "see-feature-btn",
      onClick: function onClick() {
        props.setModal(true);
      }
    }, props.modalButtonText), /*#__PURE__*/React__default["default"].createElement(Modal__default["default"], {
      "aria-labelledby": "transition-modal-title",
      "aria-describedby": "transition-modal-description",
      className: classes.modal,
      open: props.openModal,
      onClose: function onClose() {
        return props.setModal(false);
      },
      closeAfterTransition: true,
      BackdropComponent: Backdrop__default["default"],
      BackdropProps: {
        timeout: 500
      }
    }, /*#__PURE__*/React__default["default"].createElement(Fade__default["default"], {
      "in": props.openModal
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "pricing-modal"
    }, /*#__PURE__*/React__default["default"].createElement(CloseRoundedIcon__default["default"], {
      className: "close_icon",
      onClick: function onClick() {
        return props.setModal(false);
      }
    }), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      variant: "body1",
      className: "see-feature-top-bar img"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: (_applicationInfo$imag = applicationInfo === null || applicationInfo === void 0 ? void 0 : (_applicationInfo$imag2 = applicationInfo.imageMetaData) === null || _applicationInfo$imag2 === void 0 ? void 0 : _applicationInfo$imag2.imageUrl) !== null && _applicationInfo$imag !== void 0 ? _applicationInfo$imag : "",
      alt: "DFLogoImg"
    })), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      variant: "body1",
      className: "logo_tagline"
    }, applicationInfo === null || applicationInfo === void 0 ? void 0 : applicationInfo.shortDescription), /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null), /*#__PURE__*/React__default["default"].createElement(TableContainer__default["default"], {
      component: Paper__default["default"],
      className: "modal-pricing-table kiosk-pricing-modal"
    }, /*#__PURE__*/React__default["default"].createElement(Table__default["default"], {
      className: classes.table,
      "aria-label": "simple table"
    }, /*#__PURE__*/React__default["default"].createElement(core.TableHead, null, /*#__PURE__*/React__default["default"].createElement(TableRow__default["default"], null, /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
      scope: "row",
      className: "billed_monthly"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "monthly-l"
    }, "Billed Monthly"), /*#__PURE__*/React__default["default"].createElement(Switch__default["default"], {
      onChange: handleSelectedPlan,
      checked: selectedPlan === "monthly" ? false : true,
      inputProps: {
        'aria-label': 'primary checkbox'
      }
    }), /*#__PURE__*/React__default["default"].createElement("span", {
      className: "billed-a"
    }, "Billed Annually ", /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement("span", {
      className: "save-t"
    }, /*#__PURE__*/React__default["default"].createElement("i", null, selectedPlan === "annually" && props.planDiscount ? "(Save ".concat(props.planDiscount, "%)") : "")))), applicationInfo !== null && applicationInfo !== void 0 && (_applicationInfo$plan3 = applicationInfo.plans) !== null && _applicationInfo$plan3 !== void 0 && _applicationInfo$plan3.length ? applicationInfo.plans.filter(function (plan) {
      var _plan$status;

      return ((_plan$status = plan.status) === null || _plan$status === void 0 ? void 0 : _plan$status.toLowerCase()) === "available";
    }).map(function (plan, i) {
      var _plan$name, _plan$name2, _plan$name3, _plan$monthlyBilling4, _discountedPriceMonth, _plan$monthlyBilling5, _plan$monthlyBilling6, _plan$name5;

      // let price = selectedPlan === "monthly" ? plan.monthlyBilling.price : discountedPrice2(plan.monthlyBilling.price, plan?.annuallyBilling?.discountPercentage);
      var calculatedPrice = monthPriceForPlan2(plan);
      var planPrice = calculatedPrice.price;
      var disPrice = calculatedPrice.disPrice;
      var planName = plan === null || plan === void 0 ? void 0 : (_plan$name = plan.name) === null || _plan$name === void 0 ? void 0 : _plan$name.toLowerCase();
      var currentPlan = (plan === null || plan === void 0 ? void 0 : (_plan$name2 = plan.name) === null || _plan$name2 === void 0 ? void 0 : _plan$name2.toLowerCase()) === props.currentPlanName ? true : false;
      return /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
        key: i,
        align: "center"
      }, currentPlan && /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
        variant: "body1",
        className: "current-plan"
      }, "Your Current Plan"), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
        variant: "body1",
        className: "modal-label ".concat(currentPlan ? "modal-label-select-btn" : "")
      }, plan.name), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
        variant: "body1",
        className: "modal-label-price"
      }, selectedPlan === "monthly" ? "$".concat(((_plan$name3 = plan.name) === null || _plan$name3 === void 0 ? void 0 : _plan$name3.toLowerCase()) === "custom" ? customPlanPrice : disPrice) : /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement("span", {
        className: "cut-price"
      }, plan !== null && plan !== void 0 && (_plan$monthlyBilling4 = plan.monthlyBilling) !== null && _plan$monthlyBilling4 !== void 0 && _plan$monthlyBilling4.price ? /*#__PURE__*/React__default["default"].createElement("strike", null, "$", (_discountedPriceMonth = discountedPriceMonthly(plan === null || plan === void 0 ? void 0 : (_plan$monthlyBilling5 = plan.monthlyBilling) === null || _plan$monthlyBilling5 === void 0 ? void 0 : _plan$monthlyBilling5.price, plan === null || plan === void 0 ? void 0 : (_plan$monthlyBilling6 = plan.monthlyBilling) === null || _plan$monthlyBilling6 === void 0 ? void 0 : _plan$monthlyBilling6.discountPercentage)) !== null && _discountedPriceMonth !== void 0 ? _discountedPriceMonth : 0) : null), "$", monthPriceForAnnualPlan(disPrice))), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
        variant: "body1",
        className: "modal-label-plan"
      }, "/month"), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
        variant: "contained",
        className: "".concat(currentPlan ? "disabled-select-btn" : "", " modal-select-btn"),
        disabled: currentPlan,
        onClick: function onClick() {
          var _plan$name4, _applicationInfo$name;

          return planSelected((_plan$name4 = plan.name) === null || _plan$name4 === void 0 ? void 0 : _plan$name4.toLowerCase(), planName === "custom" ? customPlanPrice : disPrice, planPrice, applicationInfo === null || applicationInfo === void 0 ? void 0 : (_applicationInfo$name = applicationInfo.name) === null || _applicationInfo$name === void 0 ? void 0 : _applicationInfo$name.toLowerCase(), deviceCount[planName] ? deviceCount[planName] : 0);
        }
      }, ((_plan$name5 = plan.name) === null || _plan$name5 === void 0 ? void 0 : _plan$name5.toLowerCase()) === 'free' ? 'ADD NOW' : 'SELECT'));
    }) : null)), /*#__PURE__*/React__default["default"].createElement(TableBody__default["default"], {
      className: "scrollbar-width-none"
    }, applicationInfo !== null && applicationInfo !== void 0 && (_applicationInfo$feat = applicationInfo.features) !== null && _applicationInfo$feat !== void 0 && _applicationInfo$feat.length ? applicationInfo.features.map(function (feature, i) {
      var _applicationInfo$plan4;

      return /*#__PURE__*/React__default["default"].createElement(TableRow__default["default"], {
        key: i
      }, /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
        scope: "row",
        className: "most-left"
      }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
        variant: "body1",
        className: "monthly-left"
      }, feature.title), /*#__PURE__*/React__default["default"].createElement(CustomToolTip, {
        message: feature.description,
        infoIcon: props.infoIcon
      })), applicationInfo === null || applicationInfo === void 0 ? void 0 : (_applicationInfo$plan4 = applicationInfo.plans) === null || _applicationInfo$plan4 === void 0 ? void 0 : _applicationInfo$plan4.filter(function (plan) {
        var _plan$status2;

        return ((_plan$status2 = plan.status) === null || _plan$status2 === void 0 ? void 0 : _plan$status2.toLowerCase()) === "available";
      }).map(function (plan, i) {
        var _found$status, _found$featureType, _found$status2, _found$featureType2, _plan$name6, _found$status3, _found$featureType3, _found$status4;

        var found = plan.features.find(function (el) {
          var _el$title, _feature$title;

          return ((_el$title = el.title) === null || _el$title === void 0 ? void 0 : _el$title.toLowerCase()) === ((_feature$title = feature.title) === null || _feature$title === void 0 ? void 0 : _feature$title.toLowerCase());
        }); // console.log("found",found)

        return /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
          key: i,
          align: "center",
          className: "dark-coming"
        }, (found === null || found === void 0 ? void 0 : (_found$status = found.status) === null || _found$status === void 0 ? void 0 : _found$status.toLowerCase()) === "available" && ((found === null || found === void 0 ? void 0 : (_found$featureType = found.featureType) === null || _found$featureType === void 0 ? void 0 : _found$featureType.toLowerCase()) === "included" || (found === null || found === void 0 ? void 0 : found.price) <= 0) ? /*#__PURE__*/React__default["default"].createElement("img", {
          src: props.checkCircleIcon,
          alt: "check-circle"
        }) : null, (found === null || found === void 0 ? void 0 : (_found$status2 = found.status) === null || _found$status2 === void 0 ? void 0 : _found$status2.toLowerCase()) === "available" && (found === null || found === void 0 ? void 0 : (_found$featureType2 = found.featureType) === null || _found$featureType2 === void 0 ? void 0 : _found$featureType2.toLowerCase()) === "add-on" && ((_plan$name6 = plan.name) === null || _plan$name6 === void 0 ? void 0 : _plan$name6.toLowerCase()) === "custom" ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Checkbox__default["default"], {
          name: found === null || found === void 0 ? void 0 : found.title,
          color: "yellow",
          checked: customOptions.find(function (el) {
            return el.name === (found === null || found === void 0 ? void 0 : found.title);
          }) ? true : false,
          onChange: function onChange(e) {
            return addToSelectedArray(e, {
              name: found === null || found === void 0 ? void 0 : found.title,
              price: found === null || found === void 0 ? void 0 : found.price,
              selected: true
            });
          }
        }), "+$".concat(found === null || found === void 0 ? void 0 : found.price, "/").concat(found === null || found === void 0 ? void 0 : found.billingPeriod)) : null, (found === null || found === void 0 ? void 0 : (_found$status3 = found.status) === null || _found$status3 === void 0 ? void 0 : _found$status3.toLowerCase()) === "available" && (found === null || found === void 0 ? void 0 : (_found$featureType3 = found.featureType) === null || _found$featureType3 === void 0 ? void 0 : _found$featureType3.toLowerCase()) === "add-on" && (found === null || found === void 0 ? void 0 : found.price) > 0 ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, "+$".concat(found === null || found === void 0 ? void 0 : found.price, "/").concat(found === null || found === void 0 ? void 0 : found.billingPeriod)) : null, (found === null || found === void 0 ? void 0 : (_found$status4 = found.status) === null || _found$status4 === void 0 ? void 0 : _found$status4.toLowerCase()) === "coming soon" ? "Coming Soon" : "");
      }));
    }) : null), applicationInfo !== null && applicationInfo !== void 0 && (_applicationInfo$hard2 = applicationInfo.hardware) !== null && _applicationInfo$hard2 !== void 0 && _applicationInfo$hard2.length ? /*#__PURE__*/React__default["default"].createElement(core.TableFooter, null, /*#__PURE__*/React__default["default"].createElement(TableRow__default["default"], null, /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
      scope: "row",
      className: "most-left"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      variant: "body1",
      className: "monthly-left"
    })), applicationInfo !== null && applicationInfo !== void 0 && (_applicationInfo$plan5 = applicationInfo.plans) !== null && _applicationInfo$plan5 !== void 0 && _applicationInfo$plan5.length ? (_applicationInfo$plan6 = applicationInfo.plans) === null || _applicationInfo$plan6 === void 0 ? void 0 : _applicationInfo$plan6.filter(function (plan) {
      var _plan$status3;

      return ((_plan$status3 = plan.status) === null || _plan$status3 === void 0 ? void 0 : _plan$status3.toLowerCase()) === "available";
    }).map(function (plan, i) {
      var _plan$name7, _plan$name8, _deviceCount$planName;

      // let price = selectedPlan === "monthly" ? plan.monthlyBilling.price : discountedPrice2(plan.monthlyBilling.price, plan?.annuallyBilling?.discountPercentage);
      var calculatedPrice = monthPriceForPlan2(plan);
      var planPrice = calculatedPrice.price;
      var disPrice = calculatedPrice.disPrice;
      var planName = plan === null || plan === void 0 ? void 0 : (_plan$name7 = plan.name) === null || _plan$name7 === void 0 ? void 0 : _plan$name7.toLowerCase();
      var currentPlan = (plan === null || plan === void 0 ? void 0 : (_plan$name8 = plan.name) === null || _plan$name8 === void 0 ? void 0 : _plan$name8.toLowerCase()) === props.currentPlanName ? true : false;
      return /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
        key: i,
        align: "center",
        className: "hardware-details-number-of-devices-input-label"
      }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
        variant: "body1",
        className: "monthly-left"
      }, "+ Hardware $10/month per device"), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
        variant: "body1",
        className: "monthly-left"
      }, "+ One time setup cost $", devicePrice !== null && devicePrice !== void 0 ? devicePrice : 200, "/device"), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
        variant: "body1",
        className: "see-detail-btn"
      }, /*#__PURE__*/React__default["default"].createElement(ModalHardwareDetails, {
        numOfDevices: numOfDevices,
        setnumOfDevices: setnumOfDevices,
        deviceTitle: props.deviceTitle,
        devicePrice: props.devicePrice,
        hardwareSlideImages: props.hardwareSlideImages,
        includeInPackage: props.includeInPackage,
        hardwareFeatures: props.hardwareFeatures,
        onSelectClick: onSelectClick,
        modalButtonText: props.modalButtonText,
        modalButtonStyles: props.modalButtonStyles,
        planName: planName
      })), /*#__PURE__*/React__default["default"].createElement(TextField__default["default"], {
        id: "outlined-basic",
        variant: "outlined",
        type: "number",
        label: "Number Of Devices",
        className: "number_select",
        onChange: function onChange(e) {
          return e.target.value >= 0 ? setdeviceCount(_objectSpread2(_objectSpread2({}, deviceCount), {}, _defineProperty({}, planName, e.target.value))) : null;
        },
        value: (_deviceCount$planName = deviceCount[planName]) !== null && _deviceCount$planName !== void 0 ? _deviceCount$planName : 0
      }), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
        variant: "body1"
      }, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
        variant: "contained",
        className: "".concat(currentPlan ? "disabled-select-btn" : "", " select-btn"),
        disabled: currentPlan,
        onClick: function onClick() {
          var _applicationInfo$name2;

          planSelected(planName, planName === "custom" ? customPlanPrice : disPrice, planPrice, applicationInfo === null || applicationInfo === void 0 ? void 0 : (_applicationInfo$name2 = applicationInfo.name) === null || _applicationInfo$name2 === void 0 ? void 0 : _applicationInfo$name2.toLowerCase(), deviceCount[planName] ? deviceCount[planName] : 0);
        }
      }, "SELECT")), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
        variant: "body1",
        className: "total-cost"
      }, "Total: $", deviceCount[planName] ? deviceCount[planName] * 10 : 0, "/mo ", /*#__PURE__*/React__default["default"].createElement("span", {
        className: "hd_amount"
      }, "+$200 hardware")));
    }) : null)) : null))))));
  }

  function IntegrationDetails(props) {
    var backLink = props.backLink,
        backLinkText = props.backLinkText,
        compatibleWith = props.compatibleWith,
        title = props.title,
        features = props.features,
        DFLogo = props.DFLogo,
        logoSubHeading = props.logoSubHeading,
        planSelected = props.planSelected,
        handlePlanDuration = props.handlePlanDuration,
        planDuration = props.planDuration,
        modalButtonText = props.modalButtonText,
        paragraphText = props.paragraphText,
        checkCircleIcon = props.checkCircleIcon;
    return /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "integration-detail-section"
    }, /*#__PURE__*/React__default["default"].createElement(core.Container, {
      maxWidth: "lg"
    }, backLink && /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      to: "/",
      className: "back-link"
    }, /*#__PURE__*/React__default["default"].createElement(ArrowBackIosIcon__default["default"], null), " ", backLinkText)), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      container: true,
      spacing: 4
    }, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12,
      sm: 4,
      md: 3,
      lg: 3
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "detail-dp"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "dp-container"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.deenLabelImg,
      alt: "deen-label"
    }))), /*#__PURE__*/React__default["default"].createElement(PricingModal, {
      logoSubHeading: logoSubHeading,
      DFLogo: DFLogo,
      planDuration: planDuration,
      handlePlanDuration: handlePlanDuration,
      planSelected: planSelected,
      modalButtonText: modalButtonText,
      checkCircleIcon: checkCircleIcon,
      infoIcon: props.infoIcon
    }), /*#__PURE__*/React__default["default"].createElement(core.Button, {
      variant: "contained",
      className: "view-web-btn"
    }, "VIEW ON WEBSITE \xA0", /*#__PURE__*/React__default["default"].createElement("i", {
      "class": "fa fa-external-link",
      "aria-hidden": "true"
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "distance-top"
    }, /*#__PURE__*/React__default["default"].createElement(core.Divider, null)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "compatible-section"
    }, /*#__PURE__*/React__default["default"].createElement(core.Typography, {
      variant: "body1",
      className: "compatible-t"
    }, "Compatible with"), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "tag_row"
    }, compatibleWith && compatibleWith.length ? compatibleWith.map(function (el, i) {
      return /*#__PURE__*/React__default["default"].createElement("span", {
        key: i,
        className: "tags"
      }, el);
    }) : null))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12,
      sm: 8,
      md: 8,
      lg: 6,
      className: "integration-detail-content"
    }, /*#__PURE__*/React__default["default"].createElement(core.Typography, {
      variant: "body1",
      className: "integ-t"
    }, title), /*#__PURE__*/React__default["default"].createElement(core.Typography, {
      variant: "body1",
      className: "integ-text",
      dangerouslySetInnerHTML: {
        __html: paragraphText
      }
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "integration-feature"
    }, /*#__PURE__*/React__default["default"].createElement(core.Typography, {
      variant: "body1",
      className: "feature-t"
    }, "Features"), features && features.length ? features.map(function (el, i) {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        key: i,
        className: "feature-content"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        src: props.checkCircleIcon,
        alt: "check-circle"
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "f-text"
      }, /*#__PURE__*/React__default["default"].createElement(core.Typography, {
        variant: "body1",
        className: "feature-h"
      }, el.title), /*#__PURE__*/React__default["default"].createElement(core.Typography, {
        variant: "body1",
        className: "feature-b"
      }, el.description)));
    }) : null))))));
  }

  IntegrationDetails.propTypes = {// message: PropTypes.string,
    // onCloseClick: PropTypes.func,
    // show: PropTypes.bool
  };

  var tipIcon = "const img = require('./tip.svg'); export default img;";

  var css_248z$1l = ".TextFieldMainContainer{position:relative}.TextFieldMainContainer .Count{position:absolute;right:0}.TextFieldMainContainer .countText{color:#b0b9c1;font-size:12px;font-family:Poppins,sans-serif;font-weight:400;text-transform:uppercase}.TextFieldMainContainer .TooltipContainer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-bottom:8px}.TextFieldMainContainer .TooltipTitle{color:#4c5e67;font-size:14px;font-family:Poppins,sans-serif;font-weight:400;cursor:pointer}.TextFieldMainContainer .TooltipTitle .TooltipInfo{opacity:0;position:absolute;width:300px;background:#fff;border:1px solid #e2e2e2;top:-30px;right:-340px;padding:12px;border-radius:4px;-webkit-transition:.3s;transition:.3s}.TextFieldMainContainer .TooltipTitle:hover .TooltipInfo{opacity:1}.TextFieldMainContainer .TooltipImg{position:relative;top:5;width:20px}.TextFieldMainContainer .TooltipInfoTitle{color:#4c5e67;font-size:14px;font-family:Poppins,sans-serif;font-weight:600}.TextFieldMainContainer .TooltipInfoDes{color:#4c5e67;font-size:14px;font-family:Poppins,sans-serif;font-weight:400}";
  styleInject(css_248z$1l);

  function TextInput(props) {
    var _React$createElement;

    props.name;
        var onChange = props.onChange,
        value = props.value,
        InputProps = props.InputProps,
        onBlur = props.onBlur,
        type = props.type;
    var CssTextField = styles$1.withStyles({
      root: {
        '& label.Mui-focused': {
          color: props.focusColor
        },
        '& .MuiInput-underline:after': {
          borderBottomColor: 'yellow'
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: '#E4E8EC'
          },
          '&:hover fieldset': {
            borderColor: '#E4E8EC'
          },
          '&.Mui-focused fieldset': {
            borderColor: props.focusColor
          }
        }
      }
    })(TextField__default["default"]);
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TextFieldMainContainer"
    }, props.tooltip && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TooltipContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TooltipTitle"
    }, "pro tips ", /*#__PURE__*/React__default["default"].createElement("img", {
      className: "TooltipImg",
      src: tipIcon,
      alt: "logo"
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TooltipInfo"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "TooltipInfoTitle"
    }, "Not sure where to start?"), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "TooltipInfoDes"
    }, " body1. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos blanditiis tenetur unde suscipit,")))), /*#__PURE__*/React__default["default"].createElement(CssTextField, (_React$createElement = {
      label: "Custom CSS",
      variant: "outlined",
      id: "custom-css-outlined-input",
      error: props.error,
      placeholder: props.placeholder,
      onChange: onChange,
      value: value,
      InputProps: InputProps,
      onBlur: onBlur,
      type: type
    }, _defineProperty(_React$createElement, "label", props.label), _defineProperty(_React$createElement, "color", "primary"), _defineProperty(_React$createElement, "helperText", props.helperText), _defineProperty(_React$createElement, "disabled", props.disabled), _React$createElement)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "Count"
    }, props.count && /*#__PURE__*/React__default["default"].createElement("span", {
      className: "countText"
    }, "char 0/80 ", props.count)));
  }

  function FieldPassword(props) {
    var _useState = React.useState({
      showPassword: false
    }),
        _useState2 = _slicedToArray(_useState, 2),
        values = _useState2[0],
        setValues = _useState2[1];

    var handleClickShowPassword = function handleClickShowPassword() {
      setValues(_objectSpread2(_objectSpread2({}, values), {}, {
        showPassword: !values.showPassword
      }));
    };

    var hasNumber = function hasNumber(value) {
      return new RegExp(/[0-9]/).test(value);
    };

    var hasMixed = function hasMixed(value) {
      return new RegExp(/[a-z]/).test(value) && new RegExp(/[A-Z]/).test(value);
    };

    var hasSpecial = function hasSpecial(value) {
      return new RegExp(/[!#@$%^&*)(+=._-]/).test(value);
    };

    var hasUpperCase = function hasUpperCase(value) {
      return new RegExp(/[A-Z]/).test(value);
    };

    var strengthColor = function strengthColor(count) {
      if (count < 2) return "red";
      if (count < 3) return "coral";
      if (count < 4) return "orange";
      if (count < 5) return "lightgreen";
      if (count < 6) return "green";
    };

    var strengthIndicator = function strengthIndicator(value) {
      var strengths = 0;
      if (value.length > 5) strengths++;
      if (value.length > 7) strengths++;
      if (hasNumber(value)) strengths++;
      if (hasSpecial(value)) strengths++;
      if (hasMixed(value)) strengths++;
      return strengths;
    };

    var hasaUpperCase = hasUpperCase(props.value);
    var hasaSpecial = hasSpecial(props.value);
    var hasaNumber = hasNumber(props.value);
    var strength = strengthIndicator(props.value);
    var color = strengthColor(strength);
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FieldPasswordMainContainer"
    }, /*#__PURE__*/React__default["default"].createElement(TextField__default["default"], {
      type: values.showPassword ? "text" : "password",
      required: props.required,
      id: props.id,
      color: props.color,
      label: props.label,
      value: props.value,
      onChange: props.onChange,
      error: props.error,
      margin: props.margin,
      name: props.name,
      variant: "outlined",
      placeholder: props.placeholder,
      className: "inputHover",
      helperText: !props.hidePasswordStrength ? /*#__PURE__*/React__default["default"].createElement("span", {
        style: {
          color: props.error ? "#f44336" : strength === 1 && "#f44336" || strength === 2 && "#FF5353" || strength === 3 && "orange" || strength === 4 && "#3CC480" || strength === 5 && "#3CC480",
          display: "flex",
          justifyContent: "space-between"
        }
      }, props.helperText !== "" && props.helperText || strength === 1 && "Weak" || strength === 2 && "Fair" || strength === 3 && "Good" || strength === 4 && "Strong" || strength === 5 && "Very Strong") : "",
      style: props.style,
      InputProps: {
        endAdornment: /*#__PURE__*/React__default["default"].createElement(InputAdornment__default["default"], {
          position: "end"
        }, /*#__PURE__*/React__default["default"].createElement(IconButton__default["default"], {
          edge: "end",
          "aria-label": "toggle password visibility",
          onClick: function onClick() {
            return handleClickShowPassword();
          },
          style: {
            width: 24,
            height: 24,
            marginRight: 7,
            padding: 0
          }
        }, values.showPassword ? /*#__PURE__*/React__default["default"].createElement(Visibility__default["default"], {
          style: {
            width: 24,
            height: 24
          }
        }) : /*#__PURE__*/React__default["default"].createElement(VisibilityOff__default["default"], {
          style: {
            width: 24,
            height: 24
          }
        })))
      }
    }), props.PasswordStrong && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        width: "100%",
        justifyContent: "space-evenly",
        margin: 0,
        display: props.visible,
        marginBottom: 0,
        marginTop: "10px"
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        background: strength >= 1 ? color : "#E8E9E9",
        width: "100%",
        height: "2px",
        flex: 1,
        margin: "0 5px"
      }
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        background: strength >= 2 ? color : "#E8E9E9",
        width: "100%",
        height: "2px",
        flex: 1,
        margin: "0 5px"
      }
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        background: strength >= 3 ? color : "#E8E9E9",
        width: "100%",
        height: "2px",
        flex: 1,
        margin: "0 5px"
      }
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        background: strength >= 4 ? color : "#E8E9E9",
        width: "100%",
        height: "2px",
        flex: 1,
        margin: "0 5px"
      }
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        background: strength >= 5 ? color : "#E8E9E9",
        width: "100%",
        height: "2px",
        flex: 1,
        margin: "0 5px"
      }
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        width: "370px",
        flexDirection: "column",
        display: props.showCheck,
        marginTop: 24
      }
    }, hasaNumber === true ? /*#__PURE__*/React__default["default"].createElement("div", {
      className: "passwordCheck",
      style: style.checkConditionsstatements
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.tick,
      style: {
        marginRight: 3
      }
    }), "A Number") : /*#__PURE__*/React__default["default"].createElement("div", {
      className: "passwordCheck",
      style: style.checkConditionsstatements
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.close,
      style: {
        marginRight: 3
      }
    }), "A Number"), hasaUpperCase === true ? /*#__PURE__*/React__default["default"].createElement("div", {
      className: "passwordCheck",
      style: style.checkConditionsstatements
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.tick,
      style: {
        marginRight: 3
      }
    }), "An Upper Case") : /*#__PURE__*/React__default["default"].createElement("div", {
      className: "passwordCheck",
      style: style.checkConditionsstatements
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.close,
      style: {
        marginRight: 3
      }
    }), "An Upper Case"), props.value.length >= 8 ? /*#__PURE__*/React__default["default"].createElement("div", {
      className: "passwordCheck",
      style: style.checkConditionsstatements
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.tick,
      style: {
        marginRight: 3
      }
    }), "At Least 8 Characters") : /*#__PURE__*/React__default["default"].createElement("div", {
      className: "passwordCheck",
      style: style.checkConditionsstatements
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.close,
      style: {
        marginRight: 3
      }
    }), "At Least 8 Characters"), hasaSpecial === true ? /*#__PURE__*/React__default["default"].createElement("div", {
      className: "passwordCheck",
      style: style.checkConditionsstatements
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.tick,
      style: {
        marginRight: 3
      }
    }), "A Special Character") : /*#__PURE__*/React__default["default"].createElement("div", {
      className: "passwordCheck",
      style: style.checkConditionsstatements
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.close,
      style: {
        marginRight: 3
      }
    }), "A Special Character"))));
  }
  FieldPassword.propTypes = {
    /** Optional */
    id: PropTypes__default["default"].string,

    /** default, inherit, primary, secondary */
    color: PropTypes__default["default"].string,

    /** true or false */
    required: PropTypes__default["default"].bool,
    label: PropTypes__default["default"].string,
    value: PropTypes__default["default"].string,
    onChange: PropTypes__default["default"].func,

    /** true or false */
    error: PropTypes__default["default"].bool,
    margin: PropTypes__default["default"].string,
    name: PropTypes__default["default"].string,

    /** standard, outlined, filled */
    variant: PropTypes__default["default"].string,
    helperText: PropTypes__default["default"].string,
    onClick: PropTypes__default["default"].func,
    visible: PropTypes__default["default"].string,
    showCheck: PropTypes__default["default"].string
  };
  FieldPassword.defaultProps = {
    id: "",
    color: "primary",
    required: false,
    label: "Password",
    value: "",
    onChange: FieldPassword.handleChange,
    error: false,
    margin: "normal",
    name: "password",
    placeholder: "Placeholder Text",
    variant: "standard",
    helperText: "Helper text",
    onClick: FieldPassword.handleClickShowPassword,
    visible: "flex",
    showCheck: "flex"
  };
  var style = {
    textfield: {
      margin: 0,
      width: 370
    },
    checkConditionsstatements: {
      display: "flex",
      alignItems: "center"
    }
  };

  var css_248z$1k = ".input_container{position:relative}.input_label{display:block;margin-bottom:8px;line-height:24px}.input_container .MuiInputBase-input,.input_label{color:#4c5e67;font-size:14px;font-family:Poppins,sans-serif;font-weight:400}.input_container .MuiOutlinedInput-input{height:56px;padding:0 16px;width:100%;background:#fff}.input_container .MuiFormControl-root{width:100%}.input_container textarea{color:#4c5e67;font-size:14px;font-family:Poppins,sans-serif;font-weight:400;border-color:#e4e8ec;padding:16px;width:96%;border-radius:4px;min-height:80px!important}.input_container textarea:focus{outline:none}.input_container .MuiOutlinedInput-notchedOutline{border-color:#e4e8ec}.input_container .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline{border-color:#2a8853}.input_container .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline span{color:#2a8853}.pro_tip:hover .toolTip{display:block}.toolTip{width:277px;background:#fff 0 0 no-repeat padding-box;-webkit-box-shadow:0 1px 4px rgba(0,0,0,.0902);box-shadow:0 1px 4px rgba(0,0,0,.0902);border:1px solid #e4e8ec;opacity:1;position:absolute;right:-328px;top:-18px;padding:16px;border-radius:4px;display:none}.toolTip:after{content:\"\";border:10px solid transparent;border-right-color:#e0e0e0;position:absolute;margin:-85px 0 0 -20px;left:-1px}.toolTip .tooltip_title{font-weight:600;margin-bottom:8px}.toolTip .tooltip_description,.toolTip .tooltip_title{color:#4c5e67;font-size:14px;font-family:Poppins,sans-serif}.toolTip .tooltip_description{font-weight:400}.change_label{position:absolute;top:17px;right:40px}.change_label,.checkbox_container .MuiFormControlLabel-label{color:#4c5e67;font-size:14px;font-family:Poppins,sans-serif;font-weight:500}.info_container{position:relative;display:inline-block;left:-10px;opacity:.5;top:1px}.infoIcon svg{color:#b0b9c1;position:relative;top:8px;width:17px}.inputButtonContainer .MuiButton-contained{background-color:#2a8853;padding:0 30px;font-size:14px;font-family:Poppins,sans-serif!important;font-weight:600;color:#fff;-webkit-box-shadow:none!important;box-shadow:none!important;text-transform:uppercase;height:50px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.inputButtonContainer .Mui-disabled{background-color:#e4e8ec;padding:15px 30px}.inputButtonContainer .Mui-disabled .MuiButton-label{color:#fff}.option-card-image{width:36px;margin-right:8px}.MuiSelect-select.MuiSelect-selectMenu .option-card-image{width:45px;margin-right:8px;position:relative;top:10px}.checkbox_container .MuiSvgIcon-root{color:#7d7d7d}.checkbox_container .Mui-checked .MuiSvgIcon-root{color:#05ce78!important}.checkbox_container .checkboxDescription{color:#4c5e67;font-size:12px;margin-left:30px;margin-top:-8px}.MuiFormControl-root{width:100%}.MuiFormHelperText-contained{margin-left:0;margin-right:0}.passwordCheck{font-size:11px;letter-spacing:0;color:#818e94;margin:8px 0 0}.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*=MuiOutlinedInput-root]{padding-right:65px;background:#fff}.SelectFieldContainer{position:relative}.MuiFormControl-marginNormal{margin:0!important}.bottom_text_col{position:absolute;width:100%}.bottom_text_col .error_text{font-size:12px;color:red}.counter_text,.helper_text{color:#a4a7b0;font-size:12px;margin:3px 0 0;text-align:left;font-family:Roboto,Helvetica,Arial,sans-serif;font-weight:400;line-height:1.66;letter-spacing:.03333em;position:absolute}.counter_text{right:0;text-transform:uppercase}.MuiButton-contained.Mui-disabled{background-color:rgba(0,0,0,.12)!important;color:rgba(0,0,0,.26)!important}.input_container .pro_tip,.textfield .pro_tip{position:absolute;right:0;top:0;cursor:default}.input_container .pro_tip{color:#4c5e67;font-size:14px;font-family:Poppins,sans-serif;font-weight:400;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.MuiOutlinedInput-notchedOutline{border-color:#e4e8ec}.error .input_container textarea{border-color:#f44336!important}";
  styleInject(css_248z$1k);

  function MultilineText(props) {
    var _message$length;

    var _React$useState = React__default["default"].useState(""),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        message = _React$useState2[0],
        setmessage = _React$useState2[1];

    var handleChange = function handleChange(e) {
      var _e$target$value;

      if (((_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : _e$target$value.length) <= props.count) {
        props.onChange(e);
        setmessage(e.target.value);
      }
    };

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: props.error
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "input_container"
    }, /*#__PURE__*/React__default["default"].createElement("label", {
      className: "input_label"
    }, props.label), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "MuiFormControl-root MuiTextField-root"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl"
    }, /*#__PURE__*/React__default["default"].createElement(core.TextareaAutosize, {
      placeholder: props.placeholder,
      value: props.value,
      onChange: function onChange(e) {
        return handleChange(e);
      }
    }))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "bottom_text_col"
    }, props.helpertext && /*#__PURE__*/React__default["default"].createElement("span", {
      className: "helper_text"
    }, props.helperText), props.errortext && /*#__PURE__*/React__default["default"].createElement("span", {
      className: "error_text"
    }, props.Errormessage), props.count && /*#__PURE__*/React__default["default"].createElement("span", {
      className: "counter_text"
    }, "Char ", (_message$length = message === null || message === void 0 ? void 0 : message.length) !== null && _message$length !== void 0 ? _message$length : 0, "/", props.count)), props.tooltip && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "pro_tip"
    }, "pro tips ", /*#__PURE__*/React__default["default"].createElement("img", {
      src: tipIcon,
      alt: "logo"
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "toolTip"
    }, /*#__PURE__*/React__default["default"].createElement(core.Typography, {
      className: "tooltip_title"
    }, "Not sure where to start?"), /*#__PURE__*/React__default["default"].createElement(core.Typography, {
      className: "tooltip_description"
    }, "body1. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos blanditiis tenetur unde suscipit,")))));
  }

  function CreditCardList(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "input_container textfield"
    }, /*#__PURE__*/React__default["default"].createElement("label", {
      className: "input_label"
    }, props.label), /*#__PURE__*/React__default["default"].createElement(FormControl__default["default"], {
      variant: "outlined"
    }, /*#__PURE__*/React__default["default"].createElement(Select__default["default"] // native
    , {
      value: props.paymentWith,
      onChange: function onChange(e) {
        return props.handleSelectChange(e.target.value);
      },
      inputProps: {
        name: 'card',
        id: 'outlined-age-native-simple'
      }
    }, props.cardListOptions && props.cardListOptions.length ? props.cardListOptions.map(function (option, i) {
      return /*#__PURE__*/React__default["default"].createElement(core.MenuItem, {
        value: option.cardNumber
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        src: option.cardImage,
        alt: "card-img",
        className: "option-card-image"
      }), option.cardName);
    }) : null, /*#__PURE__*/React__default["default"].createElement(core.MenuItem, {
      value: "newCard"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.newCardImage,
      alt: "card-img",
      className: "option-card-image"
    }), "New Card")), /*#__PURE__*/React__default["default"].createElement("label", {
      className: "change_label"
    }, "Change")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "bottom_text_col"
    }, props.helpertext && /*#__PURE__*/React__default["default"].createElement("span", {
      className: "helper_text"
    }, props.helperText), props.errortext && /*#__PURE__*/React__default["default"].createElement("span", {
      className: "error_text"
    }, props.Errormessage)), props.tooltip && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "pro_tip"
    }, "pro tips ", /*#__PURE__*/React__default["default"].createElement("img", {
      src: tipIcon,
      alt: "logo"
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "toolTip"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "tooltip_title"
    }, "Not sure where to start?"), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "tooltip_description"
    }, "body1. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos blanditiis tenetur unde suscipit,"))));
  }

  function TextInputFixedLabel(props) {
    var _props$disabled;

    var name = props.name,
        onChange = props.onChange,
        value = props.value,
        InputProps = props.InputProps,
        onBlur = props.onBlur,
        type = props.type;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "input_container textfield"
    }, props.labelStatus && /*#__PURE__*/React__default["default"].createElement("label", {
      className: "input_label"
    }, props.label), /*#__PURE__*/React__default["default"].createElement(TextField__default["default"], {
      error: props.error,
      id: "outlined-basic",
      variant: "outlined",
      label: props.labelfloat,
      placeholder: props.placeholder,
      name: name,
      onChange: onChange,
      value: value,
      disabled: (_props$disabled = props === null || props === void 0 ? void 0 : props.disabled) !== null && _props$disabled !== void 0 ? _props$disabled : false // InputProps={InputProps}
      ,
      onBlur: onBlur,
      type: type,
      color: "primary",
      InputProps: _objectSpread2({
        endAdornment: /*#__PURE__*/React__default["default"].createElement(InputAdornment__default["default"], {
          position: "end"
        }, props.icon)
      }, InputProps)
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "bottom_text_col"
    }, props.HelpertextStatus && /*#__PURE__*/React__default["default"].createElement("span", {
      className: "helper_text"
    }, props.helpertext), props.errortextStatus && /*#__PURE__*/React__default["default"].createElement("span", {
      className: "error_text"
    }, props.Errormessage), props.countStatus && /*#__PURE__*/React__default["default"].createElement("span", {
      className: "counter_text"
    }, props.count ? "char ".concat(props.charCount, "/").concat(props.count) : null)), props.tooltipStatus && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "pro_tip"
    }, "pro tips ", /*#__PURE__*/React__default["default"].createElement("img", {
      src: tipIcon,
      alt: "logo"
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "toolTip"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "tooltip_title"
    }, "Not sure where to start?"), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "tooltip_description"
    }, "body1. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos blanditiis tenetur unde suscipit,"))));
  }

  var css_248z$1j = ".OrderSummaryMainContainer{position:relative}.OrderSummaryMainContainer .OrderSummaryTitle{color:#4c5e67;font-size:16;border-bottom:1px solid #b0b9c1;padding-bottom:8;font-family:Poppins,sans-serif}.OrderSummaryMainContainer .itemContainer{border-bottom:1px solid #e4e8ec;height:56px}.OrderSummaryMainContainer .itemContainer,.OrderSummaryMainContainer .itemListing{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.OrderSummaryMainContainer .itemListing{padding:6px 0}.OrderSummaryMainContainer .itemText{color:#1b2121;font-size:14px;font-weight:600;font-family:Poppins,sans-serif;width:auto}.OrderSummaryMainContainer .editButton{color:#0590fa;font-size:14px;font-weight:600;text-transform:none;margin:0;padding:0;font-family:Poppins,sans-serif}.OrderSummaryMainContainer .itemAmountText,.OrderSummaryMainContainer .itemListText{color:#4c5e67;font-size:14px;font-weight:400;font-family:Poppins,sans-serif}.OrderSummaryMainContainer .itemAmountText{text-align:right}.OrderSummaryMainContainer .itemListContainer{margin-top:20px}.OrderSummaryMainContainer .itemBlueText{color:#0590fa}.OrderSummaryMainContainer .infoIcon{color:#b0b9c1;position:relative;top:7px;left:10px}.OrderSummaryMainContainer .FieldContainer{position:relative}.OrderSummaryMainContainer .ButtonApply{color:#0590fa;font-size:14px;font-weight:600;text-transform:none;margin:0;padding:0;font-family:Poppins,sans-serif;position:absolute;right:8px;top:15px}.OrderSummaryMainContainer .ButtonApply:hover{background-color:transparent}.OrderSummaryMainContainer .TotalContainer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:32px;padding-top:20px;border-top:1px solid #e4e8ec}.OrderSummaryMainContainer .TotalAmount,.OrderSummaryMainContainer .TotalText{color:#1b2121;font-size:20px;font-weight:500;font-family:Poppins,sans-serif}.OrderSummaryMainContainer .TotalAmount{text-align:right}";
  styleInject(css_248z$1j);

  function CheckOrderSummary(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "OrderSummaryMainContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "OrderSummaryTitle"
    }, "Order summary"), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "itemContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "itemText"
    }, "8 items"), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      href: "#",
      className: "editButton"
    }, "Edit Cart")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "itemListContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "itemListing"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "itemListText"
    }, "Subtotal"), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "itemAmountText"
    }, "$100.00")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "itemListing"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "itemListText"
    }, "Shipping"), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "itemAmountText"
    }, "Free")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "itemListing"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "itemListText"
    }, "Estimated tax for: ", /*#__PURE__*/React__default["default"].createElement("spa", {
      className: "itemBlueText"
    }, "11218"), /*#__PURE__*/React__default["default"].createElement(Tooltip__default["default"], {
      title: "The sales tax listed on the checkout page is only an estimate. \r Your invoice will contain the final sales tax, including state and local taxes,\r as well as any applicable rebates or fees.",
      arrow: true,
      placement: "top"
    }, /*#__PURE__*/React__default["default"].createElement(HelpRoundedIcon__default["default"], {
      className: "infoIcon"
    }))), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "itemAmountText"
    }, "$100.00")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "itemListing"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "itemListText"
    }, "Discounts"), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "itemAmountText"
    }, "$0.00")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FieldContainer"
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      helpertext: "Helper text",
      HelpertextStatus: false,
      placeholder: "Enter promo code",
      Errormessage: "Error message",
      errortextStatus: true,
      count: 100,
      countStatus: false,
      tooltipStatus: false
    }), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      href: "#",
      className: "ButtonApply"
    }, "Apply")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TotalContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "TotalText"
    }, "Total"), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "TotalAmount"
    }, "$120.00"))));
  }

  var css_248z$1i = ".CheckoutPaymentForm{border:1px solid #e4e8ec;padding:32px;border-radius:4px}.formSectionTitle{font-size:14px;font-weight:500;font-family:Poppins,sans-serif;color:#4c5e67;border-bottom:1px solid #e4e8ec;padding-bottom:8px;text-transform:uppercase}.separator_line{background-color:#e4e8ec;height:1px}.CheckoutPaymentForm .form_button_box .MuiButton-contained{border-radius:100px!important}.CheckoutPaymentForm .form_button_box{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.CheckoutPaymentForm .form_button_box .CheckoutRemovebutton .MuiButton-contained{background-color:transparent;background:none}.CheckoutPaymentForm .form_button_box .CheckoutRemovebutton .MuiButton-contained:focus,.CheckoutPaymentForm .form_button_box .CheckoutRemovebutton .MuiButton-contained:hover{background-color:transparent;background:none;-webkit-box-shadow:none!important;box-shadow:none!important}.CheckoutPaymentForm .form_button_box .CheckoutRemovebutton .MuiButton-contained .MuiButton-label{color:#1b2121;text-transform:uppercase}.form_button_Contianer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:end;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.form_button_box .CheckoutTostext{color:#4c5e67;font-size:14px;font-family:Poppins,sans-serif;font-weight:400;-webkit-box-flex:1;-ms-flex:1;flex:1}.form_button_box .CheckoutTostext a{color:#0590fa;font-size:14px;font-family:Poppins,sans-serif;font-weight:400}.billingAddressContainer .billingAddressTitle{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.billingAddressContainer .billingAddressTitle span{color:#4c5e67;font-size:16px;font-family:Poppins,sans-serif;font-weight:600}.billingAddressContainer .billingAddressTitle a{color:#0590fa;font-size:14px;font-family:Poppins,sans-serif;font-weight:500}.billingaddressInfo li{display:block;color:#4c5e67;font-size:16px;margin-top:4px;letter-spacing:0}.masterCardImage{width:50px;left:5;position:\"relative\"}.ReactFlagsSelect-module_selectBtn__19wW7{font-size:16px;margin-top:0;height:56px}.CheckoutPaymentForm input::-webkit-inner-spin-button,.CheckoutPaymentForm input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.CheckoutPaymentForm input[type=number]{-moz-appearance:textfield}.SucureText{font-size:16px;color:#4c5e67;font-family:Poppins,sans-serif;font-weight:400;margin-bottom:8px}.SucureText svg{font-size:18px;color:#4c5e67;opacity:.5;position:relative;top:3px}.CheckoutPaymentForm .field_card{width:40px;border-radius:3px}.ZamzamCheckoutPaymentForm .CVVField{position:relative}.ZamzamCheckoutPaymentForm .cvvTooltipContainer{position:absolute;top:48px;right:9px}.ZamzamCheckoutPaymentForm .cvvTooltipContainer img{width:24px;height:24px}.FormTitle{color:#1b2121;font-size:20px;font-weight:500;position:relative;bottom:-10px;margin:-20px 0 0!important}";
  styleInject(css_248z$1i);

  var top100Films = [{
    title: 'The Shawshank Redemption',
    year: 1994
  }, {
    title: 'The Godfather',
    year: 1972
  }, {
    title: 'The Godfather: Part II',
    year: 1974
  }];

  var SelectField = function SelectField(props) {
    var _props$value, _props$selectOptions;

    var _React$useState = React__default["default"].useState((_props$value = props === null || props === void 0 ? void 0 : props.value) !== null && _props$value !== void 0 ? _props$value : ''),
        _React$useState2 = _slicedToArray(_React$useState, 2);
        _React$useState2[0];
        _React$useState2[1];

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SelectFieldContainer"
    }, props.labelStatus && /*#__PURE__*/React__default["default"].createElement("label", {
      className: "input_label"
    }, props.labelFixed), /*#__PURE__*/React__default["default"].createElement(Autocomplete__default["default"], {
      id: "combo-box-demo",
      options: (_props$selectOptions = props.selectOptions) !== null && _props$selectOptions !== void 0 && _props$selectOptions.length ? props.selectOptions : top100Films,
      getOptionLabel: function getOptionLabel(option) {
        return option.title;
      },
      defaultValue: props !== null && props !== void 0 && props.selectOptions && props !== null && props !== void 0 && props.value ? props === null || props === void 0 ? void 0 : props.selectOptions.find(function (v) {
        return v.title === (props === null || props === void 0 ? void 0 : props.value);
      }) : '',
      renderInput: function renderInput(params) {
        return /*#__PURE__*/React__default["default"].createElement(TextField__default["default"], _extends({}, params, {
          label: props.label,
          variant: "outlined"
        }));
      },
      onChange: function onChange(event, newValue) {
        return props.onChange(event, newValue);
      } // inputValue={inputValue}
      // onInputChange={(event, newInputValue) => {
      //     console.log("newInputValue: ", newInputValue);
      //     setInputValue(newInputValue.title);
      // }}

    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "bottom_text_col"
    }, props.helpertext && /*#__PURE__*/React__default["default"].createElement("span", {
      className: "helper_text"
    }, props.helperText), props.errortext && /*#__PURE__*/React__default["default"].createElement("span", {
      className: "error_text"
    }, props.Errormessage)));
  };

  function CheckBox(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "checkbox_container"
    }, /*#__PURE__*/React__default["default"].createElement(FormControlLabel__default["default"], {
      value: props.value,
      control: /*#__PURE__*/React__default["default"].createElement(Checkbox__default["default"], {
        onChange: function onChange(e) {
          return props.onChange(e.target.checked);
        },
        checked: props.checked,
        color: "primary"
      }),
      label: props.label,
      labelPlacement: "end"
    }), props.Tooltip && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "info_container"
    }, /*#__PURE__*/React__default["default"].createElement(Tooltip__default["default"], {
      title: props.Tooltiptext,
      placement: "right",
      style: {
        color: "red"
      }
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "infoIcon"
    }, /*#__PURE__*/React__default["default"].createElement(InfoIcon__default["default"], null)))), props.Description && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "checkboxDescription"
    }, props.description));
  }

  var css_248z$1h = ".MsInputButtonMainContainer .MsInputButton{font-size:14px!important;text-transform:uppercase;padding:0 23px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:0;-webkit-box-shadow:none!important;box-shadow:none!important}.MsInputButtonMainContainer .MsInputButton svg{font-size:17px;margin-left:4px}.MsInputButtonMainContainer .DonationHandIcon{width:24px;margin-right:6px}";
  styleInject(css_248z$1h);

  function ButtonOne(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "MsInputButtonMainContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      href: props.link,
      target: props.target,
      to: props.path,
      className: "MsInputButton",
      style: {
        background: props.buttoncolor,
        width: props.width,
        height: props.height,
        color: props.color,
        border: props.border,
        borderRadius: props.borderRadius,
        justifyContent: props.textAlign,
        fontWeight: props.fontWeight
      },
      onClick: props.onClick,
      disabled: props.disabled
    }, props.addIcon && /*#__PURE__*/React__default["default"].createElement(AddRoundedIcon__default["default"], {
      style: {
        color: props.AddIconColor,
        marginRight: "5px"
      }
    }), props.handIconStatus && /*#__PURE__*/React__default["default"].createElement("img", {
      className: "DonationHandIcon",
      src: "https://dc-img-assets.s3.amazonaws.com/DEENCONNECT-manage-masjid-organization-donation-hand-icon.webp"
    }), props.label, props.arrowStatus && /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        color: props.arrowColor,
        display: "flex"
      }
    }, props.arrowIcon, " ")));
  }

  var usStates = [{
    "id": 1456,
    "name": "Alabama",
    "state_code": "AL"
  }, {
    "id": 1400,
    "name": "Alaska",
    "state_code": "AK"
  }, {
    "id": 1424,
    "name": "American Samoa",
    "state_code": "AS"
  }, {
    "id": 1434,
    "name": "Arizona",
    "state_code": "AZ"
  }, {
    "id": 1444,
    "name": "Arkansas",
    "state_code": "AR"
  }, {
    "id": 1402,
    "name": "Baker Island",
    "state_code": "UM-81"
  }, {
    "id": 1416,
    "name": "California",
    "state_code": "CA"
  }, {
    "id": 1450,
    "name": "Colorado",
    "state_code": "CO"
  }, {
    "id": 1435,
    "name": "Connecticut",
    "state_code": "CT"
  }, {
    "id": 1399,
    "name": "Delaware",
    "state_code": "DE"
  }, {
    "id": 1437,
    "name": "District of Columbia",
    "state_code": "DC"
  }, {
    "id": 1436,
    "name": "Florida",
    "state_code": "FL"
  }, {
    "id": 1455,
    "name": "Georgia",
    "state_code": "GA"
  }, {
    "id": 1412,
    "name": "Guam",
    "state_code": "GU"
  }, {
    "id": 1411,
    "name": "Hawaii",
    "state_code": "HI"
  }, {
    "id": 1398,
    "name": "Howland Island",
    "state_code": "UM-84"
  }, {
    "id": 1460,
    "name": "Idaho",
    "state_code": "ID"
  }, {
    "id": 1425,
    "name": "Illinois",
    "state_code": "IL"
  }, {
    "id": 1440,
    "name": "Indiana",
    "state_code": "IN"
  }, {
    "id": 1459,
    "name": "Iowa",
    "state_code": "IA"
  }, {
    "id": 1410,
    "name": "Jarvis Island",
    "state_code": "UM-86"
  }, {
    "id": 1428,
    "name": "Johnston Atoll",
    "state_code": "UM-67"
  }, {
    "id": 1406,
    "name": "Kansas",
    "state_code": "KS"
  }, {
    "id": 1419,
    "name": "Kentucky",
    "state_code": "KY"
  }, {
    "id": 1403,
    "name": "Kingman Reef",
    "state_code": "UM-89"
  }, {
    "id": 1457,
    "name": "Louisiana",
    "state_code": "LA"
  }, {
    "id": 1453,
    "name": "Maine",
    "state_code": "ME"
  }, {
    "id": 1401,
    "name": "Maryland",
    "state_code": "MD"
  }, {
    "id": 1433,
    "name": "Massachusetts",
    "state_code": "MA"
  }, {
    "id": 1426,
    "name": "Michigan",
    "state_code": "MI"
  }, {
    "id": 1438,
    "name": "Midway Atoll",
    "state_code": "UM-71"
  }, {
    "id": 1420,
    "name": "Minnesota",
    "state_code": "MN"
  }, {
    "id": 1430,
    "name": "Mississippi",
    "state_code": "MS"
  }, {
    "id": 1451,
    "name": "Missouri",
    "state_code": "MO"
  }, {
    "id": 1446,
    "name": "Montana",
    "state_code": "MT"
  }, {
    "id": 1439,
    "name": "Navassa Island",
    "state_code": "UM-76"
  }, {
    "id": 1408,
    "name": "Nebraska",
    "state_code": "NE"
  }, {
    "id": 1458,
    "name": "Nevada",
    "state_code": "NV"
  }, {
    "id": 1404,
    "name": "New Hampshire",
    "state_code": "NH"
  }, {
    "id": 1417,
    "name": "New Jersey",
    "state_code": "NJ"
  }, {
    "id": 1423,
    "name": "New Mexico",
    "state_code": "NM"
  }, {
    "id": 1452,
    "name": "New York",
    "state_code": "NY"
  }, {
    "id": 1447,
    "name": "North Carolina",
    "state_code": "NC"
  }, {
    "id": 1418,
    "name": "North Dakota",
    "state_code": "ND"
  }, {
    "id": 1431,
    "name": "Northern Mariana Islands",
    "state_code": "MP"
  }, {
    "id": 4851,
    "name": "Ohio",
    "state_code": "OH"
  }, {
    "id": 1421,
    "name": "Oklahoma",
    "state_code": "OK"
  }, {
    "id": 1415,
    "name": "Oregon",
    "state_code": "OR"
  }, {
    "id": 1448,
    "name": "Palmyra Atoll",
    "state_code": "UM-95"
  }, {
    "id": 1422,
    "name": "Pennsylvania",
    "state_code": "PA"
  }, {
    "id": 1449,
    "name": "Puerto Rico",
    "state_code": "PR"
  }, {
    "id": 1461,
    "name": "Rhode Island",
    "state_code": "RI"
  }, {
    "id": 1443,
    "name": "South Carolina",
    "state_code": "SC"
  }, {
    "id": 1445,
    "name": "South Dakota",
    "state_code": "SD"
  }, {
    "id": 1454,
    "name": "Tennessee",
    "state_code": "TN"
  }, {
    "id": 1407,
    "name": "Texas",
    "state_code": "TX"
  }, {
    "id": 1432,
    "name": "United States Minor Outlying Islands",
    "state_code": "UM"
  }, {
    "id": 1413,
    "name": "United States Virgin Islands",
    "state_code": "VI"
  }, {
    "id": 1414,
    "name": "Utah",
    "state_code": "UT"
  }, {
    "id": 1409,
    "name": "Vermont",
    "state_code": "VT"
  }, {
    "id": 1427,
    "name": "Virginia",
    "state_code": "VA"
  }, {
    "id": 1405,
    "name": "Wake Island",
    "state_code": "UM-79"
  }, {
    "id": 1462,
    "name": "Washington",
    "state_code": "WA"
  }, {
    "id": 1429,
    "name": "West Virginia",
    "state_code": "WV"
  }, {
    "id": 1441,
    "name": "Wisconsin",
    "state_code": "WI"
  }, {
    "id": 1442,
    "name": "Wyoming",
    "state_code": "WY"
  }];

  var css_248z$1g = ".packageCardContainer .PackageTitle{font-weight:600;font-size:14px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#1b2121}.packageCardContainer .PackageTitle svg{margin-right:9px;color:#4c5e67;font-size:24px}.packageCardContainer .PackageTitle img{margin-right:9px;width:24px}.packageCardContainer .DayText{font-size:20px;color:#0b132b;font-weight:700}.packageCardContainer .PackageText{font-size:14px;color:#676c7b;font-weight:400}.packageCardContainer .MuiCardActionArea-root{width:100%;height:100%;display:block}.packageCardContainer .MuiCardContent-root{padding:16px;height:100%}.packageCardContainer .PackageDetailLink{color:#0590fa;font-size:14px;font-weight:500;margin-top:8px;display:inline-block}";
  styleInject(css_248z$1g);

  function PackageCard(props) {
    var _React$useState = React__default["default"].useState({
      tickVisibility: props !== null && props !== void 0 && props.isTickVisible ? props.isTickVisible : false
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        value = _React$useState2[0],
        setValue = _React$useState2[1];

    var _onClick = function onClick() {
      setValue(_objectSpread2(_objectSpread2({}, value), {}, {
        tickVisibility: !value.tickVisibility
      }));
      props.cardFunction(value);
    };

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "packageCardContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Card__default["default"], {
      variant: "outlined",
      style: value.tickVisibility == true ? styles.mainTicked : styles.main,
      onClick: function onClick() {
        return _onClick();
      }
    }, /*#__PURE__*/React__default["default"].createElement(CardActionArea__default["default"], null, /*#__PURE__*/React__default["default"].createElement(CardContent__default["default"], null, /*#__PURE__*/React__default["default"].createElement("section", {
      style: styles.baseIcon
    }, value.tickVisibility && /*#__PURE__*/React__default["default"].createElement(CheckCircleIcon__default["default"], {
      style: styles.icon
    })), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "PackageTitle",
      style: {
        color: props.color
      }
    }, props.cardIconStatus && props.icon, " ", props.header), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "DayText"
    }, props.dayText), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "PackageText"
    }, props.body), props.Link && /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      className: "PackageDetailLink"
    }, props.buttonLabel)))));
  }
  var styles = {
    baseIcon: {
      position: "absolute",
      right: "10px",
      top: "10px"
    },
    icon: {
      color: "#2490F9"
    }
  };
  PackageCard.propTypes = {
    /** icon name if available in BaseIcon or svg code*/
    icon: PropTypes__default["default"].string,

    /** selection of the card */
    cardFunction: PropTypes__default["default"].func,
    header: PropTypes__default["default"].string,
    body: PropTypes__default["default"].string
  };

  function CheckoutPayment(props) {
    var _props$editMode, _props$cardImage, _React$createElement, _props$editMode2, _React$createElement2, _props$editMode3, _React$createElement3, _React$createElement4, _React$createElement5, _React$createElement6, _React$createElement7, _React$createElement8, _React$createElement9, _props$buttoncolor, _props$buttonTextcolo;

    props.privacyPolicyLink;
        props.termsOfUseLink;
        var cardDetails = props.cardDetails,
        setcardDetails = props.setcardDetails,
        addressDetails = props.addressDetails,
        setaddressDetails = props.setaddressDetails,
        saveCardDetails = props.saveCardDetails,
        setsaveCardDetails = props.setsaveCardDetails,
        selectedCardDetails = props.selectedCardDetails,
        onEditBillingDetailClick = props.onEditBillingDetailClick,
        visaCardImage = props.visaCardImage,
        masterCardImage = props.masterCardImage,
        helpImage = props.helpImage,
        newCardImage = props.newCardImage,
        discoverCardImage = props.discoverCardImage,
        americanExpressImage = props.americanExpressImage,
        dinersCardImage = props.dinersCardImage;

    var _React$useState = React__default["default"].useState("newCard"),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        paymentWith = _React$useState2[0],
        setpaymentWith = _React$useState2[1];

    var _React$useState3 = React__default["default"].useState("creditCard"),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        paymentMethod = _React$useState4[0],
        setPaymentMethod = _React$useState4[1];

    var _React$useState5 = React__default["default"].useState({
      cardNumberError: false,
      expirationError: false,
      codeError: false
    }),
        _React$useState6 = _slicedToArray(_React$useState5, 2),
        cardDetailsError = _React$useState6[0],
        setcardDetailsError = _React$useState6[1];

    var onSubmit = function onSubmit() {
      if (paymentMethod === 'creditCard') {
        if (paymentWith === "newCard") {
          var _cardDetails$cardNumb;

          var newNumber = cardDetails === null || cardDetails === void 0 ? void 0 : (_cardDetails$cardNumb = cardDetails.cardNumber) === null || _cardDetails$cardNumb === void 0 ? void 0 : _cardDetails$cardNumb.replace(/\s/g, '');
          var _cardNumber = cardDetails.cardNumber;

          if (_cardNumber[0] !== '3' && newNumber.length < 16 || _cardNumber[0] === '3' && newNumber.length < 14) {
            setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
              cardNumberError: true
            }));
            return;
          } else if (_cardNumber !== null && _cardNumber !== void 0 && _cardNumber.startsWith('37') && code.length < 4 || !(_cardNumber !== null && _cardNumber !== void 0 && _cardNumber.startsWith('37')) && code.length < 3) {
            setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
              cardNumberError: true
            }));
            return;
          }

          var cardData = _objectSpread2(_objectSpread2({}, cardDetails), {}, {
            cardNumber: newNumber
          });

          props.onPlaceOrderSubmit({
            cardData: cardData,
            addressDetails: addressDetails
          });
        } else {
          props.onPlaceOrderSubmit({
            selectedCardDetails: selectedCardDetails
          });
        }
      } else {
        props.onPlaceOrderSubmit({
          paymentCheque: true
        });
      }
    };

    var handleCardDetailChange = function handleCardDetailChange(e) {
      if (e.target.name === 'expiration') {
        var input = e.target.value;

        if (!/^\d{0,2}\/?\d{0,2}$/.test(input)) {
          return;
        }

        if (/^\d{3,}$/.test(input)) {
          input = input.match(new RegExp('.{1,2}', 'g')).join('/');
        }

        setcardDetails(_objectSpread2(_objectSpread2({}, cardDetails), {}, _defineProperty({}, e.target.name, input)));
      } else {
        setcardDetails(_objectSpread2(_objectSpread2({}, cardDetails), {}, _defineProperty({}, e.target.name, e.target.value)));
      }
    };

    var handleAddressDetailChange = function handleAddressDetailChange(e) {
      if (e.target.name === "postalCode") {
        var numRegx = /^\d+$/;

        if (e.target.value.length <= 5 && numRegx.test(e.target.value)) {
          setaddressDetails(_objectSpread2(_objectSpread2({}, addressDetails), {}, _defineProperty({}, e.target.name, e.target.value)));
        } else if (event.target.value.length < 1) {
          setaddressDetails(_objectSpread2(_objectSpread2({}, addressDetails), {}, _defineProperty({}, e.target.name, e.target.value)));
        }
      } else {
        setaddressDetails(_objectSpread2(_objectSpread2({}, addressDetails), {}, _defineProperty({}, e.target.name, e.target.value)));
      }
    };

    var handleStateChange = function handleStateChange(event, newValue) {
      setaddressDetails(_objectSpread2(_objectSpread2({}, addressDetails), {}, {
        state: newValue.title
      }));
    }; // function NumberFormatCustom(props) {
    //     const { inputRef, onChange, ...other } = props;
    //     return (
    //         <NumberFormat
    //             {...other}
    //             getInputRef={inputRef}
    //             onValueChange={(values) => {
    //                 onChange({
    //                     target: {
    //                         name: props.name,
    //                         value: values.value,
    //                     },
    //                 });
    //             }}
    //             isNumericString
    //         />
    //     );
    // }
    // const cardImage = (number) => {
    //     // visa card
    //     if (/^4[0-9]{12}(?:[0-9]{3})?$/.test(number)) {
    //         return (
    //             <InputAdornment position="end">
    //                 <img src={visaCardImage} className="masterCardImage" alt="card img" />
    //             </InputAdornment>
    //         )
    //     }
    //     //master card
    //     else if (/^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/.test(number)) {
    //         return (
    //             <InputAdornment position="end">
    //                 <img src={masterCardImage} className="masterCardImage" alt="card img" />
    //             </InputAdornment>
    //         )
    //     }
    //     // American Express
    //     else if (/^3[47][0-9]{13}$/.test(number)) {
    //         return (
    //             <InputAdornment position="end">
    //                 <img src={americanExpressImage} className="masterCardImage" alt="card img" />
    //             </InputAdornment>
    //         )
    //     }
    //     //Diners Club
    //     else if (/^3(?:0[0-5]|[68][0-9])[0-9]{11}$/.test(number)) {
    //         return (
    //             <InputAdornment position="end">
    //                 <img src={dinersCardImage} className="masterCardImage" alt="card img" />
    //             </InputAdornment>
    //         )
    //     }
    //     //Discover
    //     else if (/^6(?:011|5[0-9]{2})[0-9]{12}$/.test(number)) {
    //         return (
    //             <InputAdornment position="end">
    //                 <img src={discoverCardImage} className="masterCardImage" alt="card img" />
    //             </InputAdornment>
    //         )
    //     }
    // }


    var checkCVC = function checkCVC() {
      var cardNumber = cardDetails.cardNumber,
          code = cardDetails.code;

      if (cardNumber[0] === '3' ? code.length !== 4 : code.length !== 3) {
        return false;
      } else {
        return true;
      }
    };

    var validateExpiration = function validateExpiration() {
      var expiration = cardDetails.expiration;

      if (/^(0[1-9]|1[0-2])\/\d{2}$/.test(expiration)) {
        var today, someday;
        var exMonth = expiration.split("/")[0];
        var exYear = expiration.split("/")[1];
        today = new Date();
        someday = new Date();
        someday.setFullYear('20' + exYear, exMonth, 1);

        if (someday < today) {
          console.log("The expiry date is before today's date. Please select a valid expiry date");
          return false;
        }

        return true;
      } else {
        return false;
      }
    };

    var handlePaymentCardSelectChange = function handlePaymentCardSelectChange(selectedCard) {
      props.handlePaymentSelectChange(selectedCard);
      setpaymentWith(selectedCard);
    };

    var creditCardFormat = function creditCardFormat(card, regex) {
      if (!card) return card;

      if (card[0] === '3') {
        var str = card;

        if (str.length === 4) {
          str = str + ' ';
          return str;
        } else if (str.length === 10) {
          str = str + '';
          return str;
        } else if (str.length === 11) {
          str = str + ' ';
          return str;
        } else {
          return str;
        }
      }

      var cardWithoutSpace = card.replace(/\s/g, '');
      var cardTemp = cardWithoutSpace.match(/.{1,4}/g);
      return cardTemp.join(' ');
    };

    var cardNumber = cardDetails.cardNumber,
        expiration = cardDetails.expiration,
        code = cardDetails.code;
    var cardNumberError = cardDetailsError.cardNumberError,
        expirationError = cardDetailsError.expirationError,
        codeError = cardDetailsError.codeError;
    var firstName = addressDetails.firstName,
        lastName = addressDetails.lastName,
        line1 = addressDetails.line1,
        line2 = addressDetails.line2,
        city = addressDetails.city,
        state = addressDetails.state,
        postalCode = addressDetails.postalCode,
        country = addressDetails.country;
    var isError = (cardNumber === null || cardNumber === void 0 ? void 0 : cardNumber.length) < 14;
    var disableBtn = !isError && !cardNumberError && validateExpiration() && checkCVC() && firstName && lastName && line1 && city && state && postalCode && country ? false : true; // let disableBtn = checkCVC(code) ? false : true;

    console.log("disableBtn", disableBtn);
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SucureText"
    }, props.ScuredLabel, " ", /*#__PURE__*/React__default["default"].createElement(LockOutlinedIcon__default["default"], null)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CheckoutPaymentForm"
    }, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      md: 12,
      sm: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("h1", {
      className: "FormTitle"
    }, "Select payment method")), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      md: 6,
      sm: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
      cardFunction: function cardFunction() {
        return setPaymentMethod('creditCard');
      },
      header: "Credit Card",
      color: "#1B2121",
      icon: props.creditCard,
      cardIconStatus: props.cardIconStatus,
      Link: false
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      md: 6,
      sm: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
      cardFunction: function cardFunction() {
        return setPaymentMethod('cheque');
      },
      header: "Pay Check",
      color: "#1B2121",
      icon: props.paycheck,
      cardIconStatus: props.cardIconStatus,
      Link: false
    }))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      container: true,
      spacing: 3
    }, paymentMethod === 'creditCard' ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, " ", props.paywithdropdown && /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(CreditCardList, {
      label: "Pay with",
      helperText: "Helper text",
      Errormessage: "Error message",
      helpertext: false,
      errortext: false,
      tooltip: false,
      paymentWith: paymentWith,
      handleSelectChange: handlePaymentCardSelectChange,
      cardListOptions: props.creditCardsList // visaCardImage={visaCardImage}
      // masterCardImage={masterCardImage}
      ,
      newCardImage: newCardImage
    })), paymentWith === "newCard" ? /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement = {
      label: "Card number",
      labelStatus: true,
      helperText: "Helper text",
      placeholder: "4242424242424242",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement, "count", false), _defineProperty(_React$createElement, "tooltip", false), _defineProperty(_React$createElement, "inputlabel", true), _defineProperty(_React$createElement, "name", "cardNumber"), _defineProperty(_React$createElement, "disabled", (_props$editMode = props === null || props === void 0 ? void 0 : props.editMode) !== null && _props$editMode !== void 0 ? _props$editMode : false), _defineProperty(_React$createElement, "onChange", function onChange(e) {
      if (e.target.value.replace(/\s/g, '').match(/^\d+$/)) {
        var _e$target$value;

        var card = creditCardFormat(e.target.value);
        var cardWithoutSpace = card.replace(/\s/g, '');
        setcardDetails(_objectSpread2(_objectSpread2({}, cardDetails), {}, {
          cardNumber: cardWithoutSpace.length > 16 ? cardNumber : card,
          code: !((_e$target$value = e.target.value) !== null && _e$target$value !== void 0 && _e$target$value.startsWith('37')) && code.length >= 4 ? code.slice(0, 3) : code
        }));
      } else if (!e.target.value) {
        setcardDetails(_objectSpread2(_objectSpread2({}, cardDetails), {}, {
          cardNumber: ''
        }));
      }
    }), _defineProperty(_React$createElement, "value", cardNumber), _defineProperty(_React$createElement, "onBlur", function onBlur() {
      var newNumber = cardNumber === null || cardNumber === void 0 ? void 0 : cardNumber.replace(/\s/g, '');

      if (cardNumber.length !== 0) {
        var _isError = cardNumber.length < 14;

        setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
          cardNumberError: _isError
        }));
      } else if (cardNumber[0] !== '3' && newNumber.length < 16 || cardNumber[0] === '3' && newNumber.length < 14) {
        setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
          cardNumberError: true
        }));
      } else if (cardNumber !== null && cardNumber !== void 0 && cardNumber.startsWith('37') && code.length < 4 || !(cardNumber !== null && cardNumber !== void 0 && cardNumber.startsWith('37')) && code.length < 3) {
        setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
          cardNumberError: true
        }));
      }
    }), _defineProperty(_React$createElement, "errortextStatus", cardNumberError ? true : false), _defineProperty(_React$createElement, "Errormessage", cardNumberError ? "Enter valid card number" : ""), _defineProperty(_React$createElement, "icon", (props === null || props === void 0 ? void 0 : props.editMode) && /*#__PURE__*/React__default["default"].createElement("img", {
      className: "field_card",
      src: (_props$cardImage = props === null || props === void 0 ? void 0 : props.cardImage) !== null && _props$cardImage !== void 0 ? _props$cardImage : ''
    }) || cardNumber[0] === '4' && /*#__PURE__*/React__default["default"].createElement("img", {
      className: "field_card",
      src: visaCardImage
    }) || cardNumber[0] === '2' && /*#__PURE__*/React__default["default"].createElement("img", {
      className: "field_card",
      src: masterCardImage
    }) || ((cardNumber === null || cardNumber === void 0 ? void 0 : cardNumber.startsWith('51')) || (cardNumber === null || cardNumber === void 0 ? void 0 : cardNumber.startsWith('52')) || (cardNumber === null || cardNumber === void 0 ? void 0 : cardNumber.startsWith('53')) || (cardNumber === null || cardNumber === void 0 ? void 0 : cardNumber.startsWith('54')) || (cardNumber === null || cardNumber === void 0 ? void 0 : cardNumber.startsWith('55'))) && /*#__PURE__*/React__default["default"].createElement("img", {
      className: "field_card",
      style: {
        border: '1px solid #000066',
        backgroundColor: '#000066'
      },
      src: masterCardImage
    }) || ((cardNumber === null || cardNumber === void 0 ? void 0 : cardNumber.startsWith('37')) || (cardNumber === null || cardNumber === void 0 ? void 0 : cardNumber.startsWith('34'))) && /*#__PURE__*/React__default["default"].createElement("img", {
      className: "field_card",
      src: americanExpressImage
    }) || (cardNumber === null || cardNumber === void 0 ? void 0 : cardNumber.startsWith('60')) && /*#__PURE__*/React__default["default"].createElement("img", {
      className: "field_card",
      src: discoverCardImage
    }) || ((cardNumber === null || cardNumber === void 0 ? void 0 : cardNumber.startsWith('2131')) || (cardNumber === null || cardNumber === void 0 ? void 0 : cardNumber.startsWith('1800')) || (cardNumber === null || cardNumber === void 0 ? void 0 : cardNumber.startsWith('35'))) && /*#__PURE__*/React__default["default"].createElement("img", {
      className: "field_card",
      src: props.jcbCardImg
    }) || (cardNumber === null || cardNumber === void 0 ? void 0 : cardNumber.startsWith('62')) && /*#__PURE__*/React__default["default"].createElement("img", {
      className: "field_card",
      src: props.unionPayImg
    }) || ((cardNumber === null || cardNumber === void 0 ? void 0 : cardNumber.startsWith('30')) || (cardNumber === null || cardNumber === void 0 ? void 0 : cardNumber.startsWith('36'))) && /*#__PURE__*/React__default["default"].createElement("img", {
      className: "field_card",
      src: dinersCardImage
    })), _React$createElement))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 3
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement2 = {
      label: "Expiration",
      labelStatus: true,
      placeholder: "MM/YY",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement2, "count", false), _defineProperty(_React$createElement2, "inputlabel", true), _defineProperty(_React$createElement2, "tooltip", false), _defineProperty(_React$createElement2, "name", "expiration"), _defineProperty(_React$createElement2, "onChange", handleCardDetailChange), _defineProperty(_React$createElement2, "value", expiration), _defineProperty(_React$createElement2, "onBlur", function onBlur() {
      return validateExpiration() ? setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
        expirationError: false
      })) : setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
        expirationError: true
      }));
    }), _defineProperty(_React$createElement2, "errortextStatus", !validateExpiration() && expirationError ? true : false), _defineProperty(_React$createElement2, "Errormessage", !validateExpiration() && expirationError ? "Invalid exp date" : ""), _defineProperty(_React$createElement2, "disabled", (_props$editMode2 = props === null || props === void 0 ? void 0 : props.editMode) !== null && _props$editMode2 !== void 0 ? _props$editMode2 : false), _React$createElement2))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 3
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement3 = {
      label: "Security code",
      labelStatus: true,
      helperText: "Helper text",
      placeholder: "CVV",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement3, "count", false), _defineProperty(_React$createElement3, "tooltip", false), _defineProperty(_React$createElement3, "inputlabel", true), _defineProperty(_React$createElement3, "name", "code"), _defineProperty(_React$createElement3, "onChange", function onChange(e) {
      return (cardNumber !== null && cardNumber !== void 0 && cardNumber.startsWith('37') || cardNumber !== null && cardNumber !== void 0 && cardNumber.startsWith('34')) && e.target.value.length >= 0 && e.target.value.length <= 4 ? handleCardDetailChange(e) : e.target.value.length >= 0 && e.target.value.length < 4 ? handleCardDetailChange(e) : null;
    }), _defineProperty(_React$createElement3, "value", code), _defineProperty(_React$createElement3, "type", props !== null && props !== void 0 && props.editMode ? "password" : "number"), _defineProperty(_React$createElement3, "InputProps", {
      endAdornment: /*#__PURE__*/React__default["default"].createElement(core.InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default["default"].createElement(Tooltip__default["default"], {
        title: props.TooltipQuestionIcontext,
        placement: "top",
        style: {
          color: "red"
        }
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        src: helpImage,
        width: "30px",
        alt: "card img"
      })))
    }), _defineProperty(_React$createElement3, "onBlur", function onBlur() {
      return checkCVC() ? setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
        codeError: false
      })) : setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
        codeError: true
      }));
    }), _defineProperty(_React$createElement3, "errortextStatus", !checkCVC() && codeError ? true : false), _defineProperty(_React$createElement3, "Errormessage", !checkCVC() && codeError ? "Enter Valid CVC Number" : ""), _defineProperty(_React$createElement3, "disabled", (_props$editMode3 = props === null || props === void 0 ? void 0 : props.editMode) !== null && _props$editMode3 !== void 0 ? _props$editMode3 : false), _React$createElement3)))) : null, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "formSectionTitle"
    }, "Billing address")), paymentWith !== "newCard" ? /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "billingAddressContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "billingAddressTitle"
    }, /*#__PURE__*/React__default["default"].createElement("span", null, selectedCardDetails && selectedCardDetails.firstName, "  ", selectedCardDetails && selectedCardDetails.lastName), " ", /*#__PURE__*/React__default["default"].createElement("span", {
      style: {
        color: "#0590FA",
        cursor: "pointer"
      },
      onClick: onEditBillingDetailClick
    }, "Edit")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "billingaddressInfo"
    }, /*#__PURE__*/React__default["default"].createElement("li", null, selectedCardDetails && selectedCardDetails.line1), /*#__PURE__*/React__default["default"].createElement("li", null, selectedCardDetails && selectedCardDetails.city, ", ", selectedCardDetails && selectedCardDetails.state, " ", selectedCardDetails && selectedCardDetails.postalCode), /*#__PURE__*/React__default["default"].createElement("li", null, selectedCardDetails && selectedCardDetails.country)))) : null, paymentWith === "newCard" ? /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement4 = {
      label: "First name",
      labelStatus: true,
      helperText: "Helper text",
      placeholder: "First name",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement4, "count", false), _defineProperty(_React$createElement4, "tooltip", false), _defineProperty(_React$createElement4, "inputlabel", true), _defineProperty(_React$createElement4, "name", "firstName"), _defineProperty(_React$createElement4, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement4, "value", firstName), _React$createElement4))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement5 = {
      label: "Last name",
      labelStatus: true,
      helperText: "Helper text",
      placeholder: "Last name",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement5, "count", false), _defineProperty(_React$createElement5, "tooltip", false), _defineProperty(_React$createElement5, "inputlabel", true), _defineProperty(_React$createElement5, "name", "lastName"), _defineProperty(_React$createElement5, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement5, "value", lastName), _React$createElement5))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement6 = {
      label: "Address line 1",
      labelStatus: true,
      helperText: "Helper text",
      placeholder: "Street address, P.O. box, house etc.",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement6, "count", false), _defineProperty(_React$createElement6, "tooltip", false), _defineProperty(_React$createElement6, "inputlabel", true), _defineProperty(_React$createElement6, "name", "line1"), _defineProperty(_React$createElement6, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement6, "value", line1), _React$createElement6))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement7 = {
      label: "Address line 2 (Optional)",
      labelStatus: true,
      helperText: "Helper text",
      placeholder: "Address line 2 (Optional)",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement7, "count", false), _defineProperty(_React$createElement7, "tooltip", false), _defineProperty(_React$createElement7, "inputlabel", true), _defineProperty(_React$createElement7, "name", "line2"), _defineProperty(_React$createElement7, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement7, "value", line2), _React$createElement7))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement8 = {
      label: "City/Town",
      labelStatus: true,
      helperText: "Helper text",
      placeholder: "City/Town",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement8, "count", false), _defineProperty(_React$createElement8, "tooltip", false), _defineProperty(_React$createElement8, "inputlabel", true), _defineProperty(_React$createElement8, "name", "city"), _defineProperty(_React$createElement8, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement8, "value", city), _React$createElement8))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(SelectField, {
      label: "State/Province",
      labelStatus: true,
      helperText: "Helper text",
      Errormessage: "Error message",
      helpertext: false,
      errortext: false,
      name: "state",
      onChange: handleStateChange,
      value: state,
      selectOptions: usStates === null || usStates === void 0 ? void 0 : usStates.map(function (state) {
        return {
          title: state.name
        };
      })
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement9 = {
      label: "Zip/Postal code",
      labelStatus: true,
      name: "postalCode",
      onChange: handleAddressDetailChange,
      value: postalCode
    }, _defineProperty(_React$createElement9, "label", "Zip/Postal code"), _defineProperty(_React$createElement9, "helpertext", ""), _defineProperty(_React$createElement9, "HelpertextStatus", false), _defineProperty(_React$createElement9, "placeholder", "Zip/Postal code"), _defineProperty(_React$createElement9, "Errormessage", "Error message"), _defineProperty(_React$createElement9, "errortextStatus", false), _defineProperty(_React$createElement9, "count", 100), _defineProperty(_React$createElement9, "countStatus", false), _defineProperty(_React$createElement9, "tooltipStatus", false), _React$createElement9))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement("label", {
      "class": "input_label"
    }, "Country"), /*#__PURE__*/React__default["default"].createElement(ReactFlagsSelect__default["default"], {
      searchable: true,
      selected: country,
      onSelect: function onSelect(code) {
        return setaddressDetails(_objectSpread2(_objectSpread2({}, addressDetails), {}, {
          country: code
        }));
      },
      defaultCountry: "US"
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(CheckBox, {
      onChange: setsaveCardDetails,
      checked: saveCardDetails,
      label: props.checkboxLabel,
      description: "Keep me signed in",
      value: "",
      Tooltip: true,
      Tooltiptext: props.Tooltipcheckboxtext,
      Description: false
    }))) : null) : /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "billingAddressContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "billingAddressTitle"
    }, /*#__PURE__*/React__default["default"].createElement("span", null, "CHECK PAYABLE TO :")), /*#__PURE__*/React__default["default"].createElement("span", null, props === null || props === void 0 ? void 0 : props.chequePayableTo), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "billingaddressInfo"
    }, /*#__PURE__*/React__default["default"].createElement("li", null, /*#__PURE__*/React__default["default"].createElement("b", null, props === null || props === void 0 ? void 0 : props.mailToName)), /*#__PURE__*/React__default["default"].createElement("li", null, props === null || props === void 0 ? void 0 : props.chequePayableTo), /*#__PURE__*/React__default["default"].createElement("li", null, props === null || props === void 0 ? void 0 : props.mailToStreet), /*#__PURE__*/React__default["default"].createElement("li", null, (props === null || props === void 0 ? void 0 : props.mailToCity) + (props !== null && props !== void 0 && props.mailToState ? ', ' + props.mailToState : '') + (props !== null && props !== void 0 && props.mailToPostalCode ? ' ' + props.mailToPostalCode : ''))))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "separator_line"
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "form_button_box"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "CheckoutTostext"
    }, parse__default["default"](props.BottomHelperText)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "form_button_Contianer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CheckoutRemovebutton"
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      onClick: props.onclickremove,
      label: props.RemoveButtonLabel
    })), /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      disabled: paymentMethod === 'cheque' ? false : paymentWith !== "newCard" ? false : disableBtn,
      onClick: onSubmit,
      label: props.ButtonLabel,
      buttoncolor: paymentWith !== "newCard" || !disableBtn || paymentMethod === 'cheque' ? (_props$buttoncolor = props.buttoncolor) !== null && _props$buttoncolor !== void 0 ? _props$buttoncolor : "#0053A5" : "",
      color: paymentWith !== "newCard" || !disableBtn || paymentMethod === 'cheque' ? (_props$buttonTextcolo = props.buttonTextcolor) !== null && _props$buttonTextcolo !== void 0 ? _props$buttonTextcolo : "#fff" : "" //buttoncolor={props.buttoncolor}
      ,
      width: props.buttonwidth,
      height: props.buttonheight,
      border: props.buttonborder,
      borderRadius: props.buttonRadiusr //color= {props.buttonTextcolor}
      ,
      fontWeight: props.buttonfontWeight //textAlign="center"

    })))))));
  }

  var css_248z$1f = ".CheckoutMembership{border:1px solid #e4e8ec;padding:32px;border-radius:4px}.CheckoutMembership .MuiAccordion-root{background:#edf6ff}.CheckoutMembership .MuiAccordionDetails-root{padding:32px;background:#fff;display:block}.CheckoutMembership .MuiAccordion-root .checkIcon{color:#d2d3d8;margin-right:12px}.CheckoutMembership .MuiAccordion-root.Mui-expanded .checkIcon{color:#2a8853}.CheckoutMembership .aAccordionTitle{font-size:20px;-ms-flex-align:center;font-weight:500;-ms-flex-preferred-size:343px;flex-basis:343px}.CheckoutMembership .aAccordionTitle,.CheckoutMembership .aAccordionTitle span{color:#8d9090;letter-spacing:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;align-items:center;font-family:Poppins,sans-serif}.CheckoutMembership .aAccordionTitle span{font-size:14px;border:1px solid #ccc;width:28px;height:28px;border-radius:100px;-ms-flex-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:12px;font-weight:600}.CheckoutMembership .Mui-expanded .aAccordionTitle,.CheckoutMembership .Mui-expanded .aAccordionTitle span{color:#1b2121}.CheckoutMembership .MuiAccordion-root:before{background-color:#e4e8ec}.CheckoutMembership .MuiAccordionSummary-content{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.CheckoutMembership .MuiAccordionSummary-content,.Delivery .deleverdOptionDetails{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.Delivery .deleverdOptionDetails{border:1px solid #e4e8ec;padding:16px;border-radius:4px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.Delivery .deleverdOptionDetails .deleverdOptionDetailsTitle{color:#4c5e67;font-size:14px;font-weight:500;margin-bottom:4px;opacity:.6}.Delivery .deleverdOptionDetails .deleverdOptionDetailsAddress{color:#1b2121;font-size:14px;font-weight:500;margin-bottom:4px}.Delivery .deleverdOptionDetails .deleverdOptionDetailsPhoneNumber{color:#1b2121;font-size:14px;font-weight:500}.Delivery .deleverdOptionDetails .deleverdOptionDetailsRightText{color:#b0b9c1;font-size:12px;font-weight:400}.OrderDtllst{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:1px solid #e4e8ec;padding:15px 0}.OrderDtllst:first-child{padding-top:0}.OrderDtllst:last-child{border-bottom:none}.OrderDtllst li{display:-webkit-box;display:-ms-flexbox;display:flex;color:#0b132b;font-family:Poppins,sans-serif;font-weight:400;font-size:16px}.OrderDtllst li span{font-weight:700;margin-left:3px}.OrderDtllst li a{color:#2490f9;font-family:Poppins,sans-serif;font-weight:400;font-size:16px;text-decoration:none}.OrderDtllst li a svg{color:#2490f9;position:relative;top:5px}.OrderDtllst li a:hover{text-decoration:underline}.CpnTitle{color:#0b132b;font-family:Poppins,sans-serif;font-weight:600;font-size:16px;margin-bottom:16px}.CopnField,.errorIcon{position:relative}.errorIcon{font-size:13px;top:2px}.CopnField .applyBtn{position:absolute;right:7px;top:16px}.CopnField .applyBtn .cencelBtn{position:absolute;right:-76px}.CopnField .applyBtn .MuiButton-outlined{border:none;padding:0;color:#0590fa;font-size:14px;text-transform:none}.CopnField .applyBtn .MuiButton-root.Mui-disabled{background:none!important;color:#b0b9c1}.loader .MuiCircularProgress-colorPrimary{color:#0590fa;position:absolute;top:-7px;right:12px;width:30px!important;height:30px!important}.amountIcon{color:#2a8853;font-size:22px;position:relative;top:1px;left:4px}.OderDetailsCtn{padding-bottom:20px}.FormBtn{padding-top:30px}.FormDetailsContainer .FormDetailsContainerHdr{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.FormDetailsContainer .FormDetailsContainerHdr h2{font-family:Poppins,sans-serif!important;color:#0b132b;font-size:16px;font-weight:500;margin:4px 0 0}.FormDetailsContainer .FormDetailsContainerHdr .atnEdit{font-family:Poppins,sans-serif!important;color:#0590fa;font-size:14px;font-weight:500}.FormDetailsContainer .FormDetailsContainerHdr .atnDelete{font-family:Poppins,sans-serif!important;color:#0b132b;font-size:14px;font-weight:500}.FormDetailsContainerDtl h3{font-family:Poppins,sans-serif!important;color:#0b132b;font-size:20px;font-weight:500;margin:0}.FormDetailsContainerDtl p{color:#676c7b;font-weight:400;margin-bottom:0;margin-top:4px}.FormDetailsContainerDtl p,.formSectionTitleIn{font-family:Poppins,sans-serif!important;font-size:16px}.formSectionTitleIn{color:#0b132b;font-weight:600;margin:0}";
  styleInject(css_248z$1f);

  var OrderDetais = function OrderDetais() {

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "OderDetailsCtn"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "OrderDtllst"
    }, /*#__PURE__*/React__default["default"].createElement("li", null, "Order total: ", /*#__PURE__*/React__default["default"].createElement("span", null, " $1,101.40")), /*#__PURE__*/React__default["default"].createElement("li", null, /*#__PURE__*/React__default["default"].createElement("a", {
      href: "#"
    }, "Show Order Summary"))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "OrderDtllst"
    }, /*#__PURE__*/React__default["default"].createElement("li", null, "Order total: ", /*#__PURE__*/React__default["default"].createElement("span", null, " $1,101.40"), " ", /*#__PURE__*/React__default["default"].createElement(MonetizationOnIcon__default["default"], {
      className: "amountIcon"
    })), /*#__PURE__*/React__default["default"].createElement("li", null, /*#__PURE__*/React__default["default"].createElement("a", {
      href: "#"
    }, "Enter Coupon Code ", /*#__PURE__*/React__default["default"].createElement(KeyboardArrowDownRoundedIcon__default["default"], null)), " "))), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CpnTitle"
    }, "Apply a coupon"), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CopnField"
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      labelStatus: false,
      placeholder: "Enter coupon code",
      Errormessage: /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement(CancelRoundedIcon__default["default"], {
        className: "errorIcon"
      }), " The promotion code you entered is invalid."),
      errortextStatus: true
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "applyBtn"
    }, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      variant: "outlined",
      disabled: true
    }, "Apply"), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      className: "cencelBtn",
      variant: "outlined"
    }, "Cancel"), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "loader"
    }, /*#__PURE__*/React__default["default"].createElement(CircularProgress__default["default"], null)))))));
  };

  var css_248z$1e = ".PhoneFieldManContainer .react-tel-input .country-list .country{padding:12px 9px 13px 46px!important}.PhoneFieldManContainer .underlineInput .react-tel-input .special-label{font-size:12px!important;color:rgba(0,0,0,.54)!important;margin-left:0!important}.PhoneFieldManContainer .react-tel-input .form-control:focus{border-color:#e4e8ec!important;-webkit-box-shadow:none!important;box-shadow:none!important}.PhoneFieldManContainer .react-tel-input .form-control{border:1px solid #e4e8ec!important;padding:18.5px 14px 18.5px 75px!important;min-height:56px!important;font-family:Poppins,sans-serif!important}.PhoneFieldManContainer .react-tel-input .selected-flag{outline:none!important;position:relative!important;width:60px!important;padding:0 0 0 11px!important;border-radius:3px 0 0 3px!important;border-right:1px solid #e4e8ec!important}.PhoneFieldManContainer .react-tel-input .special-label{display:none!important}.PhoneFieldManContainer .react-tel-input .form-control:hover{border-color:#e4e8ec!important}.PhoneFieldManContainer .error{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;letter-spacing:.4!important;color:red!important;font-size:12px!important;text-indent:5px!important;margin-left:5!important;position:absolute!important;margin-top:4px!important}.contactFormContainer .PhoneFieldManContainer .react-tel-input .special-label{display:none!important;color:#979797!important}.error .PhoneFieldManContainer .react-tel-input .form-control,.error .PhoneFieldManContainer .react-tel-input .selected-flag{border-color:#f44336!important}";
  styleInject(css_248z$1e);

  var excludeCountriesArr = ["by", "mm", "bi", "cn", "cu", "ir", "lb", "ly", "kp", "so", "sd", "sy", "ua", "ve", "zw"];
  function PhoneInputField(props) {
    var _props$excludeCountri;

    var _useState = React.useState(""),
        _useState2 = _slicedToArray(_useState, 2),
        stylePath = _useState2[0];
        _useState2[1];

    React.useEffect(function () {
      if (props.phoneInputVariant === "materialui") {
        require('react-phone-input-2/lib/material.css');
      } else if (props.phoneInputVariant === "underlineWithFlag") {
        require('react-phone-input-2/lib/style.css');
      } else if (props.phoneInputVariant === "default") {
        require('react-phone-input-2/lib/style.css');
      }
    }, []);
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: props.error
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PhoneFieldManContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "phone-text-field_container ".concat(props.phoneInputVariant ? props.phoneInputVariant : "")
    }, props.LabelStatus && /*#__PURE__*/React__default["default"].createElement("label", {
      className: "input_label"
    }, props.labelFixed), /*#__PURE__*/React__default["default"].createElement("link", {
      rel: "stylesheet",
      type: "text/css",
      href: stylePath
    }), /*#__PURE__*/React__default["default"].createElement(PhoneInput__default["default"], {
      country: props.country,
      value: props.value,
      countryCodeEditable: props.countryCodeEditable,
      onChange: props.onChange,
      onBlur: props.onBlur,
      onKeyDown: props.onKeyDown,
      variant: props.variant,
      onlyCountries: props.onlyCountries,
      containerStyle: props.containerStyle,
      buttonStyle: props.buttonStyle,
      inputStyle: props.inputStyle,
      containerClass: props.containerStyle,
      errorText: props.errorText,
      error: props.error,
      autoFormat: props.autoFormat,
      disableDropdown: props.disableDropdown,
      disabled: props.disabled,
      disableCountryCode: props.disableCountryCode,
      enableSearch: props.enableSearch,
      disableSearchIcon: props.disableSearchIcon,
      placeholder: props.placeholder,
      inputProps: props.inputProps,
      specialLabel: props.specialLabel,
      preferredCountries: props.preferredCountries,
      excludeCountries: (_props$excludeCountri = props.excludeCountries) !== null && _props$excludeCountri !== void 0 && _props$excludeCountri.length ? props.excludeCountries : excludeCountriesArr,
      showDropdown: false
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "bottom_text_col"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      "class": "helper_text"
    }, props.helpertext)), props.error && /*#__PURE__*/React__default["default"].createElement("span", {
      className: "error",
      style: props.errorStyles
    }, props.errorText))));
  }

  var css_248z$1d = ".CheckoutPaymentExtendedContainer{border:1px solid #e4e8ec;padding:32px;border-radius:4px}.CheckoutPaymentExtendedContainer .MuiAccordion-root.Mui-expanded{margin:0}.CheckoutPaymentExtendedContainer .aAccordionTitle{font-size:20px;-ms-flex-align:center;font-weight:500;-ms-flex-preferred-size:343px;flex-basis:343px}.CheckoutPaymentExtendedContainer .aAccordionTitle,.CheckoutPaymentExtendedContainer .aAccordionTitle span{color:#8d9090;letter-spacing:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;align-items:center;font-family:Poppins,sans-serif}.CheckoutPaymentExtendedContainer .aAccordionTitle span{font-size:14px;border:1px solid #ccc;width:28px;height:28px;border-radius:100px;-ms-flex-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:12px;font-weight:600}.CheckoutPaymentExtendedContainer .Mui-expanded .aAccordionTitle,.CheckoutPaymentExtendedContainer .Mui-expanded .aAccordionTitle span{color:#1b2121}.ContinueButton{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:10px}.DeliveryOptionsContainer,.FormdataContainer{width:100%}.DeliveryOptionsContainer .deleverdOptionDetails{border:1px solid #e4e8ec;padding:16px;border-radius:4px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.DeliveryOptionsContainer .deleverdOptionDetails .deleverdOptionDetailsTitle{color:#4c5e67;font-size:14px;font-weight:500;margin-bottom:4px;opacity:.6}.DeliveryOptionsContainer .deleverdOptionDetails .deleverdOptionDetailsAddress{color:#1b2121;font-size:14px;font-weight:500;margin-bottom:4px}.DeliveryOptionsContainer .deleverdOptionDetails .deleverdOptionDetailsPhoneNumber{color:#1b2121;font-size:14px;font-weight:500}.DeliveryOptionsContainer .deleverdOptionDetails .deleverdOptionDetailsRightText{color:#b0b9c1;font-size:12px;font-weight:400}.DeliveryDetailsContainer{width:100%}.infoTextContainer{display:-webkit-box;display:-ms-flexbox;display:flex;color:#0b132b;font-size:14px;font-family:Poppins,sans-serif;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-left:10px}.infoTextContainer svg{color:#ff6464;margin-right:5px}.CheckoutPaymentExtendedContainer .MuiAccordion-root:before{background-color:#e4e8ec}.CheckoutPaymentExtendedContainer .MuiAccordionSummary-content{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.checkOutpaymentDetailsSection,.CheckoutPaymentExtendedContainer .MuiAccordionSummary-content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.checkOutpaymentDetailsSection{-ms-flex-preferred-size:373px;flex-basis:373px}.CheckoutPaymentTabContainer .Mui-expanded .checkOutpaymentDetailsCol,.CheckoutPaymentTabContainer .Mui-expanded .checkOutpaymentDetailsEdit{display:none}.CheckoutPaymentTabContainer .checkOutpaymentDetailsCol h1{color:#8d9090;font-size:14px;font-family:Poppins,sans-serif;font-weight:700;margin:0}.CheckoutPaymentTabContainer .checkOutpaymentDetailsCol h2,.CheckoutPaymentTabContainer .checkOutpaymentDetailsCol p{color:#8d9090;font-size:14px;font-family:Poppins,sans-serif;font-weight:400;margin:0}.checkOutpaymentDetailsEdit{color:#0590fa;font-size:14px;font-family:Poppins,sans-serif;font-weight:600;margin:0;padding-left:50px}.AttendeeDetailsContainer{border:1px solid #e4e8ec;padding:16px;border-radius:4px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;margin-top:12px}.AttendeeDetailsContainer:last-child{margin-bottom:0!important}.AttendeeDetailsContainer .AttendeeDetailsCol h2{color:#1b2121;font-size:14px;font-family:Poppins,sans-serif;font-weight:600;margin:0 0 2px}.AttendeeDetailsContainer .AttendeeDetailsCol p{color:#1b2121;font-size:14px;font-family:Poppins,sans-serif;font-weight:400;margin:0 0 2px}.deleverdOptionDetailsRightText{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;color:#a4a7b0;font-size:14px;font-family:Poppins,sans-serif;font-weight:400}.checkOutpaymentAttendeeDetailsEdit{color:#0590fa;font-size:14px;font-family:Poppins,sans-serif;font-weight:600;margin:0 0 0 12px;cursor:pointer}.checkOutAttendeePhone .react-tel-input .special-label{display:none!important}.MuiButton-root.Mui-disabled{background:#e4e8ec!important}.ZamzamCheckoutPaymentForm{padding:10px 0;border-radius:4px}.ZamzamCheckoutPaymentForm .form_button_Contianer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ZamzamCheckoutPaymentForm .MuiTypography-colorPrimary{color:#0590fa}.ZamzamPaymentDetailsContainer li{display:block;margin-bottom:20px}.ZamzamPaymentDetailsContainer h1{color:#676c7b;font-size:14px;font-family:Poppins,sans-serif;font-weight:600;text-transform:uppercase;margin:0 0 8px}.ZamzamPaymentDetailsContainer h2{color:#0b132b;font-size:16px;font-family:Poppins,sans-serif;font-weight:500;margin:0}.ZamzamPaymentDetailsContainer p{color:#676c7b;font-size:16px;font-family:Poppins,sans-serif;font-weight:400;margin:0}";
  styleInject(css_248z$1d);

  var Delivery = function Delivery(props) {
    var _React$useState = React__default["default"].useState({
      country: "",
      number: ""
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        phone = _React$useState2[0];
        _React$useState2[1];

    var cardFunction = function cardFunction(value) {
      value && console.log("clicked");
    };

    var click = function click() {
      console.log("Back Button Clicked");
    };

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "Delivery"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      md: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FormDetailsContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FormDetailsContainerHdr"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FormDetailsContainerDtl"
    }, /*#__PURE__*/React__default["default"].createElement("h3", null, "Home delivery"), /*#__PURE__*/React__default["default"].createElement("h2", null, "Masukul Alam"), /*#__PURE__*/React__default["default"].createElement("p", null, "1234 Church Street #1B"), /*#__PURE__*/React__default["default"].createElement("p", null, " #1B "), /*#__PURE__*/React__default["default"].createElement("p", null, "Nashville, TN 37203")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "AtdRightCol"
    }, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      href: "#text-buttons",
      className: "atnEdit"
    }, "Edit"), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      href: "#text-buttons",
      className: "atnDelete"
    }, "Delete"))))), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
      cardFunction: cardFunction,
      header: "I'd like it delivered",
      color: "#1B2121",
      icon: /*#__PURE__*/React__default["default"].createElement(LocalShippingIcon__default["default"], null),
      Link: false,
      cardIconStatus: true
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
      cardFunction: cardFunction,
      header: "I'll pick it up",
      color: "#1B2121",
      icon: /*#__PURE__*/React__default["default"].createElement(StorefrontRoundedIcon__default["default"], null),
      Link: false,
      cardIconStatus: true
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "First name",
      labelStatus: true //helpertext="Helper text"
      ,
      HelpertextStatus: true,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Last name",
      labelStatus: true,
      helpertext: "Helper text" //HelpertextStatus={true}
      ,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Resident street address",
      labelStatus: true //helpertext="Helper text"
      ,
      HelpertextStatus: true,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Resident street address",
      labelStatus: true,
      helpertext: "Helper text" //HelpertextStatus={true}
      ,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "City/Town",
      labelStatus: true // helpertext="Helper text"
      ,
      HelpertextStatus: false,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(SelectField, {
      labelFixed: "State/Province",
      labelStatus: true,
      helperText: "Helper text",
      Errormessage: "Error message",
      helpertext: false,
      errortext: false,
      selectOptions: [{
        title: "New York"
      }, {
        title: "California"
      }, {
        title: "NY"
      }]
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Zip/Postal code",
      labelStatus: true // helpertext="Helper text"
      ,
      HelpertextStatus: false,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PhoneInputField, {
      labelFixed: "Phone number",
      phoneInputVariant: "materialui" // default, materialui, underlineInput, underlineWithFlag
      ,
      country: 'us',
      value: phone.number,
      countryCodeEditable: false,
      onChange: function onChange(phone, country) {
        return console.log("onChange", phone, country);
      },
      onBlur: function onBlur() {
        return console.log("onBlur");
      },
      onKeyDown: function onKeyDown(e) {
        return console.log("onKeyDown", e.target.value);
      },
      variant: "outlined",
      onlyCountries: ["us", "ca", "gb", "my"],
      containerStyle: {},
      buttonStyle: {},
      inputStyle: {
        marginLeft: "0px",
        height: "40px",
        width: "100%",
        fontFamily: "Roboto-Regular",
        fontSize: "16px"
      },
      containerClass: {},
      errorText: "Phone number is required",
      error: false,
      errorStyles: {
        marginBottom: "5px"
      },
      autoFormat: true,
      disableDropdown: false,
      disabled: false,
      disableCountryCode: false,
      enableSearch: false,
      disableSearchIcon: false,
      placeholder: "",
      inputProps: {},
      LabelStatus: true,
      helpertext: "In case of delivery questions" // preferredCountries={[]}
      // excludeCountries={[]}

    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Email",
      labelStatus: true,
      helpertext: "We\u2019ll email you a receipt and order updates",
      HelpertextStatus: true,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FormBtn"
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: "Continue",
      onClick: click,
      buttoncolor: props.buttonColor,
      width: "100%",
      height: "50px",
      border: "#ccc 0px solid",
      borderRadius: "4px",
      color: "#fff",
      fontWeight: "600",
      textAlign: "center",
      disabled: "disabled"
    })))));
  };

  var cardFunction$4 = function cardFunction(value) {
    value && console.log("clicked");
  };

  function Payment(props) {
    var _React$createElement, _React$createElement2, _React$createElement3, _React$createElement4, _React$createElement5, _React$createElement6, _React$createElement7, _React$createElement8;

    var privacyPolicyLink = props.privacyPolicyLink,
        termsOfUseLink = props.termsOfUseLink,
        cardDetails = props.cardDetails,
        setcardDetails = props.setcardDetails,
        addressDetails = props.addressDetails,
        setaddressDetails = props.setaddressDetails,
        saveCardDetails = props.saveCardDetails,
        setsaveCardDetails = props.setsaveCardDetails,
        selectedCardDetails = props.selectedCardDetails,
        onEditBillingDetailClick = props.onEditBillingDetailClick,
        visaCardImage = props.visaCardImage,
        masterCardImage = props.masterCardImage,
        helpImage = props.helpImage,
        newCardImage = props.newCardImage,
        discoverCardImage = props.discoverCardImage,
        americanExpressImage = props.americanExpressImage,
        dinersCardImage = props.dinersCardImage;

    var _React$useState = React__default["default"].useState("newCard"),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        paymentWith = _React$useState2[0],
        setpaymentWith = _React$useState2[1];

    var _React$useState3 = React__default["default"].useState({
      cardNumberError: false,
      expirationError: false,
      codeError: false
    }),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        cardDetailsError = _React$useState4[0],
        setcardDetailsError = _React$useState4[1];

    var onSubmit = function onSubmit() {
      if (paymentWith === "newCard") {
        props.onPlaceOrderSubmit({
          cardDetails: cardDetails,
          addressDetails: addressDetails
        });
        console.log(cardDetails, addressDetails);
      } else {
        props.onPlaceOrderSubmit({
          selectedCardDetails: selectedCardDetails
        });
        console.log(selectedCardDetails);
      }
    };

    var handleCardDetailChange = function handleCardDetailChange(e) {
      setcardDetails(_objectSpread2(_objectSpread2({}, cardDetails), {}, _defineProperty({}, e.target.name, e.target.value)));
    };

    var handleAddressDetailChange = function handleAddressDetailChange(e) {
      console.log("test", e);
      setaddressDetails(_objectSpread2(_objectSpread2({}, addressDetails), {}, _defineProperty({}, e.target.name, e.target.value)));
    };

    var handleStateChange = function handleStateChange(event, newValue) {
      setaddressDetails(_objectSpread2(_objectSpread2({}, addressDetails), {}, {
        state: newValue.title
      }));
    };

    var cardImage = function cardImage(number) {
      // visa card
      if (/^4[0-9]{12}(?:[0-9]{3})?$/.test(number)) {
        return /*#__PURE__*/React__default["default"].createElement(core.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React__default["default"].createElement("img", {
          src: visaCardImage,
          className: "masterCardImage",
          alt: "card img"
        }));
      } //master card
      else if (/^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/.test(number)) {
        return /*#__PURE__*/React__default["default"].createElement(core.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React__default["default"].createElement("img", {
          src: masterCardImage,
          className: "masterCardImage",
          alt: "card img"
        }));
      } // American Express
      else if (/^3[47][0-9]{13}$/.test(number)) {
        return /*#__PURE__*/React__default["default"].createElement(core.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React__default["default"].createElement("img", {
          src: americanExpressImage,
          className: "masterCardImage",
          alt: "card img"
        }));
      } //Diners Club
      else if (/^3(?:0[0-5]|[68][0-9])[0-9]{11}$/.test(number)) {
        return /*#__PURE__*/React__default["default"].createElement(core.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React__default["default"].createElement("img", {
          src: dinersCardImage,
          className: "masterCardImage",
          alt: "card img"
        }));
      } //Discover
      else if (/^6(?:011|5[0-9]{2})[0-9]{12}$/.test(number)) {
        return /*#__PURE__*/React__default["default"].createElement(core.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React__default["default"].createElement("img", {
          src: discoverCardImage,
          className: "masterCardImage",
          alt: "card img"
        }));
      }
    };

    var checkCVC = function checkCVC() {
      var cardNumber = cardDetails.cardNumber,
          code = cardDetails.code;

      if (cardNumber[0] === '3' ? code.length !== 4 : code.length !== 3) {
        return false;
      } else {
        return true;
      }
    };

    var validateExpiration = function validateExpiration() {
      var expiration = cardDetails.expiration;

      if (/^(0[1-9]|1[0-2])\/\d{2}$/.test(expiration)) {
        var today, someday;
        var exMonth = expiration.split("/")[0];
        var exYear = expiration.split("/")[1];
        today = new Date();
        someday = new Date();
        someday.setFullYear('20' + exYear, exMonth, 1);

        if (someday < today) {
          console.log("The expiry date is before today's date. Please select a valid expiry date");
          return false;
        }

        return true;
      } else {
        return false;
      }
    };

    var handlePaymentCardSelectChange = function handlePaymentCardSelectChange(selectedCard) {
      props.handlePaymentSelectChange(selectedCard);
      setpaymentWith(selectedCard);
    };

    var cardNumber = cardDetails.cardNumber,
        expiration = cardDetails.expiration,
        code = cardDetails.code;
    var cardNumberError = cardDetailsError.cardNumberError,
        expirationError = cardDetailsError.expirationError,
        codeError = cardDetailsError.codeError;
    var firstName = addressDetails.firstName,
        lastName = addressDetails.lastName,
        line1 = addressDetails.line1,
        line2 = addressDetails.line2,
        city = addressDetails.city,
        state = addressDetails.state,
        postalCode = addressDetails.postalCode,
        country = addressDetails.country;
    var disableBtn = cardImage(cardNumber) && validateExpiration() && checkCVC() && firstName && lastName && line1 && city && state && postalCode && country ? false : true; // let disableBtn = checkCVC(code) ? false : true;

    var _React$useState5 = React__default["default"].useState({
      country: "",
      number: ""
    }),
        _React$useState6 = _slicedToArray(_React$useState5, 2),
        phone = _React$useState6[0];
        _React$useState6[1];

    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CheckoutPaymentForm"
    }, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      md: 4,
      sm: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
      cardFunction: cardFunction$4,
      header: "Credit Card",
      color: "#1B2121",
      icon: /*#__PURE__*/React__default["default"].createElement(CreditCardRoundedIcon__default["default"], null),
      Link: false,
      cardIconStatus: true
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      md: 4,
      sm: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
      cardFunction: cardFunction$4,
      header: "Pay Check",
      color: "#1B2121",
      icon: /*#__PURE__*/React__default["default"].createElement(LocalAtmRoundedIcon__default["default"], null),
      Link: false,
      cardIconStatus: true
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      md: 4,
      sm: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
      cardFunction: cardFunction$4,
      header: "Pay Later",
      color: "#1B2121",
      icon: /*#__PURE__*/React__default["default"].createElement(ScheduleRoundedIcon__default["default"], null),
      Link: false,
      cardIconStatus: true
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(CreditCardList, {
      label: "Pay with" //helperText="Helper text"
      ,
      Errormessage: "Error message",
      helpertext: true,
      errortext: false,
      tooltip: false,
      paymentWith: paymentWith,
      handleSelectChange: handlePaymentCardSelectChange,
      cardListOptions: props.creditCardsList // visaCardImage={visaCardImage}
      // masterCardImage={masterCardImage}
      ,
      newCardImage: newCardImage
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "formSectionTitleIn"
    }, "Card information")), paymentWith === "newCard" ? /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement = {
      label: "Card number",
      labelStatus: true,
      helperText: "Helper text",
      placeholder: "4242424242424242",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement, "count", false), _defineProperty(_React$createElement, "tooltip", false), _defineProperty(_React$createElement, "inputlabel", true), _defineProperty(_React$createElement, "name", "cardNumber"), _defineProperty(_React$createElement, "onChange", handleCardDetailChange), _defineProperty(_React$createElement, "value", cardNumber), _defineProperty(_React$createElement, "InputProps", {
      endAdornment: cardImage(cardNumber) // inputComponent: NumberFormatCustom

    }), _defineProperty(_React$createElement, "onBlur", function onBlur() {
      return cardImage(cardNumber) ? setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
        cardNumberError: false
      })) : setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
        cardNumberError: true
      }));
    }), _defineProperty(_React$createElement, "errortextStatus", !cardImage(cardNumber) && cardNumberError ? true : false), _defineProperty(_React$createElement, "Errormessage", !cardImage(cardNumber) && cardNumberError ? "Enter valid card number" : ""), _React$createElement))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 3
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement2 = {
      label: "Expiration",
      labelStatus: true,
      placeholder: "MM/YY",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement2, "count", false), _defineProperty(_React$createElement2, "inputlabel", true), _defineProperty(_React$createElement2, "tooltip", false), _defineProperty(_React$createElement2, "name", "expiration"), _defineProperty(_React$createElement2, "onChange", handleCardDetailChange), _defineProperty(_React$createElement2, "value", expiration), _defineProperty(_React$createElement2, "onBlur", function onBlur() {
      return validateExpiration() ? setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
        expirationError: false
      })) : setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
        expirationError: true
      }));
    }), _defineProperty(_React$createElement2, "errortextStatus", !validateExpiration() && expirationError ? true : false), _defineProperty(_React$createElement2, "Errormessage", !validateExpiration() && expirationError ? "Invalid exp date" : ""), _React$createElement2))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 3
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement3 = {
      label: "Security code",
      labelStatus: true,
      helperText: "Helper text",
      placeholder: "CVV",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement3, "count", false), _defineProperty(_React$createElement3, "tooltip", false), _defineProperty(_React$createElement3, "inputlabel", true), _defineProperty(_React$createElement3, "name", "code"), _defineProperty(_React$createElement3, "onChange", handleCardDetailChange), _defineProperty(_React$createElement3, "value", code), _defineProperty(_React$createElement3, "type", "number"), _defineProperty(_React$createElement3, "InputProps", {
      endAdornment: /*#__PURE__*/React__default["default"].createElement(core.InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        src: helpImage,
        width: "30px",
        alt: "card img"
      }))
    }), _defineProperty(_React$createElement3, "onBlur", function onBlur() {
      return checkCVC() ? setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
        codeError: false
      })) : setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
        codeError: true
      }));
    }), _defineProperty(_React$createElement3, "errortextStatus", !checkCVC() && codeError ? true : false), _defineProperty(_React$createElement3, "Errormessage", !checkCVC() && codeError ? "Enter Valid CVC Number" : ""), _React$createElement3)))) : null, paymentWith !== "newCard" ? /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "billingAddressContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "billingAddressTitle"
    }, /*#__PURE__*/React__default["default"].createElement("span", null, selectedCardDetails && selectedCardDetails.firstName, "  ", selectedCardDetails && selectedCardDetails.lastName), " ", /*#__PURE__*/React__default["default"].createElement("span", {
      style: {
        color: "#0590FA",
        cursor: "pointer"
      },
      onClick: onEditBillingDetailClick
    }, "Edit")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "billingaddressInfo"
    }, /*#__PURE__*/React__default["default"].createElement("li", null, selectedCardDetails && selectedCardDetails.line1), /*#__PURE__*/React__default["default"].createElement("li", null, selectedCardDetails && selectedCardDetails.city, ", ", selectedCardDetails && selectedCardDetails.state, " ", selectedCardDetails && selectedCardDetails.postalCode), /*#__PURE__*/React__default["default"].createElement("li", null, selectedCardDetails && selectedCardDetails.country)))) : null, paymentWith === "newCard" ? /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement4 = {
      label: "Name on card",
      labelStatus: true,
      helperText: "Helper text",
      placeholder: "First name",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement4, "count", false), _defineProperty(_React$createElement4, "tooltip", false), _defineProperty(_React$createElement4, "inputlabel", true), _defineProperty(_React$createElement4, "name", "firstName"), _defineProperty(_React$createElement4, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement4, "value", firstName), _React$createElement4))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PhoneInputField, (_React$createElement5 = {
      labelFixed: "Phone number",
      phoneInputVariant: "materialui" // default, materialui, underlineInput, underlineWithFlag
      ,
      country: 'us',
      value: phone.number,
      countryCodeEditable: false,
      onChange: function onChange(phone, country) {
        return console.log("onChange", phone, country);
      },
      onBlur: function onBlur() {
        return console.log("onBlur");
      },
      onKeyDown: function onKeyDown(e) {
        return console.log("onKeyDown", e.target.value);
      },
      variant: "outlined",
      onlyCountries: ["us", "ca", "gb", "my"],
      containerStyle: {},
      buttonStyle: {},
      inputStyle: {
        marginLeft: "0px",
        height: "40px",
        width: "100%",
        fontFamily: "Roboto-Regular",
        fontSize: "16px"
      },
      containerClass: {},
      errorText: "Phone number is required",
      error: false,
      errorStyles: {
        marginBottom: "5px"
      },
      autoFormat: true,
      disableDropdown: false,
      disabled: false,
      disableCountryCode: false,
      enableSearch: false,
      disableSearchIcon: false,
      placeholder: "",
      inputProps: {}
    }, _defineProperty(_React$createElement5, "labelFixed", "Phone number"), _defineProperty(_React$createElement5, "LabelStatus", true), _React$createElement5))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "formSectionTitleIn"
    }, "Billing Adderess")), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(CheckBox, {
      onChange: setsaveCardDetails,
      checked: saveCardDetails,
      label: "Same as member address",
      value: ""
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement6 = {
      label: "Address line 1",
      helperText: "Helper text",
      placeholder: "Street address, P.O. box, house etc.",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement6, "count", false), _defineProperty(_React$createElement6, "tooltip", false), _defineProperty(_React$createElement6, "inputlabel", true), _defineProperty(_React$createElement6, "name", "line1"), _defineProperty(_React$createElement6, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement6, "value", line1), _React$createElement6))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement7 = {
      label: "Address line 2 (Optional)",
      helperText: "Helper text",
      placeholder: "Street address, P.O. box, house etc.",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement7, "count", false), _defineProperty(_React$createElement7, "tooltip", false), _defineProperty(_React$createElement7, "inputlabel", false), _defineProperty(_React$createElement7, "name", "line2"), _defineProperty(_React$createElement7, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement7, "value", line2), _React$createElement7))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement8 = {
      label: "City/Town",
      helperText: "Helper text",
      placeholder: "Placeholder",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement8, "count", false), _defineProperty(_React$createElement8, "tooltip", false), _defineProperty(_React$createElement8, "inputlabel", false), _defineProperty(_React$createElement8, "name", "city"), _defineProperty(_React$createElement8, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement8, "value", city), _React$createElement8))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(SelectField, {
      label: "State/Province" //helperText="Helper text"
      ,
      Errormessage: "Error message",
      helpertext: true,
      errortext: false,
      labelStatus: false,
      name: "state",
      onChange: handleStateChange,
      value: state,
      selectOptions: [{
        title: "New York"
      }, {
        title: "California"
      }]
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      name: "postalCode",
      onChange: handleAddressDetailChange,
      value: postalCode,
      label: "Zip/Postal code",
      labelStatus: false //helpertext="Helper text"
      ,
      HelpertextStatus: true,
      placeholder: "Placeholder",
      Errormessage: "Error message",
      errortextStatus: false,
      count: 100,
      countStatus: true,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(ReactFlagsSelect__default["default"], {
      searchable: true,
      selected: country,
      onSelect: function onSelect(code) {
        return setaddressDetails(_objectSpread2(_objectSpread2({}, addressDetails), {}, {
          country: code
        }));
      },
      defaultCountry: "US"
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(CheckBox, {
      onChange: setsaveCardDetails,
      checked: saveCardDetails,
      label: "Save my card details for future transaction",
      description: "Keep me signed in",
      value: "",
      Tooltip: true,
      Description: false
    }))) : null, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "separator_line"
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "form_button_box"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "tos_text"
    }, "By placing your order you agree to our ", /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      href: privacyPolicyLink
    }, "Privacy Policy"), " and ", /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      href: termsOfUseLink
    }, "Terms of Use")), /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      disabled: paymentWith !== "newCard" ? false : disableBtn,
      onclick: onSubmit,
      label: "Placeholder"
    }))))));
  }

  var CheckoutMembership = function CheckoutMembership(props) {
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SucureText"
    }, "Secured checkout ", /*#__PURE__*/React__default["default"].createElement(LockOutlinedIcon__default["default"], null)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CheckoutMembership"
    }, /*#__PURE__*/React__default["default"].createElement(Accordion__default["default"], null, /*#__PURE__*/React__default["default"].createElement(AccordionSummary__default["default"], {
      "aria-controls": "panel1a-content",
      id: "panel1a-header"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "aAccordionTitle"
    }, /*#__PURE__*/React__default["default"].createElement(CheckCircleRoundedIcon__default["default"], {
      className: "checkIcon"
    }), " ", props.StepTitle_1)), /*#__PURE__*/React__default["default"].createElement(AccordionDetails__default["default"], null, /*#__PURE__*/React__default["default"].createElement(OrderDetais, null))), /*#__PURE__*/React__default["default"].createElement(Accordion__default["default"], null, /*#__PURE__*/React__default["default"].createElement(AccordionSummary__default["default"], {
      "aria-controls": "panel1a-content",
      id: "panel1a-header"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "aAccordionTitle"
    }, /*#__PURE__*/React__default["default"].createElement(CheckCircleRoundedIcon__default["default"], {
      className: "checkIcon"
    }), " ", props.StepTitle_2)), /*#__PURE__*/React__default["default"].createElement(AccordionDetails__default["default"], null, /*#__PURE__*/React__default["default"].createElement(Delivery, {
      buttonColor: props.buttonColor
    }))), /*#__PURE__*/React__default["default"].createElement(Accordion__default["default"], {
      defaultExpanded: true
    }, /*#__PURE__*/React__default["default"].createElement(AccordionSummary__default["default"], {
      "aria-controls": "panel1a-content",
      id: "panel1a-header"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "aAccordionTitle"
    }, /*#__PURE__*/React__default["default"].createElement(CheckCircleRoundedIcon__default["default"], {
      className: "checkIcon"
    }), " ", props.StepTitle_3)), /*#__PURE__*/React__default["default"].createElement(AccordionDetails__default["default"], null, /*#__PURE__*/React__default["default"].createElement(Payment, {
      creditCardsList: props.creditCardsList,
      handlePaymentSelectChange: props.handlePaymentSelectChange,
      onPlaceOrderSubmit: props.onPlaceOrderSubmit,
      cardDetails: props.cardDetails,
      setcardDetails: props.setcardDetails,
      addressDetails: props.addressDetails,
      setaddressDetails: props.setaddressDetails,
      saveCardDetails: props.saveCardDetails,
      setsaveCardDetails: props.setsaveCardDetails,
      selectedCardDetails: props.selectedCardDetails,
      privacyPolicyLink: props.privacyPolicyLink,
      termsOfUseLink: props.termsOfUseLink,
      onEditBillingDetailClick: props.onEditBillingDetailClick,
      visaCardImage: props.visaCardImage,
      masterCardImage: props.masterCardImage,
      newCardImage: props.newCardImage,
      discoverCardImage: props.discoverCardImage,
      americanExpressImage: props.americanExpressImage,
      dinersCardImage: props.dinersCardImage,
      helpImage: props.helpImage
    })))));
  };

  var css_248z$1c = ".SelectFieldOne .MuiInput-underline:after,.SelectFieldOne .MuiInput-underline:before{display:none}.SelectFieldOne .MuiInput-underline{border:\"#E4E8EC 1px solid\";border-radius:4px}.SelectFieldOne .MuiSelect-select.MuiSelect-select{padding-right:20px;padding-left:20px}.SelectFieldOne .MuiSelect-selectMenu{font-weight:400;font-family:Poppins,sans-serif;font-size:16px!important;padding:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:56px;color:#4d4d4d;border:1px solid #e4e8ec;border-radius:4px;background:#fff}.SelectFieldOne .MuiInputBase-input:focus{border:1px solid #e4e8ec;background:#fff}.SelectFieldOne .MuiSelect-icon{right:11px}.MuiPopover-paper{margin-left:0!important}.SelectFieldOne .Mui-error .MuiSelect-selectMenu{border-color:#f44336!important}";
  styleInject(css_248z$1c);

  function SelectFieldOne(props) {
    var _React$useState = React__default["default"].useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        open = _React$useState2[0],
        setOpen = _React$useState2[1];

    var handleClose = function handleClose() {
      setOpen(false);
    };

    var handleOpen = function handleOpen() {
      setOpen(true);
    };

    var selectdata = props.selectdata;
    return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SelectFieldOne"
    }, /*#__PURE__*/React__default["default"].createElement("label", {
      className: "input_label"
    }, props.label), /*#__PURE__*/React__default["default"].createElement(FormControl__default["default"], {
      error: props.error
    }, /*#__PURE__*/React__default["default"].createElement(Select__default["default"], {
      id: "demo-controlled-open-select",
      open: open,
      onClose: handleClose,
      onOpen: handleOpen,
      onChange: props.handleChange,
      defaultValue: props.defaultValue
    }, selectdata.map(function (select, i) {
      return /*#__PURE__*/React__default["default"].createElement(MenuItem__default["default"], {
        key: i,
        value: select.value
      }, select.select);
    })))));
  }

  var useStyles$1 = styles$1.makeStyles(function (theme) {
    return {
      Container: {
        maxWidth: "500px",
        margin: "0 auto"
      },
      Title: {
        fontSize: "24px",
        color: "#1B2121",
        fontWeight: "600",
        margin: "0",
        textAlign: "center",
        fontFamily: " 'Poppins', sans-serif"
      },
      forGotPass: {
        textAlign: "right",
        paddingTop: "4px"
      },
      forGotPassText: {
        fontSize: "12px",
        color: "#1B2121",
        textDecoration: "none"
      },
      passwordField: {
        position: "relative"
      },
      signUpLinkFrom: {
        color: "#4C5E67",
        fontSize: "14px",
        fontWeight: "500",
        marginTop: "24px",
        textAlign: "center",
        marginLeft: "16px"
      },
      signUpLinkFromLink: {
        color: " #2A8853",
        fontSize: "14px",
        fontWeight: "500"
      }
    };
  });

  function SignIn(props) {
    var classes = useStyles$1();

    var _React$useState = React__default["default"].useState({
      password: "",
      showPassword: false
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        values = _React$useState2[0],
        setValues = _React$useState2[1];

    var handleChange = function handleChange(prop) {
      return function (event) {
        setValues(_objectSpread2(_objectSpread2({}, values), {}, _defineProperty({}, prop, event.target.value)));
      };
    };

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: classes.Container
    }, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("h1", {
      className: classes.Title
    }, props.Title)), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInput, {
      label: "Email address"
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: classes.passwordField
    }, /*#__PURE__*/React__default["default"].createElement(FieldPassword, {
      value: values.password,
      onChange: handleChange("password") //tick={Right}
      //close={Close}
      ,
      PasswordStrong: false
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: classes.forGotPass
    }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      className: classes.forGotPassText,
      href: "#"
    }, "Forgot password?"), " "))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(CheckBox, {
      label: "Keep me signed in",
      description: "Uncheck if using a public device.",
      value: "Keep me signed in",
      Tooltip: false,
      Description: true
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: "Sign in",
      buttoncolor: "#2A8853",
      width: "100%"
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: classes.signUpLinkFrom
    }, "Don't have an account? ", /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      className: classes.signUpLinkFromLink,
      href: "#"
    }, "Sign up")))));
  }

  var useStyles = styles$1.makeStyles(function (theme) {
    return {
      Container: {
        maxWidth: "500px",
        margin: "0 auto"
      },
      Title: {
        fontSize: "24px",
        color: "#1B2121",
        fontWeight: "600",
        margin: "0",
        textAlign: "center",
        fontFamily: " 'Poppins', sans-serif"
      },
      captchaBox: {
        background: "#FFFFFF 0% 0% no-repeat padding-box;",
        border: "1px solid #E4E8EC",
        borderRadius: "4px",
        opacity: 1,
        padding: "27px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#B0B9C1",
        fontSize: "20px"
      },
      signUpLinkFrom: {
        color: "#4C5E67",
        fontSize: "14px",
        fontWeight: "500",
        marginTop: "24px",
        textAlign: "center",
        marginLeft: "16px"
      },
      signUpLinkFromLink: {
        color: " #2A8853",
        fontSize: "14px",
        fontWeight: "500"
      }
    };
  });

  function SignUp(props) {
    var _React$createElement, _React$createElement2, _React$createElement3;

    var classes = useStyles();
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: classes.Container
    }, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("h1", {
      className: classes.Title
    }, props.Title)), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInput //labelfixed="Field label"
    , (_React$createElement = {
      label: "First name" //helperText="Helper text"
      ,
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement, "count", false), _defineProperty(_React$createElement, "tooltip", false), _defineProperty(_React$createElement, "LabelFixed", false), _React$createElement))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInput //labelfixed="Field label"
    , (_React$createElement2 = {
      label: "Last name" //helperText="Helper text"
      ,
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement2, "count", false), _defineProperty(_React$createElement2, "tooltip", false), _defineProperty(_React$createElement2, "LabelFixed", false), _React$createElement2))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInput //labelfixed="Field label"
    , (_React$createElement3 = {
      label: "Email address" //helperText="Helper text"
      ,
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement3, "count", false), _defineProperty(_React$createElement3, "tooltip", false), _defineProperty(_React$createElement3, "LabelFixed", false), _React$createElement3))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(FieldPassword, {
      PasswordStrong: true
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: classes.captchaBox
    }, "captcha"), /*#__PURE__*/React__default["default"].createElement("div", {
      className: classes.signUpLinkFrom
    }, "By signing up, you acknowledge you have read and agreed to our ", /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      className: classes.signUpLinkFromLink,
      href: "#"
    }, "Terms of Use"), " and ", /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      className: classes.signUpLinkFromLink,
      href: "#"
    }, "Privacy policy."))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: "SIGN UP",
      buttoncolor: "#2A8853",
      width: "100%"
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: classes.signUpLinkFrom
    }, "Already have an account?", /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      className: classes.signUpLinkFromLink,
      href: "#"
    }, " Sign in")))));
  }

  var css_248z$1b = ".OtpContainer{max-width:500px;margin:0 auto}.formSubTitle{font-size:14px;color:#4c5e67;text-align:center;font-weight:500;margin-top:24px}.formSubTitle span{display:block}.formSubTitle span a{color:#2a8853;text-decoration:none}.OtpFieldContainer,.OtpFieldContainer .OtpField{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.OtpFieldContainer .OtpField{border:1px solid #e4e8ec;border-radius:4px}.OtpFieldContainer .OtpFieldLine{margin:0 12px;color:#e4e8ec}.OtpFieldContainer .OtpField .MuiTextField-root{width:60px}.OtpFieldContainer .OtpField .MuiTextField-root input{text-align:center}.OtpFieldContainer .OtpField .MuiOutlinedInput-notchedOutline{border-color:transparent #e4e8ec transparent transparent;border-radius:0!important}.OtpFieldContainer .OtpField .MuiOutlinedInput-notchedOutline:focus{border-width:0}.OtpFieldContainer .OtpField .MuiTextField-root:last-child .MuiOutlinedInput-notchedOutline{border-color:transparent;border-radius:0!important}.MuiInputBase-input:focus{outline:none;border-color:transparent}.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline{border-width:1px}.wrongNumber .MuiInputBase-input{color:#f03}";
  styleInject(css_248z$1b);

  function Otp(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "OtpContainer"
    }, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("h1", {
      className: "SinginFormTitle"
    }, "Sign Up"), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "formSubTitle"
    }, "Please enter the verification code sent to your email address ", /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement("a", {
      href: "#"
    }, "shayanmahmud@email.com ")))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "OtpFieldContainer wrongNumber"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "OtpField"
    }, /*#__PURE__*/React__default["default"].createElement(TextField__default["default"], {
      id: "outlined-basic",
      variant: "outlined",
      value: "1"
    }), /*#__PURE__*/React__default["default"].createElement(TextField__default["default"], {
      id: "outlined-basic",
      variant: "outlined",
      value: "2"
    }), /*#__PURE__*/React__default["default"].createElement(TextField__default["default"], {
      id: "outlined-basic",
      variant: "outlined",
      value: "3"
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "OtpFieldLine"
    }, "-"), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "OtpField"
    }, /*#__PURE__*/React__default["default"].createElement(TextField__default["default"], {
      id: "outlined-basic",
      variant: "outlined",
      value: "4"
    }), /*#__PURE__*/React__default["default"].createElement(TextField__default["default"], {
      id: "outlined-basic",
      variant: "outlined",
      value: "5"
    }), /*#__PURE__*/React__default["default"].createElement(TextField__default["default"], {
      id: "outlined-basic",
      variant: "outlined",
      value: "6"
    })))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: "Verify"
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "signUpLinkFrom"
    }, "Didn't receive code yet? ", /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      href: "#"
    }, "Send again")))));
  }

  var cardFunction$3 = function cardFunction(value) {
    value && console.log("clicked");
  };

  var SelectPackage = function SelectPackage() {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FormdataContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
      cardFunction: cardFunction$3,
      header: "GROUP A",
      dayText: "21 Days",
      body: "Sunday, July 15 to, Thursday, August 7",
      color: "#0590FA"
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
      cardFunction: cardFunction$3,
      header: "GROUP B",
      dayText: "15 Days",
      body: "Monday, July 21 to, Thursday, August 7",
      color: "#06D02F"
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
      cardFunction: cardFunction$3,
      header: "VIP",
      dayText: "21 Days",
      body: "Monday, July 21 to, Thursday, August 7",
      color: "#6200EE"
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ContinueButton"
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: "Continue",
      buttoncolor: "#0590FA"
    })))));
  };

  var cardFunction$2 = function cardFunction(value) {
    value && console.log("clicked");
  };

  var DeliveryOptions = function DeliveryOptions() {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "DeliveryOptionsContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
      cardFunction: cardFunction$2,
      header: "I'd like it delivered",
      color: "#1B2121",
      icon: /*#__PURE__*/React__default["default"].createElement(LocalShippingIcon__default["default"], null),
      Link: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
      cardFunction: cardFunction$2,
      header: "I'd like it delivered",
      color: "#1B2121",
      icon: /*#__PURE__*/React__default["default"].createElement(StorefrontIcon__default["default"], null),
      Link: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "deleverdOptionDetails"
    }, /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "deleverdOptionDetailsTitle"
    }, "Pickup from:"), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "deleverdOptionDetailsAddress"
    }, "Street address, City, State Zip code"), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "deleverdOptionDetailsPhoneNumber"
    }, "+1 (123) 123-1234")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "deleverdOptionDetailsRightText"
    }, "In-Store pickup"))), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ContinueButton"
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: "Continue",
      buttoncolor: "#0590FA"
    })))));
  };

  var DeliveryDetails = function DeliveryDetails() {
    var _React$useState = React__default["default"].useState({
      country: "",
      number: ""
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        phone = _React$useState2[0];
        _React$useState2[1];

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "DeliveryDetailsContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "First/Given name",
      labelStatus: true //helpertext="Helper text"
      ,
      HelpertextStatus: true,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Middle name (optional)",
      labelStatus: true,
      helpertext: "Helper text" //HelpertextStatus={true}
      ,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Last/Surname",
      labelStatus: true //helpertext="Helper text"
      ,
      HelpertextStatus: false,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PhoneInputField, {
      labelFixed: "Phone number",
      phoneInputVariant: "materialui" // default, materialui, underlineInput, underlineWithFlag
      ,
      country: 'us',
      value: phone.number,
      countryCodeEditable: false,
      onChange: function onChange(phone, country) {
        return console.log("onChange", phone, country);
      },
      onBlur: function onBlur() {
        return console.log("onBlur");
      },
      onKeyDown: function onKeyDown(e) {
        return console.log("onKeyDown", e.target.value);
      },
      variant: "outlined",
      onlyCountries: ["us", "ca", "gb", "my"],
      containerStyle: {},
      buttonStyle: {},
      inputStyle: {
        marginLeft: "0px",
        height: "40px",
        width: "100%",
        fontFamily: "Roboto-Regular",
        fontSize: "16px"
      },
      containerClass: {},
      errorText: "Phone number is required",
      error: false,
      errorStyles: {
        marginBottom: "5px"
      },
      autoFormat: true,
      disableDropdown: false,
      disabled: false,
      disableCountryCode: false,
      enableSearch: false,
      disableSearchIcon: false,
      placeholder: "",
      inputProps: {} //specialLabel={'Primary Phone'}
      // preferredCountries={[]}
      // excludeCountries={[]}

    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Email",
      labelStatus: true // helpertext="Helper text"
      ,
      HelpertextStatus: false,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Age",
      labelStatus: true // helpertext="Helper text"
      ,
      HelpertextStatus: false,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(SelectField, {
      labelFixed: "Gender",
      label: "Select",
      helperText: "Helper text",
      Errormessage: "Error message",
      helpertext: false,
      errortext: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(SelectField, {
      labelFixed: "Hajj year",
      label: "Select",
      helperText: "Helper text",
      Errormessage: "Error message",
      helpertext: false,
      errortext: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Address line 1",
      labelStatus: true // helpertext="Helper text"
      ,
      HelpertextStatus: false,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Address line 2 (Optional)",
      labelStatus: true // helpertext="Helper text"
      ,
      HelpertextStatus: false,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "City/Town",
      labelStatus: true // helpertext="Helper text"
      ,
      HelpertextStatus: false,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(SelectField, {
      labelFixed: "State/Province",
      label: "Select",
      helperText: "Helper text",
      Errormessage: "Error message",
      helpertext: false,
      errortext: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Zip/Postal code",
      labelStatus: true // helpertext="Helper text"
      ,
      HelpertextStatus: false,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ContinueButton"
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: "Continue",
      buttoncolor: "#0590FA"
    })))));
  };

  var cardFunction$1 = function cardFunction(value) {
    value && console.log("clicked");
  };

  function PaymentComponent$1(props) {
    var _React$createElement, _React$createElement2, _React$createElement3, _React$createElement4, _React$createElement5, _React$createElement6, _React$createElement7, _React$createElement8;

    var privacyPolicyLink = props.privacyPolicyLink,
        termsOfUseLink = props.termsOfUseLink,
        cardDetails = props.cardDetails,
        setcardDetails = props.setcardDetails,
        addressDetails = props.addressDetails,
        setaddressDetails = props.setaddressDetails,
        saveCardDetails = props.saveCardDetails,
        setsaveCardDetails = props.setsaveCardDetails,
        selectedCardDetails = props.selectedCardDetails,
        onEditBillingDetailClick = props.onEditBillingDetailClick,
        visaCardImage = props.visaCardImage,
        masterCardImage = props.masterCardImage,
        helpImage = props.helpImage,
        newCardImage = props.newCardImage,
        discoverCardImage = props.discoverCardImage,
        americanExpressImage = props.americanExpressImage,
        dinersCardImage = props.dinersCardImage;

    var _React$useState = React__default["default"].useState("newCard"),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        paymentWith = _React$useState2[0],
        setpaymentWith = _React$useState2[1];

    var _React$useState3 = React__default["default"].useState({
      cardNumberError: false,
      expirationError: false,
      codeError: false
    }),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        cardDetailsError = _React$useState4[0],
        setcardDetailsError = _React$useState4[1];

    var onSubmit = function onSubmit() {
      if (paymentWith === "newCard") {
        props.onPlaceOrderSubmit({
          cardDetails: cardDetails,
          addressDetails: addressDetails
        });
        console.log(cardDetails, addressDetails);
      } else {
        props.onPlaceOrderSubmit({
          selectedCardDetails: selectedCardDetails
        });
        console.log(selectedCardDetails);
      }
    };

    var handleCardDetailChange = function handleCardDetailChange(e) {
      setcardDetails(_objectSpread2(_objectSpread2({}, cardDetails), {}, _defineProperty({}, e.target.name, e.target.value)));
    };

    var handleAddressDetailChange = function handleAddressDetailChange(e) {
      console.log("test", e);
      setaddressDetails(_objectSpread2(_objectSpread2({}, addressDetails), {}, _defineProperty({}, e.target.name, e.target.value)));
    };

    var handleStateChange = function handleStateChange(event, newValue) {
      setaddressDetails(_objectSpread2(_objectSpread2({}, addressDetails), {}, {
        state: newValue.title
      }));
    };

    var cardImage = function cardImage(number) {
      // visa card
      if (/^4[0-9]{12}(?:[0-9]{3})?$/.test(number)) {
        return /*#__PURE__*/React__default["default"].createElement(core.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React__default["default"].createElement("img", {
          src: visaCardImage,
          className: "masterCardImage",
          alt: "card img"
        }));
      } //master card
      else if (/^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/.test(number)) {
        return /*#__PURE__*/React__default["default"].createElement(core.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React__default["default"].createElement("img", {
          src: masterCardImage,
          className: "masterCardImage",
          alt: "card img"
        }));
      } // American Express
      else if (/^3[47][0-9]{13}$/.test(number)) {
        return /*#__PURE__*/React__default["default"].createElement(core.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React__default["default"].createElement("img", {
          src: americanExpressImage,
          className: "masterCardImage",
          alt: "card img"
        }));
      } //Diners Club
      else if (/^3(?:0[0-5]|[68][0-9])[0-9]{11}$/.test(number)) {
        return /*#__PURE__*/React__default["default"].createElement(core.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React__default["default"].createElement("img", {
          src: dinersCardImage,
          className: "masterCardImage",
          alt: "card img"
        }));
      } //Discover
      else if (/^6(?:011|5[0-9]{2})[0-9]{12}$/.test(number)) {
        return /*#__PURE__*/React__default["default"].createElement(core.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React__default["default"].createElement("img", {
          src: discoverCardImage,
          className: "masterCardImage",
          alt: "card img"
        }));
      }
    };

    var checkCVC = function checkCVC() {
      var cardNumber = cardDetails.cardNumber,
          code = cardDetails.code;

      if (cardNumber[0] === '3' ? code.length !== 4 : code.length !== 3) {
        return false;
      } else {
        return true;
      }
    };

    var validateExpiration = function validateExpiration() {
      var expiration = cardDetails.expiration;

      if (/^(0[1-9]|1[0-2])\/\d{2}$/.test(expiration)) {
        var today, someday;
        var exMonth = expiration.split("/")[0];
        var exYear = expiration.split("/")[1];
        today = new Date();
        someday = new Date();
        someday.setFullYear('20' + exYear, exMonth, 1);

        if (someday < today) {
          console.log("The expiry date is before today's date. Please select a valid expiry date");
          return false;
        }

        return true;
      } else {
        return false;
      }
    };

    var handlePaymentCardSelectChange = function handlePaymentCardSelectChange(selectedCard) {
      props.handlePaymentSelectChange(selectedCard);
      setpaymentWith(selectedCard);
    };

    var cardNumber = cardDetails.cardNumber,
        expiration = cardDetails.expiration,
        code = cardDetails.code;
    var cardNumberError = cardDetailsError.cardNumberError,
        expirationError = cardDetailsError.expirationError,
        codeError = cardDetailsError.codeError;
    var firstName = addressDetails.firstName,
        lastName = addressDetails.lastName,
        line1 = addressDetails.line1,
        line2 = addressDetails.line2,
        city = addressDetails.city,
        state = addressDetails.state,
        postalCode = addressDetails.postalCode,
        country = addressDetails.country;
    var disableBtn = cardImage(cardNumber) && validateExpiration() && checkCVC() && firstName && lastName && line1 && city && state && postalCode && country ? false : true; // let disableBtn = checkCVC(code) ? false : true;

    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CheckoutPaymentForm"
    }, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      md: 4,
      sm: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
      cardFunction: cardFunction$1,
      header: "Credit Card",
      color: "#1B2121",
      icon: /*#__PURE__*/React__default["default"].createElement(PaymentOutlinedIcon__default["default"], null),
      Link: false
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      md: 4,
      sm: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
      cardFunction: cardFunction$1,
      header: "Pay Check",
      color: "#1B2121",
      icon: /*#__PURE__*/React__default["default"].createElement(PaymentOutlinedIcon__default["default"], null),
      Link: false
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      md: 4,
      sm: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
      cardFunction: cardFunction$1,
      header: "Pay Cash",
      color: "#1B2121",
      icon: /*#__PURE__*/React__default["default"].createElement(PaymentOutlinedIcon__default["default"], null),
      Link: false
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "infoTextContainer"
    }, " ", /*#__PURE__*/React__default["default"].createElement(InfoIcon__default["default"], null), " Please, use a card without interest/Riba. If possible, use a Debit Card instead."), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(CreditCardList, {
      label: "Pay with" //helperText="Helper text"
      ,
      Errormessage: "Error message",
      helpertext: true,
      errortext: false,
      tooltip: false,
      paymentWith: paymentWith,
      handleSelectChange: handlePaymentCardSelectChange,
      cardListOptions: props.creditCardsList // visaCardImage={visaCardImage}
      // masterCardImage={masterCardImage}
      ,
      newCardImage: newCardImage
    })), paymentWith === "newCard" ? /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement = {
      label: "Card number",
      helperText: "Helper text",
      placeholder: "4242424242424242",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement, "count", false), _defineProperty(_React$createElement, "tooltip", false), _defineProperty(_React$createElement, "inputlabel", true), _defineProperty(_React$createElement, "name", "cardNumber"), _defineProperty(_React$createElement, "onChange", handleCardDetailChange), _defineProperty(_React$createElement, "value", cardNumber), _defineProperty(_React$createElement, "InputProps", {
      endAdornment: cardImage(cardNumber) // inputComponent: NumberFormatCustom

    }), _defineProperty(_React$createElement, "onBlur", function onBlur() {
      return cardImage(cardNumber) ? setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
        cardNumberError: false
      })) : setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
        cardNumberError: true
      }));
    }), _defineProperty(_React$createElement, "errortextStatus", !cardImage(cardNumber) && cardNumberError ? true : false), _defineProperty(_React$createElement, "Errormessage", !cardImage(cardNumber) && cardNumberError ? "Enter valid card number" : ""), _React$createElement))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 3
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement2 = {
      label: "Expiration",
      placeholder: "MM/YY",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement2, "count", false), _defineProperty(_React$createElement2, "inputlabel", true), _defineProperty(_React$createElement2, "tooltip", false), _defineProperty(_React$createElement2, "name", "expiration"), _defineProperty(_React$createElement2, "onChange", handleCardDetailChange), _defineProperty(_React$createElement2, "value", expiration), _defineProperty(_React$createElement2, "onBlur", function onBlur() {
      return validateExpiration() ? setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
        expirationError: false
      })) : setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
        expirationError: true
      }));
    }), _defineProperty(_React$createElement2, "errortextStatus", !validateExpiration() && expirationError ? true : false), _defineProperty(_React$createElement2, "Errormessage", !validateExpiration() && expirationError ? "Invalid exp date" : ""), _React$createElement2))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 3
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement3 = {
      label: "Security code",
      helperText: "Helper text",
      placeholder: "CVV",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement3, "count", false), _defineProperty(_React$createElement3, "tooltip", false), _defineProperty(_React$createElement3, "inputlabel", true), _defineProperty(_React$createElement3, "name", "code"), _defineProperty(_React$createElement3, "onChange", handleCardDetailChange), _defineProperty(_React$createElement3, "value", code), _defineProperty(_React$createElement3, "type", "number"), _defineProperty(_React$createElement3, "InputProps", {
      endAdornment: /*#__PURE__*/React__default["default"].createElement(core.InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        src: helpImage,
        width: "30px",
        alt: "card img"
      }))
    }), _defineProperty(_React$createElement3, "onBlur", function onBlur() {
      return checkCVC() ? setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
        codeError: false
      })) : setcardDetailsError(_objectSpread2(_objectSpread2({}, cardDetailsError), {}, {
        codeError: true
      }));
    }), _defineProperty(_React$createElement3, "errortextStatus", !checkCVC() && codeError ? true : false), _defineProperty(_React$createElement3, "Errormessage", !checkCVC() && codeError ? "Enter Valid CVC Number" : ""), _React$createElement3)))) : null, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "formSectionTitle"
    }, "Billing address")), paymentWith !== "newCard" ? /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "billingAddressContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "billingAddressTitle"
    }, /*#__PURE__*/React__default["default"].createElement("span", null, selectedCardDetails && selectedCardDetails.firstName, "  ", selectedCardDetails && selectedCardDetails.lastName), " ", /*#__PURE__*/React__default["default"].createElement("span", {
      style: {
        color: "#0590FA",
        cursor: "pointer"
      },
      onClick: onEditBillingDetailClick
    }, "Edit")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "billingaddressInfo"
    }, /*#__PURE__*/React__default["default"].createElement("li", null, selectedCardDetails && selectedCardDetails.line1), /*#__PURE__*/React__default["default"].createElement("li", null, selectedCardDetails && selectedCardDetails.city, ", ", selectedCardDetails && selectedCardDetails.state, " ", selectedCardDetails && selectedCardDetails.postalCode), /*#__PURE__*/React__default["default"].createElement("li", null, selectedCardDetails && selectedCardDetails.country)))) : null, paymentWith === "newCard" ? /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement4 = {
      label: "First name",
      helperText: "Helper text",
      placeholder: "First name",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement4, "count", false), _defineProperty(_React$createElement4, "tooltip", false), _defineProperty(_React$createElement4, "inputlabel", true), _defineProperty(_React$createElement4, "name", "firstName"), _defineProperty(_React$createElement4, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement4, "value", firstName), _React$createElement4))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement5 = {
      label: "Last name",
      helperText: "Helper text",
      placeholder: "Last name",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement5, "count", false), _defineProperty(_React$createElement5, "tooltip", false), _defineProperty(_React$createElement5, "inputlabel", true), _defineProperty(_React$createElement5, "name", "lastName"), _defineProperty(_React$createElement5, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement5, "value", lastName), _React$createElement5))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement6 = {
      label: "Address line 1",
      helperText: "Helper text",
      placeholder: "Street address, P.O. box, house etc.",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement6, "count", false), _defineProperty(_React$createElement6, "tooltip", false), _defineProperty(_React$createElement6, "inputlabel", true), _defineProperty(_React$createElement6, "name", "line1"), _defineProperty(_React$createElement6, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement6, "value", line1), _React$createElement6))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement7 = {
      label: "Address line 2 (Optional)",
      helperText: "Helper text",
      placeholder: "Street address, P.O. box, house etc.",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement7, "count", false), _defineProperty(_React$createElement7, "tooltip", false), _defineProperty(_React$createElement7, "inputlabel", false), _defineProperty(_React$createElement7, "name", "line2"), _defineProperty(_React$createElement7, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement7, "value", line2), _React$createElement7))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement8 = {
      label: "City/Town",
      helperText: "Helper text",
      placeholder: "Placeholder",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement8, "count", false), _defineProperty(_React$createElement8, "tooltip", false), _defineProperty(_React$createElement8, "inputlabel", false), _defineProperty(_React$createElement8, "name", "city"), _defineProperty(_React$createElement8, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement8, "value", city), _React$createElement8))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(SelectField, {
      label: "State/Province" //helperText="Helper text"
      ,
      Errormessage: "Error message",
      helpertext: true,
      errortext: false,
      labelStatus: false,
      name: "state",
      onChange: handleStateChange,
      value: state,
      selectOptions: [{
        title: "New York"
      }, {
        title: "California"
      }]
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      name: "postalCode",
      onChange: handleAddressDetailChange,
      value: postalCode,
      label: "Zip/Postal code",
      labelStatus: false //helpertext="Helper text"
      ,
      HelpertextStatus: true,
      placeholder: "Placeholder",
      Errormessage: "Error message",
      errortextStatus: false,
      count: 100,
      countStatus: true,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(ReactFlagsSelect__default["default"], {
      searchable: true,
      selected: country,
      onSelect: function onSelect(code) {
        return setaddressDetails(_objectSpread2(_objectSpread2({}, addressDetails), {}, {
          country: code
        }));
      },
      defaultCountry: "US"
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(CheckBox, {
      onChange: setsaveCardDetails,
      checked: saveCardDetails,
      label: "Save my card details for future transaction",
      description: "Keep me signed in",
      value: "",
      Tooltip: true,
      Description: false
    }))) : null, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "separator_line"
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "form_button_box"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "tos_text"
    }, "By placing your order you agree to our ", /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      href: privacyPolicyLink
    }, "Privacy Policy"), " and ", /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      href: termsOfUseLink
    }, "Terms of Use")), /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      disabled: paymentWith !== "newCard" ? false : disableBtn,
      onclick: onSubmit,
      label: "Placeholder"
    }))))));
  }

  var CheckoutPaymentExtended = function CheckoutPaymentExtended(props) {
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SucureText"
    }, "Secured checkout ", /*#__PURE__*/React__default["default"].createElement(LockOutlinedIcon__default["default"], null)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CheckoutPaymentExtendedContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Accordion__default["default"], null, /*#__PURE__*/React__default["default"].createElement(AccordionSummary__default["default"], {
      "aria-controls": "panel1a-content",
      id: "panel1a-header"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "aAccordionTitle"
    }, /*#__PURE__*/React__default["default"].createElement("span", null, "1"), " ", props.StepTitle_1)), /*#__PURE__*/React__default["default"].createElement(AccordionDetails__default["default"], null, /*#__PURE__*/React__default["default"].createElement(SelectPackage, null))), /*#__PURE__*/React__default["default"].createElement(Accordion__default["default"], null, /*#__PURE__*/React__default["default"].createElement(AccordionSummary__default["default"], {
      "aria-controls": "panel1a-content",
      id: "panel1a-header"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "aAccordionTitle"
    }, /*#__PURE__*/React__default["default"].createElement("span", null, "2"), " ", props.StepTitle_2)), /*#__PURE__*/React__default["default"].createElement(AccordionDetails__default["default"], null, /*#__PURE__*/React__default["default"].createElement(DeliveryOptions, null))), /*#__PURE__*/React__default["default"].createElement(Accordion__default["default"], null, /*#__PURE__*/React__default["default"].createElement(AccordionSummary__default["default"], {
      "aria-controls": "panel1a-content",
      id: "panel1a-header"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "aAccordionTitle"
    }, /*#__PURE__*/React__default["default"].createElement("span", null, "3"), " ", props.StepTitle_3)), /*#__PURE__*/React__default["default"].createElement(AccordionDetails__default["default"], null, /*#__PURE__*/React__default["default"].createElement(DeliveryDetails, null))), /*#__PURE__*/React__default["default"].createElement(Accordion__default["default"], {
      defaultExpanded: true
    }, /*#__PURE__*/React__default["default"].createElement(AccordionSummary__default["default"], {
      "aria-controls": "panel1a-content",
      id: "panel1a-header"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "aAccordionTitle"
    }, /*#__PURE__*/React__default["default"].createElement("span", null, "4"), " ", props.StepTitle_4)), /*#__PURE__*/React__default["default"].createElement(AccordionDetails__default["default"], null, /*#__PURE__*/React__default["default"].createElement(PaymentComponent$1, {
      creditCardsList: props.creditCardsList,
      handlePaymentSelectChange: props.handlePaymentSelectChange,
      onPlaceOrderSubmit: props.onPlaceOrderSubmit,
      cardDetails: props.cardDetails,
      setcardDetails: props.setcardDetails,
      addressDetails: props.addressDetails,
      setaddressDetails: props.setaddressDetails,
      saveCardDetails: props.saveCardDetails,
      setsaveCardDetails: props.setsaveCardDetails,
      selectedCardDetails: props.selectedCardDetails,
      privacyPolicyLink: props.privacyPolicyLink,
      termsOfUseLink: props.termsOfUseLink,
      onEditBillingDetailClick: props.onEditBillingDetailClick,
      visaCardImage: props.visaCardImage,
      masterCardImage: props.masterCardImage,
      newCardImage: props.newCardImage,
      discoverCardImage: props.discoverCardImage,
      americanExpressImage: props.americanExpressImage,
      dinersCardImage: props.dinersCardImage,
      helpImage: props.helpImage
    })))));
  };

  var css_248z$1a = ".MainBanner1{display:-webkit-box;display:-ms-flexbox;display:flex;margin-right:8px;position:relative;width:100%}.MainBanner1 .MainBannerInner{width:100%;height:390px}.MainBanner1 .BannerText{position:absolute;z-index:999;bottom:50px;left:40px;background:transparent!important}.MainBanner1 .BannerText .bannerTitle{color:#fff;font-size:40px;font-weight:700;font-family:Poppins,sans-serif}.MainBanner1 .BannerText .bannerDescrition{color:#fff;font-size:16px;font-weight:400;max-width:600px;font-family:Poppins,sans-serif}.MainBanner1 .bannerSteps{position:absolute;right:0;bottom:0;background:transparent;padding:0;z-index:12}.MainBanner1 .bannerSteps .MuiButtonBase-root{color:#fff;background:#56b149;width:34px;height:34px;border-radius:0;margin-left:1px;min-width:34px!important}.MainBanner1 .BannerImg{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.BannerImgContainer{position:relative;height:390px}.BannerImgContainer:after{content:\"\";position:absolute;width:100%;height:100%;left:0;top:0;background:#000;opacity:.3;z-index:10}.BannerLinkButton{width:152px;height:50px;background:hsla(0,0%,100%,.2) 0 0 no-repeat padding-box!important;border:1px solid #56b149!important;border-radius:4px;opacity:1;margin-top:32px!important;color:#fff!important;font-size:14px;font-weight:500;text-transform:uppercase}.BannerLinkButton:hover{background:#56b149;border:1px solid #56b149}.LinkCardContainer .BannerRightList{background-color:#56b149;padding:20px;border-radius:4px;margin-bottom:8px;cursor:pointer;position:relative}.LinkCardContainer .flexbox{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.LinkCardContainer .BannerRightList h1{color:#fff;font-size:20px;font-weight:700;margin:0;max-width:160px;line-height:24px;font-family:Poppins,sans-serif}.LinkCardContainer .BannerRightList .avatarSingle{width:76px;height:76px}.LinkCardContainer .BannerRightList .AvatarGroup{margin-top:14px}.LinkCardContainer .BannerRightList .BannerRightListArrow{position:absolute;right:20px;top:20px;color:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg)}";
  styleInject(css_248z$1a);

  var AutoPlaySwipeableViews$3 = reactSwipeableViewsUtils.autoPlay(SwipeableViews__default["default"]);

  function MainBanner1(props) {
    var tutorialSteps = props.tutorialSteps;
    var theme = styles$1.useTheme();

    var _React$useState = React__default["default"].useState(0),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        activeStep = _React$useState2[0],
        setActiveStep = _React$useState2[1];

    var maxSteps = tutorialSteps.length;

    var handleNext = function handleNext() {
      setActiveStep(function (prevActiveStep) {
        return prevActiveStep + 1;
      });
    };

    var handleBack = function handleBack() {
      setActiveStep(function (prevActiveStep) {
        return prevActiveStep - 1;
      });
    };

    var handleStepChange = function handleStepChange(step) {
      setActiveStep(step);
    };

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "MainBanner1"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "MainBannerInner"
    }, /*#__PURE__*/React__default["default"].createElement(Paper__default["default"], {
      square: true,
      elevation: 0,
      className: "BannerText"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "bannerTitle"
    }, tutorialSteps[activeStep].label), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "bannerDescrition"
    }, tutorialSteps[activeStep].Descrition), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      className: "BannerLinkButton",
      variant: "outlined",
      color: "primary",
      href: tutorialSteps[activeStep].Link,
      target: "blank"
    }, props.BannerButton)), /*#__PURE__*/React__default["default"].createElement(AutoPlaySwipeableViews$3, {
      axis: theme.direction === 'rtl' ? 'x-reverse' : 'x',
      index: activeStep,
      onChangeIndex: handleStepChange,
      enableMouseEvents: true
    }, tutorialSteps.map(function (step, index) {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        key: step.label,
        className: "BannerImgContainer"
      }, Math.abs(activeStep - index) <= 2 ? /*#__PURE__*/React__default["default"].createElement("img", {
        className: "BannerImg",
        src: step.imgPath,
        alt: step.label
      }) : null);
    })), /*#__PURE__*/React__default["default"].createElement(MobileStepper__default["default"], {
      className: "bannerSteps",
      steps: maxSteps,
      position: "static",
      variant: "none",
      activeStep: activeStep,
      nextButton: /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
        size: "small",
        onClick: handleNext,
        disabled: activeStep === maxSteps - 1
      }, theme.direction === 'rtl' ? /*#__PURE__*/React__default["default"].createElement(KeyboardArrowLeft__default["default"], null) : /*#__PURE__*/React__default["default"].createElement(KeyboardArrowRight__default["default"], null)),
      backButton: /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
        size: "small",
        onClick: handleBack,
        disabled: activeStep === 0
      }, theme.direction === 'rtl' ? /*#__PURE__*/React__default["default"].createElement(KeyboardArrowRight__default["default"], null) : /*#__PURE__*/React__default["default"].createElement(KeyboardArrowLeft__default["default"], null))
    })));
  }

  var _templateObject;
  var Item = styled__default["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height:auto;\n  width: 100%;\n  background-color: #fff;\n  margin: 0px;\n  margin-left:20px;\n"])));

  var css_248z$19 = ".CarouselContainer{position:relative}.CarouselContainer .DSYfs{background-color:transparent!important}.CarouselContainer .rec-arrow-left{right:53px}.CarouselContainer .rec-arrow-left,.CarouselContainer .rec-arrow-right{position:absolute;top:7px;background:#56b149;border-radius:0;width:34px;height:34px;-webkit-box-shadow:none;box-shadow:none;color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:17px}.CarouselContainer .rec-arrow-right{right:0}.CarouselContainer .rec-arrow-right:hover{background:#56b149!important}.CarouselContainer .lgksPe:hover:enabled,.lgksPe:focus:enabled{background-color:#56b149;color:#fff;background-color:#56b149!important;-webkit-box-shadow:none;box-shadow:none}.CarouselContainer .CarouselTitle{color:#0b132b;font-size:40px;font-weight:600;text-transform:uppercase;margin-bottom:20px;line-height:46px}.CarouselContainer .iLquPE:disabled{cursor:not-allowed;background:#ccc}.CarouselContainer .cukhLH{overflow:hidden;position:relative;width:102%;margin:0 -18px;right:0}.CarouselContainer .rec-pagination{display:none}.CarouselContainerItem{margin:0 15px}.rec-carousel-wrapper{margin-left:-24px;width:104%!important}.HajjReadingListContainer{padding-bottom:12px}.ImgContainer{height:160px;overflow:hidden}.HajjReadingListContainer img{width:100%;-o-object-fit:cover;object-fit:cover;height:100%}.HajjReadingListContainer .HajjReadingDescription{color:#0b132b!important;font-size:20px!important;font-weight:600!important;line-height:24px!important;margin-top:12px!important;-webkit-transition:.3ms!important;transition:.3ms!important}.CardReadmore{font-size:14px!important;font-weight:500!important;color:#0b132b!important;display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;margin-top:12px!important;position:absolute;bottom:10px}.HajjReadingListContainer:hover .HajjReadingDescription{color:#56b149!important}.CardReadmore svg{font-size:13px;margin-top:4px;margin-left:5px}.Card{cursor:pointer}.Card:hover .CardReadmore,.Card:hover .HajjReadingDescription{color:#56b149!important}.ImgContainerVideos{height:179px;overflow:hidden;position:relative}.VideosAlfa{background:-webkit-gradient(linear,left top,right top,from(rgba(2,0,36,.5578606442577031)),to(rgba(0,0,0,.44861694677871145)));background:linear-gradient(90deg,rgba(2,0,36,.5578606442577031),rgba(0,0,0,.44861694677871145));position:absolute;width:100%;height:100%;left:0;top:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:none}.VideosAlfa svg{color:#fff;font-size:34px}.ImgContainerVideos:hover .VideosAlfa{display:-webkit-box;display:-ms-flexbox;display:flex}@media(max-width:600px){.galrjd{position:relative}.CarouselContainer .rec-arrow-left,.CarouselContainer .rec-arrow-right{position:absolute;top:12px;z-index:999;margin-right:20px}.ImgContainer,.ImgContainerVideos{height:220px;overflow:hidden}.ImgContainerVideos{position:relative}.CarouselContainer .CarouselTitle{font-size:36px}}";
  styleInject(css_248z$19);

  var breakPoints = [{
    width: 1,
    itemsToShow: 1
  }, {
    width: 550,
    itemsToShow: 2
  }, {
    width: 768,
    itemsToShow: 4
  }, {
    width: 1200,
    itemsToShow: 4
  }];

  function HajjReadings(props) {
    var carouselItems = props.carouselItems,
        title = props.title;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CarouselContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CarouselTitle"
    }, title), /*#__PURE__*/React__default["default"].createElement(Carousel__default["default"], {
      breakPoints: breakPoints
    }, carouselItems !== null && carouselItems !== void 0 && carouselItems.length ? carouselItems.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Item, {
        key: i
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "HajjReadingListContainer Card"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "ImgContainer"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        src: item.image,
        alt: "item"
      })), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
        className: "HajjReadingDescription"
      }, item.description), /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        href: item.link,
        className: "CardReadmore"
      }, "READ MORE ", /*#__PURE__*/React__default["default"].createElement(ArrowForwardIosRoundedIcon__default["default"], null), " ")));
    }) : null)));
  }

  var css_248z$18 = ".GalleryContainer{background:#fff;padding:30px;position:relative}.GalleryContainer .GalleryTitle{font-size:40px;font-family:Poppins,sans-serif!important;font-weight:600;color:#0b132b;max-width:460px;line-height:46px}.GalleryContainer .GalleryDescription{font-size:24px;font-family:Poppins,sans-serif!important;font-weight:400;color:#676c7b;max-width:540px;line-height:38px;margin-top:12px}.GalleryContainer .ViewMoreGaleryButton{padding:15px 24px!important;font-size:14px!important;font-weight:600!important;text-transform:uppercase!important;margin-top:24px!important}.GalleryContainer .ViewMoreGaleryButton,.GalleryContainer .ViewMoreGaleryButton:focus,.GalleryContainer .ViewMoreGaleryButton:hover{background:#56b149!important;color:#fff!important;border:none!important}.imgsize_268{height:168px}.imgsize_130{height:80px}.imgsize_200{height:100px}.GelleryImgContaier img{-o-object-fit:cover;object-fit:cover;width:100%;height:100%;cursor:pointer}";
  styleInject(css_248z$18);

  function ViewGallery(props) {
    var buttonText = props.buttonText,
        titleText = props.titleText,
        galleryData = props.galleryData;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "GalleryContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "GalleryTitle"
    }, titleText), galleryData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
        className: "GalleryDescription"
      }, item.Description);
    }), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      className: "ViewMoreGaleryButton",
      variant: "outlined",
      color: "primary",
      onClick: props.buttonClicked
    }, buttonText)), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, props.GalleryGrid)));
  }

  var css_248z$17 = ".PricingTableContainer{background:#f8f8f9}.PricingTableContainer .MuiTableContainer-root{width:100%;overflow-x:visible;overflow-x:initial}.PricingTableContainer .pricingTitle h1{text-align:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:40px;margin:0;color:#fff;text-transform:uppercase;font-weight:400;font-size:20px;padding:3px}.PricingTableContainer .MuiTableCell-root{padding:0!important}.PricingTableContainer .pricingTitleBottomBody{padding:30px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.PricingTableContainer .pricingTitleBottomBody h2{text-align:center;color:#fff;font-size:40px;font-weight:600;margin:0}.PricingTableContainer .pricingTitleBottomBody h2 span{text-align:center;color:#fff;font-size:23px;font-weight:400;position:relative;top:-18px;text-align:right;right:-9px}.PricingTableContainer .pricingTitleBottomBody p{text-align:center;color:#fff;font-size:16px;font-weight:400;text-transform:uppercase;margin-top:30px;margin-bottom:20px}.PricingTableContainer .priceSelectButton{color:#fff;width:100%;border-radius:4px;cursor:pointer;margin:0 auto;padding:13px 60px}.PricingTableContainer .priceSelectButton:hover{text-decoration:none}.PricingTableContainer .blueTheme{background:#0590fa}.PricingTableContainer .blueTheme .prTitleName{background:#0585e6}.PricingTableContainer .blueTheme .priceSelectButton{background:#0590fa;border:1px solid #7dc5fc}.PricingTableContainer .greenTheme{background:#06d02f}.PricingTableContainer .greenTheme .prTitleName{background:#06c02b}.PricingTableContainer .greenTheme .priceSelectButton{background:#06c02b;border:1px solid #7ee793}.PricingTableContainer .greyTheme{background:#7785cd}.PricingTableContainer .greyTheme .prTitleName{background:#6e7bbd}.PricingTableContainer .greyTheme .priceSelectButton{background:#7785cd;border:1px solid #b9c0e5}.PricingTableContainer .GreemButton{background:#06c02b;border:1px solid #7ee793}.PricingTableContainer .GreyButton{background:#7785cd;border:1px solid #b9c0e5}.PricingTableContainer .BlueButton{background:#0590fa;border:1px solid #7dc5fc}.PricingTableContainer .PricingPackageTitleContainer{width:329px;padding:0 30px}.PricingTableContainer .PricingPackageTitleContainer h3{font-size:45px;line-height:49px;margin:20px 0}.PricingTableContainer .PricingPackageTitleContainerTh{vertical-align:baseline}.PricingTableContainer .PricingPackageTitleContainer .Tax_text{color:#7a7f8c;text-transform:uppercase;font-size:20px;font-weight:400;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.PricingTableContainer .PricingPackageTitleContainer .Tax_text svg{color:#31a347;font-size:30px;margin-right:6px}.PricingTableContainer .MuiTableCell-body{font-size:14px;font-weight:600;border:1px solid #f1f3f5;padding:15px 20px 15px 30px!important}.PricingTableContainer .MuiTableCell-root{border-bottom:1px solid #f1f3f5!important}.PricingTableContainer .PrcInfoIcon{color:#d3d4d9;float:right}.PricingTableContainer .tableCheckIcon{color:#56b149}.PricingTableContainer .leftAling{float:none!important}.PricingTableContainer .TextWithIcon{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:end;color:#676c7b;font-weight:400}.PricingTableContainer .TextWithIcon svg{margin-right:10px}@media(max-width:990px){.PricingTableContainer .MuiTableContainer-root{width:100%;overflow-x:auto}}";
  styleInject(css_248z$17);

  function PricingTable(props) {
    var title = props.title,
        subTitle = props.subTitle,
        tableHeadData = props.tableHeadData,
        tableBodyData = props.tableBodyData;
        props.onSelectClick;
        props.history;
    var StyledTableRow = styles$1.withStyles(function (theme) {
      return {
        root: {
          '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover
          }
        }
      };
    })(TableRow__default["default"]);
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PricingTableContainer"
    }, /*#__PURE__*/React__default["default"].createElement(TableContainer__default["default"], {
      component: Paper__default["default"]
    }, /*#__PURE__*/React__default["default"].createElement(Table__default["default"], null, /*#__PURE__*/React__default["default"].createElement(TableHead__default["default"], null, /*#__PURE__*/React__default["default"].createElement(TableRow__default["default"], null, /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
      className: "PricingPackageTitleContainerTh"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PricingPackageTitleContainer"
    }, /*#__PURE__*/React__default["default"].createElement("h3", null, title), /*#__PURE__*/React__default["default"].createElement("p", {
      className: "Tax_text"
    }, " ", /*#__PURE__*/React__default["default"].createElement(CheckCircleRoundedIcon__default["default"], null), subTitle))), tableHeadData !== null && tableHeadData !== void 0 && tableHeadData.length ? tableHeadData.map(function (el, i) {
      return /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], null, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "pricingTitle ".concat(el.theme)
      }, /*#__PURE__*/React__default["default"].createElement("h1", {
        className: "prTitleName"
      }, el.title), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "pricingTitleBottomBody"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "priceTabConInfo"
      }, /*#__PURE__*/React__default["default"].createElement("h2", null, /*#__PURE__*/React__default["default"].createElement("span", null, el.priceSign, " "), " ", el.price), /*#__PURE__*/React__default["default"].createElement("p", null, el.Subtitle), /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        className: "priceSelectButton",
        variant: "outlined",
        color: "secondary",
        href: el.link,
        to: el.path,
        target: el.target
      }, "SELECT")))));
    }) : null)), /*#__PURE__*/React__default["default"].createElement(TableBody__default["default"], null, tableBodyData !== null && tableBodyData !== void 0 && tableBodyData.length ? tableBodyData.map(function (el, i) {
      return /*#__PURE__*/React__default["default"].createElement(StyledTableRow, {
        key: i
      }, /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
        align: "left"
      }, " ", el.featureName, " ", /*#__PURE__*/React__default["default"].createElement(Tooltip__default["default"], {
        className: "tooltipStyle",
        title: "Customize your own donation form to match organization brand and embed in your website.",
        arrow: true
      }, /*#__PURE__*/React__default["default"].createElement(InfoOutlinedIcon__default["default"], {
        className: "PrcInfoIcon"
      }))), /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
        align: "center"
      }, el.col1 === "checked" ? /*#__PURE__*/React__default["default"].createElement(CheckCircleOutlineRoundedIcon__default["default"], {
        className: "tableCheckIcon"
      }) : el.col1), /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
        align: "center"
      }, el.col2 === "checked" ? /*#__PURE__*/React__default["default"].createElement(CheckCircleOutlineRoundedIcon__default["default"], {
        className: "tableCheckIcon"
      }) : el.col2), props.colmThree && /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
        align: "center"
      }, el.col3 === "checked" ? /*#__PURE__*/React__default["default"].createElement(CheckCircleOutlineRoundedIcon__default["default"], {
        className: "tableCheckIcon"
      }) : el.col3));
    }) : null, /*#__PURE__*/React__default["default"].createElement(TableRow__default["default"], null, /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
      align: "left"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TextWithIcon"
    }, /*#__PURE__*/React__default["default"].createElement(Tooltip__default["default"], {
      className: "tooltipStyle",
      title: "Customize your own donation form to match organization brand and embed in your website.",
      arrow: true
    }, /*#__PURE__*/React__default["default"].createElement(InfoRoundedIcon__default["default"], {
      className: "PrcInfoIcon leftAling"
    })), " ", /*#__PURE__*/React__default["default"].createElement("div", null, props.tableFooterCellText))), /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
      align: "center"
    }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      className: "priceSelectButton BlueButton",
      variant: "outlined",
      color: "secondary",
      href: props.SelectlinkOne,
      target: props.target
    }, "SELECT")), /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
      align: "center"
    }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      className: "priceSelectButton GreemButton",
      variant: "outlined",
      color: "secondary",
      href: props.SelectlinkTwo,
      target: props.target
    }, "SELECT")), props.colmThree && /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
      align: "center"
    }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      className: "priceSelectButton GreyButton",
      variant: "outlined",
      color: "secondary",
      href: props.Selectlinkthree,
      target: props.target
    }, "SELECT")))))));
  }

  var css_248z$16 = ".FooterWebContainer{border-top:1px solid #efefef}.FooterWebContainer .footerWebTop{padding:30px;border-top:1px solid #e8e8e8}.FooterWebContainer .FootermenuTitle{font-size:16px;font-weight:700;color:#0b132b;text-transform:uppercase;margin-bottom:20px}.footerWebLinks a{font-size:16px;color:#676c7b;font-weight:400;cursor:pointer;display:block;margin-bottom:16px}.footerWebLinks a:hover{color:#0590fa;text-decoration:none}.footerWebLinks.footerDynamicLinks div{font-size:16px;color:#676c7b;font-weight:400;cursor:pointer;display:block;margin-bottom:16px}.footerWebLinks.footerDynamicLinks div:hover{color:#0590fa;text-decoration:none}.footerWebBottom{background:#fcfcfc;padding:17px 30px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.footerWebBottom p{font-size:14px;color:#676c7b;font-weight:400;cursor:pointer;margin:0;width:70%}.footerWebBottom a{font-size:14px;display:inline-block}.footerWebBottom a,.footerWebBottompowrdBy{color:#676c7b;font-weight:400;cursor:pointer;margin:0 15px}.footerWebBottompowrdBy{font-size:10px;display:inline-block;text-transform:uppercase;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;width:40%}.footerWebBottompowrdBy img{width:146px}.footerWebBottom .MuiGrid-root{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.linkFooterBototm{width:45%}@media(max-width:500px){.FooterWebContainer .footerWebTop{padding:30px;text-align:center}.footerWebBottom .MuiGrid-root{text-align:center;display:block;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.footerWebBottompowrdBy{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}}";
  styleInject(css_248z$16);

  function FooterWeb(props) {
    var _props$poweredBy, _props$poweredBy2;

    var footerLinks = props.footerLinks;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterWebContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "footerWebTop"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 3
    }, footerLinks !== null && footerLinks !== void 0 && footerLinks.length ? footerLinks.map(function (el, i) {
      var _el$columnOnelinks, _el$columnTwolinks;

      return /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        key: i,
        item: true,
        md: 4,
        sm: 6,
        xs: 12
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "FootermenuTitle"
      }, el.headingTitle), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        container: true,
        spacing: 3,
        className: "footerWebLinks footerDynamicLinks"
      }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        item: true,
        md: 6,
        sm: 6,
        xs: 12
      }, el !== null && el !== void 0 && (_el$columnOnelinks = el.columnOnelinks) !== null && _el$columnOnelinks !== void 0 && _el$columnOnelinks.length ? el.columnOnelinks.map(function (link, index) {
        return link.linkType === "external" ? /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
          key: index,
          href: link.url,
          target: link.target
        }, link.name) : /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
          key: index,
          onClick: function onClick() {
            return props.onLinkClick(_objectSpread2({}, link));
          },
          href: link.url,
          target: link.target
        }, link.name);
      }) : null), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        item: true,
        md: 6,
        sm: 6,
        xs: 12
      }, el !== null && el !== void 0 && (_el$columnTwolinks = el.columnTwolinks) !== null && _el$columnTwolinks !== void 0 && _el$columnTwolinks.length ? el.columnTwolinks.map(function (link, index) {
        return link.linkType === "external" ? /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
          key: index,
          href: link.url,
          target: link.target
        }, link.name) : /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
          key: index,
          onClick: function onClick() {
            return props.onLinkClick(_objectSpread2({}, link));
          },
          href: link.url,
          target: link.target
        }, link.name);
      }) : null)));
    }) : null)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "footerWebBottom"
    }, /*#__PURE__*/React__default["default"].createElement("p", null, props.copyRightsText), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "linkFooterBototm"
    }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      href: props.termsOfServiceLink
    }, "Terms of Services"), /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      href: props.privacyPolicyLink
    }, "Privacy Policy")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "footerWebBottompowrdBy"
    }, "Powered by ", /*#__PURE__*/React__default["default"].createElement("a", {
      href: props === null || props === void 0 ? void 0 : (_props$poweredBy = props.poweredBy) === null || _props$poweredBy === void 0 ? void 0 : _props$poweredBy.link,
      target: "blank"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props === null || props === void 0 ? void 0 : (_props$poweredBy2 = props.poweredBy) === null || _props$poweredBy2 === void 0 ? void 0 : _props$poweredBy2.logo,
      alt: "logo"
    })))));
  }

  var css_248z$15 = ".ContactUsContainer{background:#fcfcfc;padding:30px 60px;display:-webkit-box;display:-ms-flexbox;display:flex}.ContactUsContainer .contactForm{width:100%;padding-right:30px;max-width:450px}.ContactUsContainer .contactForm .ContactUsTitle{font-size:40px;font-weight:600;color:#0b132b;line-height:46px;letter-spacing:0;text-transform:uppercase;margin-bottom:20px}.ContactUsContainer .contactForm .ContactUsDecription{font-size:14px;font-weight:400;color:#676c7b;line-height:24px;letter-spacing:0}.ContactUsContainer .contactForm .contactFormContainer{margin-top:30px}.contactinfoContainer{border-left:1px solid #e4e8ec;margin-left:20px;padding-left:60px;position:relative}.ContactUsContainer .contactinfoContainer .contactinfoTitle{font-size:16px;color:#56b149;text-transform:uppercase;font-weight:500}.ContactIfoListContainer{margin-top:12px}.ContactIfoListContainer .ContactIfoList{color:#0b132b;font-size:16px;font-weight:400;line-height:24px;letter-spacing:0;display:block;margin-bottom:8px}.ContactIfoListContainer .ContactIfoList span{font-weight:600}.masterLiSocialLinks a{display:inline-block;margin:15px 4px}.masterLiSocialLinks a img{width:44px}.ContactIfoAddressContainer .ContactIfoAddressCard{background:#fff;padding:20px;text-align:center}.ContactIfoAddressContainer .ContactIfoAddressCard .ContactIfoAddressCol{color:#56b149;text-transform:uppercase;font-size:16px;line-height:24px;letter-spacing:0;font-weight:500;margin:0 0 8px}.ContactIfoAddressContainer .ContactIfoAddressCard .ContactIfoNameCol{color:#0b132b;font-size:16px;line-height:24px;letter-spacing:0;font-weight:400;margin:0 0 5px}.ContactIfoAddressContainer .ContactIfoAddressCard .ContactIfoNumberCol{color:#0b132b;font-size:16px;line-height:24px;letter-spacing:0;margin:0;font-weight:600}.whatsappIcon{position:fixed;right:20px;bottom:14px}.whatsappIcon img{width:68px}.contactFormContainer .MuiGrid-root{margin-bottom:10px!important}@media (max-width:800px){.ContactUsContainer{display:block}.ContactUsContainer .contactForm{padding-right:0;max-width:none}.contactinfoContainer{border-left:none;margin-left:0;padding-left:0;position:relative;margin-top:30px}.whatsappIcon{position:absolute;right:-11px;bottom:-9px}.ContactUsContainer{padding:30px}}.GetDirectionField{position:relative}.GetDirectionField .MuiInputBase-input{text-indent:95px}.GetDirectionField .GetDirectionIconLabel{display:-webkit-box;display:-ms-flexbox;display:flex;position:absolute;color:#fff;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:16px;font-weight:400;border-radius:4px;top:8px;left:8px;width:62px;height:40px;padding:0 11px;z-index:2}.GetDirectionField .GetDirectionIconLabel svg{font-size:22px;margin-left:4px}";
  styleInject(css_248z$15);

  function ContactUs(props) {
    var _officeDetails$primar, _officeDetails$addres, _officeDetails$email;

    var title = props.title,
        description = props.description,
        onContactFormSubmit = props.onContactFormSubmit,
        officeDetails = props.officeDetails,
        socialLinks = props.socialLinks,
        contacts = props.contacts;

    var _React$useState = React__default["default"].useState({
      firstName: "",
      lastName: "",
      email: "",
      message: "",
      select: ""
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        contactData = _React$useState2[0],
        setcontactData = _React$useState2[1];

    var handleChange = function handleChange(prop) {
      return function (event) {
        setcontactData(_objectSpread2(_objectSpread2({}, contactData), {}, _defineProperty({}, prop, event.target.value)));
      };
    };

    var handleSelectChange = function handleSelectChange(event, newValue) {
      setcontactData(_objectSpread2(_objectSpread2({}, contactData), {}, {
        select: newValue.title
      }));
    };

    var onSubmit = function onSubmit(e) {
      e.preventDefault();
      var firstName = contactData.firstName,
          lastName = contactData.lastName,
          email = contactData.email,
          message = contactData.message,
          select = contactData.select;

      if (firstName && lastName && email && message && select) {
        onContactFormSubmit(_objectSpread2({}, contactData));
        setcontactData({
          firstName: "",
          lastName: "",
          email: "",
          message: "",
          select: ""
        });
      }
    };

    var validateEmail = function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    };

    var firstName = contactData.firstName,
        lastName = contactData.lastName,
        email = contactData.email,
        message = contactData.message,
        select = contactData.select;
    firstName && lastName && validateEmail(email) && message && select ? false : true;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ContactUsContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "contactForm"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ContactUsTitle"
    }, title), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ContactUsDecription"
    }, description), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "contactFormContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      value: firstName,
      onChange: handleChange("firstName"),
      labelfloat: "First name",
      labelStatus: false,
      HelpertextStatus: true,
      placeholder: "First name",
      Errormessage: "Error message",
      errortextStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      value: lastName,
      onChange: handleChange("lastName"),
      labelfloat: "Last name",
      labelStatus: false,
      HelpertextStatus: true,
      placeholder: "Last name",
      Errormessage: "Error message",
      errortextStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      value: email,
      onChange: handleChange("email"),
      labelfloat: "Email",
      labelStatus: false,
      HelpertextStatus: true,
      placeholder: "Email",
      Errormessage: "Error message",
      errortextStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(SelectField, {
      value: select,
      onChange: handleSelectChange,
      selectOptions: props.selectOptions,
      label: "Inquiry type" //helperText="Helper text"
      ,
      Errormessage: "Error message",
      helpertext: true,
      errortext: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(MultilineText, {
      value: message,
      onChange: handleChange("message") //helperText="Helper text"
      ,
      placeholder: "Placeholder",
      Errormessage: "Error message",
      count: 300,
      helpertext: false,
      errortext: false,
      tooltip: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.ButtonLabel,
      onClick: onSubmit,
      link: "https://www.google.com/" //target="blank"
      ,
      path: "/",
      arrow: false,
      arrowColor: "#fff",
      addIcon: false,
      AddIconColor: "#0053A5",
      buttoncolor: props.ButtonColor,
      width: "100%",
      height: "50px" //border="#ccc 0px solid"
      ,
      borderRadius: "4px",
      color: "#fff",
      fontWeight: "600",
      textAlign: "center"
    }))))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "contactinfoContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "contactinfoTitle"
    }, "MAIN office"), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ContactIfoListContainer"
    }, /*#__PURE__*/React__default["default"].createElement("li", {
      className: "ContactIfoList"
    }, /*#__PURE__*/React__default["default"].createElement("span", null, "Phone:"), " ", (_officeDetails$primar = officeDetails.primaryPhone) !== null && _officeDetails$primar !== void 0 ? _officeDetails$primar : "", officeDetails.secondaryPhone ? ", " + officeDetails.secondaryPhone : ""), /*#__PURE__*/React__default["default"].createElement("li", {
      className: "ContactIfoList"
    }, /*#__PURE__*/React__default["default"].createElement("span", null, "Address:"), " ", (_officeDetails$addres = officeDetails.address) !== null && _officeDetails$addres !== void 0 ? _officeDetails$addres : ""), /*#__PURE__*/React__default["default"].createElement("li", {
      className: "ContactIfoList"
    }, /*#__PURE__*/React__default["default"].createElement("span", null, "Email:"), " ", (_officeDetails$email = officeDetails.email) !== null && _officeDetails$email !== void 0 ? _officeDetails$email : "")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "masterLiSocialLinks"
    }, (socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.facebook) && /*#__PURE__*/React__default["default"].createElement("a", {
      href: socialLinks.facebook,
      target: "blank"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.FacebookIcon,
      alt: "FACEBOOK"
    })), (socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.youtube) && /*#__PURE__*/React__default["default"].createElement("a", {
      href: socialLinks.youtube,
      target: "blank"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.YouTubeIcon,
      alt: "YOUTUBE"
    })), (socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.twitter) && /*#__PURE__*/React__default["default"].createElement("a", {
      href: socialLinks.twitter,
      target: "blank"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.TwitterIcon,
      alt: "YOUTUBE"
    })), (socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.whatsapp) && /*#__PURE__*/React__default["default"].createElement("a", {
      href: socialLinks.whatsapp,
      target: "blank"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.WhatsAppIcon,
      alt: "YOUTUBE"
    }))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ContactIfoAddressContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 3
    }, contacts !== null && contacts !== void 0 && contacts.length ? contacts.map(function (el, i) {
      var _el$address, _el$name, _el$phone;

      return /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        key: i,
        item: true,
        md: 6,
        xs: 12
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "ContactIfoAddressCard"
      }, /*#__PURE__*/React__default["default"].createElement("h5", {
        className: "ContactIfoAddressCol"
      }, (_el$address = el.address) !== null && _el$address !== void 0 ? _el$address : ""), /*#__PURE__*/React__default["default"].createElement("p", {
        className: "ContactIfoNameCol"
      }, (_el$name = el.name) !== null && _el$name !== void 0 ? _el$name : ""), /*#__PURE__*/React__default["default"].createElement("p", {
        className: "ContactIfoNumberCol"
      }, (_el$phone = el.phone) !== null && _el$phone !== void 0 ? _el$phone : "")));
    }) : null)), props.WhatsAppIconButtonStatus && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "whatsappIcon"
    }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      href: props.whatsAppIconButtonLink
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.WhatsAppIconButton,
      alt: "WHATSAPP"
    })))));
  }

  var css_248z$14 = "@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");.TestimonialsContainer{background:#eef6f1;padding:30px}.M_TestimonialContainer{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex}.M_TestimonialArrowButton{position:absolute;top:207px;right:50px}.M_TestimonialArrowButton .TsArrow{background:#56b149;width:40px;height:28px;border:1px solid #56b149;border-radius:4px}.M_TestimonialArrowButton .TsArrow span svg{color:#fff!important}.M_TestimonialArrowButton .leftArrow{position:relative}.M_TestimonialArrowButton .RightArrow{position:absolute;left:50px}.M_TestimonialTitle{font-size:48px;color:#0b132b;font-weight:600;line-height:56px;font-family:Poppins,sans-serif}.M_TestimonialDescription{font-size:24px;color:#0b132b;line-height:38px}.M_TestimonialAurtherText,.M_TestimonialDescription{font-weight:400;font-family:Poppins,sans-serif;margin-top:20px}.M_TestimonialAurtherText{font-size:16px;color:#676c7b;line-height:24px;max-width:450px}.M_AurtherThumbnail{width:50px!important;height:50px!important}.M_TestimonialThumbnailContainer{width:100%;border-top:1px solid #c8e0c4;padding-top:7px}.M_TestimonialVideoImg{height:350px;width:350px!important}.M_TestimonialRightCol{margin-left:3%;width:70%;position:relative}.M_TestimonialVideoImg img{height:350px;width:350px!important}.videoPlayIcon{background:#56b149!important;opacity:.9!important;width:30px!important;height:30px!important;border-radius:100px!important}.videoPlayIcon svg{color:#fff!important}.M_TestimonialDetails{height:235px}.M_TestimonialDescription{max-height:160px;overflow-y:auto}@media(max-width:1400px){.M_TestimonialArrowButton{display:none}}@media(max-width:768px){.M_TestimonialContainer{display:block;height:auto}.M_TestimonialVideoImg{height:350px;width:100%!important}.M_TestimonialRightCol{margin-left:0;width:100%;position:static}.M_TestimonialThumbnailContainer{width:100%;position:relative;bottom:0;margin-top:20px}.M_TestimonialTitle{font-size:36px;color:#0b132b;font-weight:600;line-height:45px;font-family:Poppins,sans-serif;margin-top:21px}}.MuiAvatar-root{border:3px solid #eef6f1!important;padding:0!important;width:40px!important;height:40px!important}.T_active .MuiAvatar-root{border:3px solid #56b149!important;padding:0!important;width:45px!important;height:45px!important}";
  styleInject(css_248z$14);

  function Testimonials(props) {
    var users = props.users;

    var _useState = React.useState(1),
        _useState2 = _slicedToArray(_useState, 2),
        index = _useState2[0],
        setIndex = _useState2[1];

    React.useEffect(function () {
      var interval = setInterval(function () {
        setIndex(index === props.index ? 1 : index + 1);
      }, props.duration);
      return function () {
        return clearInterval(interval);
      };
    }, [index]);
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TestimonialsContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "M_TestimonialContainer"
    }, /*#__PURE__*/React__default["default"].createElement(core.Paper, {
      className: "M_TestimonialVideoImg",
      variant: "outlined",
      square: true,
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        backgroundImage: "url(".concat(users[index - 1].video, ")"),
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover"
      }
    }, props.PlayIcon && /*#__PURE__*/React__default["default"].createElement(core.IconButton, {
      className: "videoPlayIcon",
      component: "span"
    }, /*#__PURE__*/React__default["default"].createElement(PlayArrowIcon__default["default"], null))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "M_TestimonialRightCol"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "M_TestimonialDetails"
    }, props.title && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "M_TestimonialTitle"
    }, users[index - 1].title), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "M_TestimonialDescription"
    }, "\"", users[index - 1].description, "\""), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "M_TestimonialAurtherText"
    }, users[index - 1].name, /*#__PURE__*/React__default["default"].createElement("br", null), users[index - 1].address)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "M_TestimonialThumbnailContainer"
    }, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      lg: 12,
      md: 12,
      sm: 12,
      xs: 12,
      container: true,
      spacing: 1
    }, users.map(function (data) {
      return /*#__PURE__*/React__default["default"].createElement(core.Grid, {
        item: true
      }, /*#__PURE__*/React__default["default"].createElement(core.IconButton, {
        size: "small",
        component: "span",
        onClick: function onClick() {
          return setIndex(data.id);
        },
        className: data.id === index ? "T_active" : ""
      }, /*#__PURE__*/React__default["default"].createElement(core.Avatar, {
        alt: data.name,
        src: data.img,
        className: "AurtherThumbnail"
      })));
    }))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "M_TestimonialArrowButton"
    }, /*#__PURE__*/React__default["default"].createElement(core.IconButton, {
      className: "leftArrow TsArrow",
      size: "small",
      component: "span",
      onClick: function onClick() {
        setIndex(index === 1 ? props.index : index - 1);
      }
    }, /*#__PURE__*/React__default["default"].createElement(ArrowBackIosRoundedIcon__default["default"], {
      fontSize: "inherit"
    })), /*#__PURE__*/React__default["default"].createElement(core.IconButton, {
      className: "RightArrow TsArrow",
      size: "small",
      component: "span",
      onClick: function onClick() {
        setIndex(index === props.index ? 1 : index + 1);
      }
    }, /*#__PURE__*/React__default["default"].createElement(ArrowForwardIosRoundedIcon__default["default"], {
      fontSize: "inherit"
    }))))));
  }

  var css_248z$13 = ".LinkCardMainContainer{background-color:#56b149;padding:20px;border-radius:4px;margin-bottom:8px;cursor:pointer;position:relative;display:block}.LinkCardMainContainer:hover{text-decoration:none!important}.LinkCardMainContainer .LinkCararrow{position:absolute;right:20px;top:20px;color:#fff;webkit-transform:rotate(45deg);-webkit-transform:rotate(45deg);transform:rotate(45deg)}.LinkCardMainContainer .LinkCarTitle{color:#fff;font-size:20px;font-weight:700;margin:0;max-width:160px;line-height:24px;font-family:Poppins}.LinkCardMainContainer .LinkCarTitle:hover{text-decoration:none!important}.LinkCardMainContainer .SingleImg{width:76px;height:76px}.LinkCardMainContainer .LinkCarTitleContainer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.LinkCardMainContainer .AvatarGroup{margin-top:15px}";
  styleInject(css_248z$13);

  function LinkCard(props) {
    var cardData = props.cardData;
    return /*#__PURE__*/React__default["default"].createElement("div", null, cardData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        className: "LinkCardMainContainer",
        to: props.path,
        href: props.link
      }, props.Arrow && /*#__PURE__*/React__default["default"].createElement(CallMadeRoundedIcon__default["default"], {
        className: "LinkCararrow"
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "LinkCarTitleContainer"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "LinkCarTitle"
      }, item.title), props.singleImg && /*#__PURE__*/React__default["default"].createElement(Avatar__default["default"], {
        className: "SingleImg",
        alt: "Remy Sharp",
        src: item.singleImg
      })), props.AvatarGroup && /*#__PURE__*/React__default["default"].createElement(AvatarGroup__default["default"], {
        max: 5,
        className: "AvatarGroup"
      }, /*#__PURE__*/React__default["default"].createElement(Avatar__default["default"], {
        alt: "Remy Sharp",
        src: item.GroupImg
      }), /*#__PURE__*/React__default["default"].createElement(Avatar__default["default"], {
        alt: "Remy Sharp",
        src: item.GroupImg2
      }), /*#__PURE__*/React__default["default"].createElement(Avatar__default["default"], {
        alt: "Remy Sharp",
        src: item.GroupImg3
      }), /*#__PURE__*/React__default["default"].createElement(Avatar__default["default"], {
        alt: "Remy Sharp",
        src: item.GroupImg4
      }), /*#__PURE__*/React__default["default"].createElement(Avatar__default["default"], {
        alt: "Remy Sharp",
        src: item.GroupImg5
      })));
    }));
  }

  var css_248z$12 = ".NoAvailableCardMainContainer{padding:80px 124px}.NoAvailableCardMainContainer .NoAvailableCardTitle{color:#444;font-size:20px;text-align:center;font-weight:700}.NoAvailableCardMainContainer .NoAvailableCardSubTitle{color:#828282;font-size:14px;text-align:center;font-weight:400;letter-spacing:0;border-bottom:1px solid #e4e8ec;padding-bottom:20px;padding-top:10px;max-width:360px;margin:0 auto;line-height:28px}.NoAvailableCardMainContainer .NoAvailableCardDescription{color:#828282;font-size:14px;text-align:center;font-weight:400;letter-spacing:0;padding-top:20px;max-width:530px;margin:0 auto;line-height:28px}.NoAvailableCardMainContainer .NoAvailableCardButtonContainer{text-align:center;margin-top:30px}@media (max-width:500px){.NoAvailableCardMainContainer{padding:30px 24px}}";
  styleInject(css_248z$12);

  function NoAvailableEvents(props) {

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "NoAvailableCardMainContainer",
      style: {
        background: props.background
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "NoAvailableCardTitle"
    }, props.Title), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "NoAvailableCardSubTitle"
    }, props.SubTitle), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "NoAvailableCardDescription"
    }, props.Description), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "NoAvailableCardButtonContainer"
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.buttonLebel,
      link: props.link,
      target: props.target,
      path: props.path,
      arrowIcon: props.arrowIcon,
      arrowStatus: props.arrowStatus,
      arrowColor: props.arrowColor,
      buttoncolor: props.buttoncolor,
      width: props.width,
      height: props.height,
      border: props.border,
      borderRadius: props.borderRadius,
      color: props.colorlabel,
      fontWeight: props.fontWeight,
      textAlign: props.textAlign,
      onClick: props.onClick
    })));
  }

  var css_248z$11 = "@-webkit-keyframes modal-video{0%{opacity:0}to{opacity:1}}@keyframes modal-video{0%{opacity:0}to{opacity:1}}@-webkit-keyframes modal-video-inner{0%{-webkit-transform:translateY(100px);transform:translateY(100px)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes modal-video-inner{0%{-webkit-transform:translateY(100px);transform:translateY(100px)}to{-webkit-transform:translate(0);transform:translate(0)}}.modal-video{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5);z-index:1000000;cursor:pointer;opacity:1;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out;-webkit-animation-duration:.3s;animation-duration:.3s;-webkit-animation-name:modal-video;animation-name:modal-video;-webkit-transition:opacity .3s ease-out;transition:opacity .3s ease-out}.modal-video-effect-exit{opacity:0}.modal-video-effect-exit .modal-video-movie-wrap{-webkit-transform:translateY(100px);transform:translateY(100px)}.modal-video-body{max-width:960px;margin:0 auto;padding:0 10px;-webkit-box-sizing:border-box;box-sizing:border-box}.modal-video-body,.modal-video-inner{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.modal-video-inner{-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media (orientation:landscape){.modal-video-inner{padding:10px 60px;-webkit-box-sizing:border-box;box-sizing:border-box}}.modal-video-movie-wrap{width:100%;height:0;position:relative;padding-bottom:56.25%;background-color:#333;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out;-webkit-animation-duration:.3s;animation-duration:.3s;-webkit-animation-name:modal-video-inner;animation-name:modal-video-inner;-webkit-transform:translate(0);transform:translate(0);-webkit-transition:-webkit-transform .3s ease-out;transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out;transition:transform .3s ease-out,-webkit-transform .3s ease-out}.modal-video-movie-wrap iframe{position:absolute;top:0;left:0;width:100%;height:100%}.modal-video-close-btn{position:absolute;z-index:2;top:-45px;right:0;display:inline-block;width:35px;height:35px;overflow:hidden;border:none;background:transparent}@media (orientation:landscape){.modal-video-close-btn{top:0;right:-45px}}.modal-video-close-btn:before{-webkit-transform:rotate(45deg);transform:rotate(45deg)}.modal-video-close-btn:after{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.modal-video-close-btn:after,.modal-video-close-btn:before{content:\"\";position:absolute;height:2px;width:100%;top:50%;left:0;background:#fff;border-radius:5px;margin-top:-6px}";
  styleInject(css_248z$11);

  function VideoPlayerModal(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(ModalVideo__default["default"], {
      channel: "youtube",
      autoplay: true,
      isOpen: props.isOpen,
      videoId: props.vidoeID,
      onClose: props.onClose
    }));
  }

  var css_248z$10 = "@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap\");.SalatTableContainer .SalatTaleTitle{text-transform:uppercase;font-size:20px;font-weight:500;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:50px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.SlatTableFooter{color:#676c7b;font-size:12px;font-style:italic;padding:0 25px 20px}.SalatTableContainer .MuiPaper-elevation1{-webkit-box-shadow:none;box-shadow:none}.SalatTableContainer .SlatNmaeCtn{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.SalatTableContainer .SlatNmaeCtn img{width:24px;margin-right:8px}";
  styleInject(css_248z$10);

  function SalatTable(props) {
    var tableBodyData = props.tableBodyData;
    var StyledTableRow = styles$1.withStyles(function (theme) {
      return {
        root: {
          '&:nth-of-type(odd)': {
            backgroundColor: props.odd
          },
          '&:nth-of-type(even)': {
            backgroundColor: props.even
          },
          '& .MuiTableCell-root': {
            borderBottom: props.colBorder,
            padding: props.ColPadding
          }
        }
      };
    })(TableRow__default["default"]);
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SalatTableContainer",
      style: {
        border: props.tbaleBorder,
        background: props.TableBackground
      }
    }, props.tabletitleStatus && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SalatTaleTitle",
      style: {
        color: props.TitleColor,
        background: props.TitleBackground
      }
    }, props.TableTitle), /*#__PURE__*/React__default["default"].createElement(TableContainer__default["default"], null, /*#__PURE__*/React__default["default"].createElement(Table__default["default"], null, /*#__PURE__*/React__default["default"].createElement(TableBody__default["default"], null, tableBodyData !== null && tableBodyData !== void 0 && tableBodyData.length ? tableBodyData.map(function (el, i) {
      return /*#__PURE__*/React__default["default"].createElement(StyledTableRow, {
        key: i
      }, /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
        align: "left",
        style: {
          color: props.col1Color,
          fontWeight: props.col1fontWeight,
          fontSize: props.ColfontSizet
        }
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "SlatNmaeCtn"
      }, el.icon, el.col1)), /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
        align: "right",
        style: {
          color: props.col2Color,
          fontWeight: props.col2fontWeight,
          fontSize: props.ColfontSizet
        }
      }, el.col2));
    }) : null))), props.footerTextStatus && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SlatTableFooter",
      style: {
        marginTop: props.bottomTextSpace
      }
    }, props.footerText));
  }

  var css_248z$$ = ".CardOneMainContainer .CardOneMainInfoContainer{text-decoration:none!important;cursor:pointer}.CardOneMainContainer .CardOneMainInfoContainer .CardOneInner{border:1px solid #ccc}.CardOneMainContainer .CardOneMainInfoContainer .CardOneavatar{height:172px;overflow:hidden;position:relative}.CardOneMainContainer .CardOneMainInfoContainer .CardOneavatar img{width:100%;-o-object-fit:cover;object-fit:cover;position:absolute;height:100%}.CardOneMainContainer .CardOneMainInfoContainer .CardOnehover_over{-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out}.CardOneMainContainer .CardOneMainInfoContainer .CardOneboxed-grey:hover .CardOnehover_over{position:absolute;top:0;left:0;width:100%;height:100%;opacity:.73}.CardOneMainContainer .CardOneMainInfoContainer .CardOneDetails{background:#fff none repeat scroll 0 0}.CardOneMainContainer .CardOneMainInfoContainer .CardOneDesBox{padding:15px}.CardOneMainContainer .CardOneMainInfoContainer .CardOneDetails h2{color:#0b132b;font-size:14px;text-transform:uppercase;background:#f3f8fc;padding:12px 15px;margin:0!important}.CardOneMainContainer .CardOneMainInfoContainer .CardOneparagraph{color:#676c7b;font-size:13px;padding-left:0;padding-right:0;padding-top:5px;text-align:left;text-transform:inherit!important;line-height:20px;letter-spacing:0;margin:0;font-weight:400}.CardOneMainContainer .CardOneMainInfoContainer .CardOnereadmore{color:#333;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:14px;margin-right:19px;padding-bottom:8px;text-align:left;width:120px;font-weight:500;text-decoration:none;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:18px}.CardOneMainContainer .CardOneMainInfoContainer .CardOnereadmore svg{font-size:15px!important;margin-left:4px}.CardOneMainContainer .CardOneMainInfoContainer .CardOneboxed-grey:hover{-webkit-box-shadow:-1px 9px 23px -7px rgba(0,0,0,.45);box-shadow:-1px 9px 23px -7px rgba(0,0,0,.45);-webkit-transition:all 1s ease 0s;transition:all 1s ease 0s}";
  styleInject(css_248z$$);

  function CardOne(props) {
    var cardOneData = props.cardOneData;
    return /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: props.spacing
    }, cardOneData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        item: true,
        md: props.col,
        xs: 12
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardOneMainContainer"
      }, /*#__PURE__*/React__default["default"].createElement("a", {
        href: item.link,
        className: "CardOneMainInfoContainer"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardOneboxed-grey"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardOneInner"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardOneavatar"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        src: item.img,
        alt: ""
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardOnehover_over",
        style: {
          background: props.hoverbackground
        }
      })), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardOneDetails"
      }, /*#__PURE__*/React__default["default"].createElement("h2", null, item.title), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardOneDesBox"
      }, /*#__PURE__*/React__default["default"].createElement("p", {
        className: "CardOneparagraph"
      }, item.Discription), /*#__PURE__*/React__default["default"].createElement("span", {
        className: "CardOnereadmore"
      }, props.buttonLabel, " ", /*#__PURE__*/React__default["default"].createElement(ArrowForwardIosRoundedIcon__default["default"], null), " "))))))));
    }));
  }

  var css_248z$_ = ".CardTwoMainContainer .CardTwoMainInfoContainer{text-decoration:none!important;cursor:pointer}.CardTwoMainContainer .CardTwoMainInfoContainer .CardTwoInner{border:1px solid #ccc}.CardTwoMainContainer .CardTwoMainInfoContainer .CardTwoavatar{height:172px;overflow:hidden;position:relative}.CardTwoMainContainer .CardTwoMainInfoContainer .CardTwoavatar img{width:100%;-o-object-fit:cover;object-fit:cover;position:absolute;height:100%}.CardTwoMainContainer .CardTwoMainInfoContainer .CardTwohover_over{-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out}.CardTwoMainContainer .CardTwoMainInfoContainer .CardTwoboxed-grey:hover .CardTwohover_over{position:absolute;top:0;left:0;width:100%;height:100%;opacity:.73}.CardTwoMainContainer .CardTwoMainInfoContainer .CardTwoDetails{background:#fff none repeat scroll 0 0;padding:16px}.CardTwoMainContainer .CardTwoMainInfoContainer .CardTwoDetails h2{font-size:14px;margin:0!important;padding-top:8px;padding-bottom:8px}.CardTwoMainContainer .CardTwoMainInfoContainer .CardTwoparagraph{color:#676c7b;font-size:13px;text-align:left;text-transform:inherit!important;line-height:20px;letter-spacing:0;margin:0;font-weight:400}.CardTwoMainContainer .CardTwoMainInfoContainer .CardTworeadmore{color:#333;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:14px;margin-right:19px;padding-bottom:8px;text-align:left;width:120px;font-weight:500;text-decoration:none;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:18px}.CardTwoMainContainer .CardTwoMainInfoContainer .CardTworeadmore svg{font-size:15px!important;margin-left:4px}.CardTwoMainContainer .CardTwoMainInfoContainer .CardTwoboxed-grey:hover{-webkit-box-shadow:-1px 9px 23px -7px rgba(0,0,0,.45);box-shadow:-1px 9px 23px -7px rgba(0,0,0,.45);-webkit-transition:all 1s ease 0s;transition:all 1s ease 0s}.CardTwoMainContainer .CardTwoDetails .name_box{font-size:10px;text-align:left;text-transform:uppercase;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;font-weight:400;color:#a4a7b0}.CardTwoMainContainer .CardTwoDetails .name_box,.CardTwoMainContainer .CardTwoDetails .name_box span{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.CardTwoMainContainer .CardTwoDetails .name_box span{margin-right:8px}.CardTwoMainContainer .CardTwoDetails .name_box span svg{font-size:15px;margin-right:5px}";
  styleInject(css_248z$_);

  function CardTwo(props) {
    var cardTwoData = props.cardTwoData;
    return /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: props.spacing
    }, cardTwoData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        item: true,
        md: props.col,
        xs: 12
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardTwoMainContainer"
      }, /*#__PURE__*/React__default["default"].createElement("a", {
        href: item.link,
        className: "CardTwoMainInfoContainer"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardTwoboxed-grey"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardTwoInner"
      }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        container: true,
        spacing: props.spacing
      }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        item: true,
        md: props.Imgcol,
        xs: 12
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardTwoavatar"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        src: item.img,
        alt: ""
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardTwohover_over",
        style: {
          background: props.hoverbackground
        }
      }))), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        item: true,
        md: props.Contentcol,
        xs: 12
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardTwoDetails"
      }, props.nameDateStatus && /*#__PURE__*/React__default["default"].createElement("div", {
        className: "name_box"
      }, /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement(PersonRoundedIcon__default["default"], null), " ", item.name), /*#__PURE__*/React__default["default"].createElement("span", null, "|"), " ", /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement(DateRangeRoundedIcon__default["default"], null), " ", item.date)), /*#__PURE__*/React__default["default"].createElement("h2", {
        style: {
          color: props.titleColor
        }
      }, item.title), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardTwoDesBox"
      }, /*#__PURE__*/React__default["default"].createElement("p", {
        className: "CardTwoparagraph"
      }, item.Discription), /*#__PURE__*/React__default["default"].createElement("span", {
        className: "CardTworeadmore"
      }, props.buttonLabel, " ", /*#__PURE__*/React__default["default"].createElement(ArrowForwardIosRoundedIcon__default["default"], null), " "))))))))));
    }));
  }

  var css_248z$Z = ".TitleOneContainer{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding-bottom:27px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.TitleOneContainer .TitleOneTextContainer{color:#1c1c1c;font-size:28px;font-weight:400;text-align:left;text-transform:uppercase;position:relative;margin:0}.TitleOneContainer .TitleOneReadMoreBtn{border-radius:4px!important;color:#333!important;font-size:14px!important;height:50px;letter-spacing:1px!important;text-align:center;text-transform:uppercase!important;font-weight:700!important;padding:0 24px!important}.TitleOneContainer .read_more_btn svg{font-size:15px;margin-left:3px;position:relative;top:-1px}.TitleOneContainer .read_more_btn:hover{background:#0053a5!important;border:1px solid #0052a5!important;color:#fff!important}.TitleOneContainer .TitlOneeLineContainer{height:4px;background:#d2d3d8;max-width:100px;margin-top:13px}.TitleOneContainer .TitlOneeLine{height:4px;width:50px;display:block}@media (max-width:768px){.TitleOneContainer{display:block}.TitleOneContainer .TitleOneTextContainer{margin-bottom:20px}}";
  styleInject(css_248z$Z);

  function TitleOne(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TitleOneContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TitleOneTextContainer"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      style: {
        color: props.TitleLightColor,
        fontWeight: 400
      }
    }, props.TitleLight), " ", /*#__PURE__*/React__default["default"].createElement("span", {
      style: {
        color: props.TitleBoldColor,
        fontWeight: 700
      }
    }, props.TitleBold), " ", /*#__PURE__*/React__default["default"].createElement("span", {
      style: {
        color: props.TitleLightColor,
        fontWeight: 400
      }
    }, props.TitleLightEnd), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TitlOneeLineContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TitlOneeLine",
      style: {
        background: props.lineColor
      }
    }))), props.Button && /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.buttonLebel,
      onClick: props.onClick,
      link: props.Link,
      target: props.target,
      arrowIcon: props.arrowIcon,
      arrowColor: props.arrowColor,
      arrowStatus: props.arrowStatus,
      buttoncolor: props.buttoncolor,
      width: props.width,
      height: props.height,
      border: props.border,
      borderRadius: props.borderRadius,
      color: props.colorlabel,
      fontWeight: props.fontWeight,
      textAlign: props.textAlign
    }));
  }

  var css_248z$Y = ".ReserveSectionOneMainContainer{background-size:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;min-height:316px;max-height:316px;padding:30px}.ReserveSectionOneMainContainer .ReserveSectionOnebG{position:absolute;left:0;top:0;width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.ReserveSectionOneMainContainer .ReserveSectionOneInnerContainer{text-align:center;max-width:828px;margin:0 auto;position:relative;z-index:2}.ReserveSectionOneMainContainer .ReserveSectionOneInnerContainer .ReserveSectionOneTitle{color:#fff;font-family:Roboto,sans-serif;font-size:34px;font-weight:700;margin:0}.ReserveSectionOneMainContainer .ReserveSectionOneInnerContainer .ReserveSectionOneDescription{color:#fff;font-family:Roboto,sans-serif;font-size:16px;font-weight:400;max-width:800px;line-height:24px;margin:24px auto 0}.ReserveSectionOneMainContainer .ReserveSectionOneInnerContainer .ReserveSectionOneReference{color:#fff;font-family:Roboto,sans-serif;font-size:11px;font-weight:300;display:block}.ReserveSectionOneMainContainer .ReserveSectionOneInnerContainer .DownloadButtonContainer{margin-top:24px}";
  styleInject(css_248z$Y);

  function ReserveSectionOne(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ReserveSectionOneMainContainer"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.background,
      className: "ReserveSectionOnebG"
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "ReserveSectionOneInnerContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ReserveSectionOneTitle",
      style: {
        color: props.Textcolor
      }
    }, props.title), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ReserveSectionOneDescription",
      style: {
        color: props.Textcolor
      }
    }, props.description), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ReserveSectionOneReference",
      style: {
        color: props.Textcolor
      }
    }, props.reference), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "DownloadButtonContainer"
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.buttonLebel,
      link: props.buttonLink,
      target: props.target,
      arrow: props.arrow,
      arrowColor: props.arrowColor,
      buttoncolor: props.buttoncolor,
      width: props.width,
      height: props.height,
      border: props.border,
      borderRadius: props.borderRadius,
      color: props.colorlabel,
      fontWeight: props.fontWeight,
      textAlign: props.textAlign
    }))));
  }

  var css_248z$X = ".SectionMainContainer{padding:40px 20px}.SectionMainContainer .SectionInnerContainer{max-width:1175px;margin:0 auto}";
  styleInject(css_248z$X);

  function Section(props) {
    props.cardTwoData;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SectionMainContainer",
      style: {
        background: props.background,
        paddingTop: props.Spacing,
        paddingBottom: props.Spacing
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SectionInnerContainer",
      style: {
        maxWidth: props.ContainerWidth
      }
    }, props.Container));
  }

  var css_248z$W = ".VidoeListingCardOneMainContainer a{text-decoration:none}.VidoeListingCardOneMainContainer .VideoColOne{border:1px solid #e4e8ec;position:relative;background:#fff;display:-webkit-box;display:-ms-flexbox;display:flex}.VidoeListingCardOneMainContainer .VideoColOne .videoImgOne{max-width:175px;min-width:175px;max-height:175px;position:relative}.VidoeListingCardOneMainContainer .VideoColOne .videoImgOne .vidoeoneimg{-o-object-fit:cover;object-fit:cover;width:100%;height:100%}.VidoeListingCardOneMainContainer .VideoColOne .videoImgOne .vidoeoneicon{width:56px;height:56px;position:absolute;top:30px;left:60px;z-index:1}.VidoeListingCardOneMainContainer .VideoColOne .videoImgOne .vidoeoneOverlay{background:#000;position:absolute;opacity:.4;left:0;top:0;width:100%;height:100%}.VidoeListingCardOneMainContainer .VideoColOne .videoDetailsOne{padding:16px}.VidoeListingCardOneMainContainer .VideoColOne .videoDetailsOne .videoDetailsOneTitle{font-size:20px;font-weight:700;line-height:24px;color:#0053a5;margin:0 0 4px}.VidoeListingCardOneMainContainer .VideoColOne .videoDetailsOne .videoLocationOne{margin:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.VidoeListingCardOneMainContainer .VideoColOne .videoDetailsOne .videoLocationOne .videoLocationOneText{font-size:10px!important;font-weight:400;line-height:16px;color:#a4a7b0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-transform:uppercase;margin:0 10px 0 0}.VidoeListingCardOneMainContainer .VideoColOne .videoDetailsOne .videoLocationOne .videoLocationOneText svg{margin-right:4px;font-size:16px;color:#a4a7b0}.nomargin{margin-top:0!important}";
  styleInject(css_248z$W);

  function VidoeListingCardOne(props) {
    var videoListingOneData = props.videoListingOneData;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "VidoeListingCardOneMainContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: props.spacing
    }, videoListingOneData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        item: true,
        md: props.col,
        xs: 12
      }, /*#__PURE__*/React__default["default"].createElement("a", {
        href: item.link,
        to: item.path,
        onClick: item.onclick
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "VideoColOne"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoImgOne"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        className: "vidoeoneimg",
        src: item.img,
        alt: ""
      }), /*#__PURE__*/React__default["default"].createElement("img", {
        className: "vidoeoneicon",
        src: props.playicon,
        alt: ""
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "vidoeoneOverlay"
      })), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoDetailsOne"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoDetailsOneTitle"
      }, item.title), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoLocationOne"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoLocationOneText"
      }, /*#__PURE__*/React__default["default"].createElement(DateRangeIcon__default["default"], null), " ", item.date), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoLocationOneText"
      }, " ", /*#__PURE__*/React__default["default"].createElement(RemoveRedEyeOutlinedIcon__default["default"], null), " ", item.views))))));
    })));
  }

  var css_248z$V = "";
  styleInject(css_248z$V);

  function SliderOne(props) {
    props.sliderOneData;
    return /*#__PURE__*/React__default["default"].createElement("div", null);
  }

  var css_248z$U = ".BlogOneMainContainer .BlogOneinfoContainer h1{font-size:34px;line-height:40px;font-weight:700;margin:0 0 21px;font-family:Roboto,sans-serif}.BlogOneMainContainer .BlogOneinfoContainer h2{font-size:34px;line-height:40px;font-weight:300;margin:0;font-family:Roboto,sans-serif}.BlogOneMainContainer .BlogOneinfoContainer p{font-size:16px;line-height:24px;font-weight:400;font-family:Roboto,sans-serif;margin:0 0 25px}";
  styleInject(css_248z$U);

  function BlogOne(props) {
    var blogOneData = props.blogOneData;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "BlogOneMainContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: props.Spacing
    }, blogOneData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        item: true,
        md: props.col,
        xs: 12
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "BlogOneinfoContainer"
      }, /*#__PURE__*/React__default["default"].createElement("h2", {
        style: {
          color: props.color,
          fontSize: props.titleLightFontSise
        }
      }, item.titleLight), /*#__PURE__*/React__default["default"].createElement("h1", {
        style: {
          color: props.color,
          fontSize: props.titleBoldFontSise
        }
      }, item.titleBold), /*#__PURE__*/React__default["default"].createElement("div", {
        style: {
          color: props.color
        }
      }, item.description), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "BlogOneButtonContainer"
      }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
        label: props.buttonLebel,
        link: props.link,
        target: props.target,
        path: props.path,
        arrow: props.arrow,
        arrowColor: props.arrowColor,
        buttoncolor: props.buttoncolor,
        width: props.width,
        height: props.height,
        border: props.border,
        borderRadius: props.borderRadius,
        color: props.colorlabel,
        fontWeight: props.fontWeight,
        textAlign: props.textAlign
      }))));
    })));
  }

  var css_248z$T = ".ServicesTabOneManContainer{position:relative;overflow:hidden}.ServicesTabOneManContainer .ServicesTabOnebackground{position:absolute;width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.ServicesTabOneManContainer .ServicesTabOneStepsContainer{position:relative;z-index:10;display:-webkit-box;display:-ms-flexbox;display:flex}.ServicesTabOneManContainer .ServicesTabOneTabContainer{position:relative;width:384px;-webkit-box-flex:1;-ms-flex:1;flex:1;max-width:384px}.ServicesTabOneManContainer .ServicesTabOneTabContainer .MuiButtonBase-root{display:block;width:100%;max-width:none;padding-left:60px;overflow:visible}.ServicesTabOneManContainer .ServicesTabOneTabContainer .MuiButtonBase-root .MuiTab-wrapper{height:23px;border-radius:4px;position:relative;right:-12px;color:#fff;display:block;text-align:left;padding:10px 20px;width:272px;font-size:14px;text-transform:uppercase;font-weight:500}.ServicesTabOneManContainer .ServicesTabOneTabContainer .MuiButtonBase-root .MuiTab-wrapper .MuiSvgIcon-root{position:absolute;left:-31px;top:13px;border:1px solid #fff;border-radius:100px;width:15px;height:15px;z-index:1}.ServicesTabOneManContainer .Mui-selected .MuiTab-wrapper .MuiSvgIcon-root{color:#fff!important;border:1px solid #fff!important;background:#fff!important}.ServicesTabOneManContainer .ServicesTabOneTabContainer .Mui-selected .MuiTab-wrapper{background:#fff}.ServicesTabOneManContainer .ServicesTabOneTabContainer .Mui-selected .MuiTab-wrapper:after{content:\"\";position:absolute;background-color:#fff;width:20px;height:20px!important;border-radius:2px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);margin-top:1px;right:-5px}.ServicesTabOneTabContainer .MuiButtonBase-root .MuiTouchRipple-root{position:absolute;background-color:#fff;width:1px;height:100%!important;left:49px;top:0}.ServicesTabOnePanelContainer{padding:50px;-webkit-box-flex:1;-ms-flex:1;flex:1}.ServicesTabOnePanelContainer .ServicesTabOnePanelInnerContainer{background:#fff;padding:33px;max-height:310px;overflow-y:auto;border-radius:4px}.ServicesTabOnePanelInnerContainer h1{margin:0;color:#0b132b;font-size:24px;font-weight:700;text-transform:uppercase}.ServicesTabOnePanelInnerContainer p{color:#676c7b;font-size:14px;font-weight:400}.ServicesTabOneManContainer .MuiTabs-indicator{display:none!important}.ServicesTabOneManContainer .MuiTabs-root{overflow:visible;padding-top:50px;padding-bottom:50px}.ServicesTabOneManContainer .MuiTabs-scrollable{overflow-x:visible;overflow-x:initial;scrollbar-width:none}.ServicesTabOneManContainer .MuiTab-labelIcon{min-height:0;padding-top:0}";
  styleInject(css_248z$T);

  var _excluded$2 = ["children", "value", "index"];

  function TabPanel$2(props) {
    var children = props.children,
        value = props.value,
        index = props.index,
        other = _objectWithoutProperties(props, _excluded$2);

    return /*#__PURE__*/React__default["default"].createElement("div", _extends({
      role: "tabpanel",
      hidden: value !== index,
      id: "vertical-tabpanel-".concat(index),
      "aria-labelledby": "vertical-tab-".concat(index)
    }, other), value === index && /*#__PURE__*/React__default["default"].createElement("div", {
      p: 3
    }, /*#__PURE__*/React__default["default"].createElement(core.Typography, null, children)));
  }

  TabPanel$2.propTypes = {
    children: PropTypes__default["default"].node,
    index: PropTypes__default["default"].any.isRequired,
    value: PropTypes__default["default"].any.isRequired
  };

  function a11yProps$2(index) {
    return {
      id: "vertical-tab-".concat(index),
      'aria-controls': "vertical-tabpanel-".concat(index)
    };
  }

  function ServiceTabOne(props) {
    var _React$useState = React__default["default"].useState(0),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        value = _React$useState2[0],
        setValue = _React$useState2[1];

    var handleChange = function handleChange(event, newValue) {
      setValue(newValue);
    };

    var useStyles = styles$1.makeStyles(function (theme) {
      return {
        root: {
          '& .ServicesTabOneManContainer .ServicesTabOneTabContainer .Mui-selected .MuiTab-wrapper': {
            color: props.tabActivelabelcolor
          }
        }
      };
    });
    var classes = useStyles();
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: classes.root
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ServicesTabOneManContainer"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      className: "ServicesTabOnebackground",
      src: props.backgroundImg
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ServicesTabOneStepsContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ServicesTabOneTabContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        background: props.TabBackground,
        width: "100%",
        height: "100%",
        position: 'absolute',
        opacity: "0.8"
      }
    }), /*#__PURE__*/React__default["default"].createElement(core.Tabs, {
      orientation: "vertical",
      variant: "scrollable",
      value: value,
      onChange: handleChange,
      "aria-label": "Vertical tabs example"
    }, props.tabItems && props.tabItems.length ? props.tabItems.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(core.Tab, _extends({
        key: i,
        label: item.title,
        icon: /*#__PURE__*/React__default["default"].createElement(FiberManualRecordIcon__default["default"], {
          style: {
            color: props.DotColor,
            background: props.DotColor
          }
        })
      }, a11yProps$2(i)));
    }) : null)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ServicesTabOnePanelContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ServicesTabOnePanelInnerContainer"
    }, props.tabItems && props.tabItems.length ? props.tabItems.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(TabPanel$2, {
        key: i,
        value: value,
        index: i,
        className: "tabpanel"
      }, /*#__PURE__*/React__default["default"].createElement("h1", null, item.TabPanelTitle), item.TabPanelPara);
    }) : null)))));
  }

  ServiceTabOne.propTypes = {
    tabItems: PropTypes__default["default"].array
  };

  var css_248z$S = ".MuiOutlinedInput-root{position:relative;border-radius:4px;background:#fff}.ContactUsThree .contactForm .ContactUsTitle{font-size:40px;font-weight:600;color:#0b132b;line-height:46px;letter-spacing:0;text-transform:uppercase;margin-bottom:20px}.ContactUsThree .contactForm .ContactUsDecription{font-size:14px;font-weight:400;color:#676c7b;line-height:24px;letter-spacing:0}.ContactUsThree .whatsappIcon img{width:68px}.ContactUsThree .contactFormContainer .MuiGrid-root{margin-bottom:10px!important}";
  styleInject(css_248z$S);

  function ContactUsThree(props) {
    var title = props.title,
        description = props.description,
        onContactFormSubmit = props.onContactFormSubmit;
        props.selectdata;

    var _React$useState = React__default["default"].useState({
      firstName: "",
      lastName: "",
      email: "",
      message: "",
      select: ""
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        contactData = _React$useState2[0],
        setcontactData = _React$useState2[1];

    var handleChange = function handleChange(prop) {
      return function (event) {
        setcontactData(_objectSpread2(_objectSpread2({}, contactData), {}, _defineProperty({}, prop, event.target.value)));
      };
    };

    var onSubmit = function onSubmit(e) {
      e.preventDefault();
      var firstName = contactData.firstName,
          lastName = contactData.lastName,
          email = contactData.email,
          message = contactData.message,
          select = contactData.select;

      if (firstName && lastName && email && message && select) {
        onContactFormSubmit(_objectSpread2({}, contactData));
        setcontactData({
          firstName: "",
          lastName: "",
          email: "",
          message: "",
          select: ""
        });
      }
    };

    var validateEmail = function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    };

    var firstName = contactData.firstName,
        lastName = contactData.lastName,
        email = contactData.email,
        message = contactData.message,
        select = contactData.select;
    firstName && lastName && validateEmail(email) && message && select ? false : true;

    var _React$useState3 = React__default["default"].useState({
      country: "",
      number: ""
    }),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        phone = _React$useState4[0];
        _React$useState4[1];

    var handleChangeSelect = function handleChangeSelect(event, value) {
      console.log(event.target.value, value);
    };

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ContactUsThree"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "contactForm"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ContactUsTitle"
    }, title), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ContactUsDecription"
    }, description), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "contactFormContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      value: firstName,
      onChange: handleChange("firstName"),
      label: "First name",
      labelStatus: true,
      HelpertextStatus: true,
      placeholder: "First name",
      Errormessage: "Error message",
      errortextStatus: false,
      error: "error"
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      value: lastName,
      onChange: handleChange("lastName"),
      label: "Last name",
      labelStatus: true,
      HelpertextStatus: true,
      placeholder: "Last name",
      Errormessage: "Error message",
      errortextStatus: false,
      error: "error"
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      value: email,
      onChange: handleChange("email"),
      label: "Email",
      labelStatus: true,
      HelpertextStatus: true,
      placeholder: "Email",
      Errormessage: "Error message",
      errortextStatus: false,
      error: "error"
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PhoneInputField, {
      phoneInputVariant: "materialui" // default, materialui, underlineInput, underlineWithFlag
      ,
      country: 'us',
      value: phone.number,
      countryCodeEditable: false,
      onChange: function onChange(phone, country) {
        return console.log("onChange", phone, country);
      },
      onBlur: function onBlur() {
        return console.log("onBlur");
      },
      onKeyDown: function onKeyDown(e) {
        return console.log("onKeyDown", e.target.value);
      },
      variant: "outlined" // onlyCountries={["us", "ca", "gb", "my"]}
      ,
      containerStyle: {},
      buttonStyle: {},
      inputStyle: {
        marginLeft: "0px",
        height: "40px",
        width: "100%",
        fontFamily: "Roboto-Regular",
        fontSize: "16px"
      },
      containerClass: {},
      errorText: "Phone number is required",
      errorStyles: {
        marginBottom: "5px"
      },
      autoFormat: true,
      disableDropdown: false,
      disabled: false,
      disableCountryCode: false,
      enableSearch: false,
      disableSearchIcon: false,
      placeholder: "",
      inputProps: {} //specialLabel={'Primary Phone'}
      // preferredCountries={[]}
      // excludeCountries={[]}
      ,
      labelFixed: "Phone Number (Optional)",
      LabelStatus: true,
      error: props.phoneNumberError
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(SelectFieldOne, {
      label: "Inquiry type",
      selectdata: props.selectdata,
      defaultValue: 1,
      handleChange: handleChangeSelect,
      error: "error"
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(MultilineText, {
      value: message,
      onChange: handleChange("message") //helperText="Helper text"
      ,
      placeholder: "Write your message",
      Errormessage: "Error message",
      count: 300,
      helpertext: false,
      errortext: false,
      tooltip: false,
      error: "error"
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.ButtonLabel,
      onClick: onSubmit,
      arrow: false,
      arrowColor: "#fff",
      addIcon: false,
      AddIconColor: "#0053A5",
      buttoncolor: props.ButtonColor,
      width: "100%",
      height: "50px",
      borderRadius: "4px",
      color: "#fff",
      fontWeight: "600",
      textAlign: "center",
      disabled: props.disableBtn
    }))))));
  }

  function ContactUsOne(props) {
    props.onContactFormSubmit;

    var _React$useState = React__default["default"].useState({
      firstName: "",
      lastName: "",
      email: "",
      message: "",
      select: ""
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        contactData = _React$useState2[0],
        setcontactData = _React$useState2[1];

    var handleChange = function handleChange(prop) {
      return function (event) {
        setcontactData(_objectSpread2(_objectSpread2({}, contactData), {}, _defineProperty({}, prop, event.target.value)));
      };
    };

    var handleSelectChange = function handleSelectChange(event, newValue) {
      setcontactData(_objectSpread2(_objectSpread2({}, contactData), {}, {
        select: newValue.title
      }));
    };

    var validateEmail = function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    };

    var firstName = contactData.firstName,
        lastName = contactData.lastName,
        email = contactData.email,
        message = contactData.message,
        select = contactData.select;
    firstName && lastName && validateEmail(email) && message && select ? false : true;

    var _React$useState3 = React__default["default"].useState({
      country: "",
      number: ""
    }),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        phone = _React$useState4[0];
        _React$useState4[1];

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "contactFormContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Full name",
      labelfloat: "Full name",
      labelStatus: false,
      HelpertextStatus: true,
      placeholder: "Full name",
      Errormessage: "Error message",
      errortextStatus: false,
      onChange: handleChange("firstName")
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PhoneInputField, {
      phoneInputVariant: "materialui" // default, materialui, underlineInput, underlineWithFlag
      ,
      country: 'us',
      value: phone.number,
      countryCodeEditable: false,
      onChange: function onChange(phone, country) {
        return console.log("onChange", phone, country);
      },
      onBlur: function onBlur() {
        return console.log("onBlur");
      },
      onKeyDown: function onKeyDown(e) {
        return console.log("onKeyDown", e.target.value);
      },
      variant: "outlined" // onlyCountries={["us", "ca", "gb", "my"]}
      ,
      containerStyle: {},
      buttonStyle: {},
      inputStyle: {
        marginLeft: "0px",
        height: "40px",
        width: "100%",
        fontFamily: "Roboto-Regular",
        fontSize: "16px"
      },
      containerClass: {},
      errorText: "Phone number is required",
      error: false,
      errorStyles: {
        marginBottom: "5px"
      },
      autoFormat: true,
      disableDropdown: false,
      disabled: false,
      disableCountryCode: false,
      enableSearch: false,
      disableSearchIcon: false,
      placeholder: "",
      inputProps: {},
      specialLabel: 'Phone Number (Optional)'
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Email",
      labelfloat: "Email",
      labelStatus: false,
      placeholder: "Email",
      Errormessage: "Error message",
      errortextStatus: false,
      onChange: handleChange("email")
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(SelectField, {
      value: select,
      onChange: handleSelectChange,
      selectOptions: props.selectOptions,
      label: "Inquiry Type" //helperText="Helper text"
      ,
      Errormessage: "Error message",
      helpertext: true,
      errortext: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(MultilineText, {
      value: message,
      onChange: handleChange("message") //helperText="Helper text"
      ,
      placeholder: "Enter your message here...",
      Errormessage: "Error message",
      count: 300,
      helpertext: false,
      errortext: false,
      tooltip: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.buttonLebel,
      link: props.ButtonLink,
      target: props.target,
      path: props.path,
      arrow: props.arrow,
      arrowColor: props.arrowColor,
      buttoncolor: props.buttoncolor,
      width: props.width,
      height: props.height,
      border: props.border,
      borderRadius: props.borderRadius,
      color: props.colorlabel,
      fontWeight: props.fontWeight,
      textAlign: props.textAlign
    }))));
  }

  function GetDirection(props) {
    props.onContactFormSubmit; // const [contactData, setcontactData] = React.useState({
    //     from: "", 
    // })
    // let handleChange = (prop) => (event) => {
    //     setcontactData({ ...contactData, [prop]: event.target.value });
    // }
    // const handleSelectChange = (event, newValue) => {
    //     setcontactData({ ...contactData, select: newValue.title });
    // }
    // const onSubmit = (e) => {
    //     e.preventDefault();
    //     const { from, to, } = contactData;
    //     if (from && to ) {
    //         onContactFormSubmit({ ...contactData })
    //         setcontactData({
    //             from: "",
    //         })
    //     }
    // }

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "GetFormContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "GetDirectionField"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "GetDirectionIconLabel",
      style: {
        background: props.labelbackgroudColor
      }
    }, "From ", /*#__PURE__*/React__default["default"].createElement(LocationOnRoundedIcon__default["default"], null)), /*#__PURE__*/React__default["default"].createElement(TextInput, {
      placeholder: props.FromPlaceholder
    }))), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "GetDirectionField"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "GetDirectionIconLabel",
      style: {
        background: props.labelbackgroudColor
      }
    }, "To ", /*#__PURE__*/React__default["default"].createElement(LocationOnRoundedIcon__default["default"], null)), /*#__PURE__*/React__default["default"].createElement(TextInput, {
      placeholder: props.ToPlaceholder,
      disabled: "disabled"
    }))), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.buttonLebel,
      link: props.ButtonLink,
      target: props.target,
      path: props.path,
      arrow: props.arrow,
      arrowColor: props.arrowColor,
      buttoncolor: props.buttoncolor,
      width: props.width,
      height: props.height,
      border: props.border,
      borderRadius: props.borderRadius,
      color: props.colorlabel,
      fontWeight: props.fontWeight,
      textAlign: props.textAlign
    }))));
  }

  var css_248z$R = "html{scroll-behavior:smooth}";
  styleInject(css_248z$R);

  var _excluded$1 = ["children", "value", "index"];

  function TabPanel$1(props) {
    var children = props.children,
        value = props.value,
        index = props.index,
        other = _objectWithoutProperties(props, _excluded$1);

    return /*#__PURE__*/React__default["default"].createElement("div", _extends({
      role: "tabpanel",
      hidden: value !== index,
      id: "simple-tabpanel-".concat(index),
      "aria-labelledby": "simple-tab-".concat(index)
    }, other), value === index && /*#__PURE__*/React__default["default"].createElement(Box__default["default"], {
      p: 3
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], null, children)));
  }

  TabPanel$1.propTypes = {
    children: PropTypes__default["default"].node,
    index: PropTypes__default["default"].any.isRequired,
    value: PropTypes__default["default"].any.isRequired
  };

  function a11yProps$1(index) {
    return {
      id: "simple-tab-".concat(index),
      'aria-controls': "simple-tabpanel-".concat(index)
    };
  }

  function TabOne(props) {
    var _React$useState = React__default["default"].useState(0),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        value = _React$useState2[0],
        setValue = _React$useState2[1];

    var handleChange = function handleChange(event, newValue) {
      setValue(newValue);
    };

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TabOneContainer"
    }, /*#__PURE__*/React__default["default"].createElement(AppBar__default["default"], {
      position: "static"
    }, /*#__PURE__*/React__default["default"].createElement(Tabs__default["default"], {
      value: value,
      onChange: handleChange,
      "aria-label": "simple tabs example"
    }, props.tabItems && props.tabItems.length ? props.tabItems.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Tab__default["default"], _extends({
        href: item.link,
        label: item.title,
        key: i
      }, a11yProps$1(i)));
    }) : null)), props.tabBody && /*#__PURE__*/React__default["default"].createElement("div", null, props.tabItems && props.tabItems.length ? props.tabItems.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(TabPanel$1, {
        key: i,
        value: value,
        index: i
      }, " ", item.body, " ");
    }) : null));
  }

  TabOne.propTypes = {
    tabItems: PropTypes__default["default"].array
  };

  var css_248z$Q = ".MuiAccordionSummary-root.Mui-expanded{border-bottom:1px solid #ccc}.AccordionOneMainContainer .AccordionOneIcon{width:18px;height:18px;margin-right:10px}.AccordionOneMainContainer .AccordionOneTitle{display:-webkit-box;display:-ms-flexbox;display:flex}";
  styleInject(css_248z$Q);

  function AccordionOne(props) {
    return /*#__PURE__*/React__default["default"].createElement(Accordion__default["default"], {
      className: "AccordionOneMainContainer",
      expanded: props.expanded === props.panel,
      onChange: props.handleChange(props.panel)
    }, /*#__PURE__*/React__default["default"].createElement(AccordionSummary__default["default"], {
      expandIcon: /*#__PURE__*/React__default["default"].createElement(ExpandMoreIcon__default["default"], null),
      "aria-controls": props.panel,
      id: props.panel
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "AccordionOneTitle",
      style: {
        color: props.titleColor,
        fontSize: props.titleFontSize,
        fontWeight: props.TitleFontWeight
      }
    }, props.iconStatus && /*#__PURE__*/React__default["default"].createElement("img", {
      className: "AccordionOneIcon",
      src: props.icon
    }), " ", props.title)), /*#__PURE__*/React__default["default"].createElement(AccordionDetails__default["default"], null, props.AccordionBody));
  }

  var css_248z$P = ".VidoeListingCardTwoMainContainer a{text-decoration:none;cursor:pointer}.VidoeListingCardTwoMainContainer a:hover{text-decoration:none}.VidoeListingCardTwoMainContainer .VideoColTwo{position:relative;background:#fff;display:-webkit-box;display:-ms-flexbox;display:flex}.VidoeListingCardTwoMainContainer .VideoColTwo .videoImgTwo{max-width:83px;min-width:83px;max-height:100%;position:relative}.VidoeListingCardTwoMainContainer .VideoColTwo .videoImgTwo .vidoeTwoimg{-o-object-fit:cover;object-fit:cover;width:100%;height:100%}.VidoeListingCardTwoMainContainer .VideoColTwo .videoImgTwo .vidoeTwoicon{width:56px;height:56px;position:absolute;top:15px;left:14px;z-index:1}.VidoeListingCardTwoMainContainer .VideoColTwo .videoImgTwo .vidoeTwoOverlay{background:#000;position:absolute;opacity:.4;left:0;top:0;width:100%;height:100%}.VidoeListingCardTwoMainContainer .VideoColTwo .videoDetailsTwo{padding:11px;-webkit-box-flex:1;-ms-flex:1;flex:1}.VidoeListingCardTwoMainContainer .VideoColTwo .videoDetailsTwo .videoDetailsTwoTitle{font-size:16px;font-weight:400;line-height:20px;color:#0b132b;margin:0 0 4px}.VidoeListingCardTwoMainContainer .VideoColTwo .videoDetailsTwo .videoDetailsTwoSubTitle{font-size:12px;font-weight:400;line-height:16px;color:#676c7b;margin:0 0 4px;text-transform:uppercase}.VidoeListingCardTwoMainContainer .VideoColTwo .videoDetailsTwo .videoLocationTwo{margin:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.VidoeListingCardTwoMainContainer .VideoColTwo .videoDetailsTwo .videoLocationTwo .videoLocationTwoText{font-size:10px!important;font-weight:400;line-height:16px;color:#a4a7b0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-transform:uppercase;margin:0 10px 0 0}.VidoeListingCardTwoMainContainer .VideoColTwo .videoDetailsTwo .videoLocationTwo .videoLocationTwoText svg{margin-right:4px;font-size:16px;color:#a4a7b0}.nomargin{margin-top:0!important}.VidoeListingCardTwoBorderLine{background:#e4e8ec;height:1px;width:100%;margin-top:10px}@media (max-width:450px){.VidoeListingCardTwoMainContainer .VideoColTwo .videoImgTwo .vidoeTwoicon{top:25px}}";
  styleInject(css_248z$P);

  function VidoeListingCardTwo(props) {
    var videoListingTwoData = props.videoListingTwoData;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "VidoeListingCardTwoMainContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: props.spacing
    }, videoListingTwoData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        item: true,
        md: props.col,
        xs: 12
      }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        to: item.path,
        onClick: item.onclick
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "VideoColTwo"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoImgTwo",
        style: {
          minWidth: props.Thumnailwidth
        }
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        className: "vidoeTwoimg",
        src: item.img,
        alt: ""
      }), props.playiconStatus && /*#__PURE__*/React__default["default"].createElement("img", {
        className: "vidoeTwoicon",
        src: props.playicon,
        alt: ""
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "vidoeTwoOverlay"
      })), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoDetailsTwo"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoDetailsTwoTitle"
      }, item.title), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoDetailsTwoSubTitle"
      }, item.subtitle), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoLocationTwo"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoLocationTwoText"
      }, /*#__PURE__*/React__default["default"].createElement(DateRangeIcon__default["default"], null), " ", item.date), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoLocationTwoText"
      }, " ", /*#__PURE__*/React__default["default"].createElement(RemoveRedEyeOutlinedIcon__default["default"], null), " ", item.views))))), props.borderLine && /*#__PURE__*/React__default["default"].createElement("div", {
        className: "VidoeListingCardTwoBorderLine"
      }));
    })));
  }

  var css_248z$O = ".SearchOneFieldMainContainer{display:-webkit-box;display:-ms-flexbox;display:flex;position:relative}.SearchOneFieldMainContainer .Mui-focused,.SearchOneFieldMainContainer .MuiOutlinedInput-notchedOutline,.SearchOneFieldMainContainer .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline{border-color:transparent;border-radius:0!important}.SearchOneFieldMainContainer .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline{border-color:transparent;border-radius:0!important;border-width:0}";
  styleInject(css_248z$O);

  function SearchField(props) {
    var _props$disabled;

    var name = props.name,
        onChange = props.onChange,
        value = props.value,
        InputProps = props.InputProps,
        onBlur = props.onBlur,
        type = props.type;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SearchOneFieldMainContainer",
      style: {
        border: props.BorderColor
      }
    }, /*#__PURE__*/React__default["default"].createElement(TextField__default["default"], {
      id: "outlined-basic",
      variant: "outlined",
      placeholder: props.placeholder,
      name: name,
      onChange: onChange,
      value: value,
      disabled: (_props$disabled = props === null || props === void 0 ? void 0 : props.disabled) !== null && _props$disabled !== void 0 ? _props$disabled : false // InputProps={InputProps}
      ,
      onBlur: onBlur,
      type: type,
      color: "primary",
      InputProps: _objectSpread2({
        endAdornment: /*#__PURE__*/React__default["default"].createElement(InputAdornment__default["default"], {
          position: "end"
        }, props.icon)
      }, InputProps)
    }), /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.buttonLebel,
      link: props.getDirectiontLink,
      target: props.target,
      path: props.path,
      arrow: props.arrow,
      arrowColor: props.arrowColor,
      buttoncolor: props.buttoncolor,
      width: props.width,
      height: props.height,
      border: props.border,
      borderRadius: props.borderRadius,
      color: props.colorlabel,
      fontWeight: props.fontWeight,
      textAlign: props.textAlign,
      onClick: props.onClick
    }));
  }

  var css_248z$N = ".SmallPostCardOneMainContainer a{text-decoration:none;cursor:pointer}.SmallPostCardOneMainContainer a:hover{text-decoration:none}.SmallPostCardOneMainContainer .SmallPostCardOneCol{position:relative;background:#fff;display:-webkit-box;display:-ms-flexbox;display:flex}.SmallPostCardOneMainContainer .SmallPostCardOneCol .SmallPostCardOneImg{max-width:83px;min-width:83px;max-height:100%;position:relative;overflow:hidden}.SmallPostCardOneMainContainer .SmallPostCardOneCol .SmallPostCardOneImg .SmallPostCardOneThumbnail{-o-object-fit:cover;object-fit:cover;width:100%;height:100%}.SmallPostCardOneMainContainer .SmallPostCardOneCol .SmallPostCardOneImg .SmallPostCardOneTwoOverlay{background:#000;position:absolute;opacity:.4;left:0;top:0;width:100%;height:100%}.SmallPostCardOneMainContainer .SmallPostCardOneCol .SmallPostCardOneDetails{padding:11px;-webkit-box-flex:1;-ms-flex:1;flex:1}.SmallPostCardOneMainContainer .SmallPostCardOneCol .SmallPostCardOneDetails .SmallPostCardOneDetailsTitle{font-size:14px;margin:0 0 4px;line-height:20px;letter-spacing:0}.SmallPostCardOneMainContainer .SmallPostCardOneCol .SmallPostCardOneDetails .SmallPostCardOneDetailsSubTitle{font-size:12px;font-weight:400;line-height:16px;color:#676c7b;margin:0 0 4px;text-transform:uppercase}.SmallPostCardOneMainContainer .SmallPostCardOneCol .SmallPostCardOneDetails .SmallPostCardOneLocation{margin:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.SmallPostCardOneMainContainer .SmallPostCardOneCol .SmallPostCardOneDetails .SmallPostCardOneLocation .SmallPostCardOneLocationText{font-size:10px!important;font-weight:400;line-height:16px;color:#a4a7b0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-transform:uppercase;margin:0 10px 9px 0}.SmallPostCardOneMainContainer .SmallPostCardOneCol .SmallPostCardOneDetails .SmallPostCardOneLocation .SmallPostCardOneLocationText svg{margin-right:4px;font-size:16px;color:#a4a7b0}.nomargin{margin-top:0!important}.SmallPostCardOneBorderLine{background:#e4e8ec;height:1px;width:100%;margin-top:10px}";
  styleInject(css_248z$N);

  function SmallPostCardOne(props) {
    var SmallPostCardOneData = props.SmallPostCardOneData;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SmallPostCardOneMainContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: props.spacing
    }, SmallPostCardOneData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        item: true,
        md: props.col,
        xs: 12
      }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        to: item.path
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "SmallPostCardOneCol"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "SmallPostCardOneImg",
        style: {
          minWidth: props.Thumnailwidth,
          minHeight: props.ThumnailHeight,
          borderRadius: props.thumnailRadius
        }
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        className: "SmallPostCardOneThumbnail",
        src: item.img,
        alt: ""
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "SmallPostCardOneTwoOverlay"
      })), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "SmallPostCardOneDetails"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "SmallPostCardOneLocation"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "SmallPostCardOneLocationText"
      }, /*#__PURE__*/React__default["default"].createElement(DateRangeIcon__default["default"], null), " ", item.date)), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "SmallPostCardOneDetailsTitle",
        style: {
          fontWeight: props.titleWieght,
          color: props.titleColor,
          textTransform: props.titletextTransform
        }
      }, item.title), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "SmallPostCardOneDetailsSubTitle"
      }, item.subtitle)))), props.borderLine && /*#__PURE__*/React__default["default"].createElement("div", {
        className: "SmallPostCardOneBorderLine"
      }));
    })));
  }

  var css_248z$M = ".PageNotFoundContainer{padding:80px 124px}.PageNotFoundContainer .PageNotFoundTitle{color:#1b2121;font-size:34px;text-align:center;font-weight:700}.PageNotFoundContainer .PageNotFounddDescription{color:#828282;font-size:14px;text-align:center;font-weight:400;letter-spacing:0;padding-top:16px;max-width:530px;margin:0 auto;line-height:28px}.PageNotFoundContainer .PageNotFounddDescription a{font-weight:600;text-decoration:underline}.PageNotFoundContainer .PageNotFounddButtonContainer{text-align:center;margin-top:40px}@media (max-width:500px){.PageNotFoundContainer{padding:30px 24px}}";
  styleInject(css_248z$M);

  function PageNotFound(props) {

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PageNotFoundContainer",
      style: {
        background: props.background
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PageNotFoundTitle"
    }, props.Title), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PageNotFounddDescription"
    }, props.Description, " ", /*#__PURE__*/React__default["default"].createElement("a", {
      href: props.Contactlink,
      target: "blank",
      style: {
        color: props.ContactlinkColor
      }
    }, "Contact Us.")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PageNotFounddButtonContainer"
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.buttonLebel,
      link: props.getDirectiontLink,
      target: props.target,
      path: props.path,
      arrow: props.arrow,
      arrowColor: props.arrowColor,
      buttoncolor: props.buttoncolor,
      width: props.width,
      height: props.height,
      border: props.border,
      borderRadius: props.borderRadius,
      color: props.colorlabel,
      fontWeight: props.fontWeight,
      textAlign: props.textAlign,
      onClick: props.onClick
    })));
  }

  var css_248z$L = ".SideBarBodyContainer{padding:20px;margin-bottom:30px}";
  styleInject(css_248z$L);

  function SideBarBody(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SideBarBodyContainer",
      style: {
        background: props.background,
        border: props.border
      }
    }, props.SideBarBody);
  }

  var css_248z$K = ".UserAvatarOne a,.UserAvatarOne a:hover{text-decoration:none}.UserAvatarOne .GuestCardOneSection .GuestCardOneTitle{font-size:16px;font-weight:700;line-height:24px;color:#0b132b;text-align:left;margin:12px 0 0}.UserAvatarOne .GuestCardOneSection .GuestCardOneDesignation{font-size:14px;font-weight:400;line-height:24px;color:#4c5e67;text-align:left;margin:2px 0 4px}.UserAvatarOne .GuestCardOneSection .GuestCardOneImgCol{width:100%;height:100%;overflow:hidden;background:#e4e8ec;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.UserAvatarOne .GuestCardOneSection .GuestCardOneImgCol img{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;position:absolute;left:0;top:0}.UserAvatarOne .GuestCardOneSection .GuestCardOneImgCol svg{font-size:130px;color:#989fa7}.textItalic{font-style:italic}";
  styleInject(css_248z$K);

  function UserAvatarOne(props) {
    var guestCardOneData = props.guestCardOneData;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "UserAvatarOne"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: props.spacing
    }, guestCardOneData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        item: true,
        md: props.col,
        xs: 12
      }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        href: item.link,
        to: item.path
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "GuestCardOneSection"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "GuestCardOneImgCol",
        style: {
          width: props.width,
          height: props.height
        }
      }, /*#__PURE__*/React__default["default"].createElement(PersonIcon__default["default"], null), /*#__PURE__*/React__default["default"].createElement("img", {
        className: "GuestCardOneimg",
        src: item.img,
        alt: ""
      })), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "GuestCardOneTitle"
      }, item.name), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "GuestCardOneDesignation textItalic"
      }, item.Designation), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "GuestCardOneDesignation"
      }, item.email), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "GuestCardOneDesignation"
      }, item.phone))));
    })));
  }

  var css_248z$J = ".UserAvatarFour .GuestCardOneSection{text-align:center}.UserAvatarFour a,.UserAvatarFour a:hover{text-decoration:none}.UserAvatarFour .GuestCardOneSection .GuestCardOneTitle{font-size:16px;font-weight:700;line-height:24px;color:#0b132b;text-align:center;margin:12px 0 0}.UserAvatarFour .GuestCardOneSection .GuestCardOneDesignation{font-size:14px;font-weight:400;line-height:24px;color:#4c5e67;text-align:center;margin:2px 0 4px}.UserAvatarFour .GuestCardOneSection .GuestCardOneImgCol{background:#fff;width:214px;height:214px;border:1px solid #e4e8ec;padding:10px;margin:0 auto}.UserAvatarFour .GuestCardOneSection .GuestCardOneImgCol img{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}";
  styleInject(css_248z$J);

  function UserAvatarFour(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "UserAvatarFour"
    }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      href: props.link,
      to: props.path
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "GuestCardOneSection"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "GuestCardOneImgCol"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      className: "GuestCardOneimg",
      src: props.img,
      alt: ""
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "GuestCardOneTitle"
    }, props.Title), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "GuestCardOneDesignation"
    }, props.Designation))));
  }

  var css_248z$I = ".UserAvatarFive .GuestCardOneSection{text-align:center}.UserAvatarFive a,.UserAvatarFive a:hover{text-decoration:none}.UserAvatarFive .GuestCardOneSection .GuestCardOneTitle{font-size:16px;font-weight:700;line-height:24px;color:#0b132b;text-align:center;margin:12px 0 0}.UserAvatarFive .GuestCardOneSection .GuestCardOneDesignation{font-size:14px;font-weight:400;line-height:24px;color:#4c5e67;text-align:center;margin:2px 0 4px}.UserAvatarFive .GuestCardOneSection .GuestCardOneImgCol{width:80px;height:80px;overflow:hidden;border-radius:100%;margin:0 auto}.UserAvatarFive .GuestCardOneSection .GuestCardOneImgCol img{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}";
  styleInject(css_248z$I);

  function UserAvatarFive(props) {
    var guestCardOneData = props.guestCardOneData;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "UserAvatarFive"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: props.spacing
    }, guestCardOneData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        item: true,
        md: props.col,
        xs: 12
      }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        href: item.link,
        to: item.path
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "GuestCardOneSection"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "GuestCardOneImgCol"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        className: "GuestCardOneimg",
        src: item.img,
        alt: ""
      })), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "GuestCardOneTitle"
      }, item.name), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "GuestCardOneDesignation"
      }, item.Designation))));
    })));
  }

  var css_248z$H = ".GuestCardOneMainContainer .GuestCardOneSection{text-align:center}.GuestCardOneMainContainer a,.GuestCardOneMainContainer a:hover{text-decoration:none}.GuestCardOneMainContainer .GuestCardOneSection .GuestCardOneTitle{font-size:16px;font-weight:700;line-height:24px;color:#0b132b;text-align:center;margin:12px 0 0}.GuestCardOneMainContainer .GuestCardOneSection .GuestCardOneDesignation{font-size:14px;font-weight:400;line-height:24px;color:#4c5e67;text-align:center;margin:2px 0 4px}.GuestCardOneMainContainer .GuestCardOneSection .GuestCardOneImgCol{width:80px;height:80px;overflow:hidden;border-radius:100%;margin:0 auto}.GuestCardOneMainContainer .GuestCardOneSection .GuestCardOneImgCol img{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}";
  styleInject(css_248z$H);

  function SliderText(props) {
    props.guestCardOneData;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "GuestCardOneMainContainer"
    });
  }

  var AttendeeForm = function AttendeeForm() {
    var _React$useState = React__default["default"].useState({
      country: "",
      number: ""
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        phone = _React$useState2[0];
        _React$useState2[1];

    var click = function click() {
      console.log("Back Button Clicked");
    };

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "DeliveryDetailsContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "First/Given name",
      labelStatus: true //helpertext="Helper text"
      ,
      HelpertextStatus: true,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Middle name (optional)",
      labelStatus: true,
      helpertext: "Helper text" //HelpertextStatus={true}
      ,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Last/Surname",
      labelStatus: true //helpertext="Helper text"
      ,
      HelpertextStatus: false,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Age",
      labelStatus: true // helpertext="Helper text"
      ,
      HelpertextStatus: false,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(SelectField, {
      label: "Gender",
      labelStatus: true,
      helperText: "Helper text",
      Errormessage: "Error message",
      helpertext: false,
      errortext: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(SelectField, {
      label: "Hajj year",
      labelStatus: true,
      helperText: "Helper text",
      Errormessage: "Error message",
      helpertext: false,
      errortext: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Address line 1",
      labelStatus: true // helpertext="Helper text"
      ,
      HelpertextStatus: false,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Address line 2 (Optional)",
      labelStatus: true // helpertext="Helper text"
      ,
      HelpertextStatus: false,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "City/Town",
      labelStatus: true // helpertext="Helper text"
      ,
      HelpertextStatus: false,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(SelectField, {
      label: "Select",
      labelFixed: "State",
      labelStatus: true,
      helperText: "Helper text",
      Errormessage: "Error message",
      helpertext: false,
      errortext: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Zip/Postal code",
      labelStatus: true // helpertext="Helper text"
      ,
      HelpertextStatus: false,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "checkOutAttendeePhone"
    }, /*#__PURE__*/React__default["default"].createElement(PhoneInputField, {
      labelFixed: "Phone number",
      LabelStatus: true,
      phoneInputVariant: "materialui" // default, materialui, underlineInput, underlineWithFlag
      ,
      country: 'us',
      value: phone.number,
      countryCodeEditable: false,
      onChange: function onChange(phone, country) {
        return console.log("onChange", phone, country);
      },
      onBlur: function onBlur() {
        return console.log("onBlur");
      },
      onKeyDown: function onKeyDown(e) {
        return console.log("onKeyDown", e.target.value);
      },
      variant: "outlined",
      onlyCountries: ["us", "ca", "gb", "my"],
      containerStyle: {},
      buttonStyle: {},
      inputStyle: {
        marginLeft: "0px",
        height: "40px",
        width: "100%",
        fontFamily: "Roboto-Regular",
        fontSize: "16px"
      },
      containerClass: {},
      errorText: "Phone number is required",
      error: false,
      errorStyles: {
        marginBottom: "5px"
      },
      autoFormat: true,
      disableDropdown: false,
      disabled: false,
      disableCountryCode: false,
      enableSearch: false,
      disableSearchIcon: false,
      placeholder: "",
      inputProps: {} //specialLabel={'Primary Phone'}
      // preferredCountries={[]}
      // excludeCountries={[]}

    }))), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 6,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      label: "Email",
      labelStatus: true,
      placeholder: "someone@example.com" // helpertext="Helper text"
      ,
      HelpertextStatus: false,
      Errormessage: "Error message",
      errortextStatus: false,
      count: false,
      countStatus: false,
      tooltipStatus: false
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        display: "flex",
        justifyContent: "end",
        paddingTop: "10px"
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        paddingRight: "15px"
      }
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: "ADD MORE ATTEENDEE",
      onClick: click,
      addIcon: true,
      AddIconColor: "#0590FA",
      buttoncolor: "#fff",
      width: "auto",
      height: "50px",
      border: "#0590FA 1px solid",
      borderRadius: "4px",
      color: "#0590FA",
      fontWeight: "600",
      textAlign: "center"
    })), /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: "CONTINUE TO PAYMENT",
      onClick: click,
      arrow: false,
      arrowColor: "#fff",
      buttoncolor: "#0590FA",
      width: "auto",
      height: "50px",
      border: "#0590FA 0px solid",
      borderRadius: "4px",
      color: "#fff",
      fontWeight: "600",
      textAlign: "center"
    })))));
  };

  var cardFunction = function cardFunction(value) {
    value && console.log("clicked");
  };

  function PaymentComponent(props) {
    var _React$createElement, _React$createElement2, _React$createElement3, _React$createElement4, _React$createElement5;

    var privacyPolicyLink = props.privacyPolicyLink,
        termsOfUseLink = props.termsOfUseLink,
        cardDetails = props.cardDetails;
        props.setcardDetails;
        var addressDetails = props.addressDetails,
        setaddressDetails = props.setaddressDetails;
        props.saveCardDetails;
        props.setsaveCardDetails;
        var selectedCardDetails = props.selectedCardDetails,
        CreditCard = props.CreditCard,
        Paycheck = props.Paycheck,
        CashIcon = props.CashIcon,
        visaCardImage = props.visaCardImage,
        masterCardImage = props.masterCardImage,
        helpImage = props.helpImage;
        props.newCardImage;
        var discoverCardImage = props.discoverCardImage,
        americanExpressImage = props.americanExpressImage,
        dinersCardImage = props.dinersCardImage;

    var _React$useState = React__default["default"].useState("newCard"),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        paymentWith = _React$useState2[0];
        _React$useState2[1];

    var _React$useState3 = React__default["default"].useState({
      cardNumberError: false,
      expirationError: false,
      codeError: false
    }),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        cardDetailsError = _React$useState4[0];
        _React$useState4[1];

    var onSubmit = function onSubmit() {
      if (paymentWith === "newCard") {
        props.onPlaceOrderSubmit({
          cardDetails: cardDetails,
          addressDetails: addressDetails
        });
        console.log(cardDetails, addressDetails);
      } else {
        props.onPlaceOrderSubmit({
          selectedCardDetails: selectedCardDetails
        });
        console.log(selectedCardDetails);
      }
    };

    var handleAddressDetailChange = function handleAddressDetailChange(e) {
      console.log("test", e);
      setaddressDetails(_objectSpread2(_objectSpread2({}, addressDetails), {}, _defineProperty({}, e.target.name, e.target.value)));
    };

    var cardImage = function cardImage(number) {
      // visa card
      if (/^4[0-9]{12}(?:[0-9]{3})?$/.test(number)) {
        return /*#__PURE__*/React__default["default"].createElement(core.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React__default["default"].createElement("img", {
          src: visaCardImage,
          className: "masterCardImage",
          alt: "card img"
        }));
      } //master card
      else if (/^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/.test(number)) {
        return /*#__PURE__*/React__default["default"].createElement(core.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React__default["default"].createElement("img", {
          src: masterCardImage,
          className: "masterCardImage",
          alt: "card img"
        }));
      } // American Express
      else if (/^3[47][0-9]{13}$/.test(number)) {
        return /*#__PURE__*/React__default["default"].createElement(core.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React__default["default"].createElement("img", {
          src: americanExpressImage,
          className: "masterCardImage",
          alt: "card img"
        }));
      } //Diners Club
      else if (/^3(?:0[0-5]|[68][0-9])[0-9]{11}$/.test(number)) {
        return /*#__PURE__*/React__default["default"].createElement(core.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React__default["default"].createElement("img", {
          src: dinersCardImage,
          className: "masterCardImage",
          alt: "card img"
        }));
      } //Discover
      else if (/^6(?:011|5[0-9]{2})[0-9]{12}$/.test(number)) {
        return /*#__PURE__*/React__default["default"].createElement(core.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React__default["default"].createElement("img", {
          src: discoverCardImage,
          className: "masterCardImage",
          alt: "card img"
        }));
      }
    };

    var checkCVC = function checkCVC() {
      var cardNumber = cardDetails.cardNumber,
          code = cardDetails.code;

      if (cardNumber[0] === '3' ? code.length !== 4 : code.length !== 3) {
        return false;
      } else {
        return true;
      }
    };

    var validateExpiration = function validateExpiration() {
      var expiration = cardDetails.expiration;

      if (/^(0[1-9]|1[0-2])\/\d{2}$/.test(expiration)) {
        var today, someday;
        var exMonth = expiration.split("/")[0];
        var exYear = expiration.split("/")[1];
        today = new Date();
        someday = new Date();
        someday.setFullYear('20' + exYear, exMonth, 1);

        if (someday < today) {
          console.log("The expiry date is before today's date. Please select a valid expiry date");
          return false;
        }

        return true;
      } else {
        return false;
      }
    };

    var cardNumber = cardDetails.cardNumber;
        cardDetails.expiration;
        cardDetails.code;
    cardDetailsError.cardNumberError;
        cardDetailsError.expirationError;
        cardDetailsError.codeError;
    var firstName = addressDetails.firstName,
        lastName = addressDetails.lastName,
        line1 = addressDetails.line1,
        line2 = addressDetails.line2,
        city = addressDetails.city,
        state = addressDetails.state,
        postalCode = addressDetails.postalCode,
        country = addressDetails.country;
    var disableBtn = cardImage(cardNumber) && validateExpiration() && checkCVC() && firstName && lastName && line1 && city && state && postalCode && country ? false : true; // let disableBtn = checkCVC(code) ? false : true;

    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ZamzamCheckoutPaymentForm"
    }, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      md: 4,
      sm: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
      cardFunction: cardFunction,
      header: "Credit Card",
      color: "#1B2121",
      icon: CreditCard,
      Link: false,
      cardIconStatus: true
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      md: 4,
      sm: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
      cardFunction: cardFunction,
      header: "Pay Check",
      color: "#1B2121",
      icon: Paycheck,
      Link: false,
      cardIconStatus: true
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      md: 4,
      sm: 4,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
      cardFunction: cardFunction,
      header: "Pay Cash",
      color: "#1B2121",
      icon: CashIcon,
      Link: false,
      cardIconStatus: true
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "infoTextContainer"
    }, " ", /*#__PURE__*/React__default["default"].createElement(InfoIcon__default["default"], null), " Please, use a card without interest/Riba. If possible, use a Debit Card instead."), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ZamzamPaymentDetailsContainer"
    }, /*#__PURE__*/React__default["default"].createElement("li", null, /*#__PURE__*/React__default["default"].createElement("h1", null, "Check Payable to :"), /*#__PURE__*/React__default["default"].createElement("h2", null, "ZamZam Hajj & Umrah Services, Inc")), /*#__PURE__*/React__default["default"].createElement("li", null, /*#__PURE__*/React__default["default"].createElement("h1", null, "Mail the check to:"), /*#__PURE__*/React__default["default"].createElement("h2", null, "Md D. Hossain"), /*#__PURE__*/React__default["default"].createElement("p", null, "ZamZam Hajj & Umrah Services, Inc"), /*#__PURE__*/React__default["default"].createElement("p", null, "1049 Glenmore Ave, #5B"), /*#__PURE__*/React__default["default"].createElement("p", null, "Brooklyn, NY 11208")))), /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement = {
      label: "Card number",
      labelStatus: true,
      placeholder: "Card number",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement, "count", false), _defineProperty(_React$createElement, "tooltip", false), _defineProperty(_React$createElement, "inputlabel", true), _defineProperty(_React$createElement, "name", "firstName"), _defineProperty(_React$createElement, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement, "value", firstName), _React$createElement))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 3
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement2 = {
      label: "Expiration",
      labelStatus: true,
      placeholder: "MM/YY",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement2, "count", false), _defineProperty(_React$createElement2, "tooltip", false), _defineProperty(_React$createElement2, "inputlabel", true), _defineProperty(_React$createElement2, "name", "lastName"), _defineProperty(_React$createElement2, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement2, "value", lastName), _React$createElement2))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 3
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CVVField"
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement3 = {
      label: "Security code",
      labelStatus: true,
      placeholder: "CVC",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement3, "count", false), _defineProperty(_React$createElement3, "tooltip", false), _defineProperty(_React$createElement3, "inputlabel", true), _defineProperty(_React$createElement3, "name", "line1"), _defineProperty(_React$createElement3, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement3, "value", line1), _React$createElement3)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "cvvTooltipContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Tooltip__default["default"], {
      title: "CVV is the last 3 digits on the back. In American Express, it is a 4 digit code in the front of the credit card",
      placement: "top",
      style: {
        color: "red"
      }
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: helpImage,
      width: "30px",
      alt: "card img"
    }))))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement4 = {
      label: "Name on card",
      labelStatus: true,
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement4, "count", false), _defineProperty(_React$createElement4, "tooltip", false), _defineProperty(_React$createElement4, "inputlabel", false), _defineProperty(_React$createElement4, "name", "line2"), _defineProperty(_React$createElement4, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement4, "value", line2), _React$createElement4))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, (_React$createElement5 = {
      label: "Zip/Postal code",
      labelStatus: true,
      helperText: "Helper text",
      placeholder: "Same as billing address",
      Errormessage: "Error message",
      count: 100,
      helpertext: true,
      errortext: false
    }, _defineProperty(_React$createElement5, "count", false), _defineProperty(_React$createElement5, "tooltip", false), _defineProperty(_React$createElement5, "inputlabel", false), _defineProperty(_React$createElement5, "name", "city"), _defineProperty(_React$createElement5, "onChange", handleAddressDetailChange), _defineProperty(_React$createElement5, "value", city), _React$createElement5)))), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "separator_line"
    })), /*#__PURE__*/React__default["default"].createElement(core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "form_button_Contianer"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "tos_text"
    }, "By placing your order you agree to our ", /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      href: privacyPolicyLink
    }, "Privacy Policy"), " and ", /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      href: termsOfUseLink
    }, "Terms of Use")), /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: "Place order",
      disabled: paymentWith !== "newCard" ? false : disableBtn,
      onclick: onSubmit,
      arrow: false,
      arrowColor: "#fff",
      buttoncolor: "#0590FA",
      width: "auto",
      height: "50px",
      border: "#0590FA 0px solid",
      borderRadius: "4px",
      color: "#fff",
      fontWeight: "600",
      textAlign: "center"
    }))))));
  }

  var css_248z$G = ".CheckoutPaymentExtendedContainer .MuiAccordionSummary-root.Mui-expanded{border-bottom:transparent;border:none!important}.aAccordionTitleSmall{color:#676c7b;font-size:14px!important;font-family:Poppins,sans-serif!important;font-weight:600!important;margin:0;text-transform:uppercase;margin-top:12px!important}";
  styleInject(css_248z$G);

  var CheckoutPaymentZamZam = function CheckoutPaymentZamZam(props) {

    var packegeData = [{
      GroupName: "Group A",
      TimePeriod: "7 Days",
      Details: "Sunday, July 15 to, Thursday, August 7",
      color: "#0590FA",
      onclick: "onclick",
      ButtonLabel: "Package details"
    }, {
      GroupName: "Group B",
      TimePeriod: "7 Days",
      Details: "Sunday, July 15 to, Thursday, August 7",
      color: "#06D02F",
      onclick: "onclick",
      ButtonLabel: "Package details"
    }, {
      GroupName: "VIP",
      TimePeriod: "7 Days",
      Details: "Sunday, July 15 to, Thursday, August 7",
      color: "#6200EE",
      onclick: "onclick",
      ButtonLabel: "Package details"
    }];

    var _React$useState = React__default["default"].useState('panel1'),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        expanded = _React$useState2[0],
        setExpanded = _React$useState2[1];

    var handleChange = function handleChange(panel) {
      return function (event, isExpanded) {
        setExpanded(isExpanded ? panel : false);
      };
    };

    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SucureText"
    }, "Secured checkout ", /*#__PURE__*/React__default["default"].createElement(LockOutlinedIcon__default["default"], null)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CheckoutPaymentExtendedContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Accordion__default["default"], {
      className: "CheckoutPaymentTabContainer",
      expanded: expanded === 'panel1',
      onChange: handleChange('panel1')
    }, /*#__PURE__*/React__default["default"].createElement(AccordionSummary__default["default"], {
      "aria-controls": "panel1bh-content",
      id: "panel1bh-content"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "aAccordionTitle"
    }, /*#__PURE__*/React__default["default"].createElement("span", null, "1"), " ", props.StepTitle_1), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "checkOutpaymentDetailsSection"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "checkOutpaymentDetailsCol"
    }, /*#__PURE__*/React__default["default"].createElement("h1", null, "Sheikh Raihan"), /*#__PURE__*/React__default["default"].createElement("p", null, "Male, 34"), /*#__PURE__*/React__default["default"].createElement("p", null, "Street address City, "), /*#__PURE__*/React__default["default"].createElement("p", null, "State Zip code"), /*#__PURE__*/React__default["default"].createElement("p", null, "+1 (123) 123-1234"), /*#__PURE__*/React__default["default"].createElement("p", null, "customename@email.com"), /*#__PURE__*/React__default["default"].createElement("p", null, "Package Group A, Hajj year 2021")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "checkOutpaymentDetailsEdit"
    }, "Edit"))), /*#__PURE__*/React__default["default"].createElement(AccordionDetails__default["default"], null, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 2
    }, packegeData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        item: true,
        xs: 4
      }, /*#__PURE__*/React__default["default"].createElement(PackageCard, {
        cardFunction: item.onclick,
        header: item.GroupName,
        dayText: item.TimePeriod,
        body: item.Details,
        color: item.color,
        icon: item.icon,
        Link: true,
        buttonLabel: item.ButtonLabel
      }));
    }), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "aAccordionTitleSmall"
    }, props.StepTitle_2)), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement(AttendeeForm, null))))), /*#__PURE__*/React__default["default"].createElement(Accordion__default["default"], {
      expanded: expanded === 'panel3',
      onChange: handleChange('panel3')
    }, /*#__PURE__*/React__default["default"].createElement(AccordionSummary__default["default"], {
      "aria-controls": "panel3bh-content",
      id: "panel3bh-header"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "aAccordionTitle"
    }, /*#__PURE__*/React__default["default"].createElement("span", null, "2"), " ", props.StepTitle_3)), /*#__PURE__*/React__default["default"].createElement(AccordionDetails__default["default"], null, /*#__PURE__*/React__default["default"].createElement(PaymentComponent, {
      creditCardsList: props.creditCardsList,
      handlePaymentSelectChange: props.handlePaymentSelectChange,
      onPlaceOrderSubmit: props.onPlaceOrderSubmit,
      cardDetails: props.cardDetails,
      setcardDetails: props.setcardDetails,
      addressDetails: props.addressDetails,
      setaddressDetails: props.setaddressDetails,
      saveCardDetails: props.saveCardDetails,
      setsaveCardDetails: props.setsaveCardDetails,
      selectedCardDetails: props.selectedCardDetails,
      privacyPolicyLink: props.privacyPolicyLink,
      termsOfUseLink: props.termsOfUseLink,
      onEditBillingDetailClick: props.onEditBillingDetailClick,
      visaCardImage: props.visaCardImage,
      masterCardImage: props.masterCardImage,
      newCardImage: props.newCardImage,
      discoverCardImage: props.discoverCardImage,
      americanExpressImage: props.americanExpressImage,
      dinersCardImage: props.dinersCardImage,
      helpImage: props.helpImage,
      CreditCard: props.CreditCard,
      CashIcon: props.CashIcon,
      Paycheck: props.Paycheck
    })))));
  };

  var css_248z$F = ".PageTitleOneMainContainer{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:50px 25px}.PageTitleOneMainContainer .PageTitleOneTextContainer .PageTitleOneMain{font-size:48px;text-transform:uppercase;font-weight:600;text-align:center}.PageTitleOneMainContainer .PageTitleOneTextContainer .PageSubTitleOne{font-size:16px;font-weight:400;text-align:center;max-width:500px;margin:0 auto}.PageTitleOneMainContainer .backgroundPattern{position:absolute;left:0;top:0;width:100%;height:100%}.PageTitleOneMainContainer .backgroundPattern img{width:100%;-o-object-fit:cover;object-fit:cover;height:100%}";
  styleInject(css_248z$F);

  function PageTitleOne(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PageTitleOneMainContainer",
      style: {
        background: props.backgroundcolor,
        height: props.height
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "backgroundPattern"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.backgroundPattern
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PageTitleOneTextContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PageTitleOneMain",
      style: {
        color: props.color
      }
    }, props.Title), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PageSubTitleOne",
      style: {
        color: props.color
      }
    }, props.SubTitle)));
  }

  var css_248z$E = ".PageTitleTwoMainContainer{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:left;-ms-flex-pack:left;justify-content:left;padding:50px 25px}.PageTitleTwoMainContainer .PageTitleTwoTextContainer .PageTitleTwoMain{font-size:48px;text-transform:uppercase;font-weight:600;text-align:left}.PageTitleTwoMainContainer .PageTitleTwoTextContainer .PageSubTitleTwo a{font-size:14px;font-weight:500;text-align:left;max-width:500px;margin:0 auto;color:#fff;cursor:pointer!important;opacity:.5;text-transform:uppercase}.PageTitleTwoMainContainer .PageTitleTwoTextContainer .PageSubTitleTwo a:hover{opacity:1}.PageTitleTwoMainContainer .PageTitleTwoTextContainer .PageSubTitleTwo .MuiBreadcrumbs-separator{color:#fff}.PageTitleTwoMainContainer .PageTitleTwoTextContainer .PageSubTitleTwo .MuiTypography-root{color:#fff;text-transform:uppercase;font-size:14px;font-weight:500}.PageTitleTwoMainContainer .backgroundPattern{position:absolute;left:0;top:0;width:100%;height:100%}.PageTitleTwoMainContainer .backgroundPattern img{width:100%;-o-object-fit:cover;object-fit:cover;height:100%}";
  styleInject(css_248z$E);

  function PageTitleTwo(props) {
    var breadcrumbsData = props.breadcrumbsData;

    function handleClick(event) {
      event.preventDefault();
      console.info('You clicked a breadcrumb.');
    }

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PageTitleTwoMainContainer",
      style: {
        background: props.backgroundcolor,
        height: props.height
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "backgroundPattern"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.backgroundPattern
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PageTitleTwoTextContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PageTitleTwoMain",
      style: {
        color: props.color
      }
    }, props.Title), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PageSubTitleTwo",
      style: {
        color: props.color
      }
    }, /*#__PURE__*/React__default["default"].createElement(Breadcrumbs__default["default"], {
      "aria-label": "breadcrumb"
    }, breadcrumbsData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        color: "inherit",
        href: item.paht,
        onClick: handleClick
      }, item.page);
    }), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      color: "textPrimary"
    }, props.currentPage)))));
  }

  var css_248z$D = ".VidoeListingWithSearchMainContainer{border:1px solid #e4e8ec}.VidoeListingWithSearchMainContainer .VidoeListingBody{padding:15px;background:#f4f9fc}.VidoeListingWithSearchMainContainer a{text-decoration:none;cursor:pointer}.VidoeListingWithSearchMainContainer a:hover{text-decoration:none}.VidoeListingWithSearchMainContainer .VideoColTwo{position:relative;background:#fff;display:-webkit-box;display:-ms-flexbox;display:flex}.VidoeListingWithSearchMainContainer .VideoColTwo .videoImgTwo{max-width:83px;min-width:83px;max-height:100%;position:relative}.VidoeListingWithSearchMainContainer .VideoColTwo .videoImgTwo .vidoeTwoimg{-o-object-fit:cover;object-fit:cover;width:100%;height:100%}.VidoeListingWithSearchMainContainer .VideoColTwo .videoImgTwo .vidoeTwoicon{width:56px;height:56px;position:absolute;top:15px;left:14px;z-index:1}.VidoeListingWithSearchMainContainer .VideoColTwo .videoImgTwo .vidoeTwoOverlay{background:#000;position:absolute;opacity:.4;left:0;top:0;width:100%;height:100%}.VidoeListingWithSearchMainContainer .VideoColTwo .videoDetailsTwo{padding:11px;-webkit-box-flex:1;-ms-flex:1;flex:1}.VidoeListingWithSearchMainContainer .VideoColTwo .videoDetailsTwo .videoDetailsTwoTitle{font-size:16px;font-weight:500;line-height:20px;color:#0b132b;margin:0 0 4px;letter-spacing:0}.VidoeListingWithSearchMainContainer .VideoColTwo .videoDetailsTwo .videoDetailsTwoSubTitle{font-size:12px;font-weight:400;line-height:16px;color:#676c7b;margin:0 0 4px;text-transform:uppercase}.VidoeListingWithSearchMainContainer .VideoColTwo .videoDetailsTwo .videoLocationTwo{margin:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.VidoeListingWithSearchMainContainer .VideoColTwo .videoDetailsTwo .videoLocationTwo .videoLocationTwoText{font-size:10px!important;font-weight:400;line-height:16px;color:#a4a7b0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-transform:uppercase;margin:0 10px 0 0}.VidoeListingWithSearchMainContainer .VideoColTwo .videoDetailsTwo .videoLocationTwo .videoLocationTwoText svg{margin-right:4px;font-size:16px;color:#a4a7b0}.nomargin{margin-top:0!important}.VidoeListingCardTwoBorderLine{background:#e4e8ec;height:1px;width:100%;margin-top:10px}.VidoeListingSearchMainContainer{background:#e8eff4;padding:10px}@media (max-width:450px){.VidoeListingWithSearchMainContainer .VideoColTwo .videoImgTwo .vidoeTwoicon{top:25px}}";
  styleInject(css_248z$D);

  require('./Done.png');

  require('./cancel.png');

  function VidoeListingWithSearch(props) {

    var videoListingTwoData = props.videoListingTwoData;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "VidoeListingWithSearchMainContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "VidoeListingBody"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: props.spacing
    }, videoListingTwoData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        item: true,
        md: props.col,
        xs: 12
      }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        to: item.path
      }, /*#__PURE__*/React__default["default"].createElement("a", {
        href: item.link,
        to: item.path,
        onClick: item.onclick
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "VideoColTwo"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoImgTwo",
        style: {
          minWidth: props.Thumnailwidth
        }
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        className: "vidoeTwoimg",
        src: item.img,
        alt: ""
      }), props.playiconStatus && /*#__PURE__*/React__default["default"].createElement("img", {
        className: "vidoeTwoicon",
        src: props.playicon,
        alt: ""
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "vidoeTwoOverlay"
      })), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoDetailsTwo"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoDetailsTwoTitle"
      }, item.title), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoDetailsTwoSubTitle"
      }, item.subtitle), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoLocationTwo"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoLocationTwoText"
      }, /*#__PURE__*/React__default["default"].createElement(DateRangeIcon__default["default"], null), " ", item.date), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "videoLocationTwoText"
      }, " ", /*#__PURE__*/React__default["default"].createElement(RemoveRedEyeOutlinedIcon__default["default"], null), " ", item.views)))))));
    }))));
  }

  var css_248z$C = ".OrderSummaryMainContainer{position:relative}.OrderSummaryMainContainer .OrderSummaryTitle{color:#4c5e67;font-size:16;border-bottom:1px solid #b0b9c1;padding-bottom:8;font-family:Poppins,sans-serif}.OrderSummaryMainContainer .itemContainer{border-bottom:1px solid #e4e8ec;height:56px}.OrderSummaryMainContainer .itemContainer,.OrderSummaryMainContainer .itemListing{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.OrderSummaryMainContainer .itemListing{padding:6px 0}.OrderSummaryMainContainer .itemText{color:#1b2121;font-size:14px;font-weight:600;font-family:Poppins,sans-serif;width:auto}.OrderSummaryMainContainer .editButton{color:#0590fa;font-size:14px;font-weight:600;text-transform:none;margin:0;padding:0;font-family:Poppins,sans-serif}.OrderSummaryMainContainer .itemAmountText,.OrderSummaryMainContainer .itemListText{color:#4c5e67;font-size:14px;font-weight:400;font-family:Poppins,sans-serif}.OrderSummaryMainContainer .itemAmountText{text-align:right}.OrderSummaryMainContainer .itemListContainer{margin-top:20px}.OrderSummaryMainContainer .itemBlueText{color:#0590fa}.OrderSummaryMainContainer .infoIcon{color:#b0b9c1;position:relative;top:7px;left:10px}.OrderSummaryMainContainer .FieldContainer{position:relative}.OrderSummaryMainContainer .ButtonApply{color:#0590fa;font-size:14px;font-weight:600;text-transform:none;margin:0;padding:0;font-family:Poppins,sans-serif;position:absolute;right:8px;top:15px}.OrderSummaryMainContainer .ButtonApply:hover{background-color:transparent}.OrderSummaryMainContainer .TotalContainer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:32px;padding-top:20px;border-top:1px solid #e4e8ec}.OrderSummaryMainContainer .TotalAmount,.OrderSummaryMainContainer .TotalText{color:#1b2121;font-size:20px;font-weight:500;font-family:Poppins,sans-serif}.OrderSummaryMainContainer .TotalAmount{text-align:right}";
  styleInject(css_248z$C);

  function ZamzamOrderSummary(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "OrderSummaryMainContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "OrderSummaryTitle"
    }, "Summary"), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "itemListContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "itemListing"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "itemListText"
    }, "Pre-Registration Fee/Person"), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "itemAmountText"
    }, "$1000.00")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "itemListing"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "itemListText"
    }, "Number of members"), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "itemAmountText"
    }, "2")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "itemListing"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "itemListText"
    }, "Total due"), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "itemAmountText"
    }, "$2000")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "itemListing"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "itemListText"
    }, "Pay now"), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "itemAmountText"
    }, "$2000")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FieldContainer"
    }, /*#__PURE__*/React__default["default"].createElement(TextInputFixedLabel, {
      helpertext: "Helper text",
      HelpertextStatus: false,
      placeholder: "Enter custom ammount here",
      Errormessage: "Error message",
      errortextStatus: true,
      count: 100,
      countStatus: false,
      tooltipStatus: false
    }), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      href: "#",
      className: "ButtonApply"
    }, "Apply")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TotalContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "TotalText"
    }, "Paying now"), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "TotalAmount"
    }, "$2000.00"))));
  }

  var css_248z$B = ".FooterMainBoxBottomMainContainer .FooterMainBoxBottomGrey{background:#fbfafd;padding:15px;border-top:1px solid #ebeaed}.FooterMainBoxBottomMainContainer .FooterMainBoxBottomContainer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin:0 auto}.FooterMainBoxBottomMainContainer .FooterMainBoxBottomGrey .FooterMainBoxBottomGreyText{text-align:left;font-size:12px;text-transform:uppercase;text-decoration:none;color:#a4a7b0}.FooterMainBoxBottomMainContainer .FooterMainBoxBottomGrey .FooterMainBoxBottomGreyText .FooterBottomtermlink{color:#a4a7b0;text-decoration:none}.FooterMainBoxBottomMainContainer .FooterMainBoxBottomGrey .FooterMainBoxBottomGreyText .FooterBottomtheartIcon{color:#828282;font-size:15px!important;vertical-align:middle}.FooterMainBoxBottomMainContainer .FooterMainBoxBottomWhite .FooterMainBoxBottomWhiteText{text-align:left;font-size:12px;text-transform:uppercase;text-decoration:none;color:#a4a7b0}.FooterMainBoxBottomMainContainer .FooterMainBoxBottomWhite .FooterMainBoxBottomdclogoftr{width:130px;margin-left:5px}.FooterMainBoxBottomMainContainer .FooterMainBoxBottomWhite .FooterMainBoxBottompweredText{vertical-align:middle;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#828282;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:12px}.FooterMainBoxBottomMainContainer .FooterMainBoxBottomWhite .FooterMainBoxBottompweredText span{position:relative;top:-2px}.FooterMainBoxBottomMainContainer .FooterMainBoxBottomWhite .visitUs{text-align:right;color:#828282;text-decoration:none}.FooterMainBoxBottomMainContainer .FooterMainBoxBottomWhite{background:#fff;padding:15px}@media (max-width:768px){.FooterMainBoxBottomMainContainer .FooterMainBoxBottomContainer{display:block;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin:0 auto}.FooterMainBoxBottomMainContainer .FooterMainBoxBottomGrey{display:block;text-align:center}.FooterMainBoxBottomMainContainer .FooterMainBoxBottomGrey .FooterMainBoxBottomGreyText{text-align:center;padding:5px 0}.FooterMainBoxBottomMainContainer .FooterMainBoxBottomWhite{display:block}.FooterMainBoxBottomMainContainer .FooterMainBoxBottomWhite .FooterMainBoxBottomWhiteText{text-align:center;margin-top:12px}.FooterMainBoxBottomMainContainer .FooterMainBoxBottomWhite .FooterMainBoxBottompweredText{margin-top:10px}}";
  styleInject(css_248z$B);

  function FooterBottomOne(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterMainBoxBottomMainContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterMainBoxBottomGrey"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterMainBoxBottomContainer",
      style: {
        maxWidth: props.Container
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterMainBoxBottomGreyText"
    }, /*#__PURE__*/React__default["default"].createElement("a", {
      href: props.TermsLink,
      className: "FooterBottomtermlink",
      target: props.target
    }, " Terms of Services "), /*#__PURE__*/React__default["default"].createElement("span", null, "|"), /*#__PURE__*/React__default["default"].createElement("a", {
      href: props.PrivacyLink,
      className: "FooterBottomtermlink",
      target: props.target
    }, " Privacy Policy ")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterMainBoxBottomGreyText"
    }, "Crafted With ", /*#__PURE__*/React__default["default"].createElement(FavoriteIcon__default["default"], {
      className: "FooterBottomtheartIcon"
    }), " In Islam"))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterMainBoxBottomWhite"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterMainBoxBottomContainer",
      style: {
        maxWidth: props.Container
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterMainBoxBottomWhiteText"
    }, "\xA9 2022 DEECONNECT. ALL RIGHTS RESERVED"), /*#__PURE__*/React__default["default"].createElement("div", {
      gutterBottom: true,
      className: "FooterMainBoxBottompweredText"
    }, /*#__PURE__*/React__default["default"].createElement("span", null, "POWERED BY"), " ", /*#__PURE__*/React__default["default"].createElement("a", {
      href: "https://deenconnect.io/",
      target: "_blank"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      className: "FooterMainBoxBottomdclogoftr",
      src: "https://dc-img-assets.s3.amazonaws.com/DEENCONNECT-manage-masjid-organization-logo.png",
      alt: "DC Logo"
    }))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterMainBoxBottomWhiteText"
    }, "Visit us - ", /*#__PURE__*/React__default["default"].createElement("a", {
      className: "visitUs",
      href: "https://deenconnect.io/",
      target: "_blank"
    }, "www.deenconnect.io")))), /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        background: props.bordercolor,
        height: "4px"
      }
    }));
  }

  var css_248z$A = ".TimeCardOneMainContainer .TimeCardOneTopText{font-size:14px;margin-bottom:8px}.TimeCardOneMainContainer .TimeCardOneCard{text-align:center;-webkit-box-shadow:0 12px 17px rgba(0,0,0,.0902);box-shadow:0 12px 17px rgba(0,0,0,.0902);padding:18px 18px 30px}.TimeCardOneMainContainer .TimeCardOneCardTime{font-size:14px;text-align:center;margin-bottom:4px}.TimeCardOneMainContainer .TimeCardOneCardTimeFormate{font-size:24px;text-align:center}.TimeCardOneMainContainer .TimeCardOneTopBorderLine{height:2px}.TimeCardOneMainContainer .TimeCardOneCardIcon{font-size:24px}";
  styleInject(css_248z$A);

  function TimeCardOne(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TimeCardOneMainContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TimeCardOneTopText",
      style: {
        color: props.TopTextcolor
      }
    }, props.TopText), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TimeCardOneTopBorderLine",
      style: {
        background: props.TopBorderLine
      }
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TimeCardOneCard",
      style: {
        background: props.Cardbackground
      }
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      className: "TimeCardOneCardIcon",
      src: "https://dc-img-assets.s3.amazonaws.com/DEENCONNECT-website-for-masjid-organization-development-sun-icon.webp",
      alt: "sun icon"
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TimeCardOneCardTime",
      style: {
        color: props.Textcolor
      }
    }, props.CardTextOne), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TimeCardOneCardTimeFormate",
      style: {
        color: props.Textcolor
      }
    }, props.CardTextTwo)));
  }

  function TableRwo(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TableCellContainer"
    }, props.rows.map(function (row, i) {
      return /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
        align: "center"
      }, row.label);
    }));
  }

  function TableButton(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TableCellContainer"
    }, props.buttons.map(function (row, i) {
      return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, props.buttonStatus && /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], {
        align: "center"
      }, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
        className: "tableButton"
      }, row.buttonlabel)));
    }));
  }

  var css_248z$z = "@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");.TableWithTabsContainer .MuiTableContainer-root{width:100%;overflow-x:visible;overflow-x:initial}.TableWithTabsContainer .pricingTitle h1{text-align:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:40px;margin:0;color:#fff;text-transform:uppercase;font-weight:400;font-size:20px;padding:3px}.TableWithTabsContainer .MuiTableCell-root{padding:0!important}.TableWithTabsContainer .pricingTitleBottomBody{padding:30px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.TableWithTabsContainer .pricingTitleBottomBody h2{text-align:center;color:#fff;font-size:40px;font-weight:600;margin:0}.TableWithTabsContainer .pricingTitleBottomBody h2 span{text-align:center;color:#fff;font-size:23px;font-weight:400;position:relative;top:-18px;text-align:right;right:-9px}.TableWithTabsContainer .pricingTitleBottomBody p{text-align:center;color:#fff;font-size:16px;font-weight:400;text-transform:uppercase;margin-top:30px;margin-bottom:20px}.TableWithTabsContainer .priceSelectButton{color:#fff;width:100%;border-radius:4px;cursor:pointer;margin:0 auto;padding:13px 60px}.TableWithTabsContainer .priceSelectButton:hover{text-decoration:none}.TableWithTabsContainer .blueTheme{background:#0590fa}.TableWithTabsContainer .blueTheme .prTitleName{background:#0585e6}.TableWithTabsContainer .blueTheme .priceSelectButton{background:#0590fa;border:1px solid #7dc5fc}.TableWithTabsContainer .greenTheme{background:#06d02f}.TableWithTabsContainer .greenTheme .prTitleName{background:#06c02b}.TableWithTabsContainer .greenTheme .priceSelectButton{background:#06c02b;border:1px solid #7ee793}.TableWithTabsContainer .greyTheme{background:#7785cd}.TableWithTabsContainer .greyTheme .prTitleName{background:#6e7bbd}.TableWithTabsContainer .greyTheme .priceSelectButton{background:#7785cd;border:1px solid #b9c0e5}.TableWithTabsContainer .GreemButton{background:#06c02b;border:1px solid #7ee793}.TableWithTabsContainer .GreyButton{background:#7785cd;border:1px solid #b9c0e5}.TableWithTabsContainer .BlueButton{background:#0590fa;border:1px solid #7dc5fc}.TableWithTabsContainer .PricingPackageTitleContainer{width:329px;padding:0 30px}.TableWithTabsContainer .PricingPackageTitleContainer h3{font-size:45px;line-height:49px;margin:20px 0}.TableWithTabsContainer .PricingPackageTitleContainerTh{vertical-align:baseline}.TableWithTabsContainer .PricingPackageTitleContainer .Tax_text{color:#7a7f8c;text-transform:uppercase;font-size:20px;font-weight:400;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.TableWithTabsContainer .PricingPackageTitleContainer .Tax_text svg{color:#31a347;font-size:30px;margin-right:6px}.TableWithTabsContainer .MuiTableCell-body{padding:15px 20px!important}.TableWithTabsContainer .MuiTableCell-root{border-bottom:1px solid #f1f3f5!important}.TableWithTabsContainer .PrcInfoIcon{color:#d3d4d9;float:right}.TableWithTabsContainer .tableCheckIcon{color:#56b149}.TableWithTabsContainer .leftAling{float:none!important}.TableWithTabsContainer .TextWithIcon{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:end;color:#676c7b;font-weight:400}.TableWithTabsContainer .TextWithIcon svg{margin-right:10px}@media(max-width:990px){.TableWithTabsContainer .MuiTableContainer-root{width:100%;overflow-x:auto}}.TableWithTabsTabContainer .MuiTabs-indicator{display:none}.TableWithTabsTableTitle{font-size:34px;font-weight:700;color:#1b2121}.TableWithTabTitleandTabContainer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:24px}.TableWithTabTitleandTabContainer .MuiTab-textColorPrimary.Mui-selected{color:#fff;background:#56b149}.TableWithTabTitleandTabContainer .MuiAppBar-colorDefault{background-color:#fcfcfc;-webkit-box-shadow:none;box-shadow:none}.TableWithTabTitleandTabContainer .MuiTab-root{font-family:Poppins,sans-serif;color:#4d4d4d;font-weight:500}.TableWithTabTitleandTabContainer .MuiAppBar-colorDefault:first-child,.TableWithTabTitleandTabContainer .MuiTab-textColorPrimary.Mui-selected:first-child{border-radius:4px 0 0 4px}.TableWithTabTitleandTabContainer .MuiAppBar-colorDefault:last-child,.TableWithTabTitleandTabContainer .MuiTab-textColorPrimary.Mui-selected:last-child{border-radius:0 4px 4px 0}.TableWithTabsContainer .MuiTableCell-head{background:#f7f9fa;padding:10px 20px!important}.TableWithTabsContainer .MuiTableCell-head .Tablehead{color:#4c5e67;font-size:12px;font-weight:600;font-family:Poppins,sans-serif;text-transform:uppercase}.TableWithTabsContainer .MuiTableRow-root:hover{background-color:#56b149}.TableWithTabsContainer .MuiTableCell-body{color:#0b132b;font-size:14px;font-weight:400;font-family:Poppins,sans-serif;text-align:left}.TableWithTabsContainer .MuiTableRow-root:hover .MuiTableCell-body{color:#fff}.TableWithTabsContainer .MuiTableRow-root{background:#fff}.TableCellContainer{display:contents}.tableButton{min-width:126px}";
  styleInject(css_248z$z);

  var _excluded = ["children", "value", "index"];

  function TableWithTabs(props) {
    props.title;
        props.subTitle;
        var tableHeadData = props.tableHeadData,
        tableBodyData = props.tableBodyData;
        props.onSelectClick;
        props.history;
    var StyledTableRow = styles$1.withStyles(function (theme) {
      return {
        root: {
          '&:nth-of-type(even)': {
            backgroundColor: "#FCFCFC"
          }
        }
      };
    })(TableRow__default["default"]);
    var theme = styles$1.useTheme();

    var _React$useState = React__default["default"].useState(0),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        value = _React$useState2[0],
        setValue = _React$useState2[1];

    var handleChange = function handleChange(event, newValue) {
      setValue(newValue);
    };

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TableWithTabsContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TableWithTabTitleandTabContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TableWithTabsTableTitle"
    }, "Ramadan 2021"), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TableWithTabsTabContainer"
    }, /*#__PURE__*/React__default["default"].createElement(AppBar__default["default"], {
      position: "static",
      color: "default"
    }, /*#__PURE__*/React__default["default"].createElement(Tabs__default["default"], {
      value: value,
      onChange: handleChange,
      indicatorColor: "primary",
      textColor: "primary",
      variant: "fullWidth",
      "aria-label": "full width tabs example"
    }, /*#__PURE__*/React__default["default"].createElement(Tab__default["default"], _extends({
      label: "FIRST 10 DAYS"
    }, a11yProps(0))), /*#__PURE__*/React__default["default"].createElement(Tab__default["default"], _extends({
      label: "MID 10 DAYS"
    }, a11yProps(1))), /*#__PURE__*/React__default["default"].createElement(Tab__default["default"], _extends({
      label: "LAST 10 DAYS"
    }, a11yProps(2))))))), /*#__PURE__*/React__default["default"].createElement(TabPanel, {
      value: value,
      index: 0,
      dir: theme.direction
    }, /*#__PURE__*/React__default["default"].createElement(TableContainer__default["default"], {
      component: Paper__default["default"]
    }, /*#__PURE__*/React__default["default"].createElement(Table__default["default"], null, /*#__PURE__*/React__default["default"].createElement(TableHead__default["default"], null, /*#__PURE__*/React__default["default"].createElement(TableRow__default["default"], null, tableHeadData !== null && tableHeadData !== void 0 && tableHeadData.length ? tableHeadData.map(function (el, i) {
      return /*#__PURE__*/React__default["default"].createElement(TableCell__default["default"], null, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "Tablehead",
        style: {
          width: el.width
        }
      }, el.title));
    }) : null)), /*#__PURE__*/React__default["default"].createElement(TableBody__default["default"], null, tableBodyData !== null && tableBodyData !== void 0 && tableBodyData.length ? tableBodyData.map(function (el, i) {
      return /*#__PURE__*/React__default["default"].createElement(StyledTableRow, {
        key: i
      }, /*#__PURE__*/React__default["default"].createElement(TableRwo, {
        rows: el.rows
      }), /*#__PURE__*/React__default["default"].createElement(TableButton, {
        buttons: el.buttons,
        buttonStatus: props.buttonStatus
      }));
    }) : null)))), /*#__PURE__*/React__default["default"].createElement(TabPanel, {
      value: value,
      index: 1,
      dir: theme.direction
    }, "Item Two"), /*#__PURE__*/React__default["default"].createElement(TabPanel, {
      value: value,
      index: 2,
      dir: theme.direction
    }, "Item Three"));
  }

  function TabPanel(props) {
    var children = props.children,
        value = props.value,
        index = props.index,
        other = _objectWithoutProperties(props, _excluded);

    return /*#__PURE__*/React__default["default"].createElement("div", _extends({
      role: "tabpanel",
      hidden: value !== index,
      id: "full-width-tabpanel-".concat(index),
      "aria-labelledby": "full-width-tab-".concat(index)
    }, other), value === index && /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], null, children)));
  }

  TabPanel.propTypes = {
    children: PropTypes__default["default"].node,
    index: PropTypes__default["default"].any.isRequired,
    value: PropTypes__default["default"].any.isRequired
  };

  function a11yProps(index) {
    return {
      id: "full-width-tab-".concat(index),
      'aria-controls': "full-width-tabpanel-".concat(index)
    };
  }

  var css_248z$y = ".SliderTwo{position:relative}.SliderTwo .bannerContentsWrapper{width:100%}.SliderTwo .bannerContentsBG{position:absolute;left:0;bottom:0;width:100%;height:100%;opacity:.4;z-index:1}.SliderTwo .carousel .slide .bannerContents{position:absolute;z-index:99;padding:30px;left:0;bottom:10px}.SliderTwo .bannerContents h1 a{display:block;color:#fff;padding:0;font-size:28px;text-align:left;margin:0;font-weight:600;max-width:650px}.SliderTwo .bannerContents .SldierReadBtn{text-align:left}.SliderTwo .bannerContents .SldierReadBtn a{color:#fff;font-size:14px;text-align:left;font-weight:500;display:inline-block;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;position:relative;z-index:999;margin:20px 0 0;text-transform:uppercase;padding:10px 26px 13px}.SliderTwo .bannerContents .SldierReadBtn a svg{color:#fff;font-size:19px;position:relative;left:5px;top:4px}.SliderTwo .control-dots{display:none}.SliderTwo .carousel .control-next.control-arrow{right:100px!important}.SliderTwo .carousel .control-next.control-arrow,.SliderTwo .carousel .control-prev.control-arrow{color:#fff;font-size:26px;margin-top:0;padding:5px;width:34px;height:34px;bottom:50px;position:absolute;opacity:1;background:transparent!important;left:auto;top:auto}.SliderTwo .carousel .control-prev.control-arrow{right:50px!important}.SliderTwo .control-prev:before{background:#005aff url(arrow-next.svg);background-size:70%;background-repeat:no-repeat;background-position:5px 5px}.SliderTwo .control-next:before,.SliderTwo .control-prev:before{width:34px;height:34px;padding:0!important;margin:0!important;border:none!important;border-radius:100%}.SliderTwo .control-next:before{background:#005aff url(arrow-prev.svg);background-size:70%;background-repeat:no-repeat;background-position:5px 5px}.carousel .carousel-status{display:none}@media (max-width:768px){.SliderTwo .bannerContentsWrapper{position:relative}.SliderTwo .bannerContentsBG{opacity:1}.SliderTwo .bannerContents h1{font-size:20px}}";
  styleInject(css_248z$y);

  function SliderTwo(props) {
    var bannerData = props.bannerData;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SliderTwo"
    }, /*#__PURE__*/React__default["default"].createElement(reactResponsiveCarousel.Carousel, {
      autoPlay: true,
      emulateTouch: true,
      infiniteLoop: true,
      interval: 8000,
      transitionTime: 1000,
      swipeable: true,
      showThumbs: false,
      thumbWidth: 146,
      swipeScrollTolerance: 100
    }, bannerData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("img", {
        src: item.img
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "bannerContentsWrapper"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "bannerContentsContainer"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "bannerContentsBG",
        style: {
          background: props.background
        }
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "bannerContents"
      }, /*#__PURE__*/React__default["default"].createElement("h1", null, " ", /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        href: item.link,
        target: item.target
      }, item.title)), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "SldierReadBtn"
      }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        href: item.link,
        target: item.target,
        style: {
          background: props.Buttonbackground,
          borderRadius: props.ButtonRadius
        }
      }, item.readmore, /*#__PURE__*/React__default["default"].createElement(ArrowForwardRoundedIcon__default["default"], null)))))));
    }))) // https://www.npmjs.com/package/react-responsive-carousel
    ;
  }

  var css_248z$x = ".SliderThree .carousel .thumbs-wrapper{margin:0!important;overflow:hidden}.SliderThree .carousel .thumbs{padding:0;margin:0}.SliderThree .carousel .thumbs li{padding:0;margin:0;height:80px!important;border:0;position:relative}.SliderThree .carousel .thumbs li:after{content:\"\";position:absolute;background:#000;opacity:.5;width:100%;height:100%;left:0;top:0}.SliderThree .thumb.selected:after{content:\"\";display:none}.SliderThree .bannerContentsWrapper{position:absolute;width:100%;left:0;bottom:0}.SliderThree .bannerContentsContainer{position:relative;padding:30px}.SliderThree .bannerContentsBG{position:absolute;left:0;bottom:0;width:100%;height:100%;opacity:.8}.SliderThree .carousel .slide .bannerContents{position:relative}.SliderThree .bannerContents h1{color:#fff;padding:0;font-size:28px;text-align:left;margin:0;font-weight:600}.SliderThree .bannerContents a{color:#fff;padding:0;font-size:14px;text-align:left;font-weight:500;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;position:relative;z-index:999;margin:20px 0 0;text-transform:uppercase}.SliderThree .bannerContents a svg{color:#fff;font-size:17px;position:relative;left:5px}.SliderThree .control-dots{display:none}@media (max-width:768px){.SliderThree .bannerContentsWrapper{position:relative}.SliderThree .bannerContentsBG{opacity:1}.SliderThree .bannerContents h1{font-size:20px}.SliderThree .carousel.carousel-slider .control-arrow{top:0;color:#fff;font-size:26px;bottom:0;margin-top:0;padding:5px;display:none}}";
  styleInject(css_248z$x);

  function SliderThree(props) {
    var bannerData = props.bannerData;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SliderThree"
    }, /*#__PURE__*/React__default["default"].createElement(reactResponsiveCarousel.Carousel, {
      autoPlay: true,
      emulateTouch: true,
      infiniteLoop: true,
      interval: 8000,
      transitionTime: 1000,
      swipeable: true,
      showThumbs: true,
      thumbWidth: 146,
      swipeScrollTolerance: 100
    }, bannerData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("img", {
        src: item.img
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "bannerContentsWrapper"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "bannerContentsContainer"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "bannerContentsBG",
        style: {
          background: props.background
        }
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "bannerContents"
      }, /*#__PURE__*/React__default["default"].createElement("h1", null, " ", item.title), /*#__PURE__*/React__default["default"].createElement(Link__default["default"], null, item.readmore, " ", /*#__PURE__*/React__default["default"].createElement(ArrowForwardIosRoundedIcon__default["default"], null))))));
    }))) // https://www.npmjs.com/package/react-responsive-carousel
    ;
  }

  var css_248z$w = ".SliderFour{position:relative}.SliderFour .carousel .thumbs-wrapper{margin:0!important;overflow:hidden}.SliderFour .bannerContentsWrapper{width:100%}.SliderFour .bannerContentsBG{position:absolute;left:0;bottom:0;width:100%;height:100%;opacity:.4;z-index:1}.SliderFour .carousel .slide .bannerContents{position:absolute;z-index:99;padding:30px;left:0;bottom:60px}.SliderFour .bannerContents h1 a{display:block;color:#fff;padding:0;font-size:28px;text-align:left;margin:0;font-weight:600;max-width:650px}.SliderFour .bannerContents .SldierReadBtn{text-align:left}.SliderFour .bannerContents .SldierReadBtn a{color:#fff;font-size:14px;text-align:left;font-weight:500;display:inline-block;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;position:relative;z-index:999;margin:20px 0 0;text-transform:uppercase;padding:10px 26px 13px}.SliderFour .bannerContents .SldierReadBtn a svg{color:#fff;font-size:19px;position:relative;left:5px;top:4px}.SliderFour .control-dots{display:none}.SliderFour .carousel .control-next.control-arrow{right:90px!important}.SliderFour .carousel .control-next.control-arrow,.SliderFour .carousel .control-prev.control-arrow{color:#fff;font-size:26px;margin-top:0;padding:5px;width:34px;height:34px;bottom:10px;position:absolute;opacity:1;background:transparent!important;left:auto;top:auto}.SliderFour .carousel .control-prev.control-arrow{right:50px!important}.SliderFour .control-prev:before{background:#a0ce4e url(arrow-next.svg);background-size:70%;background-repeat:no-repeat;background-position:5px 5px}.SliderFour .control-next:before,.SliderFour .control-prev:before{width:34px;height:34px;padding:0!important;margin:0!important;border:none!important;border-radius:0}.SliderFour .control-next:before{background:#a0ce4e url(arrow-prev.svg);background-size:70%;background-repeat:no-repeat;background-position:5px 5px}.carousel .carousel-status{display:none}.SliderFour .BottomTextSlider{position:absolute;bottom:0;background:#000;width:100%;left:0;min-height:44px;color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-indent:30px;font-size:17px}.SliderFour .carousel .slide img{width:100%;-o-object-fit:cover;object-fit:cover}@media (max-width:768px){.SliderFour .bannerContentsWrapper{position:relative}.SliderFour .bannerContentsBG{opacity:1}.SliderFour .bannerContents h1{font-size:20px}}";
  styleInject(css_248z$w);

  function SliderFour(props) {
    var bannerData = props.bannerData;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SliderFour"
    }, /*#__PURE__*/React__default["default"].createElement(reactResponsiveCarousel.Carousel, {
      autoPlay: true,
      emulateTouch: true,
      infiniteLoop: true,
      interval: 8000,
      transitionTime: 1000,
      swipeable: true,
      showThumbs: false,
      thumbWidth: 146,
      swipeScrollTolerance: 100
    }, bannerData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("img", {
        src: item.img,
        style: {
          height: props.SliderHieght
        }
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "bannerContentsWrapper"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "bannerContentsContainer"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "bannerContentsBG",
        style: {
          background: props.background
        }
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "bannerContents"
      }, /*#__PURE__*/React__default["default"].createElement("h1", null, " ", /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        href: item.link,
        target: item.target
      }, item.title)), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "SldierReadBtn"
      }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        href: item.link,
        target: item.target,
        style: {
          background: props.Buttonbackground,
          borderRadius: props.ButtonRadius
        }
      }, item.readmore))))));
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "BottomTextSlider"
    }, props.BottomText)) // https://www.npmjs.com/package/react-responsive-carousel
    ;
  }

  var css_248z$v = ".SliderFive{position:relative}.SliderFive .carousel .thumbs-wrapper{margin:0!important;overflow:hidden}.SliderFive .bannerContentsWrapper{width:100%}.SliderFive .bannerContentsBG{position:absolute;left:0;bottom:0;width:100%;height:100%;opacity:.4;z-index:1}.SliderFive .carousel .slide .bannerContents{position:absolute;z-index:99;padding:30px;left:0;bottom:30px}.SliderFive .bannerContents h1 a{display:block;color:#fff;padding:0;font-size:28px;text-align:left;margin:0;font-weight:600;max-width:650px}.SliderFive .bannerContents .SldierReadBtn{text-align:left}.SliderFive .bannerContents .SldierReadBtn a{color:#fff;font-size:14px;text-align:left;font-weight:500;display:inline-block;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;position:relative;z-index:999;margin:20px 0 0;text-transform:uppercase;padding:10px 26px 13px}.SliderFive .bannerContents .SldierReadBtn a svg{color:#fff;font-size:19px;position:relative;left:5px;top:4px}.SliderFive .control-dots{display:none}.SliderFive .carousel .control-next.control-arrow{right:90px!important}.SliderFive .carousel .control-next.control-arrow,.SliderFive .carousel .control-prev.control-arrow{color:#fff;font-size:26px;margin-top:0;padding:5px;width:34px;height:34px;bottom:60px;position:absolute;opacity:1;background:transparent!important;left:auto;top:auto}.SliderFive .carousel .control-prev.control-arrow{right:50px!important}.SliderFive .control-prev:before{background:#56b149 url(arrow-next.svg);background-size:70%;background-repeat:no-repeat;background-position:5px 5px}.SliderFive .control-next:before,.SliderFive .control-prev:before{width:34px;height:34px;padding:0!important;margin:0!important;border:none!important;border-radius:0}.SliderFive .control-next:before{background:#56b149 url(arrow-prev.svg);background-size:70%;background-repeat:no-repeat;background-position:5px 5px}.carousel .carousel-status{display:none}.SliderFive .BottomTextSlider{position:absolute;bottom:0;background:#000;width:100%;left:0;min-height:44px;color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-indent:30px;font-size:17px}.SliderFive .carousel .slide img{width:100%;-o-object-fit:cover;object-fit:cover}@media (max-width:768px){.SliderFive .bannerContentsWrapper{position:relative}.SliderFive .bannerContentsBG{opacity:1}.SliderFive .bannerContents h1{font-size:20px}}";
  styleInject(css_248z$v);

  function SliderFive(props) {
    var bannerData = props.bannerData;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SliderFive"
    }, /*#__PURE__*/React__default["default"].createElement(reactResponsiveCarousel.Carousel, {
      autoPlay: true,
      emulateTouch: true,
      infiniteLoop: true,
      interval: 8000,
      transitionTime: 1000,
      swipeable: true,
      showThumbs: false,
      thumbWidth: 146,
      swipeScrollTolerance: 100
    }, bannerData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("img", {
        src: item.img,
        style: {
          height: props.SliderHieght
        }
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "bannerContentsWrapper"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "bannerContentsContainer"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "bannerContentsBG",
        style: {
          background: props.background
        }
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "bannerContents"
      }, /*#__PURE__*/React__default["default"].createElement("h1", null, " ", /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        href: item.link,
        target: item.target
      }, item.title)), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "SldierReadBtn"
      }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        href: item.link,
        target: item.target,
        style: {
          background: props.Buttonbackground,
          borderRadius: props.ButtonRadius
        }
      }, item.readmore, /*#__PURE__*/React__default["default"].createElement(ArrowForwardIosRoundedIcon__default["default"], null)))))));
    }))) // https://www.npmjs.com/package/react-responsive-carousel
    ;
  }

  var css_248z$u = ".SliderSixContainer{display:-webkit-box;display:-ms-flexbox;display:flex;margin-right:8px;position:relative;width:100%}.SliderSixContainer .MainBannerInner{width:100%;height:390px}.SliderSixContainer .BannerText{position:absolute;z-index:999;bottom:50px;left:40px;background:transparent!important}.SliderSixContainer .BannerText .bannerTitle{color:#fff;font-size:40px;font-weight:700;font-family:Poppins,sans-serif}.SliderSixContainer .BannerText .bannerDescrition{color:#fff;font-size:16px;font-weight:400;max-width:600px;font-family:Poppins,sans-serif}.SliderSixContainer .bannerSteps{position:absolute;right:0;bottom:0;background:transparent;padding:0;z-index:12}.SliderSixContainer .bannerSteps .MuiButtonBase-root{color:#fff;background:#56b149;width:34px;height:34px;border-radius:0;margin-left:1px;min-width:34px!important}.SliderSixContainer .BannerImg{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.SliderSixContainer .BannerImgContainer{position:relative;height:390px}.SliderSixContainer .BannerImgContainer:after{content:\"\";position:absolute;width:100%;height:100%;left:0;top:0;background:#000;opacity:.3;z-index:10}.SliderSixContainer .BannerLinkButton{width:152px;height:50px;background:hsla(0,0%,100%,.2) 0 0 no-repeat padding-box!important;border:1px solid #56b149!important;border-radius:4px;opacity:1;margin-top:32px!important;color:#fff!important;font-size:14px;font-weight:500;text-transform:uppercase}.SliderSixContainer .BannerLinkButton:hover{background:#56b149;border:1px solid #56b149}";
  styleInject(css_248z$u);

  var AutoPlaySwipeableViews$2 = reactSwipeableViewsUtils.autoPlay(SwipeableViews__default["default"]);

  function SliderSix(props) {
    var tutorialSteps = props.tutorialSteps;
    var theme = styles$1.useTheme();

    var _React$useState = React__default["default"].useState(0),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        activeStep = _React$useState2[0],
        setActiveStep = _React$useState2[1];

    var maxSteps = tutorialSteps.length;

    var handleNext = function handleNext() {
      setActiveStep(function (prevActiveStep) {
        return prevActiveStep + 1;
      });
    };

    var handleBack = function handleBack() {
      setActiveStep(function (prevActiveStep) {
        return prevActiveStep - 1;
      });
    };

    var handleStepChange = function handleStepChange(step) {
      setActiveStep(step);
    };

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SliderSixContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "MainBannerInner"
    }, /*#__PURE__*/React__default["default"].createElement(Paper__default["default"], {
      square: true,
      elevation: 0,
      className: "BannerText"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "bannerTitle"
    }, tutorialSteps[activeStep].label), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "bannerDescrition"
    }, tutorialSteps[activeStep].Descrition), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      className: "BannerLinkButton",
      variant: "outlined",
      color: "primary",
      href: tutorialSteps[activeStep].Link,
      target: "blank"
    }, props.BannerButton)), /*#__PURE__*/React__default["default"].createElement(AutoPlaySwipeableViews$2, {
      axis: theme.direction === 'rtl' ? 'x-reverse' : 'x',
      index: activeStep,
      onChangeIndex: handleStepChange,
      enableMouseEvents: true
    }, tutorialSteps.map(function (step, index) {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        key: step.label,
        className: "BannerImgContainer"
      }, Math.abs(activeStep - index) <= 2 ? /*#__PURE__*/React__default["default"].createElement("img", {
        className: "BannerImg",
        src: step.imgPath,
        alt: step.label
      }) : null);
    })), /*#__PURE__*/React__default["default"].createElement(MobileStepper__default["default"], {
      className: "bannerSteps",
      steps: maxSteps,
      position: "static",
      variant: "none",
      activeStep: activeStep,
      nextButton: /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
        size: "small",
        onClick: handleNext,
        disabled: activeStep === maxSteps - 1
      }, theme.direction === 'rtl' ? /*#__PURE__*/React__default["default"].createElement(KeyboardArrowLeft__default["default"], null) : /*#__PURE__*/React__default["default"].createElement(KeyboardArrowRight__default["default"], null)),
      backButton: /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
        size: "small",
        onClick: handleBack,
        disabled: activeStep === 0
      }, theme.direction === 'rtl' ? /*#__PURE__*/React__default["default"].createElement(KeyboardArrowRight__default["default"], null) : /*#__PURE__*/React__default["default"].createElement(KeyboardArrowLeft__default["default"], null))
    })));
  }

  var css_248z$t = ".SliderSeven{display:-webkit-box;display:-ms-flexbox;display:flex;margin-right:8px;position:relative;width:100%}.SliderSeven .MainBannerInner{width:100%;height:100%}.SliderSeven .BannerText{position:absolute;z-index:999;right:0;padding:40px;top:0;bottom:0;width:45%}.SliderSeven .BannerText h3{font-size:16px;font-weight:700;font-family:Poppins,sans-serif;margin:0}.SliderSeven .BannerText h2{color:#fff;font-size:34px;font-weight:700;font-family:Poppins,sans-serif}.SliderSeven .BannerText .bannerDescrition{color:#fff;font-size:20px;font-weight:400;max-width:600px;font-family:Poppins,sans-serif}.SliderSeven .bannerSteps{position:relative;right:0;bottom:0;background:transparent;padding:0;z-index:12;width:100px;margin:0 auto}.SliderSeven .bannerSteps .MuiButtonBase-root{width:34px;height:34px;min-width:34px!important;border:1px solid #fff}.SliderSeven .BannerImg{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.SliderSeven .BannerImgContainer{position:relative}.SliderSeven .BannerImgContainer:after{content:\"\";position:absolute;width:100%;height:100%;left:0;top:0;background:#000;opacity:.3;z-index:10}.SliderSeven .BannerLinkButton{width:152px;height:50px;background:hsla(0,0%,100%,.2) 0 0 no-repeat padding-box!important;border:1px solid #56b149!important;border-radius:4px;opacity:1;margin-top:32px!important;color:#fff!important;font-size:14px;font-weight:500;text-transform:uppercase}.SliderSeven .BannerLinkButton:hover{background:#56b149;border:1px solid #56b149}.SliderArrobody{position:absolute;height:46px;width:100%;bottom:0;text-align:center;left:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.SliderArrobody,.SliderArrobody span{display:-webkit-box;display:-ms-flexbox;display:flex}.react-swipeable-view-container div:first-child{overflow:hidden}@media (max-width:768px){.SliderSeven .BannerText{position:absolute;z-index:999;right:0;padding:16px;top:auto;bottom:0;width:93%;height:200px}.SliderSeven .BannerText h2{font-size:14px}.SliderSeven .BannerText .bannerDescrition{font-size:13px}}";
  styleInject(css_248z$t);

  var AutoPlaySwipeableViews$1 = reactSwipeableViewsUtils.autoPlay(SwipeableViews__default["default"]);

  function SliderSeven(props) {
    var tutorialSteps = props.tutorialSteps;
    var theme = styles$1.useTheme();

    var _React$useState = React__default["default"].useState(0),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        activeStep = _React$useState2[0],
        setActiveStep = _React$useState2[1];

    var maxSteps = tutorialSteps.length;

    var handleNext = function handleNext() {
      setActiveStep(function (prevActiveStep) {
        return prevActiveStep + 1;
      });
    };

    var handleBack = function handleBack() {
      setActiveStep(function (prevActiveStep) {
        return prevActiveStep - 1;
      });
    };

    var handleStepChange = function handleStepChange(step) {
      setActiveStep(step);
    };

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SliderSeven"
    }, /*#__PURE__*/React__default["default"].createElement(AutoPlaySwipeableViews$1, {
      axis: theme.direction === 'rtl' ? 'x-reverse' : 'x',
      index: activeStep,
      onChangeIndex: handleStepChange,
      enableMouseEvents: true
    }, tutorialSteps.map(function (step, index) {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        key: step.label,
        className: "BannerImgContainer",
        style: {
          height: props.SliderHieght
        }
      }, Math.abs(activeStep - index) <= 2 ? /*#__PURE__*/React__default["default"].createElement("div", {
        className: "MainBannerInner"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        className: "BannerImg",
        src: step.imgPath,
        alt: step.label
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "BannerText",
        style: {
          background: props.Contentbackground
        }
      }, /*#__PURE__*/React__default["default"].createElement("h3", {
        style: {
          color: props.subtitleColor
        }
      }, step.subtitle), /*#__PURE__*/React__default["default"].createElement("h2", null, step.title), /*#__PURE__*/React__default["default"].createElement("p", {
        className: "bannerDescrition"
      }, step.discription), step.Buttonstatus && /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
        label: step.buttonlabel,
        link: step.link,
        target: step.target,
        path: props.path,
        arrowIcon: props.arrowIcon,
        arrowStatus: props.arrowStatus,
        arrowColor: props.ButtonarrowColor,
        buttoncolor: props.buttoncolor,
        width: props.width,
        height: props.height,
        border: props.border,
        borderRadius: props.borderRadius,
        color: props.color,
        textAlign: props.textAlign
      }))) : null);
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SliderArrobody",
      style: {
        background: props.ArrowContainerBg
      }
    }, /*#__PURE__*/React__default["default"].createElement(MobileStepper__default["default"], {
      className: "bannerSteps",
      steps: maxSteps,
      position: "static",
      variant: "none",
      activeStep: activeStep,
      nextButton: /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
        className: "arrownext arrow",
        style: {
          background: props.arrowBgColor,
          borderRadius: props.borderRadius
        },
        onClick: handleNext,
        disabled: activeStep === maxSteps - 1
      }, theme.direction === 'rtl' ? /*#__PURE__*/React__default["default"].createElement("span", {
        style: {
          color: props.arrowColor
        }
      }, props.leftArrowIcon) : /*#__PURE__*/React__default["default"].createElement("span", {
        style: {
          color: props.arrowColor
        }
      }, props.RightArrowIcon)),
      backButton: /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
        className: "arrowback arrow",
        style: {
          background: props.arrowBgColor,
          borderRadius: props.borderRadius
        },
        onClick: handleBack,
        disabled: activeStep === 0
      }, theme.direction === 'rtl' ? /*#__PURE__*/React__default["default"].createElement("span", {
        style: {
          color: props.arrowColor
        }
      }, props.RightArrowIcon) : /*#__PURE__*/React__default["default"].createElement("span", {
        style: {
          color: props.arrowColor
        }
      }, props.leftArrowIcon))
    })));
  }

  function CarouselOne(props) {
    var breakPoints = [{
      width: 1,
      itemsToShow: 1
    }, {
      width: 550,
      itemsToShow: 2
    }, {
      width: 768,
      itemsToShow: props.mobileview
    }, {
      width: 1200,
      itemsToShow: props.desktopview
    }];
    var carouseldata = props.carouseldata;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CarouselContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CarouselTitle"
    }, props.title), /*#__PURE__*/React__default["default"].createElement(Carousel__default["default"], {
      breakPoints: breakPoints
    }, carouseldata.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CarouselContainerItem"
      }, item.sliderItem);
    }))));
  }

  var css_248z$s = ".CardThreeMainContainer{width:243px;height:464px;background:#fff 0 0 no-repeat padding-box;border:1px solid #e4e8ec;opacity:1;cursor:pointer;padding:6px;display:inline-block}.CardThreeMainContainer:hover{-webkit-box-shadow:0 12px 17px rgba(0,0,0,.0902);box-shadow:0 12px 17px rgba(0,0,0,.0902);-webkit-transition:all 1s ease 0s;transition:all 1s ease 0s}.CardThreeImageContainer{height:314px;background:#627fff 0 0 no-repeat padding-box;opacity:1;overflow:hidden;position:relative}.CardThreeDateTime{width:223px;height:44px;background:#a0ce4e 0 0 no-repeat padding-box;color:#fff;opacity:1;padding:10px;border:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:left;-ms-flex-pack:left;justify-content:left;position:absolute;bottom:10px;left:10px;right:10px}.CardThreeEventText{letter-spacing:1px;font:normal normal normal 14px/30px Poppins;margin-left:10px}.CardThreeInfoContainer{height:120px;background:transparent none repeat scroll 0 0;padding:10px}.CardThreeHeading{margin:0;color:#444;font:normal normal 600 20px/24px Poppins}.CardThreeReadMoreText{color:#333;display:-webkit-box;display:-ms-flexbox;display:flex;font:normal normal 700 14px/24px Poppins;margin-right:19px;padding-bottom:8px;text-align:left;width:120px;text-decoration:none;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:18px;color:#444}.CardThreeReadMoreText svg{font:normal normal 700 14px/24px Poppins;margin-left:4px}.CardThreeMainContainer:hover .CardThreeReadMoreText{color:#a0ce4e;-webkit-transition:all 1s ease 0s;transition:all 1s ease 0s}";
  styleInject(css_248z$s);

  const img = require('./EventPattern.png');

  function CardThree(props) {
    var cardData = props.cardData,
        buttonLabel = props.buttonLabel,
        color = props.color;
    return /*#__PURE__*/React__default["default"].createElement("a", {
      href: cardData.link
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardThreeMainContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardThreeImageContainer",
      style: {
        backgroundImage: !cardData.img || cardData.img === "" ? "url('".concat(img, "')") : "url('".concat(cardData.img, "')")
      }
    }, /*#__PURE__*/React__default["default"].createElement("button", {
      className: "CardThreeDateTime",
      style: {
        backgroundColor: color
      }
    }, /*#__PURE__*/React__default["default"].createElement(DateRangeRoundedIcon__default["default"], null), /*#__PURE__*/React__default["default"].createElement("span", {
      className: "CardThreeEventText"
    }, cardData.eventDateTime))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardThreeInfoContainer"
    }, /*#__PURE__*/React__default["default"].createElement("p", {
      className: "CardThreeHeading"
    }, cardData.heading), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardThreeReadMore"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "CardThreeReadMoreText"
    }, buttonLabel, " ", /*#__PURE__*/React__default["default"].createElement(ArrowForwardIosRoundedIcon__default["default"], null), " ")))));
  }

  var css_248z$r = ".CardFourMainContainer{width:730px;height:100%;background:#fff 0 0 no-repeat padding-box;border:1px solid #e4e8ec;opacity:1;cursor:pointer;padding:16px;display:inline-block}.CardFourMainContainer:hover{-webkit-box-shadow:0 12px 17px rgba(0,0,0,.0902);box-shadow:0 12px 17px rgba(0,0,0,.0902);-webkit-transition:all 1s ease 0s;transition:all 1s ease 0s}.CardFourRow{display:-webkit-box;display:-ms-flexbox;display:flex}.CardFourLeftColumn{height:100%;-webkit-box-flex:20%;-ms-flex:20%;flex:20%}.CardFourRightColumn{-webkit-box-flex:80%;-ms-flex:80%;flex:80%;border-left:1px solid #e4e8ec}.CardFourEventDate{text-align:left;font:normal normal 700 20px/24px Poppins;letter-spacing:0;color:#56b149;opacity:1;padding-right:8px;margin:0}.CardFourRightColumnContainer{margin-left:16px}.CardFourTitle{text-align:left;font:normal normal 600 26px/30px Poppins;letter-spacing:0;color:#0b132b;opacity:1;margin:0;padding-bottom:8px}.CardFourMainContainer:hover .CardFourTitle{color:#56b149;-webkit-transition:all 1s ease 0s;transition:all 1s ease 0s}.CardFourEventTime{text-align:left;font:normal normal normal 14px/20px Poppins;letter-spacing:0;color:#676c7b;text-transform:uppercase;opacity:1;margin:0;padding-bottom:12px}.CardFourEventTime span{color:#e4e8ec;opacity:1}.CardFourReadMoreText{color:#333;display:-webkit-box;display:-ms-flexbox;display:flex;font:normal normal 700 14px/24px Poppins;text-align:left;width:120px;text-decoration:none;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#444}.CardFourReadMoreText svg{font:normal normal 700 14px/24px Poppins;margin-left:4px}.CardFourMainContainer:hover .CardFourReadMoreText{color:#56b149;-webkit-transition:all 1s ease 0s;transition:all 1s ease 0s}";
  styleInject(css_248z$r);

  function CardFour(props) {
    var cardData = props.cardData,
        buttonLabel = props.buttonLabel;
        props.color;
    return /*#__PURE__*/React__default["default"].createElement("a", {
      href: cardData.link
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardFourMainContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardFourRow"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardFourLeftColumn"
    }, /*#__PURE__*/React__default["default"].createElement("h1", {
      className: "CardFourEventDate"
    }, cardData.eventDate, " ", /*#__PURE__*/React__default["default"].createElement("br", null), " ", cardData.eventDay)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardFourRightColumn"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardFourRightColumnContainer"
    }, /*#__PURE__*/React__default["default"].createElement("h1", {
      className: "CardFourTitle"
    }, cardData.title), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardFourEventTime"
    }, cardData.eventTime, " ", /*#__PURE__*/React__default["default"].createElement("span", null, "\u25CF"), " ", cardData.eventType), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardFourReadMore"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "CardFourReadMoreText"
    }, buttonLabel, " ", /*#__PURE__*/React__default["default"].createElement(ArrowForwardIosRoundedIcon__default["default"], null), " ")))))));
  }

  var css_248z$q = ".CardFiveMainContainer{width:350px;height:264px;background:#fff 0 0 no-repeat padding-box;border:1px solid #e4e8ec;opacity:1;display:inline-block}.CardFiveMainContainer:hover{-webkit-box-shadow:0 12px 17px rgba(0,0,0,.0902);box-shadow:0 12px 17px rgba(0,0,0,.0902);-webkit-transition:all 1s ease 0s;transition:all 1s ease 0s}.CardFiveTitleContainer{width:auto;background:#635bff url(EventPattern.png) 0 0 padding-box;opacity:1;padding:20px}.CardFiveTitle{text-align:left;font:normal normal 700 20px/28px Poppins;letter-spacing:0;color:#fff;opacity:1;margin:0;padding:0}.CardFiveRow{display:-webkit-box;display:-ms-flexbox;display:flex}.CardFiveLeftColumn{-webkit-box-flex:45%;-ms-flex:45%;flex:45%;background:#a4a7b0 0 0 no-repeat padding-box;opacity:1}.CardFiveRightColumn{-webkit-box-flex:55%;-ms-flex:55%;flex:55%;padding:16px}.CardFourEventDate{text-align:left;font:normal normal 700 20px/24px Poppins;letter-spacing:0;color:#56b149;opacity:1;padding-right:8px;margin:0}.CardFiveEventDate{margin:0 0 16px;text-decoration:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.CardFiveEventDate,.CardFiveEventDate svg{text-align:left;font:normal normal normal 14px/20px Poppins;letter-spacing:0;color:#0a2540;opacity:1}.CardFiveEventDate svg{margin-right:8px}.CardFiveEventTime{margin:0 0 52px;text-decoration:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.CardFiveEventTime,.CardFiveEventTime svg{text-align:left;font:normal normal normal 14px/20px Poppins;letter-spacing:0;color:#0a2540;opacity:1}.CardFiveEventTime svg{margin-right:8px}.CardFiveViewDetails{text-align:left;font:normal normal 600 14px/24px Poppins;letter-spacing:.56px;color:#676c7b;text-transform:capitalize;opacity:1;margin:0 0 8px;text-decoration:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.CardFiveMainContainer:hover .CardFiveViewDetails{color:#635bff;-webkit-transition:all 1s ease 0s;transition:all 1s ease 0s}.CardFiveViewDetails svg{text-align:left;font:normal normal 700 14px/24px Poppins;letter-spacing:.56px;color:#676c7b;opacity:1;margin-left:8px}.CardFiveMainContainer:hover .CardFiveViewDetails svg{color:#635bff;-webkit-transition:all 1s ease 0s;transition:all 1s ease 0s}";
  styleInject(css_248z$q);

  function CardFive(props) {
    var cardData = props.cardData,
        buttonLabel = props.buttonLabel;
        props.color;
    return /*#__PURE__*/React__default["default"].createElement("a", {
      href: cardData.link
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardFiveMainContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardFiveTitleContainer"
    }, /*#__PURE__*/React__default["default"].createElement("h1", {
      className: "CardFiveTitle"
    }, cardData.title)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardFiveRow"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardFiveLeftColumn",
      style: !cardData.image || cardData.image === "" ? {
        display: "none"
      } : {
        backgroundImage: "url('".concat(cardData.image, "')")
      }
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardFiveRightColumn"
    }, /*#__PURE__*/React__default["default"].createElement("h1", {
      className: "CardFiveEventDate"
    }, /*#__PURE__*/React__default["default"].createElement(CalendarIcon__default["default"], null), cardData.eventDate), /*#__PURE__*/React__default["default"].createElement("h1", {
      className: "CardFiveEventTime"
    }, /*#__PURE__*/React__default["default"].createElement(ClockIcon__default["default"], null), cardData.eventTime), /*#__PURE__*/React__default["default"].createElement("h1", {
      className: "CardFiveViewDetails"
    }, buttonLabel, /*#__PURE__*/React__default["default"].createElement(ArrowForwardIcon__default["default"], null))))));
  }

  var css_248z$p = ".CardSixMainContainer{width:100%;height:315px;opacity:1;display:inline-block;cursor:pointer}.CardSixImageContainer{height:144px;background:#635bff 0 0 no-repeat padding-box;position:relative;overflow:hidden}.CardSixImageContainer .CardSixEventImage{-o-object-fit:cover;object-fit:cover;width:100%;height:100%}.CardSixGradientContainer{height:48px;background:transparent -webkit-gradient(linear,left top,left bottom,from(transparent),to(#000)) 0 0 no-repeat padding-box;background:transparent linear-gradient(180deg,transparent,#000) 0 0 no-repeat padding-box;opacity:1;position:absolute;bottom:0;left:0;right:0}.CardSixEventDateTime{font:normal normal 500 14px/24px Poppins;color:#ff6200;text-transform:uppercase;margin:12px 0 8px}.CardSixEventDateTime,.CardSixTitle{text-align:left;letter-spacing:0;opacity:1}.CardSixTitle{font:normal normal 700 16px/24px Poppins;color:#0b132b;margin:0 0 8px}.CardSixMainContainer:hover .CardSixTitle{color:#635bff;text-decoration:underline;-webkit-transition:all 1s ease 0s;transition:all 1s ease 0s}.CardSixEventStatus{font:normal normal 500 14px/24px Poppins;letter-spacing:0;color:#676c7b;margin:0 0 12px}.CardSixEventDetails,.CardSixEventStatus{text-align:left;text-transform:capitalize;opacity:1}.CardSixEventDetails{font:normal normal 600 14px/24px Poppins;letter-spacing:.56px;margin:0 0 8px;text-decoration:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.CardSixEventDetails svg{text-align:left;font:normal normal 700 14px/24px Poppins;letter-spacing:.56px;opacity:1;margin-left:8px}";
  styleInject(css_248z$p);

  require('./EventPattern.png');

  function CardSix(props) {
    return /*#__PURE__*/React__default["default"].createElement("a", {
      href: props.link
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardSixMainContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardSixImageContainer"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      className: "CardSixEventImage",
      src: props.img
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardSixGradientContainer"
    })), /*#__PURE__*/React__default["default"].createElement("h1", {
      className: "CardSixEventDateTime"
    }, props.DateTime), /*#__PURE__*/React__default["default"].createElement("h1", {
      className: "CardSixTitle"
    }, props.title), /*#__PURE__*/React__default["default"].createElement("h1", {
      className: "CardSixEventStatus"
    }, props.eventStatus), /*#__PURE__*/React__default["default"].createElement("h1", {
      className: "CardSixEventDetails",
      style: {
        color: props.btnColor
      }
    }, props.buttonLabel, /*#__PURE__*/React__default["default"].createElement(ArrowForwardIcon__default["default"], null))));
  }

  var css_248z$o = ".CardEight .UcomingEvents_col{border:1px solid #e4e8ec;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex}.CardEight .UcomingEvents_col .events_img{position:relative}.CardEight .UcomingEvents_col .events_img img{-o-object-fit:cover;object-fit:cover;width:100%;height:100%}.CardEight .UcomingEvents_col .events_details{padding:24px}.CardEight .UcomingEvents_col .events_details h2{font-size:24px;font-weight:700;line-height:28px;color:#0b132b;margin:0 0 24px}.CardEight .UcomingEvents_col .events_details .eventLocation{font-size:16px;font-weight:400;line-height:24px;color:#676c7b;display:-webkit-box;display:-ms-flexbox;display:flex;margin:0 0 17px}.CardEight .UcomingEvents_col .events_details .eventLocation svg{margin-right:10px;font-size:20px;color:#676c7b}.CardEight .UcomingEvents_col .event_detail_pop{width:100%;position:absolute;top:0;height:100%;z-index:999;opacity:0}.CardEight .UcomingEvents_col:hover .event_detail_pop{opacity:1}.CardEight .UcomingEvents_col .event_detail_pop .blue_bg{background:#0053a5;width:100%;height:100%;position:absolute;top:0;opacity:.92;left:0;z-index:99}.CardEight .UcomingEvents_col .event_detail_pop a{background:#fff;border-radius:2px;color:#0b132b;display:-webkit-box;display:-ms-flexbox;display:flex;left:37%;letter-spacing:.56px;position:relative;text-align:center;text-transform:uppercase;top:43%;z-index:999;font-size:14px;font-weight:700;text-decoration:none;height:50px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;max-width:196px}.CardEight .UcomingEvents_col .events_img .EventcardSocialIcon{position:absolute;bottom:5px;right:13px}.CardEight .UcomingEvents_col .events_img .EventcardSocialIcon a img{width:34px;margin-left:10px}@media (max-width:768px){.CardEight .UcomingEvents_col{display:block}.eventmainIme{max-width:none!important;min-width:0!important;width:100%}}";
  styleInject(css_248z$o);

  function CardEight(props) {
    var eventCardOneData = props.eventCardOneData;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardEight MainSection"
    }, /*#__PURE__*/React__default["default"].createElement(Container__default["default"], {
      maxWidth: "lg"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 3
    }, eventCardOneData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        item: true,
        md: props.col,
        xs: 12
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "UcomingEvents_col"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "events_img"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        className: "eventmainIme",
        src: item.img,
        alt: "",
        style: {
          minWidth: props.ImgWidth,
          maxWidth: props.ImgWidth
        }
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "EventcardSocialIcon"
      }, props.SocialIcon)), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "events_details"
      }, /*#__PURE__*/React__default["default"].createElement("h2", null, item.title), props.DateRangeStatus && /*#__PURE__*/React__default["default"].createElement("div", {
        className: "eventLocation"
      }, /*#__PURE__*/React__default["default"].createElement(DateRangeIcon__default["default"], null), " ", item.date), props.LocationStatus && /*#__PURE__*/React__default["default"].createElement("div", {
        className: "eventLocation"
      }, /*#__PURE__*/React__default["default"].createElement(LocationOnIcon__default["default"], null), " ", item.location), props.MoneyStatus && /*#__PURE__*/React__default["default"].createElement("div", {
        className: "eventLocation"
      }, /*#__PURE__*/React__default["default"].createElement(AttachMoneyRoundedIcon__default["default"], null), " ", item.amount), props.FoodStatus && /*#__PURE__*/React__default["default"].createElement("div", {
        className: "eventLocation"
      }, /*#__PURE__*/React__default["default"].createElement(FastfoodRoundedIcon__default["default"], null), " ", item.food), props.JoinStatus && /*#__PURE__*/React__default["default"].createElement("div", {
        className: "eventLocation"
      }, /*#__PURE__*/React__default["default"].createElement(GroupRoundedIcon__default["default"], null), " ", item.join), props.groupStatus && /*#__PURE__*/React__default["default"].createElement(AvatarGroup__default["default"], {
        max: 4
      }, /*#__PURE__*/React__default["default"].createElement(Avatar__default["default"], {
        alt: "Remy Sharp",
        src: "/static/images/avatar/1.jpg"
      }), /*#__PURE__*/React__default["default"].createElement(Avatar__default["default"], {
        alt: "Travis Howard",
        src: "/static/images/avatar/2.jpg"
      }), /*#__PURE__*/React__default["default"].createElement(Avatar__default["default"], {
        alt: "Cindy Baker",
        src: "/static/images/avatar/3.jpg"
      }), /*#__PURE__*/React__default["default"].createElement(Avatar__default["default"], {
        alt: "Agnes Walker",
        src: "/static/images/avatar/4.jpg"
      }))), props.viewdetailStatus && /*#__PURE__*/React__default["default"].createElement("div", {
        className: "event_detail_pop"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "blue_bg"
      }), /*#__PURE__*/React__default["default"].createElement("a", {
        href: item.link
      }, props.buttonLabel))));
    }))));
  }

  var css_248z$n = ".CardNine{border:1px solid #e4e8ec;display:-webkit-box;display:-ms-flexbox;display:flex;min-height:245px;max-height:245px}.CardNine:hover{text-decoration:none!important}.CardNine .UpcomingEventImg{width:190px;background-color:#e4e8ec}.CardNine .UpcomingEventContents{padding:20px;width:57%;position:relative}.CardNine .UpcomingEventContents .EventCardTitle{font-size:20px;font-weight:700;color:#0b132b;margin:0}.CardNine .UpcomingEventImg img{width:100%;-o-object-fit:cover;object-fit:cover;height:100%}.CardNine .GreenText{color:#56b149!important}.CardNine .UpcomingEventContents .EventCardSubTitle{font-size:24px;font-weight:700;color:#0b132b;margin-top:20px}.CardNine .UpcomingEventContents .EventCardSubText{font-size:14px;font-weight:400;color:#676c7b;margin-top:10px}.CardNine .UpcomingEventCardContainer,.CardNine .UpcomingEventCardContainer h1,.CardNine .UpcomingEventCardContainer p,.CardNine .UpcomingEventCardContainer span{text-decoration:none!important}@media(max-width:600px){.CardNine{display:block;min-height:0;max-height:none}.CardNine .UpcomingEventImg{width:100%}.CardNine .UpcomingEventContents .EventCardSubText{margin-bottom:21px}}";
  styleInject(css_248z$n);

  function CardNine(props) {
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      href: props.link,
      className: "CardNine",
      target: "blank"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "UpcomingEventImg"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.image,
      alt: "eventImg"
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "UpcomingEventContents"
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "EventCardTitle GreenText",
      variant: "h1",
      component: "h1",
      gutterBottom: true
    }, props.time), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "EventCardSubTitle",
      variant: "h1",
      component: "h1",
      gutterBottom: true
    }, props.title), /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "EventCardSubText"
    }, props.subTitle), /*#__PURE__*/React__default["default"].createElement("span", {
      className: "CardReadmore"
    }, props.buttonText, " ", /*#__PURE__*/React__default["default"].createElement(ArrowForwardIosRoundedIcon__default["default"], null), " "))));
  }

  var css_248z$m = ".CardEleven .CardElevenInfoContainer{text-decoration:none!important;cursor:pointer}.CardEleven .CardElevenInfoContainer .CardElevenavatar{height:172px;overflow:hidden;position:relative}.CardEleven .CardElevenInfoContainer .CardElevenavatar img{width:100%;-o-object-fit:cover;object-fit:cover;position:absolute;height:100%}.CardEleven .CardElevenInfoContainer .CardElevenhover_over{-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out}.CardEleven .CardElevenInfoContainer .CardOneboxed-grey:hover .CardElevenhover_over{position:absolute;top:0;left:0;width:100%;height:100%;opacity:.73}.CardEleven .CardElevenInfoContainer .CardElevenDetails{padding:20px}.CardEleven .CardElevenInfoContainer .CardElevenDesBox{padding:20px 0 0}.CardEleven .CardElevenInfoContainer .CardElevenDetails h2{font-size:20px;margin:0!important}.CardEleven .CardElevenInfoContainer .CardElevenreadmore{display:-webkit-box;display:-ms-flexbox;display:flex;font-size:14px;text-align:left;font-weight:600;text-decoration:none;margin:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.CardEleven:hover .CardElevenInfoContainer .CardElevenreadmore{color:#635bff!important}.CardEleven .CardElevenInfoContainer .CardElevenreadmore svg{font-size:15px!important;margin-left:4px}.CardEleven .CardElevenInfoContainer .CardElevenboxed-grey:hover{-webkit-box-shadow:-1px 9px 23px -7px rgba(0,0,0,.45);box-shadow:-1px 9px 23px -7px rgba(0,0,0,.45);-webkit-transition:all 1s ease 0s;transition:all 1s ease 0s}.CardEleven .bottomLine{height:4px}.border{border:1px solid #e4e8ec}.CardEleven:hover .underline{text-decoration:underline}";
  styleInject(css_248z$m);

  function CardEleven(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardEleven"
    }, /*#__PURE__*/React__default["default"].createElement("a", {
      href: props.link,
      className: "CardElevenInfoContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardElevenboxed-grey"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: props.border
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardElevenInner",
      style: {
        padding: props.ImgSpace
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardElevenavatar"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.img,
      alt: ""
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardElevenhover_over"
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardElevenDetails",
      style: {
        background: props.Titlebackground
      }
    }, /*#__PURE__*/React__default["default"].createElement("h2", {
      style: {
        color: props.titleColor
      },
      className: props.underline
    }, props.title), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardElevenDesBox"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "CardElevenreadmore",
      style: {
        color: props.ReadmoreColor
      }
    }, props.buttonLabel, " ", props.ReadmoreIcon, " "))), props.BottomLine && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "bottomLine",
      style: {
        background: props.BottomLineColor
      }
    }))))));
  }

  var css_248z$l = ".CardFifteen .CardFifteenInfoContainer{text-decoration:none!important;cursor:pointer}.CardFifteen .CardFifteenInfoContainer .CardFifteenavatar{min-height:250px;overflow:hidden;position:relative}.CardFifteen .CardFifteenInfoContainer .CardFifteenavatar img{width:100%;-o-object-fit:cover;object-fit:cover;position:absolute;height:100%}.CardFifteen .CardFifteenInfoContainer .CardFifteenhover_over{-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out}.CardFifteen .CardFifteenInfoContainer .CardOneboxed-grey:hover .CardFifteenhover_over{position:absolute;top:0;left:0;width:100%;height:100%;opacity:.73}.CardFifteen .CardFifteenInfoContainer .CardFifteenDetails{padding:20px}.CardFifteen .CardFifteenInfoContainer .CardFifteenDesBox{padding:20px 0 0}.CardFifteen .CardFifteenInfoContainer .CardFifteenDetails h2{font-size:20px;margin:0!important}.CardFifteen .CardFifteenInfoContainer .CardFifteenreadmore{font-size:14px;text-align:left;font-weight:400;text-decoration:none}.CardFifteen .CardFifteenInfoContainer .CardFifteenreadmore svg{font-size:15px!important;margin-left:4px}.CardFifteen .CardFifteenInfoContainer .CardFifteenboxed-grey:hover{-webkit-box-shadow:-1px 9px 23px -7px rgba(0,0,0,.45);box-shadow:-1px 9px 23px -7px rgba(0,0,0,.45);-webkit-transition:all 1s ease 0s;transition:all 1s ease 0s}.CardFifteen .bottomLine{height:4px}.border{border:1px solid #e4e8ec}.CardFifteenTwo{padding-top:20px}.CardFifteen .CardFifteenTopSec{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.CardFifteen .CardFifteenTopSec h4{font-size:14px;font-weight:400}.CardFifteenTopSec span{background:#fff;padding:5px;border-radius:4px;color:#000;font-size:14px;font-weight:600;text-transform:uppercase;display:-webkit-box;display:-ms-flexbox;display:flex}.CardFifteenTopSec span img{width:30px;margin-right:5px}";
  styleInject(css_248z$l);

  function CardFifteen(props) {
    var cardFifteenData = props.cardFifteenData;
    return /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: props.colSpacing
    }, cardFifteenData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
        item: true,
        xs: 12,
        md: props.col
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardFifteen"
      }, /*#__PURE__*/React__default["default"].createElement("a", {
        href: item.link,
        className: "CardFifteenInfoContainer",
        onClick: item.onClick
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardFifteenboxed-grey"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: props.border
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardFifteenInner",
        style: {
          padding: props.ImgSpace
        }
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardFifteenavatar"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        src: item.img,
        alt: ""
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardFifteenhover_over"
      })), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardFifteenDetails",
        style: {
          background: props.Titlebackground
        }
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardFifteenTopSec"
      }, /*#__PURE__*/React__default["default"].createElement("h4", {
        style: {
          color: props.titleTopLeftcolor
        }
      }, item.titleTop), /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement("img", {
        src: item.flag
      }), " ", item.countryname)), /*#__PURE__*/React__default["default"].createElement("h2", {
        style: {
          color: props.titleColor
        },
        className: props.underline
      }, item.title), /*#__PURE__*/React__default["default"].createElement("p", {
        style: {
          color: props.discriptionColor
        },
        className: props.underline
      }, item.description, " ", /*#__PURE__*/React__default["default"].createElement("span", {
        className: "CardFifteenreadmore",
        style: {
          color: props.ReadmoreColor
        }
      }, props.buttonLabel, " ", props.ReadmoreIcon, " ")), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CardFifteenTwo"
      }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
        label: props.label,
        arrowIcon: props.arrowIcon,
        arrowStatus: props.arrowStatus,
        arrowColor: props.arrowColor,
        buttoncolor: props.buttoncolor,
        width: props.width,
        height: props.height,
        border: props.border,
        borderRadius: props.borderRadius,
        color: props.color,
        textAlign: props.textAlign
      })))))))));
    }));
  }

  var css_248z$k = ".CardSixteen{border:1px solid #e4e8ec;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.CardSixteen:hover{text-decoration:none!important}.CardSixteen .CardSixteenImg{min-width:350px;height:196px;background-color:#e4e8ec;position:relative}.CardSixteen .CardSixteenImg img{width:100%;-o-object-fit:cover;object-fit:cover;height:100%}.CardSixteen .CardSixteenContents{padding:20px}.CardSixteen .CardSixteenDate{font-size:14px;font-weight:400;color:#0b132b;margin:0}.CardSixteen .CardSixteenTitle{color:#1b2121;font-size:20px;font-weight:700;line-height:30px;margin-top:12px}.CardSixteen .CardSixteenReadmore{font-size:14px;font-weight:600;display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:13px}.CardSixteen .CardSixteenReadmore svg{font-size:18px;margin-left:5px;position:relative;top:2px}.CardSixteen .VideoCardOnehover_over{-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out;background:#000;position:absolute;width:100%;left:0;top:0;height:100%;opacity:0}.CardSixteen:hover .VideoCardOnehover_over{opacity:.5}.CardSixteen .videoIcon{-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out;position:absolute;width:100%;left:0;top:0;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#fff;opacity:0}.CardSixteen:hover .videoIcon{opacity:1}.CardSixteen .videoIcon svg{font-size:35px}@media(max-width:768px){.CardSixteen{display:block}.CardSixteen .CardSixteenImg{min-width:0;width:100%}}";
  styleInject(css_248z$k);

  function CardSixteen(props) {
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      href: props.link,
      className: "CardSixteen"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardSixteenImg"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.image,
      alt: "eventImg"
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "VideoCardOnehover_over"
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "videoIcon"
    }, props.playicon)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardSixteenContents"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardSixteenDate"
    }, props.date), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CardSixteenTitle"
    }, props.title), /*#__PURE__*/React__default["default"].createElement("span", {
      className: "CardSixteenReadmore",
      style: {
        color: props.readmoreColor
      }
    }, props.buttonText, " ", /*#__PURE__*/React__default["default"].createElement(ArrowForwardRoundedIcon__default["default"], null), " "))));
  }

  var css_248z$j = ".HeaderOneMainContainer{background:#fff;-webkit-box-shadow:0 2px 6px 0 hsla(0,0%,68.6%,.51);box-shadow:0 2px 6px 0 hsla(0,0%,68.6%,.51);width:100%;z-index:99999;top:0;height:80px;left:0}.HeaderOneMainContainer .HeaderOneContainer{margin:0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0 25px}.HeaderOneMainContainer .HeaderOneContainer .HeaderOnesiteLogo{height:80px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.HeaderOneMainContainer .HeaderOneContainer .HeaderOnesiteLogo a{display:inline-block;cursor:pointer}.HeaderOneMainContainer .HeaderOneContainer .HeaderOnesiteLogo a img{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}.is-active{color:#ff5800!important}.navBar .col-md-3{z-index:7}ul.main-menu{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;list-style:none;margin:0 auto;padding:0;float:right;z-index:7}ul.main-menu>li.menu-item:first-child{padding-left:0;margin-left:0}.menu-item{line-height:23px}li{list-style-type:none}.menu-item a{height:80px;text-decoration:none;padding:0 13px;font-size:14px;color:#676c7b;line-height:24px;font-weight:500;text-transform:uppercase;cursor:pointer}.header__middle__menus,.menu-item a{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.menu-item.menu__qqqitem a{margin:27px 10px}.header__middle__search{width:7%;display:inline-block;float:right;padding:36px 3px 27px;border-left:1px solid #e6e6fa}.header__middle{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;float:left;border-bottom:1px dashed #e6e6fa;position:relative}.header__middle__logo>a>h1{color:#07a8ff;text-transform:uppercase;text-decoration:none;margin-top:33px}.header__middle__menus span.text{position:absolute;right:177px;bottom:10px;font-size:14px;color:#ff1800}.sub__menus__arrows{position:relative}.sub__menus__arrows__full svg,.sub__menus__arrows svg{padding-top:0}.sub__menus{position:absolute;display:none;background:#fff;border:1px solid #e6e6fa;min-width:300px;left:-13px;padding:0;z-index:1000;-webkit-box-shadow:0 2px 7px hsla(0,0%,76.5%,.25);box-shadow:0 2px 7px hsla(0,0%,76.5%,.25);top:80px;border-radius:0 0 4px 4px}@media (max-width:767px){.header__middle .active{color:#ff3d00!important}}.sub__menus__arrows:hover .sub__menus{display:block}.sub__menus__arrows__full:hover .sub__menus{display:block;z-index:1000000}.menu-item .sub__menus a{padding:7px 27px;height:auto;display:block;font-size:14px}.menu-item:hover>a{color:#0053a5!important}.menu-item .sub__menus li:hover a{color:#0053a5!important;background:#f7f9fa}.header__middle__logo img{max-width:207px;margin:17px 0 0}.HeaderOneButtonDekstop{margin-left:13px}@media(max-width:768px){.header__middle__logo img{max-width:197px;margin:27px 0 0}.main-nav .menu-item:hover>a{color:#07a8ff!important}.main-nav .menubar__button{display:block!important;cursor:pointer;position:relative;z-index:10037;top:4px}.main-nav .menubar__button svg{font-size:27px}.menu-item a{height:auto;text-decoration:none;padding:4px 13px;font-size:14px;color:#2b3a42!important;line-height:24px;font-weight:500;text-transform:uppercase;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.main-nav ul.menuq2{display:block!important;position:absolute;left:0;z-index:10007;background-color:#fff;border-bottom:3px solid #006db4;right:0;padding-bottom:0;padding-top:0;top:60px;border-top:1px solid #ebebeb}.sub__menus{width:100%;top:0;left:0;position:relative;-webkit-box-shadow:none;box-shadow:none;border-left:none!important;border-right:none!important;background:#fdfdfd}.HeaderOneMainContainer,.HeaderOneMainContainer .HeaderOneContainer .HeaderOnesiteLogo{height:60px}.HeaderOneMainContainer .HeaderOneContainer .HeaderOnesiteLogo a{max-width:160px!important}.main-nav .menu-item a{margin:10px 17px;text-align:center;color:#000}.main-nav ul.main-menu{display:none}.main-nav .sub__menus__arrows:hover .sub__menus,.sub__menus__Active{margin:0 auto;left:0;right:0}.sub__menus__Active,.sub__menus__Active2{display:block!important}.menus__categorysss,.menus__categorysss2{display:none}.menu-item .sub__menus__full a{text-align:left}.HeaderOneButtonDekstop{display:none}}";
  styleInject(css_248z$j);

  function Dropdown$2(props) {
    var _useState = React.useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        isMenuSubMenu = _useState2[0];
        _useState2[1];

    var boxClassSubMenu = ["sub__menus"];
    isMenuSubMenu ? boxClassSubMenu.push('sub__menus__Active') : boxClassSubMenu.push('');
    return /*#__PURE__*/React__default["default"].createElement("ul", {
      className: boxClassSubMenu.join(' ')
    }, props.children && props.children.map(function (child, i) {
      return /*#__PURE__*/React__default["default"].createElement("li", null, " ", /*#__PURE__*/React__default["default"].createElement("a", {
        activeClassName: "is-active",
        href: child.link
      }, " ", child.label, " "), " ");
    }));
  }

  function NavBarOne(props) {
    var menuData = props.menuData;

    var _useState = React.useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        isMenu = _useState2[0],
        setisMenu = _useState2[1];

    var _useState3 = React.useState(false),
        _useState4 = _slicedToArray(_useState3, 2),
        isResponsiveclose = _useState4[0],
        setResponsiveclose = _useState4[1];

    var toggleClass = function toggleClass() {
      setisMenu(isMenu === false ? true : false);
      setResponsiveclose(isResponsiveclose === false ? true : false);
    };

    var boxClass = ["main-menu menu-right menuq1"];

    if (isMenu) {
      boxClass.push('menuq2');
    } else {
      boxClass.push('');
    }

    var _useState5 = React.useState(false),
        _useState6 = _slicedToArray(_useState5, 2),
        isMenuSubMenu = _useState6[0],
        setMenuSubMenu = _useState6[1];

    var toggleSubmenu = function toggleSubmenu() {
      setMenuSubMenu(isMenuSubMenu === false ? true : false);
    };

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "HeaderOneMainContainer",
      style: {
        background: props.background,
        position: props.position
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "HeaderOneContainer",
      style: {
        maxWidth: props.maxWidth
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "HeaderOnesiteLogo"
    }, /*#__PURE__*/React__default["default"].createElement("a", {
      exact: true,
      activeClassName: "is-active",
      href: props.logoLink,
      style: {
        maxWidth: props.LogoSize
      }
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.logo,
      alt: "logo"
    }))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "header__middle__menus"
    }, props.MenuStatus && /*#__PURE__*/React__default["default"].createElement("nav", {
      className: "main-nav "
    }, isResponsiveclose === true ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "menubar__button",
      style: {
        display: 'none'
      },
      onClick: toggleClass
    }, " ", /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.CloseIcon
    }))) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "menubar__button",
      style: {
        display: 'none'
      },
      onClick: toggleClass
    }, " ", /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.MenuIcon
    }))), /*#__PURE__*/React__default["default"].createElement("ul", {
      className: boxClass.join(' ')
    }, menuData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("li", {
        onClick: toggleSubmenu,
        className: "menu-item sub__menus__arrows"
      }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        exact: true,
        activeClassName: "is-active",
        onClick: toggleClass,
        to: item.to,
        href: item.link
      }, " ", item.label, item.hasChildren && /*#__PURE__*/React__default["default"].createElement(KeyboardArrowDownRoundedIcon__default["default"], null)), /*#__PURE__*/React__default["default"].createElement(Dropdown$2, {
        children: item.children
      }));
    }))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "HeaderOneButtonDekstop"
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.buttonLebel,
      link: props.ButtonLink,
      target: props.target,
      path: props.path,
      arrowIcon: props.arrowIcon,
      arrowStatus: props.arrowStatus,
      arrowColor: props.arrowColor,
      buttoncolor: props.buttoncolor,
      width: props.width,
      height: props.height,
      border: props.border,
      borderRadius: props.borderRadius,
      color: props.colorlabel,
      fontWeight: props.fontWeight,
      textAlign: props.textAlign,
      handIconStatus: props.handIconStatus
    })))));
  }

  var css_248z$i = ".WebHeaderContainer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-shadow:0 4px 2px -2px rgba(0,0,0,.05882);box-shadow:0 4px 2px -2px rgba(0,0,0,.05882);position:relative;background-color:#fff}.MuiIconButton-label .MuiSvgIcon-root{color:#000}.WebHeaderContainer .WebsiteHeaderLogo{max-width:188px;margin-right:75px;margin-left:30px}.WebHeaderContainer .WebsiteHeaderLogo img{max-width:188px}.WebHeaderContainer .headerMenuLinks .menu-li-container{cursor:pointer}.WebHeaderContainer .headerMenuLinks .menu-li-container .MuiListItem-gutters{padding-left:16px;padding-right:16px;display:-webkit-box;display:-ms-flexbox;display:flex;width:auto;float:left;height:60px;font-size:14px;font-weight:500;text-transform:uppercase}.WebHeaderContainer .TopHeaderContaier{border-bottom:1px solid #e4e8ec;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:14px 30px 14px 0}.WebHeaderContainer .TopHeaderContaier .TopHeaderdDataCol{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-left:25px}.WebHeaderContainer .TopHeaderContaier .TopHeaderdDataCol svg{color:#a4a7b0;margin-right:14px}.WebHeaderContainer .TopHeaderContaier .TopHeaderdDataCol .Th-Label{color:#676c7b;font-size:10px;text-transform:uppercase;font-weight:400}.WebHeaderContainer .TopHeaderContaier .TopHeaderdDataCol .Th-Text{color:#0b132b;font-size:12px;font-weight:400}.WebHeaderContainer .TopHeaderContaier .TpHrButton{border:1px solid #56b149;color:#56b149;padding:10px 16px;font-weight:500;font-size:14px;cursor:pointer;-webkit-transition:.2s;transition:.2s;border-radius:4px}.WebHeaderContainer .TopHeaderContaier .TpHrButton:hover{text-decoration:none;border:1px solid #fff;color:#fff;background:#56b149}.headerMenuLinks{padding-right:20px;position:relative}.headerMenuLinks .menu-li-container{font-size:14px;color:#1b2121;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.headerMenuLinks .menu-li-container a{font-size:14px;color:#1b2121;padding:15px 18px;position:relative;cursor:pointer;text-transform:uppercase}.headerMenuLinks .menu-li-container a svg{position:absolute;right:-8px;font-size:21px}.headerMenuLinks .menu-li-container a:hover{font-size:14px;color:#56b149;padding:15px 18px;position:relative;text-decoration:none}.MuiPopover-paper{outline:0;position:absolute;max-width:calc(100% - 32px);min-width:16px;max-height:calc(100% - 32px);min-height:16px;overflow-x:hidden;overflow-y:hidden!important;margin-top:47px;padding:0;margin-left:-100px}.MuiPopover-paper .MuiMenu-list a{font-size:14px;color:#1b2121;padding:10px 18px;position:relative;display:block;cursor:pointer;text-transform:uppercase}.MuiPopover-paper .MuiMenu-list a:hover{color:#56b149;text-decoration:none;background:#f7f9fa}.MuiPopover-paper .MuiList-padding{padding-top:0;padding-bottom:0}.WebHeaderContainer .MuiList-padding{padding-top:0!important;padding-bottom:0!important}@media (max-width:1050px){.WebHeaderContainer .headerMenuLinks .menu-li-container .MuiListItem-gutters{padding-left:6px;padding-right:6px}.WebHeaderContainer .TopHeaderContaier .TpHrButton{min-width:190px}.WebHeaderContainer .WebsiteHeaderLogo{margin-right:15px}}@media (max-width:950px){.WebHeaderContainer{display:block;padding-top:20px;-webkit-box-shadow:none;box-shadow:none}.WebHeaderContainer .WebsiteHeaderLogo{max-width:168px;margin:0 auto}.headerMenuLinks{padding-right:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.headerMenuLinks,.WebHeaderContainer .TopHeaderContaier{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}}@media (max-width:850px){.WebHeaderContainer{display:none}}.headerMenuLinks .MuiPaper-root.MuiMenu-paper{margin-top:35px!important}";
  styleInject(css_248z$i);

  function HeaderWebsite(props) {
    var _props$topHeaderButto2, _props$topHeaderButto3;

    var _useState = React.useState(false),
        _useState2 = _slicedToArray(_useState, 2);
        _useState2[0];
        _useState2[1];

    var _useState3 = React.useState([]),
        _useState4 = _slicedToArray(_useState3, 2),
        showMenuItems = _useState4[0],
        setshowMenuItems = _useState4[1];

    var _React$useState = React__default["default"].useState(null),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        anchorEl = _React$useState2[0],
        setAnchorEl = _React$useState2[1];

    var handleClick = function handleClick(event, children) {
      setshowMenuItems(children);
      setAnchorEl(event.currentTarget);
    };

    var handleClose = function handleClose(path) {
      if (path) {
        props.navigate(path);
      }

      setAnchorEl(null);
    };

    var _useState5 = React.useState(false),
        _useState6 = _slicedToArray(_useState5, 2),
        show = _useState6[0],
        setShow = _useState6[1];

    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(core.AppBar, {
      position: "static",
      className: "mob-header-bar"
    }, /*#__PURE__*/React__default["default"].createElement(core.Toolbar, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "top-mob-container"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "logo"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      onClick: props.onLogoClick
    }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      href: props.logolink
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.logo,
      alt: "logo"
    })))), /*#__PURE__*/React__default["default"].createElement(core.IconButton, {
      "aria-controls": "simple-menu",
      onClick: function onClick() {
        return setShow(!show);
      }
    }, /*#__PURE__*/React__default["default"].createElement(MenuIcon__default["default"], null)))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "header-menu-links"
    }, show ? /*#__PURE__*/React__default["default"].createElement(core.Typography, {
      className: "menu-li-container"
    }, props.headerItems && props.headerItems.length ? props.headerItems.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        key: i,
        onClick: function onClick() {
          return props.navigate(item.path);
        },
        href: item.link,
        target: props.target
      }, item.icon, " ", item.title, " ", item.children && item.children.length ? /*#__PURE__*/React__default["default"].createElement(KeyboardArrowDownIcon__default["default"], {
        onClick: handleClick
      }) : null, " ");
    }) : null) : null)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "WebHeaderContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "WebsiteHeaderLogo"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      onClick: function onClick() {
        return props.onLogoClick();
      }
    }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      href: props.logolink
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.logo,
      alt: "logo"
    })))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ManuRightCol"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TopHeaderContaier"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TopHeaderdDataCol"
    }, /*#__PURE__*/React__default["default"].createElement(EmailOutlinedIcon__default["default"], null), /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "Th-Label"
    }, "Email us at"), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "Th-Text"
    }, props.email1))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TopHeaderdDataCol"
    }, /*#__PURE__*/React__default["default"].createElement(CallIcon__default["default"], null), /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "Th-Label"
    }, "Call us"), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "Th-Text"
    }, props.ContactNumber))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TopHeaderdDataCol"
    }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
      onClick: function onClick() {
        var _props$topHeaderButto;

        return (_props$topHeaderButto = props.topHeaderButton) === null || _props$topHeaderButto === void 0 ? void 0 : _props$topHeaderButto.buttonClick();
      },
      className: "TpHrButton",
      variant: "outlined",
      to: props.Buttonpath,
      href: props.ButtonLink,
      target: props.target
    }, (_props$topHeaderButto2 = props === null || props === void 0 ? void 0 : (_props$topHeaderButto3 = props.topHeaderButton) === null || _props$topHeaderButto3 === void 0 ? void 0 : _props$topHeaderButto3.buttonText) !== null && _props$topHeaderButto2 !== void 0 ? _props$topHeaderButto2 : ""))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "headerMenuLinks"
    }, /*#__PURE__*/React__default["default"].createElement(core.Typography, {
      className: "menu-li-container"
    }, props.headerItems && props.headerItems.length ? props.headerItems.map(function (item) {
      var _item$children;

      return /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        href: item.link,
        to: item.path,
        target: props.target
      }, item.icon, " ", item.title, " ", item !== null && item !== void 0 && (_item$children = item.children) !== null && _item$children !== void 0 && _item$children.length ? /*#__PURE__*/React__default["default"].createElement(KeyboardArrowDownIcon__default["default"], {
        onClick: function onClick(e) {
          return handleClick(e, item.children);
        }
      }) : null, " ");
    }) : null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "menuDropdown"
    }, showMenuItems !== null && showMenuItems !== void 0 && showMenuItems.length ? /*#__PURE__*/React__default["default"].createElement(Menu__default["default"], {
      id: "simple-menu",
      anchorEl: anchorEl,
      keepMounted: true,
      open: Boolean(anchorEl),
      onClose: handleClose
    }, showMenuItems.map(function (el, i) {
      return /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        href: el.link,
        target: props.target,
        key: i,
        onClick: function onClick() {
          return handleClose(el.path);
        }
      }, el.title);
    })) : null, " "))))));
  }

  HeaderWebsite.propTypes = {
    headerItems: PropTypes__default["default"].array,
    showSearchInput: PropTypes__default["default"].bool,
    dropdownItems: PropTypes__default["default"].array,
    navigate: PropTypes__default["default"].func
  };

  var css_248z$h = ".VideoCardOne .VideoCardOneInfoContainer{text-decoration:none!important;cursor:pointer}.VideoCardOne .VideoCardOneInfoContainer .VideoCardOneavatar{overflow:hidden;position:relative}.VideoCardOne .VideoCardOneInfoContainer .VideoCardOneavatar img{width:100%;-o-object-fit:cover;object-fit:cover;position:absolute;height:100%}.VideoCardOne .VideoCardOnehover_over{-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out;background:#000;position:absolute;width:100%;left:0;top:0;height:100%;opacity:0}.VideoCardOne:hover .VideoCardOnehover_over{opacity:.5}.VideoCardOne .videoIcon{-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out;position:absolute;width:100%;left:0;top:0;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#fff;opacity:0}.VideoCardOne:hover .videoIcon{opacity:1}.VideoCardOne .videoIcon svg{font-size:35px}.VideoCardOne .VideoCardOneInfoContainer .VideoCardOneDetails{padding:20px}.VideoCardOne .VideoCardOneInfoContainer .VideoCardOneDesBox{padding:20px 0 0}.VideoCardOne .VideoCardOneInfoContainer .VideoCardOneDetails h2{font-size:20px;margin:0!important}.VideoCardOne .VideoCardOneInfoContainer .VideoCardOnereadmore{display:-webkit-box;display:-ms-flexbox;display:flex;font-size:14px;text-align:left;font-weight:600;text-decoration:none;margin:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.VideoCardOne:hover .VideoCardOneInfoContainer .VideoCardOnereadmore{color:#635bff!important}.VideoCardOne .VideoCardOneInfoContainer .VideoCardOnereadmore svg{font-size:15px!important;margin-left:4px}.VideoCardOne .VideoCardOneInfoContainer .VideoCardOneboxed-grey:hover{-webkit-box-shadow:-1px 9px 23px -7px rgba(0,0,0,.45);box-shadow:-1px 9px 23px -7px rgba(0,0,0,.45);-webkit-transition:all 1s ease 0s;transition:all 1s ease 0s}.VideoCardOne .bottomLine{height:4px}.border{border:1px solid #e4e8ec}.VideoCardOne:hover .underline{text-decoration:underline}";
  styleInject(css_248z$h);

  function VideoCardOne(props) {
    props.VideoCardOneData;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "VideoCardOne"
    }, /*#__PURE__*/React__default["default"].createElement("a", {
      href: props.link,
      className: "VideoCardOneInfoContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "VideoCardOneboxed-grey"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: props.border
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "VideoCardOneInner",
      style: {
        padding: props.ImgSpace
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "VideoCardOneavatar",
      style: {
        height: props.ImgHeight
      }
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.img,
      alt: ""
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "VideoCardOnehover_over"
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "videoIcon"
    }, props.icon)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "VideoCardOneDetails",
      style: {
        background: props.Titlebackground
      }
    }, /*#__PURE__*/React__default["default"].createElement("h2", {
      style: {
        color: props.titleColor
      },
      className: props.underline
    }, props.title), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "VideoCardOneDesBox"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "VideoCardOnereadmore",
      style: {
        color: props.ReadmoreColor
      }
    }, props.buttonLabel, " ", props.ReadmoreIcon, " "))), props.BottomLine && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "bottomLine",
      style: {
        background: props.BottomLineColor
      }
    }))))));
  }

  var css_248z$g = ".CTAOne{position:relative;padding:20px;border-radius:4px}.CTAOne h2{font-size:24px;font-weight:900;line-height:28px;margin:0}.CTAOne h2,.CTAOne p{color:#fff;font-family:Poppins,sans-serif}.CTAOne p{font-size:12px;font-weight:400;line-height:20px;margin:12px 0 0}.CTAOne a{display:-webkit-box;display:-ms-flexbox;display:flex;position:absolute;bottom:20px;left:20px;color:#fff;font-size:14px;font-weight:700;font-family:Poppins,sans-serif;text-decoration:none}.CTAOne a svg{font-size:19px;margin-left:4px;position:relative;top:1px}";
  styleInject(css_248z$g);

  function CTAOne(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CTAOne",
      style: {
        background: props.backgroundColor,
        minHeight: props.minHeight
      }
    }, /*#__PURE__*/React__default["default"].createElement("h2", null, props.Title), /*#__PURE__*/React__default["default"].createElement("p", null, props.SubTitle), /*#__PURE__*/React__default["default"].createElement("a", {
      href: props.link,
      target: props.target,
      style: {
        background: props.Btnbackground,
        color: props.Btncolor,
        padding: props.BtnPadding
      }
    }, props.ButtonLebel, " ", /*#__PURE__*/React__default["default"].createElement(ArrowForwardIosRoundedIcon__default["default"], null)));
  }

  var css_248z$f = ".CTATwo{position:relative;border-radius:4px;border:1px solid #e4e8ec}.CTATwo .DonationCardTwoIconContainer{height:88px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:10px}.DonationCardTwoInfoContainer{padding:20px}.CTATwo h2{color:#0a2540;font-size:34px;font-weight:900;line-height:40px;margin:0}.CTATwo a,.CTATwo h2{font-family:Poppins,sans-serif}.CTATwo a{display:-webkit-box;display:-ms-flexbox;display:flex;font-size:14px;font-weight:700;text-decoration:none;margin-top:20px}.CTATwo a svg{font-size:19px;margin-left:4px;position:relative;top:1px}";
  styleInject(css_248z$f);

  function CTATwo(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CTATwo",
      style: {
        background: props.backgroundColor
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "DonationCardTwoIconContainer",
      style: {
        background: props.IconbackgroundColor
      }
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.icon
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "DonationCardTwoInfoContainer"
    }, /*#__PURE__*/React__default["default"].createElement("h2", null, props.Title), /*#__PURE__*/React__default["default"].createElement("a", {
      href: props.link,
      target: props.target,
      style: {
        color: props.ButtonColor
      }
    }, props.ButtonLebel, " ", /*#__PURE__*/React__default["default"].createElement(ArrowForwardIosRoundedIcon__default["default"], null))));
  }

  var css_248z$e = ".CTAEight{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex}.CTAEight h2{font-size:20px;font-weight:500;text-align:center;margin:0 0 16px}.CTAEight h2,.CTAEight p{font-family:Poppins,sans-serif}.CTAEight p{font-size:12px;font-weight:400;line-height:20px;margin:12px 0 0}.CTAEight a svg{font-size:19px;margin-left:4px;position:relative;top:1px}.CTAEight .CTAEightLeftCol{-webkit-box-flex:1;-ms-flex:1;flex:1;padding:60px 30px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:end}.CTAEight .CTAEightRightCol{-webkit-box-flex:1;-ms-flex:1;flex:1;padding:60px 30px}.CTAEight .CTAEightRightColBtn a{display:-webkit-box;display:-ms-flexbox;display:flex;text-decoration:none;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:20px;border-radius:4px;background:#fff;margin-bottom:16px;font-size:20px;font-weight:500;font-family:Poppins,sans-serif;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer}.CTAEight .CTAEightRightColBtn a img{height:32px}.CTAEight .CTAEightRightColBtn a svg{color:#000}.CTAEight .CTAEightLeftColTitle{font-size:16px;font-weight:500;color:#fff;margin-bottom:5px}.CTAEight .CTAEightLeftColDescription{font-size:34px;font-weight:500;color:#fff;line-height:42px}.CTAEight .CTAEightLeftColDescription span{font-size:20px;font-weight:300;color:#fff}.CTAEight .CTAEightInner{width:445px}.CTAEight .CTAEightLeftBottomText{font-size:24px;font-weight:300;color:#fff;padding-top:25px}.CTAEight .CTAEightLogoCtn{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.CTAEight .CTAEightLogoCtn span{color:#1b2121;font-size:29px;margin-left:10px;font-weight:600;line-height:0;font-family:Poppins,sans-serif}@media (max-width:768px){.CTAEight{display:block}.CTAEight .CTAEightInner{width:100%}.CTAEight .CTAEightRightColBtn a img{height:27px}.CTAEight .CTAEightLogoCtn span{font-size:20px}}";
  styleInject(css_248z$e);

  function CTAEight(props) {
    var cTAEightData = props.cTAEightData;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CTAEight",
      style: {
        background: props.backgroundColor,
        minHeight: props.minHeight
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CTAEightLeftCol",
      style: {
        background: props.backgroundColor,
        minHeight: props.minHeight
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CTAEightInner"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CTAEightLeftColTitle"
    }, props.TitleLeft), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CTAEightLeftColDescription"
    }, props.LeftDescription, " ", /*#__PURE__*/React__default["default"].createElement("span", null, props.bookname)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CTAEightLeftBottomText"
    }, props.LeftBottomText))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CTAEightRightCol",
      style: {
        background: props.backgroundColorRight,
        minHeight: props.minHeight
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CTAEightInner"
    }, /*#__PURE__*/React__default["default"].createElement("h2", {
      style: {
        color: props.color
      }
    }, props.Title), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "CTAEightRightColBtn"
    }, cTAEightData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("a", {
        href: item.link,
        target: props.target,
        style: {
          color: props.btnlebelcolor
        },
        onClick: item.onClick
      }, item.lebel, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "CTAEightLogoCtn"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        src: item.icon
      }), " ", /*#__PURE__*/React__default["default"].createElement("span", null, item.TitleafterLogo)), /*#__PURE__*/React__default["default"].createElement(ArrowForwardRoundedIcon__default["default"], null));
    })))));
  }

  var css_248z$d = ".AlertThree{margin-right:8px;position:relative;width:100%}.AlertThree .AlertThreeInner{margin:0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:24px;-ms-flex-pack:distribute;justify-content:space-around}.AlertThree .AlertThreeInner .react-swipeable-view-container{overflow-y:visible}.AlertThree .AlertThreeInner .AlertThreeRight{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.AlertThree .AlertThreeInner .AlertThreeRight .closeIcon{margin-left:70px;font-size:24px;cursor:pointer}.AlertThree .AlertThreeInner .AlertThreeRight .closeIcon:hover{opacity:.5}.AlertThree .AlertThreeRight .MuiMobileStepper-root{background:none}.AlertThree .AlertThreeRight .arrow{color:#fff;width:24px;height:24px;margin:0 5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer}.AlertThree .AlertThreeRight .arrow:hover{opacity:.8}.AlertThree .AlertThreeRight .arrow svg{font-size:20px}.AlertThree .AlertThreeLeft{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.AlertThree .AlertThreeLeft .AlertThreeleftIcon{width:24px;margin-right:14px}.AlertThree .AlertThreeLeftcontents{max-width:665px}.AlertThree .AlertThreeLeftcontents h3{font-size:17px;font-weight:500;margin:0}.AlertThree .AlertThreeLeftcontents p{font-size:12px;font-weight:400;margin:5px 0 0}.AlertThree .AlertThreeLeftcontents a{font-size:14px;font-weight:700;margin:5px 0 0;text-decoration:none}.AlertThree .AlertThreeLeftcontents a svg{position:relative;top:8px}";
  styleInject(css_248z$d);

  var AutoPlaySwipeableViews = reactSwipeableViewsUtils.autoPlay(SwipeableViews__default["default"]);

  function AlertThree(props) {
    var tutorialSteps = props.tutorialSteps;
    var theme = styles$1.useTheme();

    var _React$useState = React__default["default"].useState(0),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        activeStep = _React$useState2[0],
        setActiveStep = _React$useState2[1];

    var maxSteps = tutorialSteps.length;

    var handleNext = function handleNext() {
      setActiveStep(function (prevActiveStep) {
        return prevActiveStep + 1;
      });
    };

    var handleBack = function handleBack() {
      setActiveStep(function (prevActiveStep) {
        return prevActiveStep - 1;
      });
    };

    var handleStepChange = function handleStepChange(step) {
      setActiveStep(step);
    };

    var _React$useState3 = React__default["default"].useState(true),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        showElement = _React$useState4[0],
        setShowElement = _React$useState4[1];

    React.useEffect(function () {
      setTimeout(function () {
        setShowElement(false);
      }, props.AlertDuration);
    }, []);

    var _useState = React.useState(true),
        _useState2 = _slicedToArray(_useState, 2),
        show = _useState2[0],
        setShow = _useState2[1];

    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, showElement ? /*#__PURE__*/React__default["default"].createElement("div", null, show ? /*#__PURE__*/React__default["default"].createElement("div", {
      className: "AlertThree",
      style: {
        background: props.background
      },
      "in": open
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "AlertThreeInner",
      style: {
        maxWidth: props.maxWidth
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "AlertThreeLeft"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      className: "AlertThreeleftIcon",
      src: props.leftIcon,
      alt: "icon"
    }), /*#__PURE__*/React__default["default"].createElement(AutoPlaySwipeableViews, {
      axis: theme.direction === 'rtl' ? 'x-reverse' : 'x',
      index: activeStep,
      onChangeIndex: handleStepChange,
      enableMouseEvents: true
    }, tutorialSteps.map(function (step, index) {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        key: step.label
      }, Math.abs(activeStep - index) <= 2 ? /*#__PURE__*/React__default["default"].createElement("div", {
        className: "AlertThreeLeftcontents"
      }, /*#__PURE__*/React__default["default"].createElement("h3", {
        style: {
          color: props.color
        }
      }, step.title), /*#__PURE__*/React__default["default"].createElement("p", {
        style: {
          color: props.color
        }
      }, step.description), props.ButtonStatus && /*#__PURE__*/React__default["default"].createElement("a", {
        href: step.path,
        target: step.target,
        style: {
          color: props.color
        }
      }, props.ButtonText, " ", /*#__PURE__*/React__default["default"].createElement(KeyboardArrowRight__default["default"], null))) : null);
    }))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "AlertThreeRight"
    }, /*#__PURE__*/React__default["default"].createElement(MobileStepper__default["default"], {
      className: "bannerSteps",
      steps: maxSteps,
      position: "static",
      variant: "none",
      activeStep: activeStep,
      nextButton: /*#__PURE__*/React__default["default"].createElement("div", {
        className: "arrownext arrow",
        style: {
          background: props.arrowColor
        },
        onClick: handleNext,
        disabled: activeStep === maxSteps - 1
      }, theme.direction === 'rtl' ? /*#__PURE__*/React__default["default"].createElement(KeyboardArrowLeft__default["default"], null) : /*#__PURE__*/React__default["default"].createElement(KeyboardArrowRight__default["default"], null)),
      backButton: /*#__PURE__*/React__default["default"].createElement("div", {
        className: "arrowback arrow",
        style: {
          background: props.arrowColor
        },
        onClick: handleBack,
        disabled: activeStep === 0
      }, theme.direction === 'rtl' ? /*#__PURE__*/React__default["default"].createElement(KeyboardArrowRight__default["default"], null) : /*#__PURE__*/React__default["default"].createElement(KeyboardArrowLeft__default["default"], null))
    }), /*#__PURE__*/React__default["default"].createElement(CloseIcon__default["default"], {
      className: "closeIcon",
      style: {
        color: props.color
      },
      onClick: function onClick() {
        return setShow(false);
      }
    })))) : null) : /*#__PURE__*/React__default["default"].createElement("div", null), " ");
  }

  var css_248z$c = ".ImageGridFour{background:#fff;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.ImageGridFour .GridCol{max-height:270px;max-width:270px;margin:5px}.ImageGridFour .GridCol img{-o-object-fit:cover;object-fit:cover;width:100%;height:100%;cursor:pointer}@media(max-width:500px){.ImageGridFour .GridCol{max-height:none;max-width:none;width:100%}}";
  styleInject(css_248z$c);

  function ImageGridFour(props) {
    var images = props.images,
        imgGridData = props.imgGridData;

    var _useState = React.useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        isOpen = _useState2[0],
        setisOpen = _useState2[1];

    var _useState3 = React.useState(0),
        _useState4 = _slicedToArray(_useState3, 2),
        photoIndex = _useState4[0],
        setphotoIndex = _useState4[1];

    var imageClick = function imageClick(i) {
      setphotoIndex(i);
      setisOpen(true);
    };

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ImageGridFour"
    }, imgGridData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: "GridCol"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        className: "",
        src: item.img,
        onClick: function onClick() {
          return imageClick(i);
        }
      }));
    }), isOpen && /*#__PURE__*/React__default["default"].createElement(Lightbox__default["default"], {
      mainSrc: images[photoIndex],
      nextSrc: images[(photoIndex + 1) % images.length],
      prevSrc: images[(photoIndex + images.length - 1) % images.length],
      onCloseRequest: function onCloseRequest() {
        return setisOpen(false);
      },
      onMovePrevRequest: function onMovePrevRequest() {
        return setphotoIndex((photoIndex + images.length - 1) % images.length);
      },
      onMoveNextRequest: function onMoveNextRequest() {
        return setphotoIndex((photoIndex + 1) % images.length);
      },
      animationDisabled: false,
      animationOnKeyInput: true
    }));
  }

  var css_248z$b = "@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap\");.FooterTwoMainContainer{padding:40px 0}.FooterTwoMainContainer .FooterTwoContainer{margin:0 auto;padding:0 25px}.FooterTwoMainContainer .FooterTwoCol .FooterTwoColTitle{font-size:20px;font-weight:500;font-family:Roboto,sans-serif!important;text-transform:uppercase;margin-bottom:12px}.FooterTwoMainContainer .FooterTwoCol .FooterTwoColParagraph{font-size:14px;font-weight:400;font-family:Roboto,sans-serif!important;line-height:20px;opacity:.6;margin:0 0 33px!important}.FooterTwoMainContainer .FooterTwoListinCol{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;margin-bottom:20px}.FooterTwoMainContainer .FooterTwoListinCol .FooterTwoListingInfo{padding-bottom:20px;width:90%}.FooterTwoMainContainer .FooterTwoListinCol .FooterTwoListingInfo .FooterTwoListingTitle{font-size:14px;font-weight:700;font-family:Roboto,sans-serif!important;margin-bottom:6px;line-height:20px}.FooterTwoMainContainer .FooterTwoListinCol .FooterTwoListingInfo .FooterTwoListingSubTitle{font-size:12px;font-weight:400;font-family:Roboto,sans-serif!important;line-height:16px;opacity:.6}.FooterTwoMainContainer .FooterTwoListinCol .FooterTwoListingIcon{margin-right:14px;position:relative;top:-2px}.FooterTwoMainContainer .FooterTwoSocial,.FooterTwoMainContainer .FooterTwoSocial a{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.FooterTwoMainContainer .FooterTwoSocial a{border:1px solid #0868c9;min-width:60px;min-height:60px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:100px;margin-right:12px}.FooterTwoMainContainer .FooterTwoSocial a img{width:24px}.FooterTwoMainContainer .FooterTwoBorder{margin-top:10px;margin-bottom:10px}.FooterTwoMainContainer .FooterTwoRowTwo{margin-top:30px}.FooterTwoMainContainer .FooterTwoRowTwo .FooterTwoListingContactInfo .FooterTwoListingTitle{font-size:14px;font-weight:400;font-family:Roboto,sans-serif!important;margin-bottom:4px}.FooterTwoMainContainer .FooterTwoRowTwo .FooterTwoLocatioIcon{text-align:left;margin-left:35px}.FooterTwoButtonContainer{padding-top:30px}.FooterTwoMainContainer .FooterTwoListinCol:last-child{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;margin-bottom:0!important}.FooterTwoColSubText{font-size:14px;text-transform:uppercase;opacity:.6;margin-bottom:17px}";
  styleInject(css_248z$b);

  var click = function click() {
    console.log("Back Button Clicked");
  };

  function FooterTwo(props) {
    var FooterTwoColOne = props.FooterTwoColOne,
        FooterTwoColTwo = props.FooterTwoColTwo,
        FooterTwoSocial = props.FooterTwoSocial,
        FooterTwoContactinfo = props.FooterTwoContactinfo,
        FooterTwoGiveUs = props.FooterTwoGiveUs;
    var CssTextField = styles$1.withStyles({
      root: {
        '& label.Mui-focused': {
          color: '#E4E8EC',
          opacity: "0.4"
        },
        '& .MuiInput-underline:after': {
          borderBottomColor: 'yellow'
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: '#FFFFFF'
          },
          '&:hover fieldset': {
            borderColor: 'white'
          },
          '&.Mui-focused fieldset': {
            borderColor: '#E4E8EC'
          }
        },
        '& .MuiInputLabel-outlined': {
          color: "#fff",
          opacity: "0.4"
        },
        '& .MuiOutlinedInput-input': {
          color: "#fff"
        }
      }
    })(TextField__default["default"]);
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterTwoMainContainer",
      style: {
        background: props.background
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterTwoContainer",
      style: {
        maxWidth: props.ContainerMaxWidth
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterTwoRowOne"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      md: 3,
      lg: 3
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterTwoCol"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterTwoColTitle",
      style: {
        color: props.color
      }
    }, props.ColTitleOne), FooterTwoColOne.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: "FooterTwoColParagraph",
        style: {
          color: props.color
        }
      }, item.description);
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterTwoSocial"
    }, FooterTwoSocial.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        href: item.link,
        target: "blank"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        src: item.icon
      }));
    })))), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      md: 4,
      lg: 3
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterTwoCol"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterTwoColTitle",
      style: {
        color: props.color
      }
    }, props.ColTitleTwo), FooterTwoColTwo.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        "class": "FooterTwoListinCol",
        style: {
          color: props.color,
          borderBottom: props.listingBorder
        }
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        "class": "FooterTwoListingIcon",
        src: item.icon
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        "class": "FooterTwoListingInfo",
        style: {
          color: props.color
        }
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        "class": "FooterTwoListingTitle",
        style: {
          color: props.color
        }
      }, item.Title), /*#__PURE__*/React__default["default"].createElement("div", {
        "class": "FooterTwoListingSubTitle",
        style: {
          color: props.color
        }
      }, item.subtitle)));
    }))), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      md: 6,
      lg: 6
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterTwoCol"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterTwoColTitle",
      style: {
        color: props.color
      }
    }, props.ColTitleThree), /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterTwoColSubText",
      style: {
        color: props.color
      }
    }, props.SalatiqamaDataTime), /*#__PURE__*/React__default["default"].createElement(SalatTable, {
      title: "HAJJ 2021 PACKAGES",
      tableBodyData: props.tableBodyData,
      odd: props.odd,
      even: props.even,
      colBorder: props.colBorder,
      col1Color: props.col1Color,
      col2Color: props.col2Color,
      ColPadding: props.ColPadding
    })))))), props.FooterRowTwo && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterTwoBorder",
      style: {
        borderTop: "#014386 1px solid",
        borderBottom: "#0868C9 1px solid"
      }
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterTwoContainer",
      style: {
        maxWidth: props.ContainerMaxWidth
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterTwoRowTwo"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      md: 4,
      lg: 3
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterTwoCol"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterTwoColTitle",
      style: {
        color: props.color
      }
    }, props.ColTitleFour), FooterTwoContactinfo.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        "class": "FooterTwoListinCol"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        "class": "FooterTwoListingIcon",
        src: item.icon
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        "class": "FooterTwoListingContactInfo",
        style: {
          color: props.color
        }
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        "class": "FooterTwoListingTitle",
        style: {
          color: props.color
        }
      }, item.TextOne), /*#__PURE__*/React__default["default"].createElement("div", {
        "class": "FooterTwoListingTitle",
        style: {
          color: props.color
        }
      }, item.TextTwo)));
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterTwoButtonContainer"
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.ContactbuttonLebel,
      onClick: click,
      link: props.ContactLink,
      target: props.target,
      arrow: props.arrow,
      arrowColor: props.arrowColor,
      buttoncolor: props.buttoncolor,
      width: props.width,
      height: props.height,
      border: props.border,
      borderRadius: props.borderRadius,
      color: props.colorlabel,
      fontWeight: props.fontWeight,
      textAlign: props.textAlign
    })))), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      sm: 6,
      md: 4,
      lg: 3
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterTwoCol"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterTwoColTitle",
      style: {
        color: props.color
      }
    }, props.ColTitleFive), FooterTwoGiveUs.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        "class": "FooterTwoVisitCol"
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "FooterTwoColParagraph",
        style: {
          color: props.color
        }
      }, "Give us a visit and earn the Hasanah of praying together in Jam\u2019at !"), /*#__PURE__*/React__default["default"].createElement("div", {
        "class": "FooterTwoLocatioIcon"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        src: item.icon
      })));
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterTwoButtonContainer"
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.getDirectionbuttonLebel,
      onClick: click,
      link: props.getDirectiontLink,
      target: props.target,
      arrow: props.arrow,
      arrowColor: props.arrowColor,
      buttoncolor: props.buttoncolor,
      width: props.width,
      height: props.height,
      border: props.border,
      borderRadius: props.borderRadius,
      color: props.colorlabel,
      fontWeight: props.fontWeight,
      textAlign: props.textAlign
    })))), props.SubscribeSectoin && /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      sm: 6,
      md: 6,
      lg: 6
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterTwoCol FooterTwoColform"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterTwoColTitle",
      style: {
        color: props.color
      }
    }, props.ColTitleSix), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterTwoColParagraph",
      style: {
        color: props.color
      }
    }, props.FormDescription), /*#__PURE__*/React__default["default"].createElement(CssTextField, {
      label: "Full Name",
      variant: "outlined",
      id: "custom-css-outlined-input",
      className: "labelColor"
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React__default["default"].createElement(CssTextField, {
      label: "Enter Your Email",
      variant: "outlined",
      id: "custom-css-outlined-input",
      className: "labelColor"
    }))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterTwoButtonContainer"
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.formButtonLabel,
      onClick: props.onClick,
      link: props.formButtonlink,
      target: props.target,
      arrow: props.arrow,
      arrowColor: props.arrowColor,
      buttoncolor: props.buttoncolor,
      width: "100%",
      height: props.height,
      border: props.border,
      borderRadius: props.borderRadius,
      color: props.colorlabel,
      fontWeight: props.fontWeight,
      textAlign: props.textAlign
    })))))))));
  }

  var css_248z$a = "@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");.FooterThreeMainContainer{padding:20px 0}.FooterThreeMainContainer .FooterThreeContainer{margin:0 auto;padding:0 25px}.FooterThreeMainContainer .FooterThreeOrgTitle{font-size:20px;font-weight:900;font-family:Poppins,sans-serif;margin-bottom:12px}.FooterThreeMainContainer .FooterThreeOrgParagraph{font-size:14px;font-weight:400;font-family:Poppins,sans-serif;line-height:20px;margin:0!important}.FooterThreeMainContainer .FooterThreeListinCol{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;margin-bottom:20px}.FooterThreeMainContainer .FooterThreeListinCol .FooterThreeListingInfo{padding-bottom:20px;width:90%}.FooterThreeMainContainer .FooterThreeListinCol .FooterThreeListingInfo .FooterThreeListingTitle{font-size:14px;font-weight:700;font-family:Poppins,sans-serif;margin-bottom:6px;line-height:20px}.FooterThreeMainContainer .FooterThreeListinCol .FooterThreeListingInfo .FooterThreeListingSubTitle{font-size:12px;font-weight:400;font-family:Poppins,sans-serif;line-height:16px;opacity:.6}.FooterThreeMainContainer .FooterThreeListinCol .FooterThreeListingIcon{margin-right:14px;position:relative;top:-2px}.FooterThreeMainContainer .FooterThreeSocial{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:end}.FooterThreeMainContainer .FooterThreeSocial,.FooterThreeMainContainer .FooterThreeSocial a{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.FooterThreeMainContainer .FooterThreeSocial a{min-width:60px;min-height:60px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:100px;margin-right:12px}.FooterThreeMainContainer .FooterThreeSocial a img{width:56px}.FooterThreeMainContainer .FooterThreeBorder{margin-top:10px;margin-bottom:10px}.FooterThreeMainContainer .FooterThreeRowTwo{margin-top:30px}.FooterThreeMainContainer .FooterThreeRowTwo .FooterThreeListingContactInfo .FooterThreeListingTitle{font-size:14px;font-weight:400;margin-bottom:4px}.FooterThreeMainContainer .FooterThreeRowTwo .FooterThreeLocatioIcon{text-align:left;margin-left:35px}.FooterThreeHelping{background:#fff;max-width:445px}.FooterThreeMainContainer .FooterThreeListinCol:last-child{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;margin-bottom:0!important}.FooterThreeColSubText{font-size:14px;text-transform:uppercase;opacity:.6;margin-bottom:17px;font-family:Poppins,sans-serif}.FooterThreeTopLeft{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.FooterThreeTopLeft img{height:100px;width:100px;-o-object-fit:contain;object-fit:contain;margin-right:20px}.FooterThreeLink a{text-decoration:none;font-size:14px;font-weight:500;font-family:Poppins,sans-serif;margin-bottom:16px;display:block}.FooterThreeColTitle{margin-bottom:20px}.FooterThreeColTitle,.FooterThreeColTitleBottom{text-decoration:none;font-size:20px;font-weight:600;font-family:Poppins,sans-serif}.FooterThreeColTitleBottom{color:#4267b2;margin:0}.FooterThreeMainContainer .PrivacySection{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.FooterThreeMainContainer .PrivacySection a{text-decoration:none;font-size:14px;font-weight:400;opacity:.6}.FooterThreeMainContainer .PrivacySection a:hover{text-decoration:underline}.FooterThreeMainContainer .PrivacySection span{display:inline-block;margin:0 15px;opacity:.6}.FooterThreeMainContainer .PrivacySectionRight{text-decoration:none;font-size:14px;font-weight:400;opacity:.6}.FooterThreeMainContainer .logoBottom{padding:20px;background:#fff}.FooterThreeMainContainer .logoBottom img{max-width:56px;max-height:56px}.FooterThreeMainContainer .BottomBtnCtn{background:#f5f6f7;padding:20px}";
  styleInject(css_248z$a);

  function FooterThree(props) {
    var FooterThreeColOne = props.FooterThreeColOne,
        FooterThreeSocial = props.FooterThreeSocial,
        FooterThreeContactinfo = props.FooterThreeContactinfo,
        footerThreelinks = props.footerThreelinks;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterThreeMainContainer",
      style: {
        background: props.background
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterThreeContainer",
      style: {
        maxWidth: props.ContainerMaxWidth
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterThreeRowOne"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      sm: 7,
      md: 7
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterThreeCol FooterThreeTopLeft"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.logo
    }), /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterThreeOrgTitle",
      style: {
        color: props.color
      }
    }, props.ColTitleOne), FooterThreeColOne.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: "FooterThreeOrgParagraph",
        style: {
          color: props.color
        }
      }, item.description);
    })))), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      sm: 5,
      md: 5
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterThreeCol"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterThreeSocial"
    }, FooterThreeSocial.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        href: item.link,
        target: "blank"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        src: item.icon
      }));
    }))))))), props.FooterRowTwo && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterThreeBorder",
      style: {
        background: props.dividerLine,
        height: "1px"
      }
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterThreeContainer",
      style: {
        maxWidth: props.ContainerMaxWidth
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterThreeRowTwo"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      "class": ""
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterThreeHelping"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterThreeCol FooterThreeTopLeft logoBottom"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.Bottomlogo
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterThreeColTitleBottom"
    }, props.BottomTitle)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "BottomBtnCtn"
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.label,
      link: props.link,
      target: props.target,
      path: props.path,
      arrowIcon: props.arrowIcon,
      arrowStatus: props.arrowStatus,
      arrowColor: props.arrowColor,
      buttoncolor: props.buttoncolor,
      width: props.width,
      height: props.height,
      border: props.border,
      borderRadius: props.borderRadius,
      color: props.color,
      textAlign: props.textAlign
    }))))), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      sm: 3,
      md: 3
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterThreeColTitle",
      style: {
        color: props.color
      }
    }, props.TitleOne), FooterThreeContactinfo.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        "class": "FooterThreeListinCol"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        "class": "FooterThreeListingIcon",
        src: item.icon
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        "class": "FooterThreeListingContactInfo",
        style: {
          color: props.color
        }
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        "class": "FooterThreeListingTitle",
        style: {
          color: props.color
        }
      }, item.TextOne), /*#__PURE__*/React__default["default"].createElement("div", {
        "class": "FooterThreeListingTitle",
        style: {
          color: props.color
        }
      }, item.TextTwo)));
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      sm: 3,
      md: 3
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterThreeColTitle",
      style: {
        color: props.color
      }
    }, /*#__PURE__*/React__default["default"].createElement("a", null, props.TitleTwo)), footerThreelinks.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        "class": "FooterThreeLink",
        style: {
          color: props.color
        }
      }, /*#__PURE__*/React__default["default"].createElement("a", {
        style: {
          color: props.color
        },
        href: item.link
      }, item.label));
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      sm: 12,
      md: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterThreeBorder",
      style: {
        background: props.dividerLine,
        height: "1px"
      }
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PrivacySection"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PrivacySectionLeft"
    }, /*#__PURE__*/React__default["default"].createElement("a", {
      href: props.TosLink,
      style: {
        color: props.color
      }
    }, "TERMS OF SERVICES"), /*#__PURE__*/React__default["default"].createElement("span", {
      style: {
        color: props.color
      }
    }, "|"), /*#__PURE__*/React__default["default"].createElement("a", {
      href: props.ppLink,
      style: {
        color: props.color
      }
    }, "PRIVACY POLICY")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PrivacySectionRight",
      style: {
        color: props.color
      }
    }, "\xA9 2021 HELPING HAND FOR CHITTAGONIAN. ALL RIGHT RESERVED"))))))));
  }

  var css_248z$9 = "@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");.FooterFiveMainContainer{padding:20px 0}.FooterFiveMainContainer .FooterFiveContainer{margin:0 auto;padding:0 25px}.FooterFiveMainContainer .FooterFiveOrgTitle{font-size:20px;font-weight:900;font-family:Poppins,sans-serif;margin-bottom:12px}.FooterFiveMainContainer .FooterFiveOrgParagraph{font-size:14px;font-weight:400;font-family:Poppins,sans-serif;line-height:20px;margin:0!important}.FooterFiveMainContainer .FooterFiveListinCol{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;margin-bottom:20px}.FooterFiveMainContainer .FooterFiveListinCol .FooterFiveListingInfo{padding-bottom:20px;width:90%}.FooterFiveMainContainer .FooterFiveListinCol .FooterFiveListingInfo .FooterFiveListingTitle{font-size:14px;font-weight:700;font-family:Poppins,sans-serif;margin-bottom:6px;line-height:20px}.FooterFiveMainContainer .FooterFiveListinCol .FooterFiveListingInfo .FooterFiveListingSubTitle{font-size:12px;font-weight:400;font-family:Poppins,sans-serif;line-height:16px;opacity:.6}.FooterFiveMainContainer .FooterFiveListinCol .FooterFiveListingIcon{margin-right:14px;position:relative;top:-2px}.FooterFiveMainContainer .FooterFiveSocial{padding-top:20px}.FooterFiveMainContainer .FooterFiveSocial,.FooterFiveMainContainer .FooterFiveSocial a{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.FooterFiveMainContainer .FooterFiveSocial a{min-width:60px;min-height:60px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:100px;margin-right:12px}.FooterFiveMainContainer .FooterFiveSocial a img{width:56px}.FooterFiveMainContainer .FooterFiveBorder{margin-top:10px;margin-bottom:10px}.FooterFiveMainContainer .FooterFiveRowTwo{margin-top:30px}.FooterFiveColSubText{font-size:14px;text-transform:uppercase;opacity:.6;margin-bottom:17px;font-family:Poppins,sans-serif}.FooterFiveTopLeft{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.FooterFiveTopLeft img{height:100px;width:100px;-o-object-fit:contain;object-fit:contain;margin-right:20px}.FooterFiveLink a{font-size:14px;margin-bottom:16px;display:block}.FooterFiveColTitle,.FooterFiveLink a{text-decoration:none;font-weight:500;font-family:Poppins,sans-serif}.FooterFiveColTitle{font-size:20px;margin-bottom:0;display:inline-block;padding:4px 8px}.FooterFiveColTitleBottom{text-decoration:none;font-size:20px;font-weight:600;font-family:Poppins,sans-serif;color:#4267b2;margin:0}.FooterFiveMainContainer .PrivacySection{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.FooterFiveMainContainer .PrivacySection a{text-decoration:none;font-size:14px;font-weight:400;opacity:.6}.FooterFiveMainContainer .PrivacySection a:hover{text-decoration:underline}.FooterFiveMainContainer .PrivacySection span{display:inline-block;margin:0 15px;opacity:.6}.FooterFiveMainContainer .PrivacySectionRight{text-decoration:none;font-size:14px;font-weight:400;opacity:.6}.footerFiveAboutText p{font-size:14px;font-weight:400;font-family:Poppins,sans-serif;line-height:24px}.FooterFiveListingContactInfo{padding-bottom:24px}.FooterFiveListingContactInfo h3{font-weight:600}.FooterFiveListingContactInfo h3,.FooterFiveListingContactInfo p{margin:0;font-size:14px;font-family:Poppins,sans-serif;line-height:24px}.FooterFiveListingContactInfo p{font-weight:400}.FooterFiveListingContactInfo a{font-size:14px;font-weight:400;font-family:Poppins,sans-serif;line-height:24px;display:-webkit-box;display:-ms-flexbox;display:flex;text-decoration:none;margin:15px 0 0}.FooterFiveListingContactInfo a svg{font-size:18px;position:relative;top:4px;margin-left:8px}.FooterFiveMainContainer .SlatTableFooter{padding-left:0}";
  styleInject(css_248z$9);

  function FooterFive(props) {
    var footerFiveSocial = props.footerFiveSocial;
        props.footerFivelinks;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterFiveMainContainer",
      style: {
        background: props.background
      }
    }, props.FooterRowTwo && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterFiveContainer",
      style: {
        maxWidth: props.ContainerMaxWidth
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterFiveRowTwo"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      sm: 4,
      md: 4
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterFiveColTitle",
      style: {
        color: props.color,
        background: props.Titlebackground
      }
    }, props.TitleAbout), /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        background: props.Titlebackground,
        height: "2px",
        width: "100%",
        marginBottom: "24px"
      }
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "footerFiveAboutText"
    }, /*#__PURE__*/React__default["default"].createElement("p", {
      style: {
        color: props.color
      }
    }, props.AboutTextOne), /*#__PURE__*/React__default["default"].createElement("p", {
      style: {
        color: props.color
      }
    }, props.AboutTextTwo)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterFiveCol"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterFiveSocial"
    }, footerFiveSocial.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        href: item.link,
        target: "blank"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        src: item.icon
      }));
    })))), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      sm: 4,
      md: 4
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterFiveColTitle",
      style: {
        color: props.color,
        background: props.Titlebackground
      }
    }, props.TitleContactIfo), /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        background: props.Titlebackground,
        height: "2px",
        width: "100%",
        marginBottom: "24px"
      }
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterFiveListingContactInfo"
    }, /*#__PURE__*/React__default["default"].createElement("h3", {
      style: {
        color: props.color
      }
    }, "Address:"), /*#__PURE__*/React__default["default"].createElement("p", {
      style: {
        color: props.color
      }
    }, props.address), /*#__PURE__*/React__default["default"].createElement("a", {
      href: props.getDirectionLink,
      style: {
        color: props.color
      },
      target: props.getDirectiontarget
    }, "Get Directions ", /*#__PURE__*/React__default["default"].createElement(DirectionsOutlinedIcon__default["default"], null))), /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterFiveListingContactInfo"
    }, /*#__PURE__*/React__default["default"].createElement("h3", {
      style: {
        color: props.color
      }
    }, "Phone:"), /*#__PURE__*/React__default["default"].createElement("p", {
      style: {
        color: props.color
      }
    }, props.phoneOne), /*#__PURE__*/React__default["default"].createElement("p", {
      style: {
        color: props.color
      }
    }, props.phoneOne)), /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterFiveListingContactInfo"
    }, /*#__PURE__*/React__default["default"].createElement("h3", {
      style: {
        color: props.color
      }
    }, "Email:"), /*#__PURE__*/React__default["default"].createElement("p", {
      style: {
        color: props.color
      }
    }, props.email), /*#__PURE__*/React__default["default"].createElement("a", {
      href: props.contactLink,
      style: {
        color: props.color
      },
      target: props.contactTarget
    }, "Contact Us ", /*#__PURE__*/React__default["default"].createElement(ArrowForwardRoundedIcon__default["default"], null)))), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      sm: 4,
      md: 4
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      "class": "FooterFiveColTitle",
      style: {
        color: props.color,
        background: props.Titlebackground
      }
    }, /*#__PURE__*/React__default["default"].createElement("a", null, props.TitleIqamah)), /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        background: props.Titlebackground,
        height: "2px",
        width: "100%",
        marginBottom: "24px"
      }
    }), /*#__PURE__*/React__default["default"].createElement(SalatTable, {
      title: "HAJJ 2021 PACKAGES",
      tableBodyData: props.tableBodyData //odd="#005EBB"
      //even="#0868C9"
      ,
      colBorder: "#E4E8EC 1px solid",
      col1Color: "#fff",
      col2Color: "#fff",
      ColPadding: "9px 0px !important",
      footerText: props.SlatTablebottomText,
      footerTextStatus: true,
      bottomTextSpace: "10px"
    })), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      xs: 12,
      sm: 12,
      md: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "FooterFiveBorder",
      style: {
        background: props.dividerLine,
        height: "1px"
      }
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PrivacySection"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PrivacySectionLeft"
    }, /*#__PURE__*/React__default["default"].createElement("a", {
      href: props.TosLink,
      style: {
        color: props.color
      }
    }, "TERMS OF SERVICES"), /*#__PURE__*/React__default["default"].createElement("span", {
      style: {
        color: props.color
      }
    }, "|"), /*#__PURE__*/React__default["default"].createElement("a", {
      href: props.ppLink,
      style: {
        color: props.color
      }
    }, "PRIVACY POLICY")), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "PrivacySectionRight",
      style: {
        color: props.color
      }
    }, props.allRightText))))))));
  }

  var css_248z$8 = "@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");.ModalThree .ModalThreeContainer{background:#fff;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);border-radius:4px;padding:60px}.ModalThree .ModalThreeIconCtn .closeIcon{color:#9593b3;position:absolute;right:10px;cursor:pointer;top:11px}.ModalThree .ModalThreeMdlBody h2{font-size:20px;font-family:Poppins,sans-serif!important;font-weight:600;margin:0 0 24px}.ModalThree .ModalThreeMdlBody p{font-size:14px;color:#4c5e67;font-family:Poppins,sans-serif!important;font-weight:500;margin:0 0 8px}.ModalThree .ModalThreeMdlBody a{color:#0b132b;font-size:16px;font-weight:600;text-decoration:none}";
  styleInject(css_248z$8);

  function ModalThree(props) {
    var _React$useState = React__default["default"].useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2);
        _React$useState2[0];
        _React$useState2[1];

    return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(Modal__default["default"], {
      "aria-labelledby": "transition-modal-title",
      "aria-describedby": "transition-modal-description",
      open: props.open,
      onClose: props.handleClose,
      closeAfterTransition: true,
      BackdropComponent: Backdrop__default["default"],
      BackdropProps: {
        timeout: 500
      }
    }, /*#__PURE__*/React__default["default"].createElement(Fade__default["default"], {
      "in": props.open
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ModalThree"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ModalThreeContainer",
      style: {
        width: props.width
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ModalThreeIconCtn"
    }, /*#__PURE__*/React__default["default"].createElement(CloseRoundedIcon__default["default"], {
      className: "closeIcon",
      onClick: function onClick() {
        return props.handleClose();
      }
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ModalThreeMdlBody"
    }, /*#__PURE__*/React__default["default"].createElement("h2", {
      style: {
        color: props.titileColor
      }
    }, props.title), props.body))))));
  }

  var css_248z$7 = "@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");.ModalFour{background:#fff;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);border-radius:4px}.ModalFour .ModalFourContainer{position:relative}.ModalFour .ModalFourIconCtn{border-bottom:1px solid #dedded;padding:14px 20px}.ModalFour .ModalFourIconCtn h2{font-size:14px;font-family:Poppins,sans-serif!important;font-weight:400;margin:0;color:#676c7b}.ModalFour .ModalFourIconCtn .closeIcon{color:#9593b3;position:absolute;right:10px;cursor:pointer;top:11px}.ModalFour .ModalFourMdlBody{padding:32px 60px;overflow-y:auto}.ModalFour .ModalFourMdlBody p{font-size:14px;color:#4c5e67;font-family:Poppins,sans-serif!important;font-weight:500;margin:0 0 8px}.ModalFour .ModalFourMdlBody a{color:#0b132b;font-size:16px;font-weight:600;text-decoration:none}.ModalFour .ModalFourimg{width:100%;-o-object-fit:cover;object-fit:cover}.ModalFour .ModalFoureventTitle{color:#0b132b;font-size:20px;font-weight:700;font-family:Poppins,sans-serif!important}.ModalFour .ModalFoureventdetails{margin-top:12px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;max-width:500px;margin-bottom:16px}.ModalFour .ModalFoureventdetails,.ModalFour .ModalFoureventdetailsinner{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ModalFour .ModalFoureventdetailsinner h4{color:#0b132b;font-size:14px;font-weight:600;font-family:Poppins,sans-serif!important;margin:0 5px 0 0}.ModalFour .ModalFourBody p{color:#0b132b;line-height:30px}.ModalFour .ModalFourBody p,.ModalFour .ModalFoureventdetailsinner a{font-size:14px;font-weight:400;font-family:Poppins,sans-serif!important;margin:0}.ModalFour .ModalFoureventdetailsinner a{color:#07f}.ModalFour .ModalFoureventdetailsinner a:hover{text-decoration:underline}.ModalFourFooter{background:#f7f9fa;padding:16px 0;position:absolute;bottom:0;left:0;width:100%;text-align:center}";
  styleInject(css_248z$7);

  function ModalFour(props) {
    var _React$useState = React__default["default"].useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2);
        _React$useState2[0];
        _React$useState2[1];

    return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(Modal__default["default"], {
      "aria-labelledby": "transition-modal-title",
      "aria-describedby": "transition-modal-description",
      open: props.open,
      onClose: props.handleClose,
      closeAfterTransition: true,
      BackdropComponent: Backdrop__default["default"],
      BackdropProps: {
        timeout: 500
      }
    }, /*#__PURE__*/React__default["default"].createElement(Fade__default["default"], {
      "in": props.open
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ModalFour"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ModalFourContainer",
      style: {
        width: props.width
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ModalFourIconCtn"
    }, /*#__PURE__*/React__default["default"].createElement("h2", null, props.title), /*#__PURE__*/React__default["default"].createElement(CloseRoundedIcon__default["default"], {
      className: "closeIcon",
      onClick: function onClick() {
        return props.handleClose();
      }
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ModalFourMdlBody",
      style: {
        height: props.height
      }
    }, props.imgstatus && /*#__PURE__*/React__default["default"].createElement("img", {
      className: "ModalFourimg",
      src: props.img
    }), props.eventTitleStatus && /*#__PURE__*/React__default["default"].createElement("h1", {
      className: "ModalFoureventTitle"
    }, props.eventTitle), props.LocationStatus && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ModalFoureventdetails"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ModalFoureventdetailsinner"
    }, /*#__PURE__*/React__default["default"].createElement("h4", null, "Location:"), /*#__PURE__*/React__default["default"].createElement("p", null, props.location)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ModalFoureventdetailsinner"
    }, /*#__PURE__*/React__default["default"].createElement("h4", null, "Program:"), /*#__PURE__*/React__default["default"].createElement("a", {
      href: props.Programlink
    }, props.Program))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ModalFourBody"
    }, props.body))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ModalFourFooter"
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.buttonlabel,
      link: props.buttonlink,
      target: props.target,
      path: props.path,
      arrowIcon: /*#__PURE__*/React__default["default"].createElement(ArrowForwardRoundedIcon__default["default"], null),
      arrowStatus: props.buttonarrowStatus,
      arrowColor: props.buttonarrowColor,
      buttoncolor: props.buttoncolor,
      width: props.buttonwidth,
      height: props.buttonheight,
      borderRadius: props.ButtonRadius,
      color: props.color,
      textAlign: props.textAlign
    }))))));
  }

  var css_248z$6 = ".contactinfoContainer{position:relative}.ContactInfoOne .contactinfoContainer .contactinfoTitle{font-size:16px;text-transform:uppercase;font-weight:500}.ContactInfoOne .ContactIfoListContainer{margin-top:12px}.ContactInfoOne .ContactIfoListContainer .ContactIfoList{color:#0b132b;font-size:16px;font-weight:400;line-height:24px;letter-spacing:0;display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:10px}.ContactInfoOne .ContactIfoListContainer .ContactIfoList svg{color:#5e6474;font-size:21px;margin-right:10px}.ContactInfoOne .ContactIfoListContainer .ContactIfoList span{font-weight:600}.ContactInfoOne .masterLiSocialLinks a{display:inline-block;margin:15px 4px}.ContactInfoOne .masterLiSocialLinks a img{width:44px}.ContactInfoOne .ContactIfoAddressContainer .ContactIfoAddressCard{background:#fff;padding:20px;text-align:center}.ContactInfoOne .ContactIfoAddressContainer .ContactIfoAddressCard .ContactIfoAddressCol{color:#56b149;text-transform:uppercase;font-size:16px;line-height:24px;letter-spacing:0;font-weight:500;margin:0 0 8px}.ContactInfoOne .ContactIfoAddressContainer .ContactIfoAddressCard .ContactIfoNameCol{color:#0b132b;font-size:16px;line-height:24px;letter-spacing:0;font-weight:400;margin:0 0 5px}.ContactInfoOne .ContactIfoAddressContainer .ContactIfoAddressCard .ContactIfoNumberCol{color:#0b132b;font-size:16px;line-height:24px;letter-spacing:0;margin:0;font-weight:600}.ContactInfoOne .whatsappIcon{position:fixed;right:20px;bottom:14px}.ContactInfoOne .whatsappIcon img{width:68px}.ContactInfoOne .contactFormContainer .MuiGrid-root{margin-bottom:10px!important}.ContactInfoOneImg{width:100%;height:260px;overflow:hidden;margin-bottom:20px}.ContactInfoOneImg img{width:100%;-o-object-fit:cover;object-fit:cover;height:100%}";
  styleInject(css_248z$6);

  function ContactInfoOne(props) {
    var contactDetails = props.contactDetails,
        socialLinks = props.socialLinks;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ContactInfoOne"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "contactinfoContainer"
    }, props.imgStatus && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ContactInfoOneImg"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.img,
      alt: "Office image"
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "contactinfoTitle",
      style: {
        color: props.titleColor
      }
    }, props.title), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ContactIfoListContainer"
    }, contactDetails.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("li", {
        className: "ContactIfoList"
      }, /*#__PURE__*/React__default["default"].createElement("span", null, item.icon, " "), " ", item.details);
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "masterLiSocialLinks"
    }, socialLinks.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("a", {
        href: item.link,
        target: "blank"
      }, item.icon);
    }))));
  }

  var css_248z$5 = ".NavBarThree{background:#fff;-webkit-box-shadow:0 2px 6px 0 hsla(0,0%,68.6%,.51);box-shadow:0 2px 6px 0 hsla(0,0%,68.6%,.51);width:100%;z-index:99999;top:0;left:0}.NavBarThree .HeaderOneContainer{margin:0 auto;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0 25px}.NavBarThree .HeaderOneContainer,.NavBarThree .HeaderOneContainer .HeaderOnesiteLogo{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.NavBarThree .HeaderOneContainer .HeaderOnesiteLogo{height:80px;margin-right:30px}.NavBarThree .HeaderOneContainer .HeaderOnesiteLogo a{display:inline-block;cursor:pointer}.NavBarThree .HeaderOneContainer .HeaderOnesiteLogo a img{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}.NavBarThree .is-active{color:#ff5800!important}.NavBarThree .navBar .col-md-3{z-index:7}.NavBarThree ul.main-menu{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;list-style:none;margin:0 auto;padding:0;float:right;z-index:7}.NavBarThree ul.main-menu>li.menu-item:first-child{padding-left:0;margin-left:0}.NavBarThree .menu-item{line-height:23px}li{list-style-type:none}.NavBarThree .menu-item a{height:80px;text-decoration:none;padding:0 13px;font-size:14px;color:#676c7b;line-height:24px;font-weight:500;text-transform:uppercase;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex}.NavBarThree .header__middle__menus,.NavBarThree .menu-item a{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.NavBarThree .header__middle__menus{display:block;-webkit-box-flex:1;-ms-flex:1;flex:1}.NavBarThree .menu-item.menu__qqqitem a{margin:27px 10px}.NavBarThree .header__middle__search{width:7%;display:inline-block;float:right;padding:36px 3px 27px;border-left:1px solid #e6e6fa}.NavBarThree .header__middle{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;float:left;border-bottom:1px dashed #e6e6fa;position:relative}.NavBarThree .header__middle__logo>a>h1{color:#07a8ff;text-transform:uppercase;text-decoration:none;margin-top:33px}.NavBarThree .header__middle__menus span.text{position:absolute;right:177px;bottom:10px;font-size:14px;color:#ff1800}.NavBarThree .sub__menus__arrows{position:relative}.NavBarThree .sub__menus__arrows svg,.sub__menus__arrows__full svg{padding-top:0}.NavBarThree .sub__menus{position:absolute;display:none;background:#fff;border:1px solid #e6e6fa;min-width:300px;left:-13px;padding:0;z-index:1000;-webkit-box-shadow:0 2px 7px hsla(0,0%,76.5%,.25);box-shadow:0 2px 7px hsla(0,0%,76.5%,.25);top:80px;border-radius:0 0 4px 4px}.NavBarThree .headerTopContentContainer{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:end;padding:10px 0}.NavBarThree .headerTopContentContainer,.NavBarThree .SocialIcon{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.NavBarThree .SocialIcon{width:40px;height:40px;border-radius:100px;text-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.NavBarThree .HeaderCallCol{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.NavBarThree .HeaderCallCol span{margin-right:10px}.NavBarThree .HeaderCallCol a{margin-right:10px;text-decoration:none;font-size:12px}.NavBarThreeSoial .SocialIcon img{width:24px}.NavBarThreeSoial,.NavBarThreeSoial .SocialIcon span{display:-webkit-box;display:-ms-flexbox;display:flex}.NavBarThreeSoial{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.NavBarThreeSoial .SocialIcon{margin:0 4px;cursor:pointer}.headerTopContentContainer .S-line{width:1px;height:37px;margin:0 25px}@media (max-width:767px){.NavBarThree .header__middle .active{color:#ff3d00!important}}.NavBarThree .sub__menus__arrows:hover .sub__menus{display:block}.NavBarThree .sub__menus__arrows__full:hover .sub__menus{display:block;z-index:1000000}.NavBarThree .menu-item .sub__menus a{padding:7px 27px;height:auto;display:block;font-size:14px}.NavBarThree .menu-item:hover>a{color:#0053a5!important}.NavBarThree .menu-item .sub__menus li:hover a{color:#0053a5!important;background:#f7f9fa}.NavBarThree .header__middle__logo img{max-width:207px;margin:17px 0 0}.NavBarThree .HeaderOneButtonDekstop{margin-left:13px}.mobileview{display:none}@media(max-width:768px){.NavBarThree .header__middle__logo img{max-width:197px;margin:27px 0 0}.NavBarThree .main-nav .menu-item:hover>a{color:#07a8ff!important}.NavBarThree .main-nav .menubar__button{display:block!important;cursor:pointer;position:relative;z-index:10037;top:4px}.NavBarThree .main-nav .menubar__button svg{font-size:27px}.NavBarThree .menu-item a{height:auto;text-decoration:none;padding:4px 13px;font-size:14px;color:#2b3a42!important;line-height:24px;font-weight:500;text-transform:uppercase;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.NavBarThree .main-nav ul.menuq2{display:block!important;position:absolute;left:0;z-index:10007;background-color:#fff;border-bottom:3px solid #006db4;right:0;padding-bottom:0;padding-top:0;top:60px;border-top:1px solid #ebebeb}.NavBarThree .sub__menus{width:100%;top:0;left:0;position:relative;-webkit-box-shadow:none;box-shadow:none;border-left:none!important;border-right:none!important;background:#fdfdfd}.NavBarThree .HeaderOneContainer .HeaderOnesiteLogo{height:60px}.NavBarThree .HeaderOneContainer .HeaderOnesiteLogo a{max-width:160px!important}.NavBarThree .main-nav .menu-item a{margin:10px 17px;text-align:center;color:#000}.NavBarThree .main-nav ul.main-menu{display:none}.NavBarThree .main-nav .sub__menus__arrows:hover .sub__menus{margin:0 auto;left:0;right:0}.NavBarThree .sub__menus__Active{display:block!important;margin:0 auto;left:0;right:0}.NavBarThree .sub__menus__Active2{display:block!important}.NavBarThree .menus__categorysss,.NavBarThree .menus__categorysss2{display:none}.NavBarThree .menu-item .sub__menus__full a{text-align:left}.NavBarThree .HeaderOneButtonDekstop{display:none}.dekstopview{display:none!important}.mobileview{display:block}.NavBarThree .SocialIcon{width:40px;height:40px;min-width:40px;min-height:40px}.menuContainer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}}@media(max-width:560px){.NavBarThree .SocialIcon{width:30px;height:30px;min-width:30px;min-height:30px}.NavBarThreeSoial .SocialIcon img{width:18px}.NavBarThree .HeaderCallCol a{margin-right:0;text-decoration:none;font-size:12px}.HeaderCallCol svg{width:18px}.headerTopContentContainer .S-line{width:1px;height:37px;margin:0 10px}.NavBarThree .headerTopContentContainer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:10px 0;-webkit-box-align:center;-ms-flex-align:center;align-items:center}}";
  styleInject(css_248z$5);

  function Dropdown$1(props) {
    var _useState = React.useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        isMenuSubMenu = _useState2[0];
        _useState2[1];

    var boxClassSubMenu = ["sub__menus"];
    isMenuSubMenu ? boxClassSubMenu.push('sub__menus__Active') : boxClassSubMenu.push('');
    return /*#__PURE__*/React__default["default"].createElement("ul", {
      className: boxClassSubMenu.join(' ')
    }, props.children && props.children.map(function (child, i) {
      return /*#__PURE__*/React__default["default"].createElement("li", null, " ", /*#__PURE__*/React__default["default"].createElement("a", {
        activeClassName: "is-active",
        href: child.link
      }, " ", child.label, " "), " ");
    }));
  }

  function NavBarThree(props) {
    var menuData = props.menuData,
        socialIconData = props.socialIconData;

    var _useState = React.useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        isMenu = _useState2[0],
        setisMenu = _useState2[1];

    var _useState3 = React.useState(false),
        _useState4 = _slicedToArray(_useState3, 2),
        isResponsiveclose = _useState4[0],
        setResponsiveclose = _useState4[1];

    var toggleClass = function toggleClass() {
      setisMenu(isMenu === false ? true : false);
      setResponsiveclose(isResponsiveclose === false ? true : false);
    };

    var boxClass = ["main-menu menu-right menuq1"];

    if (isMenu) {
      boxClass.push('menuq2');
    } else {
      boxClass.push('');
    }

    var _useState5 = React.useState(false),
        _useState6 = _slicedToArray(_useState5, 2),
        isMenuSubMenu = _useState6[0],
        setMenuSubMenu = _useState6[1];

    var toggleSubmenu = function toggleSubmenu() {
      setMenuSubMenu(isMenuSubMenu === false ? true : false);
    };

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "NavBarThree",
      style: {
        background: props.background,
        position: props.position
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "HeaderOneContainer",
      style: {
        maxWidth: props.maxWidth
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "HeaderOnesiteLogo dekstopview"
    }, /*#__PURE__*/React__default["default"].createElement("a", {
      exact: true,
      activeClassName: "is-active",
      href: props.logoLink,
      style: {
        maxWidth: props.LogoSize
      }
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.logo,
      alt: "logo"
    }))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "header__middle__menus"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "headerTopContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "headerTopContentContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "HeaderCallCol"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "SocialIcon",
      style: {
        background: props.CalliconBg
      }
    }, /*#__PURE__*/React__default["default"].createElement(CallIcon__default["default"], {
      style: {
        color: props.CalliconColor
      }
    })), /*#__PURE__*/React__default["default"].createElement("a", {
      style: {
        color: props.phonenumberColor
      },
      href: props.Cta
    }, props.phone)), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "S-line",
      style: {
        background: props.vrLineBg
      }
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "NavBarThreeSoial"
    }, socialIconData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("a", {
        className: "SocialIcon",
        style: {
          background: item.iconColor
        },
        href: item.link,
        target: "_blank"
      }, /*#__PURE__*/React__default["default"].createElement("span", null, item.icon));
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "HeaderOneButtonDekstop"
    }, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.buttonLebel,
      link: props.ButtonLink,
      target: props.target,
      path: props.path,
      arrowIcon: props.arrowIcon,
      arrowStatus: props.arrowStatus,
      arrowColor: props.arrowColor,
      buttoncolor: props.buttoncolor,
      width: props.width,
      height: props.height,
      border: props.border,
      borderRadius: props.borderRadius,
      color: props.colorlabel,
      fontWeight: props.fontWeight,
      textAlign: props.textAlign,
      handIconStatus: props.handIconStatus
    }))), /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        background: props.borderLine,
        height: "1px",
        width: "100%"
      }
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "menuContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "HeaderOnesiteLogo mobileview"
    }, /*#__PURE__*/React__default["default"].createElement("a", {
      exact: true,
      activeClassName: "is-active",
      href: props.logoLink,
      style: {
        maxWidth: props.LogoSize
      }
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.logo,
      alt: "logo"
    }))), props.MenuStatus && /*#__PURE__*/React__default["default"].createElement("nav", {
      className: "main-nav "
    }, isResponsiveclose === true ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "menubar__button",
      style: {
        display: 'none'
      },
      onClick: toggleClass
    }, " ", /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.CloseIcon
    }))) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "menubar__button",
      style: {
        display: 'none'
      },
      onClick: toggleClass
    }, " ", /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.MenuIcon
    }))), /*#__PURE__*/React__default["default"].createElement("ul", {
      className: boxClass.join(' ')
    }, menuData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("li", {
        onClick: toggleSubmenu,
        className: "menu-item sub__menus__arrows"
      }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        exact: true,
        activeClassName: "is-active",
        onClick: toggleClass,
        to: item.to,
        href: item.link
      }, " ", item.label, item.hasChildren && /*#__PURE__*/React__default["default"].createElement(KeyboardArrowDownRoundedIcon__default["default"], null)), /*#__PURE__*/React__default["default"].createElement(Dropdown$1, {
        children: item.children
      }));
    })))))));
  }

  var css_248z$4 = ".NavBarFour{background:#fff;-webkit-box-shadow:0 2px 6px 0 hsla(0,0%,68.6%,.51);box-shadow:0 2px 6px 0 hsla(0,0%,68.6%,.51);width:100%;z-index:99999;top:0;left:0}.NavBarFour .HeaderOneContainer{margin:0 auto;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0 25px}.NavBarFour .HeaderOneContainer,.NavBarFour .HeaderOneContainer .HeaderOnesiteLogo{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.NavBarFour .HeaderOneContainer .HeaderOnesiteLogo{height:80px;margin-right:30px}.NavBarFour .HeaderOneContainer .HeaderOnesiteLogo a{display:inline-block;cursor:pointer}.NavBarFour .HeaderOneContainer .HeaderOnesiteLogo a img{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}.NavBarFour .is-active{color:#ff5800!important}.NavBarFour .navBar .col-md-3{z-index:7}.NavBarFour ul.main-menu{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;list-style:none;margin:0 auto;padding:0;float:right;z-index:7}.NavBarFour ul.main-menu>li.menu-item:first-child{padding-left:0;margin-left:0}.NavBarFour .menu-item{line-height:23px}li{list-style-type:none}.NavBarFour .menu-item a{height:80px;text-decoration:none;padding:0 13px;font-size:14px;color:#676c7b;line-height:24px;font-weight:500;text-transform:uppercase;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex}.NavBarFour .header__middle__menus,.NavBarFour .menu-item a{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.NavBarFour .header__middle__menus{display:block;-webkit-box-flex:1;-ms-flex:1;flex:1}.NavBarFour .menu-item.menu__qqqitem a{margin:27px 10px}.NavBarFour .header__middle__search{width:7%;display:inline-block;float:right;padding:36px 3px 27px;border-left:1px solid #e6e6fa}.NavBarFour .header__middle{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;float:left;border-bottom:1px dashed #e6e6fa;position:relative}.NavBarFour .header__middle__logo>a>h1{color:#07a8ff;text-transform:uppercase;text-decoration:none;margin-top:33px}.NavBarFour .header__middle__menus span.text{position:absolute;right:177px;bottom:10px;font-size:14px;color:#ff1800}.NavBarFour .sub__menus__arrows{position:relative}.NavBarFour .sub__menus__arrows svg,.sub__menus__arrows__full svg{padding-top:0}.NavBarFour .sub__menus{position:absolute;display:none;background:#fff;border:1px solid #e6e6fa;min-width:300px;left:-13px;padding:0;z-index:1000;-webkit-box-shadow:0 2px 7px hsla(0,0%,76.5%,.25);box-shadow:0 2px 7px hsla(0,0%,76.5%,.25);top:80px;border-radius:0 0 4px 4px}.NavBarFour .headerTopContentContainer{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:10px 0}.NavBarFour .headerTopContentContainer,.NavBarFour .SocialIcon{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.NavBarFour .SocialIcon{width:40px;height:40px;border-radius:100px;text-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.NavBarFour .HeaderCallCol{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.NavBarFour .HeaderCallCol span{margin-right:10px}.NavBarFour .HeaderCallCol a{margin-right:10px;text-decoration:none;font-size:12px}.NavBarFour .NavBarFourSoial .SocialIcon img{width:24px}.NavBarFour .NavBarFourSoial,.NavBarFour .NavBarFourSoial .SocialIcon span{display:-webkit-box;display:-ms-flexbox;display:flex}.NavBarFour .NavBarFourSoial{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.NavBarFour .NavBarFourSoial .SocialIcon{margin:0 4px;cursor:pointer}.NavBarFour .headerTopContentContainer .S-line{width:1px;height:37px;margin:0 25px}.NavBarFour .menuContainer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}@media (max-width:767px){.NavBarFour .header__middle .active{color:#ff3d00!important}}.NavBarFour .sub__menus__arrows:hover .sub__menus{display:block}.NavBarFour .sub__menus__arrows__full:hover .sub__menus{display:block;z-index:1000000}.NavBarFour .menu-item .sub__menus a{padding:7px 27px;height:auto;display:block;font-size:14px}.NavBarFour .menu-item:hover>a{color:#0053a5!important}.NavBarFour .menu-item .sub__menus li:hover a{color:#0053a5!important;background:#f7f9fa}.NavBarFour .header__middle__logo img{max-width:207px;margin:17px 0 0}.NavBarFour .HeaderOneButtonDekstop{margin-left:13px}.NavBarFour .MobileView{display:none!important}@media(max-width:768px){.NavBarFour .DekstopView{display:none!important}.NavBarFour .MobileView{display:block!important}.NavBarFour .header__middle__logo img{max-width:197px;margin:27px 0 0}.NavBarFour .main-nav .menu-item:hover>a{color:#07a8ff!important}.NavBarFour .main-nav .menubar__button{display:block!important;cursor:pointer;position:relative;z-index:10037;top:4px}.NavBarFour .main-nav .menubar__button svg{font-size:27px}.NavBarFour .menu-item a{height:auto;text-decoration:none;padding:4px 13px;font-size:14px;color:#2b3a42!important;line-height:24px;font-weight:500;text-transform:uppercase;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.NavBarFour .main-nav ul.menuq2{display:block!important;position:absolute;left:0;z-index:10007;background-color:#fff;border-bottom:3px solid #006db4;right:0;padding-bottom:0;padding-top:0;top:60px;border-top:1px solid #ebebeb}.NavBarFour .sub__menus{width:100%;top:0;left:0;position:relative;-webkit-box-shadow:none;box-shadow:none;border-left:none!important;border-right:none!important;background:#fdfdfd}.NavBarFour .HeaderOneContainer .HeaderOnesiteLogo{height:60px}.NavBarFour .HeaderOneContainer .HeaderOnesiteLogo a{max-width:160px!important}.NavBarFour .main-nav .menu-item a{margin:10px 17px;text-align:center;color:#000}.NavBarFour .main-nav ul.main-menu{display:none}.NavBarFour .main-nav .sub__menus__arrows:hover .sub__menus{margin:0 auto;left:0;right:0}.NavBarFour .sub__menus__Active{display:block!important;margin:0 auto;left:0;right:0}.NavBarFour .sub__menus__Active2{display:block!important}.NavBarFour .menus__categorysss,.NavBarFour .menus__categorysss2{display:none}.NavBarFour .menu-item .sub__menus__full a{text-align:left}.NavBarFour .menuContainer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.NavBarFour .HeaderOneContainer .HeaderOnesiteLogo a img{position:relative;top:6px}}";
  styleInject(css_248z$4);

  function Dropdown(props) {
    var _useState = React.useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        isMenuSubMenu = _useState2[0];
        _useState2[1];

    var boxClassSubMenu = ["sub__menus"];
    isMenuSubMenu ? boxClassSubMenu.push('sub__menus__Active') : boxClassSubMenu.push('');
    return /*#__PURE__*/React__default["default"].createElement("ul", {
      className: boxClassSubMenu.join(' ')
    }, props.children && props.children.map(function (child, i) {
      return /*#__PURE__*/React__default["default"].createElement("li", null, " ", /*#__PURE__*/React__default["default"].createElement("a", {
        activeClassName: "is-active",
        href: child.link
      }, " ", child.label, " "), " ");
    }));
  }

  function NavBarFour(props) {
    var menuData = props.menuData,
        socialIconData = props.socialIconData;

    var _useState = React.useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        isMenu = _useState2[0],
        setisMenu = _useState2[1];

    var _useState3 = React.useState(false),
        _useState4 = _slicedToArray(_useState3, 2),
        isResponsiveclose = _useState4[0],
        setResponsiveclose = _useState4[1];

    var toggleClass = function toggleClass() {
      setisMenu(isMenu === false ? true : false);
      setResponsiveclose(isResponsiveclose === false ? true : false);
    };

    var boxClass = ["main-menu menu-right menuq1"];

    if (isMenu) {
      boxClass.push('menuq2');
    } else {
      boxClass.push('');
    }

    var _useState5 = React.useState(false),
        _useState6 = _slicedToArray(_useState5, 2),
        isMenuSubMenu = _useState6[0],
        setMenuSubMenu = _useState6[1];

    var toggleSubmenu = function toggleSubmenu() {
      setMenuSubMenu(isMenuSubMenu === false ? true : false);
    };

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "NavBarFour",
      style: {
        background: props.background,
        position: props.position
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "HeaderOneContainer",
      style: {
        maxWidth: props.maxWidth
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "header__middle__menus"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "headerTopContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "headerTopContentContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "NavBarFourSoial"
    }, socialIconData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("a", {
        className: "SocialIcon",
        style: {
          background: item.iconColor
        },
        href: item.link,
        target: "_blank"
      }, /*#__PURE__*/React__default["default"].createElement("span", null, item.icon));
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "HeaderOnesiteLogo DekstopView"
    }, /*#__PURE__*/React__default["default"].createElement("a", {
      exact: true,
      activeClassName: "is-active",
      href: props.logoLink,
      style: {
        maxWidth: props.LogoSize
      }
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.logo,
      alt: "logo"
    }))), /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.buttonLebel,
      link: props.ButtonLink,
      target: props.target,
      path: props.path,
      arrowIcon: props.arrowIcon,
      arrowStatus: props.arrowStatus,
      arrowColor: props.arrowColor,
      buttoncolor: props.buttoncolor,
      width: props.width,
      height: props.height,
      border: props.border,
      borderRadius: props.borderRadius,
      color: props.colorlabel,
      fontWeight: props.fontWeight,
      textAlign: props.textAlign,
      handIconStatus: props.handIconStatus
    }))), /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        background: props.borderLine,
        height: "1px",
        width: "100%"
      }
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "menuContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "HeaderOnesiteLogo MobileView"
    }, /*#__PURE__*/React__default["default"].createElement("a", {
      exact: true,
      activeClassName: "is-active",
      href: props.logoLink,
      style: {
        maxWidth: props.LogoSize
      }
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.logo,
      alt: "logo"
    }))), props.MenuStatus && /*#__PURE__*/React__default["default"].createElement("nav", {
      className: "main-nav "
    }, isResponsiveclose === true ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "menubar__button",
      style: {
        display: 'none'
      },
      onClick: toggleClass
    }, " ", /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.CloseIcon
    }))) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "menubar__button",
      style: {
        display: 'none'
      },
      onClick: toggleClass
    }, " ", /*#__PURE__*/React__default["default"].createElement("img", {
      src: props.MenuIcon
    }))), /*#__PURE__*/React__default["default"].createElement("ul", {
      className: boxClass.join(' ')
    }, menuData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("li", {
        onClick: toggleSubmenu,
        className: "menu-item sub__menus__arrows"
      }, /*#__PURE__*/React__default["default"].createElement(Link__default["default"], {
        exact: true,
        activeClassName: "is-active",
        to: item.to,
        href: item.link
      }, " ", item.label, item.hasChildren && /*#__PURE__*/React__default["default"].createElement(KeyboardArrowDownRoundedIcon__default["default"], null)), /*#__PURE__*/React__default["default"].createElement(Dropdown, {
        children: item.children
      }));
    })))))));
  }

  var css_248z$3 = ".TitleTwoContainer .TitleTwoTextContainer{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.TitleTwoContainer .TitleTwoTextContainer h1{font-size:20px;text-transform:uppercase;line-height:24px;font-weight:500;margin:0;padding:4px 8px}.TitleTwoContainer .TitleTwoReadMoreBtn{border-radius:4px!important;color:#333!important;font-size:14px!important;height:50px;letter-spacing:1px!important;text-align:center;text-transform:uppercase!important;font-weight:700!important;padding:0 24px!important}.TitleTwoContainer .read_more_btn svg{font-size:15px;margin-left:3px;position:relative;top:-1px}.TitleTwoContainer .read_more_btn:hover{background:#0053a5!important;border:1px solid #0052a5!important;color:#fff!important}.TitleTwoContainer .TitlOneeLine{height:2px;display:block}.TitleTwoContainer .MsInputButtonMainContainer .MsInputButton{padding:0!important;text-transform:none!important}@media (max-width:768px){.TitleTwoContainer{display:block}}";
  styleInject(css_248z$3);

  function TitleTwo(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TitleTwoContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TitleTwoTextContainer"
    }, /*#__PURE__*/React__default["default"].createElement("h1", {
      style: {
        color: props.TitleColor,
        background: props.background
      }
    }, props.Title), props.Button && /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.buttonLebel,
      onClick: props.onClick,
      link: props.Link,
      target: props.target,
      arrowIcon: props.arrowIcon,
      arrowColor: props.arrowColor,
      arrowStatus: props.arrowStatus,
      buttoncolor: props.buttoncolor,
      width: props.width,
      height: props.height,
      border: props.border,
      borderRadius: props.borderRadius,
      color: props.colorlabel,
      fontWeight: props.fontWeight,
      textAlign: props.textAlign
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TitlOneeLineContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TitlOneeLine",
      style: {
        background: props.background
      }
    })));
  }

  var css_248z$2 = ".SocialMediaOne{margin:0 -4px}.SocialMediaOne .CopyLink{height:44px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:100px}.SocialMediaOne .CopyLink svg{margin-right:8px}.SocialMediaOne .SocialCtn{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.SocialMediaOne .SocialCtn a{margin:0 4px;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:14px;font-weight:500}";
  styleInject(css_248z$2);

  function SocialMediaOne(props) {
    var socialIconData = props.socialIconData;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SocialMediaOne"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "SocialCtn"
    }, socialIconData.map(function (item, i) {
      return /*#__PURE__*/React__default["default"].createElement("a", {
        href: item.link,
        target: "blank"
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        src: item.icon
      }));
    }), props.copyButton && /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      onClick: props.onClick,
      className: "CopyLink",
      variant: "contained",
      color: "primary",
      href: "#contained-buttons",
      style: {
        background: props.copyBackground,
        color: props.copyColor
      }
    }, /*#__PURE__*/React__default["default"].createElement(InsertLinkRoundedIcon__default["default"], null), " COPY LINK ")));
  }

  var css_248z$1 = "@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");.MuiAccordionSummary-root.Mui-expanded{border-bottom:1px solid #ccc}.AccordionThreeMainContainer .AccordionThreeIcon{width:18px;height:18px;margin-right:10px}.AccordionThreeMainContainer .AccordionThreeTitle{display:-webkit-box;display:-ms-flexbox;display:flex;font-family:Poppins,sans-serif}.AccordionThreeMainContainer .MuiIconButton-edgeEnd{margin-right:0;position:absolute;left:0}.AccordionThreeMainContainer .MuiExpansionPanelSummary-content{margin:12px 30px;font-family:Poppins,sans-serif}.AccordionThreeMainContainer .MuiSvgIcon-root{color:#56b149}.AccordionThreeMainContainer .minusIcon,.AccordionThreeMainContainer .Mui-expanded .addIcon{display:none}.AccordionThreeMainContainer.Mui-expanded .minusIcon{display:block}.AccordionThreeMainContainer .MuiAccordionSummary-content{margin-left:32px}.AccordionThreeMainContainer .MuiExpansionPanelDetails-root{padding:8px 46px 15px!important}.AccordionThreeMainContainer .MuiExpansionPanelSummary-root.Mui-expanded{min-height:48px}.AccordionThreeMainContainer .IconContianer{display:inherit}.AccordionThreeMainContainer .MuiButtonBase-root{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;padding:0 16px}.AccordionThreeMainContainer{margin-bottom:10px!important;-webkit-box-shadow:none;box-shadow:none;border:1px solid #e4e8ec}.AccordionThreeMainContainer:before{display:none}";
  styleInject(css_248z$1);

  function AccordionThree(props) {
    return /*#__PURE__*/React__default["default"].createElement(Accordion__default["default"], {
      className: "AccordionThreeMainContainer",
      expanded: props.expanded === props.panel,
      onChange: props.handleChange(props.panel)
    }, /*#__PURE__*/React__default["default"].createElement(AccordionSummary__default["default"], {
      expandIcon: /*#__PURE__*/React__default["default"].createElement("span", {
        className: "IconContianer"
      }, /*#__PURE__*/React__default["default"].createElement(AddCircleOutlineRoundedIcon__default["default"], {
        className: "addIcon"
      }), /*#__PURE__*/React__default["default"].createElement(RemoveCircleOutlineRoundedIcon__default["default"], {
        className: "minusIcon"
      })),
      "aria-controls": props.panel,
      id: props.panel
    }, /*#__PURE__*/React__default["default"].createElement(Typography__default["default"], {
      className: "AccordionThreeTitle",
      style: {
        color: props.titleColor,
        fontSize: props.titleFontSize,
        fontWeight: props.TitleFontWeight
      }
    }, props.iconStatus && /*#__PURE__*/React__default["default"].createElement("img", {
      className: "AccordionThreeIcon",
      src: props.icon
    }), " ", props.title)), /*#__PURE__*/React__default["default"].createElement(AccordionDetails__default["default"], null, props.AccordionBody));
  }

  var css_248z = ".ConfirmationContainer{background:#fcfcfc;text-align:center;padding-top:60px;padding-bottom:212px}.iconContainer{background:#4aab10;width:144px;height:144px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:100px;margin:0 auto}.iconContainer svg{color:#fff;font-size:70px}.ConfirmationContainer h1{text-align:center;max-width:460px;margin:0 auto;font-size:34px;padding-top:40px}.ConfirmationContainer p{text-align:center;max-width:720px;margin:0 auto;font-size:20px;padding-top:16px;color:#676c7b}";
  styleInject(css_248z);

  function ConfirmationOne(props) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "TitleOneContainer"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ConfirmationContainer"
    }, /*#__PURE__*/React__default["default"].createElement(Container__default["default"], {
      maxWidth: "md"
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      sm: 12,
      xs: 12
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "iconContainer"
    }, /*#__PURE__*/React__default["default"].createElement(DoneOutlineIcon__default["default"], null)), /*#__PURE__*/React__default["default"].createElement("h1", null, props.title), /*#__PURE__*/React__default["default"].createElement("p", null, props.Descrition)), /*#__PURE__*/React__default["default"].createElement(Grid__default["default"], {
      item: true,
      md: 12,
      sm: 12,
      xs: 12
    }, props.Button && /*#__PURE__*/React__default["default"].createElement(ButtonOne, {
      label: props.buttonLebel,
      onClick: props.onClick,
      link: props.Link,
      target: props.target,
      arrowIcon: props.arrowIcon,
      arrowColor: props.arrowColor,
      arrowStatus: props.arrowStatus,
      buttoncolor: props.buttoncolor,
      width: props.width,
      height: props.height,
      border: props.border,
      borderRadius: props.borderRadius,
      color: props.colorlabel,
      fontWeight: props.fontWeight,
      textAlign: props.textAlign
    }))))));
  }

  exports.AccordionOne = AccordionOne;
  exports.AccordionThree = AccordionThree;
  exports.Alert = Alert;
  exports.AlertThree = AlertThree;
  exports.BlogOne = BlogOne;
  exports.ButtonOne = ButtonOne;
  exports.CTAEight = CTAEight;
  exports.CTAOne = CTAOne;
  exports.CTATwo = CTATwo;
  exports.CardEight = CardEight;
  exports.CardEleven = CardEleven;
  exports.CardFifteen = CardFifteen;
  exports.CardFive = CardFive;
  exports.CardFour = CardFour;
  exports.CardNine = CardNine;
  exports.CardOne = CardOne;
  exports.CardSix = CardSix;
  exports.CardSixteen = CardSixteen;
  exports.CardThree = CardThree;
  exports.CardTwo = CardTwo;
  exports.CarouselOne = CarouselOne;
  exports.CheckBox = CheckBox;
  exports.CheckOrderSummary = CheckOrderSummary;
  exports.CheckoutMembership = CheckoutMembership;
  exports.CheckoutPayment = CheckoutPayment;
  exports.CheckoutPaymentExtended = CheckoutPaymentExtended;
  exports.CheckoutPaymentZamZam = CheckoutPaymentZamZam;
  exports.ConfirmationOne = ConfirmationOne;
  exports.ContactInfoOne = ContactInfoOne;
  exports.ContactUs = ContactUs;
  exports.ContactUsOne = ContactUsOne;
  exports.ContactUsThree = ContactUsThree;
  exports.CreditCardList = CreditCardList;
  exports.CustomToolTip = CustomToolTip;
  exports.FieldPassword = FieldPassword;
  exports.FooterBottomOne = FooterBottomOne;
  exports.FooterFive = FooterFive;
  exports.FooterThree = FooterThree;
  exports.FooterTwo = FooterTwo;
  exports.FooterWeb = FooterWeb;
  exports.GetDirection = GetDirection;
  exports.HajjReadings = HajjReadings;
  exports.Header = Header;
  exports.HeaderWebsite = HeaderWebsite;
  exports.ImageGridFour = ImageGridFour;
  exports.IntegrationDetails = IntegrationDetails;
  exports.LinkCard = LinkCard;
  exports.MainBanner1 = MainBanner1;
  exports.ModalFour = ModalFour;
  exports.ModalThree = ModalThree;
  exports.MultilineText = MultilineText;
  exports.NavBarFour = NavBarFour;
  exports.NavBarOne = NavBarOne;
  exports.NavBarThree = NavBarThree;
  exports.NoAvailableEvents = NoAvailableEvents;
  exports.Otp = Otp;
  exports.PackageCard = PackageCard;
  exports.PageNotFound = PageNotFound;
  exports.PageTitleOne = PageTitleOne;
  exports.PageTitleTwo = PageTitleTwo;
  exports.PhoneInputField = PhoneInputField;
  exports.PricingModal = PricingModal;
  exports.PricingTable = PricingTable;
  exports.ReserveSectionOne = ReserveSectionOne;
  exports.SalatTable = SalatTable;
  exports.SearchField = SearchField;
  exports.Section = Section;
  exports.SelectField = SelectField;
  exports.SelectFieldOne = SelectFieldOne;
  exports.ServiceTabOne = ServiceTabOne;
  exports.SideBarBody = SideBarBody;
  exports.SignIn = SignIn;
  exports.SignUp = SignUp;
  exports.SliderFive = SliderFive;
  exports.SliderFour = SliderFour;
  exports.SliderOne = SliderOne;
  exports.SliderSeven = SliderSeven;
  exports.SliderSix = SliderSix;
  exports.SliderText = SliderText;
  exports.SliderThree = SliderThree;
  exports.SliderTwo = SliderTwo;
  exports.SmallPostCardOne = SmallPostCardOne;
  exports.SocialMediaOne = SocialMediaOne;
  exports.SubHeader = SubHeader;
  exports.TabOne = TabOne;
  exports.TableWithTabs = TableWithTabs;
  exports.Testimonials = Testimonials;
  exports.TextInput = TextInput;
  exports.TextInputFixedLabel = TextInputFixedLabel;
  exports.TimeCardOne = TimeCardOne;
  exports.TitleOne = TitleOne;
  exports.TitleTwo = TitleTwo;
  exports.UserAvatarFive = UserAvatarFive;
  exports.UserAvatarFour = UserAvatarFour;
  exports.UserAvatarOne = UserAvatarOne;
  exports.VerticalTabs = VerticalTabs;
  exports.VideoCardOne = VideoCardOne;
  exports.VideoPlayerModal = VideoPlayerModal;
  exports.VidoeListingCardOne = VidoeListingCardOne;
  exports.VidoeListingCardTwo = VidoeListingCardTwo;
  exports.VidoeListingWithSearch = VidoeListingWithSearch;
  exports.ViewGallery = ViewGallery;
  exports.ZamzamOrderSummary = ZamzamOrderSummary;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
